/* eslint-disable */
/* tslint:disable */
import React from 'react';

export function dashboardLocaleKeys<R extends string>(t: (...args: unknown[]) => R) {
  return {
    resources: {
      balances: {
        name: () => t('resources.balances.name'), /* Balance |||| Balances */
        show: {
          title: () => t('resources.balances.show.title'), /* Balance Details */
          titleWithCurrency: (data: Record<'currency', unknown>) => t('resources.balances.show.titleWithCurrency', data), /* %{currency} balance */
        },
      },
      'auth-admin': {
        name: () => t('resources.auth-admin.name'), /* Auth Dashboard */
      },
      'ai-kyb': {
        name: () => t('resources.ai-kyb.name'), /* AI KYB |||| AI KYBs */
        actions: {
          createReport: () => t('resources.ai-kyb.actions.createReport'), /* Create Report */
        },
        fields: {
          buyer: () => t('resources.ai-kyb.fields.buyer'), /* Buyer */
          model: () => t('resources.ai-kyb.fields.model'), /* Model */
          verifiedBusinessDetails: () => t('resources.ai-kyb.fields.verifiedBusinessDetails'), /* Verified Business Details */
          relatedPersons: () => t('resources.ai-kyb.fields.relatedPersons'), /* Related Persons */
          relatedCompanies: () => t('resources.ai-kyb.fields.relatedCompanies'), /* Related Companies */
          businessScope: () => t('resources.ai-kyb.fields.businessScope'), /* Business Scope */
          registrationRecords: () => t('resources.ai-kyb.fields.registrationRecords'), /* Registration Records */
          internationalScore: () => t('resources.ai-kyb.fields.internationalScore'), /* International Score */
          recommendedCreditLimit: () => t('resources.ai-kyb.fields.recommendedCreditLimit'), /* Recommended Credit Limit */
          shareCapital: () => t('resources.ai-kyb.fields.shareCapital'), /* Share Capital */
          confidenceScore: () => t('resources.ai-kyb.fields.confidenceScore'), /* Confidence Score */
          annualRevenue: () => t('resources.ai-kyb.fields.annualRevenue'), /* Annual Revenue */
          negativeInformation: () => t('resources.ai-kyb.fields.negativeInformation'), /* Negative Information */
          numberOfEmployees: () => t('resources.ai-kyb.fields.numberOfEmployees'), /* Number of Employees */
          notes: () => t('resources.ai-kyb.fields.notes'), /* Notes */
        },
        show: {
          title: () => t('resources.ai-kyb.show.title'), /* AI KYB Details */
        },
      },
      insurance: {
        name: () => t('resources.insurance.name'), /* Insurance */
        alert: {
          insuranceConnected: () => t('resources.insurance.alert.insuranceConnected'), /* Insurance is connected to your account */
          connectInsurance: () => t('resources.insurance.alert.connectInsurance'), /* Connect your insurance to request coverage */
          linkInsurance: () => t('resources.insurance.alert.linkInsurance'), /* Link your credit insurance provider to request buyer coverage and reduce your risk. */
          connectInsuranceButton: () => t('resources.insurance.alert.connectInsuranceButton'), /* Connect insurance */
          manualInsuranceConnected: (data: Record<'insuranceProvider', unknown>) => t('resources.insurance.alert.manualInsuranceConnected', data), /* %{insuranceProvider} is now set up */
          manualInsuranceDescription: () => t('resources.insurance.alert.manualInsuranceDescription'), /* You can now add buyer coverage details manually and keep them updated for informed credit decisions. */
        },
        actions: {
          requestCover: () => t('resources.insurance.actions.requestCover'), /* Request cover */
          requestCoverManually: () => t('resources.insurance.actions.requestCoverManually'), /* Add cover manually */
          updateCover: () => t('resources.insurance.actions.updateCover'), /* Update cover */
        },
        emptyState: {
          insuranceStatus: () => t('resources.insurance.emptyState.insuranceStatus'), /* Insurance status */
          insuranceDisconnected: () => t('resources.insurance.emptyState.insuranceDisconnected'), /* Disconnected */
          insuranceNoCover: () => t('resources.insurance.emptyState.insuranceNoCover'), /* No cover */
        },
        show: {
          title: () => t('resources.insurance.show.title'), /* Insurance */
          companyId: () => t('resources.insurance.show.companyId'), /* Company ID */
          legalName: () => t('resources.insurance.show.legalName'), /* Legal name */
          buyer: () => t('resources.insurance.show.buyer'), /* Buyer */
          phone: () => t('resources.insurance.show.phone'), /* Phone */
          businessStartDate: () => t('resources.insurance.show.businessStartDate'), /* Business start date */
          companyGrade: () => t('resources.insurance.show.companyGrade'), /* Company grade */
          address: () => t('resources.insurance.show.address'), /* Address */
          match: () => t('resources.insurance.show.match'), /* Match */
          coverAmount: () => t('resources.insurance.show.coverAmount'), /* Cover amount */
          insuranceStatus: () => t('resources.insurance.show.insuranceStatus'), /* Insurance status */
        },
        dialogs: {
          holdCoverDialog: {
            buttonLabel: () => t('resources.insurance.dialogs.holdCoverDialog.buttonLabel'), /* Hold cover */
            title: () => t('resources.insurance.dialogs.holdCoverDialog.title'), /* Are you sure you want to put this buyer cover on hold? */
            subtitle: () => t('resources.insurance.dialogs.holdCoverDialog.subtitle'), /* You can add a new cover in the future if needed. */
            confirmButton: () => t('resources.insurance.dialogs.holdCoverDialog.confirmButton'), /* Confirm */
            cancelButton: () => t('resources.insurance.dialogs.holdCoverDialog.cancelButton'), /* Keep cover */
            successMessage: () => t('resources.insurance.dialogs.holdCoverDialog.successMessage'), /* Buyer cover on hold successfully */
            errorMessage: () => t('resources.insurance.dialogs.holdCoverDialog.errorMessage'), /* Failed to put buyer cover on hold */
          },
          cancelCoverDialog: {
            buttonLabel: () => t('resources.insurance.dialogs.cancelCoverDialog.buttonLabel'), /* Cancel */
            title: () => t('resources.insurance.dialogs.cancelCoverDialog.title'), /* Are you sure you want to cancel this buyer's cover? */
            subtitle: () => t('resources.insurance.dialogs.cancelCoverDialog.subtitle'), /* You can add a new cover in the future if needed. */
            confirmButton: () => t('resources.insurance.dialogs.cancelCoverDialog.confirmButton'), /* Confirm */
            cancelButton: () => t('resources.insurance.dialogs.cancelCoverDialog.cancelButton'), /* Keep cover */
            successMessage: () => t('resources.insurance.dialogs.cancelCoverDialog.successMessage'), /* Buyer cover cancelled successfully */
            errorMessage: () => t('resources.insurance.dialogs.cancelCoverDialog.errorMessage'), /* Failed to cancel buyer cover */
          },
        },
      },
      'identity-verification': {
        name: () => t('resources.identity-verification.name'), /* Identity Verification |||| Identity Verifications */
        fields: {
          id: () => t('resources.identity-verification.fields.id'), /* ID */
          buyer: () => t('resources.identity-verification.fields.buyer'), /* Buyer */
          email: () => t('resources.identity-verification.fields.email'), /* Email */
          status: () => t('resources.identity-verification.fields.status'), /* Status */
          verifyIdentityId: () => t('resources.identity-verification.fields.verifyIdentityId'), /* Verify Identity ID */
          identity: () => t('resources.identity-verification.fields.identity'), /* Identity Data */
          createdAt: () => t('resources.identity-verification.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.identity-verification.fields.updatedAt'), /* Updated At */
        },
        actions: {
          createVerification: () => t('resources.identity-verification.actions.createVerification'), /* Create Verification */
          editVerification: () => t('resources.identity-verification.actions.editVerification'), /* Edit Verification */
          viewVerification: () => t('resources.identity-verification.actions.viewVerification'), /* View Verification */
        },
        show: {
          title: () => t('resources.identity-verification.show.title'), /* Identity Verification Details */
          basicInformation: () => t('resources.identity-verification.show.basicInformation'), /* Basic Information */
          stripeIdentityData: () => t('resources.identity-verification.show.stripeIdentityData'), /* Stripe Identity Data */
          timestamps: () => t('resources.identity-verification.show.timestamps'), /* Timestamps */
        },
        list: {
          title: () => t('resources.identity-verification.list.title'), /* Identity Verifications */
        },
      },
      'buyers/insurance': {
        fields: {
          buyer: () => t('resources.buyers/insurance.fields.buyer'), /* Buyer */
          companyId: () => t('resources.buyers/insurance.fields.companyId'), /* Company ID */
          grade: () => t('resources.buyers/insurance.fields.grade'), /* Grade */
          requestedAmount: () => t('resources.buyers/insurance.fields.requestedAmount'), /* Requested Amount */
          status: () => t('resources.buyers/insurance.fields.status'), /* Status */
          coverAmount: () => t('resources.buyers/insurance.fields.coverAmount'), /* Cover Amount */
          startDate: () => t('resources.buyers/insurance.fields.startDate'), /* Start Date */
        },
      },
      'bank-account': {
        name: () => t('resources.bank-account.name'), /* Bank Account |||| Bank Accounts */
        segments: {
          bankAccounts: () => t('resources.bank-account.segments.bankAccounts'), /* Your bank accounts */
          bankAccountLabel: () => t('resources.bank-account.segments.bankAccountLabel'), /* Your accounts */
          recipientAccounts: () => t('resources.bank-account.segments.recipientAccounts'), /* Recipients bank accounts */
          recipientAccountLabel: () => t('resources.bank-account.segments.recipientAccountLabel'), /* Recipients accounts */
        },
        actions: {
          create: () => t('resources.bank-account.actions.create'), /* Add bank account */
          recipientCreate: () => t('resources.bank-account.actions.recipientCreate'), /* Add recipient */
        },
      },
      'credit-monitoring': {
        name: () => t('resources.credit-monitoring.name'), /* Credit Monitoring */
        actions: {
          migrate: () => t('resources.credit-monitoring.actions.migrate'), /* Migrate */
        },
        migrate: {
          title: () => t('resources.credit-monitoring.migrate.title'), /* Migrate Credit Monitoring */
          description: () => t('resources.credit-monitoring.migrate.description'), /* This will create credit-monitoring timeline entries for existing buyers based on their credit reviews, financial connections, attachments, and credit references. */
          selectTenant: () => t('resources.credit-monitoring.migrate.selectTenant'), /* Select Tenant */
          tenantHelperText: () => t('resources.credit-monitoring.migrate.tenantHelperText'), /* Select the tenant to run migration for */
          selectBuyers: () => t('resources.credit-monitoring.migrate.selectBuyers'), /* Select Buyers */
          buyersHelperText: () => t('resources.credit-monitoring.migrate.buyersHelperText'), /* Select one or more buyers to process */
          allBuyers: () => t('resources.credit-monitoring.migrate.allBuyers'), /* Process all buyers in this tenant */
          dryRun: () => t('resources.credit-monitoring.migrate.dryRun'), /* Dry run (preview only, no records created) */
          runDryRun: () => t('resources.credit-monitoring.migrate.runDryRun'), /* Run Dry Run */
          runMigration: () => t('resources.credit-monitoring.migrate.runMigration'), /* Run Migration */
          processing: () => t('resources.credit-monitoring.migrate.processing'), /* Processing... */
          cancel: () => t('resources.credit-monitoring.migrate.cancel'), /* Cancel */
          close: () => t('resources.credit-monitoring.migrate.close'), /* Close */
          runActualMigration: () => t('resources.credit-monitoring.migrate.runActualMigration'), /* Run Actual Migration */
          results: {
            title: () => t('resources.credit-monitoring.migrate.results.title'), /* Migration Results */
            dryRunTitle: () => t('resources.credit-monitoring.migrate.results.dryRunTitle'), /* Migration Dry Run Results */
            dryRunCompleted: () => t('resources.credit-monitoring.migrate.results.dryRunCompleted'), /* Dry Run Completed */
            migrationCompleted: () => t('resources.credit-monitoring.migrate.results.migrationCompleted'), /* Migration Completed */
            buyersProcessed: (data: Record<'count', unknown>) => t('resources.credit-monitoring.migrate.results.buyersProcessed', data), /* %{count} buyers processed */
            recordsCreated: (data: Record<'count', unknown>) => t('resources.credit-monitoring.migrate.results.recordsCreated', data), /* %{count} records created */
            recordsWouldBeCreated: (data: Record<'count', unknown>) => t('resources.credit-monitoring.migrate.results.recordsWouldBeCreated', data), /* %{count} records would be created */
            tenant: () => t('resources.credit-monitoring.migrate.results.tenant'), /* Tenant */
            totalBuyers: () => t('resources.credit-monitoring.migrate.results.totalBuyers'), /* Total Buyers */
            totalEvents: () => t('resources.credit-monitoring.migrate.results.totalEvents'), /* Total Events */
            created: () => t('resources.credit-monitoring.migrate.results.created'), /* Created */
            skipped: () => t('resources.credit-monitoring.migrate.results.skipped'), /* Skipped */
            failed: () => t('resources.credit-monitoring.migrate.results.failed'), /* Failed */
            timelineItemsWithChanges: () => t('resources.credit-monitoring.migrate.results.timelineItemsWithChanges'), /* Timeline items with changes */
            dbRecordsLabel: (data: Record<'status', unknown>) => t('resources.credit-monitoring.migrate.results.dbRecordsLabel', data), /* DB records %{status} */
            estimated: () => t('resources.credit-monitoring.migrate.results.estimated'), /* (estimated) */
            createdLabel: () => t('resources.credit-monitoring.migrate.results.createdLabel'), /* created */
            dryRunNotification: (data: Record<'actualRecordsCreated' | 'totalEvents' | 'created' | 'skipped', unknown>) => t('resources.credit-monitoring.migrate.results.dryRunNotification', data), /* Dry run completed: %{actualRecordsCreated} records would be created from %{totalEvents} timeline items (%{created} with changes, %{skipped} skipped) */
            migrationNotification: (data: Record<'actualRecordsCreated' | 'totalEvents' | 'created' | 'skipped', unknown>) => t('resources.credit-monitoring.migrate.results.migrationNotification', data), /* Migration completed: %{actualRecordsCreated} records created from %{totalEvents} timeline items (%{created} with changes, %{skipped} skipped) */
            migrationFailed: (data: Record<'message', unknown>) => t('resources.credit-monitoring.migrate.results.migrationFailed', data), /* Migration failed: %{message} */
          },
        },
        create: {
          eventTypes: {
            creditScore: () => t('resources.credit-monitoring.create.eventTypes.creditScore'), /* Credit Score */
            internationalScore: () => t('resources.credit-monitoring.create.eventTypes.internationalScore'), /* International Score */
            recommendedLimit: () => t('resources.credit-monitoring.create.eventTypes.recommendedLimit'), /* Recommended Limit */
            bankAccount: () => t('resources.credit-monitoring.create.eventTypes.bankAccount'), /* Bank Account */
            financialDocument: () => t('resources.credit-monitoring.create.eventTypes.financialDocument'), /* Financial Document */
            personalGuarantee: () => t('resources.credit-monitoring.create.eventTypes.personalGuarantee'), /* Personal Guarantee */
            creditReference: () => t('resources.credit-monitoring.create.eventTypes.creditReference'), /* Credit Reference */
            identityVerification: () => t('resources.credit-monitoring.create.eventTypes.identityVerification'), /* Identity Verification */
          },
          changeTypes: {
            increase: () => t('resources.credit-monitoring.create.changeTypes.increase'), /* Increase */
            decrease: () => t('resources.credit-monitoring.create.changeTypes.decrease'), /* Decrease */
            add: () => t('resources.credit-monitoring.create.changeTypes.add'), /* Add */
            remove: () => t('resources.credit-monitoring.create.changeTypes.remove'), /* Remove */
          },
        },
        fields: {
          buyer: () => t('resources.credit-monitoring.fields.buyer'), /* Buyer */
          eventType: () => t('resources.credit-monitoring.fields.eventType'), /* Event Type */
          changeType: () => t('resources.credit-monitoring.fields.changeType'), /* Change Type */
          reference: {
            entityType: () => t('resources.credit-monitoring.fields.reference.entityType'), /* Reference Entity Type */
            entityId: () => t('resources.credit-monitoring.fields.reference.entityId'), /* Reference Entity ID */
          },
        },
        timeline: {
          noUpdates: () => t('resources.credit-monitoring.timeline.noUpdates'), /* No recent credit monitoring updates */
          showMore: () => t('resources.credit-monitoring.timeline.showMore'), /* Show more */
          creditScore: {
            dropped: () => t('resources.credit-monitoring.timeline.creditScore.dropped'), /* Credit score dropped */
            increased: () => t('resources.credit-monitoring.timeline.creditScore.increased'), /* Credit score increased */
          },
          recommendedLimit: {
            decreased: () => t('resources.credit-monitoring.timeline.recommendedLimit.decreased'), /* Recommended credit limit decreased */
            increased: () => t('resources.credit-monitoring.timeline.recommendedLimit.increased'), /* Recommended credit limit increased */
          },
          internationalScore: {
            improved: () => t('resources.credit-monitoring.timeline.internationalScore.improved'), /* International score improved */
            worsened: () => t('resources.credit-monitoring.timeline.internationalScore.worsened'), /* International score worsened */
            updated: () => t('resources.credit-monitoring.timeline.internationalScore.updated'), /* International score updated */
          },
          bankAccount: {
            added: () => t('resources.credit-monitoring.timeline.bankAccount.added'), /* Bank account connected */
          },
          financialDocument: {
            added: () => t('resources.credit-monitoring.timeline.financialDocument.added'), /* Financial document uploaded */
          },
          personalGuarantee: {
            added: () => t('resources.credit-monitoring.timeline.personalGuarantee.added'), /* Personal guarantee provided */
          },
          creditReference: {
            added: () => t('resources.credit-monitoring.timeline.creditReference.added'), /* Credit reference added */
          },
        },
      },
      'credit-references': {
        name: () => t('resources.credit-references.name'), /* Credit References */
        fields: {
          address: {
            country: () => t('resources.credit-references.fields.address.country'), /* Country */
            state: () => t('resources.credit-references.fields.address.state'), /* State */
            city: () => t('resources.credit-references.fields.address.city'), /* City */
            addressLine1: () => t('resources.credit-references.fields.address.addressLine1'), /* Address Line 1 */
            addressLine2: () => t('resources.credit-references.fields.address.addressLine2'), /* Address Line 2 */
            zipCode: () => t('resources.credit-references.fields.address.zipCode'), /* Zip Code */
          },
          companyName: () => t('resources.credit-references.fields.companyName'), /* Company Name */
          accountReceivableContact: () => t('resources.credit-references.fields.accountReceivableContact'), /* Account Receivable Contact */
          phone: () => t('resources.credit-references.fields.phone'), /* Phone */
          email: () => t('resources.credit-references.fields.email'), /* Email */
          fax: () => t('resources.credit-references.fields.fax'), /* Fax */
          createdAt: () => t('resources.credit-references.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-references.fields.updatedAt'), /* Updated At */
        },
        actions: {
          create: () => t('resources.credit-references.actions.create'), /* Create Credit Reference */
        },
      },
      'credit-review/reports': {
        internationalScore: {
          title: () => t('resources.credit-review/reports.internationalScore.title'), /* International score */
          tooltip: () => t('resources.credit-review/reports.internationalScore.tooltip'), /* Worldwide measure of 12‑month failure risk, blending local history, legal records, and structure into one comparable global score. */
          getFullReport: () => t('resources.credit-review/reports.internationalScore.getFullReport'), /* Get enhanced report */
          A: () => t('resources.credit-review/reports.internationalScore.A'), /* Very Low Risk Score */
          B: () => t('resources.credit-review/reports.internationalScore.B'), /* Low Risk Score */
          C: () => t('resources.credit-review/reports.internationalScore.C'), /* Moderate Risk Score */
          D: () => t('resources.credit-review/reports.internationalScore.D'), /* High Risk Score */
          E: () => t('resources.credit-review/reports.internationalScore.E'), /* Very High Risk Score */
          descriptions: {
            A: () => t('resources.credit-review/reports.internationalScore.descriptions.A'), /* Very good credit worthiness */
            B: () => t('resources.credit-review/reports.internationalScore.descriptions.B'), /* Good credit worthiness */
            C: () => t('resources.credit-review/reports.internationalScore.descriptions.C'), /* Credit worthy */
            D: () => t('resources.credit-review/reports.internationalScore.descriptions.D'), /* Caution - Credit at your discretion */
            E: () => t('resources.credit-review/reports.internationalScore.descriptions.E'), /* Very Low Risk Score */
            BankruptcyProceedingsFiled: () => t('resources.credit-review/reports.internationalScore.descriptions.BankruptcyProceedingsFiled'), /* Bankruptcy proceedings filed */
          },
          dialogTitle: () => t('resources.credit-review/reports.internationalScore.dialogTitle'), /* International score details */
        },
        riskScore: {
          title: () => t('resources.credit-review/reports.riskScore.title'), /* Credit risk score */
          tooltip: () => t('resources.credit-review/reports.riskScore.tooltip'), /* Measures a company's 12‑month failure risk based on its history, legal issues, ownership, age, and industry. */
          notScored: () => t('resources.credit-review/reports.riskScore.notScored'), /* Not scored */
          veryLowRiskScore: () => t('resources.credit-review/reports.riskScore.veryLowRiskScore'), /* Very Low Risk Score */
          lowRiskScore: () => t('resources.credit-review/reports.riskScore.lowRiskScore'), /* Low Risk Score */
          moderateRiskScore: () => t('resources.credit-review/reports.riskScore.moderateRiskScore'), /* Moderate Risk Score */
          highRiskScore: () => t('resources.credit-review/reports.riskScore.highRiskScore'), /* High Risk Score */
          veryHighRiskScore: () => t('resources.credit-review/reports.riskScore.veryHighRiskScore'), /* Very High Risk Score */
          getFullReport: () => t('resources.credit-review/reports.riskScore.getFullReport'), /* Get enhanced report */
          ranges: {
            veryLow: () => t('resources.credit-review/reports.riskScore.ranges.veryLow'), /* 71 to 100 */
            low: () => t('resources.credit-review/reports.riskScore.ranges.low'), /* 51 to 70 */
            moderate: () => t('resources.credit-review/reports.riskScore.ranges.moderate'), /* 30 to 50 */
            high: () => t('resources.credit-review/reports.riskScore.ranges.high'), /* 21 to 29 */
            veryHigh: () => t('resources.credit-review/reports.riskScore.ranges.veryHigh'), /* 1 to 20 */
            notScored: () => t('resources.credit-review/reports.riskScore.ranges.notScored'), /* - */
          },
          dialogTitle: () => t('resources.credit-review/reports.riskScore.dialogTitle'), /* Risk score details */
        },
        complianceAlerts: {
          title: () => t('resources.credit-review/reports.complianceAlerts.title'), /* Risk and compliance alerts */
          tooltip: () => t('resources.credit-review/reports.complianceAlerts.tooltip'), /* Flags key legal and compliance risks, from lawsuits and bankruptcies to AML and OFAC sanctions */
        },
        dbt: {
          title: () => t('resources.credit-review/reports.dbt.title'), /* Days beyond terms */
        },
        paymentTrend: {
          title: () => t('resources.credit-review/reports.paymentTrend.title'), /* Payment trend */
          small: () => t('resources.credit-review/reports.paymentTrend.small'), /* small */
          medium: () => t('resources.credit-review/reports.paymentTrend.medium'), /* medium */
          large: () => t('resources.credit-review/reports.paymentTrend.large'), /* large */
        },
        paymentExperiences: {
          title: () => t('resources.credit-review/reports.paymentExperiences.title'), /* Payment experiences */
        },
        paidOnTime: {
          title: () => t('resources.credit-review/reports.paidOnTime.title'), /* Paid on time */
        },
        paidOnTimePercentage: {
          title: () => t('resources.credit-review/reports.paidOnTimePercentage.title'), /* % Paid on time */
        },
        inquiriesTrend: {
          title: () => t('resources.credit-review/reports.inquiriesTrend.title'), /* Inquiries trend */
          small: () => t('resources.credit-review/reports.inquiriesTrend.small'), /* small */
          medium: () => t('resources.credit-review/reports.inquiriesTrend.medium'), /* medium */
          large: () => t('resources.credit-review/reports.inquiriesTrend.large'), /* large */
        },
        creditLimit: {
          title: () => t('resources.credit-review/reports.creditLimit.title'), /* Recommended credit limit */
        },
      },
      'credit-reviews/notes': {
        name: () => t('resources.credit-reviews/notes.name'), /* Credit Review Notes */
        fields: {
          id: () => t('resources.credit-reviews/notes.fields.id'), /* ID */
          buyer: () => t('resources.credit-reviews/notes.fields.buyer'), /* Buyer */
          summary: () => t('resources.credit-reviews/notes.fields.summary'), /* Summary */
          comments: () => t('resources.credit-reviews/notes.fields.comments'), /* Comments */
          creditScore: () => t('resources.credit-reviews/notes.fields.creditScore'), /* Credit Score */
          recommendedCreditLimit: () => t('resources.credit-reviews/notes.fields.recommendedCreditLimit'), /* Recommended Credit Limit */
          verifiedBusinessDetails: () => t('resources.credit-reviews/notes.fields.verifiedBusinessDetails'), /* Verified Business Details */
          relatedPersons: () => t('resources.credit-reviews/notes.fields.relatedPersons'), /* Related Persons */
          relatedCompanies: () => t('resources.credit-reviews/notes.fields.relatedCompanies'), /* Related Companies */
          businessScope: () => t('resources.credit-reviews/notes.fields.businessScope'), /* Business Scope */
          registrationRecords: () => t('resources.credit-reviews/notes.fields.registrationRecords'), /* Registration Records */
          international: () => t('resources.credit-reviews/notes.fields.international'), /* International Data */
          seller: () => t('resources.credit-reviews/notes.fields.seller'), /* Seller */
          author: () => t('resources.credit-reviews/notes.fields.author'), /* Author */
          createdAt: () => t('resources.credit-reviews/notes.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-reviews/notes.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-reviews/notes.fields.createdBy'), /* Created By */
        },
        actions: {
          create: () => t('resources.credit-reviews/notes.actions.create'), /* Create Credit Review Note */
        },
        show: {
          basicInformation: () => t('resources.credit-reviews/notes.show.basicInformation'), /* Basic Information */
          creditAnalysis: () => t('resources.credit-reviews/notes.show.creditAnalysis'), /* Credit Analysis */
          businessDetails: () => t('resources.credit-reviews/notes.show.businessDetails'), /* Business Details */
          relatedEntities: () => t('resources.credit-reviews/notes.show.relatedEntities'), /* Related Entities */
        },
      },
      'credit-safe/companies': {
        name: () => t('resources.credit-safe/companies.name'), /* Credit Safe */
        fields: {
          id: () => t('resources.credit-safe/companies.fields.id'), /* ID */
          buyer: () => t('resources.credit-safe/companies.fields.buyer'), /* Buyer */
          searchQuery: {
            name: () => t('resources.credit-safe/companies.fields.searchQuery.name'), /* Company Name */
            country: () => t('resources.credit-safe/companies.fields.searchQuery.country'), /* Country */
          },
          searchResult: {
            name: () => t('resources.credit-safe/companies.fields.searchResult.name'), /* Company Name */
            status: () => t('resources.credit-safe/companies.fields.searchResult.status'), /* Status */
            address: () => t('resources.credit-safe/companies.fields.searchResult.address'), /* Address */
            vatNumber: () => t('resources.credit-safe/companies.fields.searchResult.vatNumber'), /* VAT Number */
            connectionId: () => t('resources.credit-safe/companies.fields.searchResult.connectionId'), /* Connection ID */
          },
          match: () => t('resources.credit-safe/companies.fields.match'), /* Match */
          rawData: () => t('resources.credit-safe/companies.fields.rawData'), /* Raw Data */
          createdAt: () => t('resources.credit-safe/companies.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/companies.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/companies.fields.createdBy'), /* Created By */
        },
        actions: {
          createCompany: () => t('resources.credit-safe/companies.actions.createCompany'), /* Create Company */
          refresh: () => t('resources.credit-safe/companies.actions.refresh'), /* Refresh */
        },
      },
      'credit-safe/reports': {
        name: () => t('resources.credit-safe/reports.name'), /* Credit Safe Reports */
        fields: {
          id: () => t('resources.credit-safe/reports.fields.id'), /* ID */
          buyer: () => t('resources.credit-safe/reports.fields.buyer'), /* Buyer */
          companyId: () => t('resources.credit-safe/reports.fields.companyId'), /* Company ID */
          connectionId: () => t('resources.credit-safe/reports.fields.connectionId'), /* Connection ID */
          reportData: () => t('resources.credit-safe/reports.fields.reportData'), /* Report Data */
          rawData: () => t('resources.credit-safe/reports.fields.rawData'), /* Raw Data */
          createdAt: () => t('resources.credit-safe/reports.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/reports.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/reports.fields.createdBy'), /* Created By */
        },
        statistics: {
          netSales: () => t('resources.credit-safe/reports.statistics.netSales'), /* Net Sales (Last 12 months) */
          otherOperationIncome: () => t('resources.credit-safe/reports.statistics.otherOperationIncome'), /* Other Operation Income (Last 12 months) */
          latestBalance: () => t('resources.credit-safe/reports.statistics.latestBalance'), /* Latest Balance (Last 12 months) */
          totalDebt: () => t('resources.credit-safe/reports.statistics.totalDebt'), /* Total Debt (Last 12 months) */
          netIncome: () => t('resources.credit-safe/reports.statistics.netIncome'), /* Net Income (Last 12 months) */
          employees: () => t('resources.credit-safe/reports.statistics.employees'), /* Employees (Last 12 months) */
          cashFlow: () => t('resources.credit-safe/reports.statistics.cashFlow'), /* Cash (Last 12 months) */
        },
        actions: {
          createReport: () => t('resources.credit-safe/reports.actions.createReport'), /* Create Report */
          refresh: () => t('resources.credit-safe/reports.actions.refresh'), /* Refresh */
        },
        riskScore: {
          high: () => t('resources.credit-safe/reports.riskScore.high'), /* High risk */
          medium: () => t('resources.credit-safe/reports.riskScore.medium'), /* Medium risk */
          low: () => t('resources.credit-safe/reports.riskScore.low'), /* Low risk */
        },
      },
      'credit-safe/portfolios': {
        name: () => t('resources.credit-safe/portfolios.name'), /* Credit Safe Portfolios */
        fields: {
          id: () => t('resources.credit-safe/portfolios.fields.id'), /* ID */
          name: () => t('resources.credit-safe/portfolios.fields.name'), /* Name */
          portfolioId: () => t('resources.credit-safe/portfolios.fields.portfolioId'), /* Portfolio ID */
          companies: () => t('resources.credit-safe/portfolios.fields.companies'), /* Companies */
          createdAt: () => t('resources.credit-safe/portfolios.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/portfolios.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/portfolios.fields.createdBy'), /* Created By */
        },
        actions: {
          createPortfolio: () => t('resources.credit-safe/portfolios.actions.createPortfolio'), /* Create Portfolio */
          addCompany: () => t('resources.credit-safe/portfolios.actions.addCompany'), /* Add Company */
          removeCompany: () => t('resources.credit-safe/portfolios.actions.removeCompany'), /* Remove Company */
        },
      },
      'credit-safe/portfolio-companies': {
        name: () => t('resources.credit-safe/portfolio-companies.name'), /* Credit Safe Portfolio Companies */
        fields: {
          id: () => t('resources.credit-safe/portfolio-companies.fields.id'), /* ID */
          portfolioId: () => t('resources.credit-safe/portfolio-companies.fields.portfolioId'), /* Portfolio ID */
          connectionId: () => t('resources.credit-safe/portfolio-companies.fields.connectionId'), /* Connection ID */
          buyer: () => t('resources.credit-safe/portfolio-companies.fields.buyer'), /* Buyer */
          seller: () => t('resources.credit-safe/portfolio-companies.fields.seller'), /* Seller */
          createdAt: () => t('resources.credit-safe/portfolio-companies.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/portfolio-companies.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/portfolio-companies.fields.createdBy'), /* Created By */
        },
        actions: {
          createPortfolioCompany: () => t('resources.credit-safe/portfolio-companies.actions.createPortfolioCompany'), /* Create Portfolio Company */
          editPortfolioCompany: () => t('resources.credit-safe/portfolio-companies.actions.editPortfolioCompany'), /* Edit Portfolio Company */
        },
      },
      'credit-safe/portfolio-event-rules': {
        name: () => t('resources.credit-safe/portfolio-event-rules.name'), /* Credit Safe Portfolio Event Rules */
        fields: {
          id: () => t('resources.credit-safe/portfolio-event-rules.fields.id'), /* ID */
          name: () => t('resources.credit-safe/portfolio-event-rules.fields.name'), /* Name */
          portfolioId: () => t('resources.credit-safe/portfolio-event-rules.fields.portfolioId'), /* Portfolio ID */
          status: () => t('resources.credit-safe/portfolio-event-rules.fields.status'), /* Status */
          ruleCode: () => t('resources.credit-safe/portfolio-event-rules.fields.ruleCode'), /* Rule Code */
          ruleCountry: () => t('resources.credit-safe/portfolio-event-rules.fields.ruleCountry'), /* Rule Country */
          ruleType: () => t('resources.credit-safe/portfolio-event-rules.fields.ruleType'), /* Rule Type */
          param0: () => t('resources.credit-safe/portfolio-event-rules.fields.param0'), /* Parameter 0 */
          param1: () => t('resources.credit-safe/portfolio-event-rules.fields.param1'), /* Parameter 1 */
          createdAt: () => t('resources.credit-safe/portfolio-event-rules.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/portfolio-event-rules.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/portfolio-event-rules.fields.createdBy'), /* Created By */
        },
        actions: {
          createEventRule: () => t('resources.credit-safe/portfolio-event-rules.actions.createEventRule'), /* Create Event Rule */
          editEventRule: () => t('resources.credit-safe/portfolio-event-rules.actions.editEventRule'), /* Edit Event Rule */
          toggleEventRule: () => t('resources.credit-safe/portfolio-event-rules.actions.toggleEventRule'), /* Toggle Event Rule */
        },
      },
      'credit-safe/portfolio-events': {
        name: () => t('resources.credit-safe/portfolio-events.name'), /* Credit Safe Portfolio Events */
        fields: {
          id: () => t('resources.credit-safe/portfolio-events.fields.id'), /* ID */
          portfolioId: () => t('resources.credit-safe/portfolio-events.fields.portfolioId'), /* Portfolio ID */
          eventId: () => t('resources.credit-safe/portfolio-events.fields.eventId'), /* Event ID */
          status: () => t('resources.credit-safe/portfolio-events.fields.status'), /* Status */
          ruleCode: () => t('resources.credit-safe/portfolio-events.fields.ruleCode'), /* Rule Code */
          companyConnectionId: () => t('resources.credit-safe/portfolio-events.fields.companyConnectionId'), /* Company Connection ID */
          eventDate: () => t('resources.credit-safe/portfolio-events.fields.eventDate'), /* Event Date */
          seller: () => t('resources.credit-safe/portfolio-events.fields.seller'), /* Seller */
          createdAt: () => t('resources.credit-safe/portfolio-events.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-safe/portfolio-events.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-safe/portfolio-events.fields.createdBy'), /* Created By */
        },
        actions: {
          createEvent: () => t('resources.credit-safe/portfolio-events.actions.createEvent'), /* Create Event */
          editEvent: () => t('resources.credit-safe/portfolio-events.actions.editEvent'), /* Edit Event */
        },
      },
      'credit-requirements': {
        name: () => t('resources.credit-requirements.name'), /* Credit Requirements */
        fields: {
          id: () => t('resources.credit-requirements.fields.id'), /* ID */
          supplier: () => t('resources.credit-requirements.fields.supplier'), /* Supplier */
          tasks: () => t('resources.credit-requirements.fields.tasks'), /* Required Tasks */
          connectBank: () => t('resources.credit-requirements.fields.connectBank'), /* Connect Bank */
          uploadDocuments: () => t('resources.credit-requirements.fields.uploadDocuments'), /* Upload Documents */
          signGuarantee: () => t('resources.credit-requirements.fields.signGuarantee'), /* Sign Guarantee */
          identityVerification: () => t('resources.credit-requirements.fields.identityVerification'), /* Identity Verification */
          creditReference: () => t('resources.credit-requirements.fields.creditReference'), /* Credit Reference */
          createdAt: () => t('resources.credit-requirements.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.credit-requirements.fields.updatedAt'), /* Updated At */
          createdBy: () => t('resources.credit-requirements.fields.createdBy'), /* Created By */
        },
        actions: {
          create: () => t('resources.credit-requirements.actions.create'), /* Create Credit Requirements */
          edit: () => t('resources.credit-requirements.actions.edit'), /* Edit Requirements */
          save: () => t('resources.credit-requirements.actions.save'), /* Save Configuration */
        },
      },
      billings: {
        name: () => t('resources.billings.name'), /* Billing |||| Billings */
        fields: {
          id: () => t('resources.billings.fields.id'), /* ID */
          amount: () => t('resources.billings.fields.amount'), /* Amount */
          currency: () => t('resources.billings.fields.currency'), /* Currency */
          entityType: () => t('resources.billings.fields.entityType'), /* Entity Type */
          entityId: () => t('resources.billings.fields.entityId'), /* Entity ID */
          status: () => t('resources.billings.fields.status'), /* Status */
          note: () => t('resources.billings.fields.note'), /* Note */
          createdAt: () => t('resources.billings.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.billings.fields.updatedAt'), /* Updated At */
        },
        list: {
          title: () => t('resources.billings.list.title'), /* Billings */
        },
        show: {
          title: () => t('resources.billings.show.title'), /* Billing Details */
        },
        edit: {
          title: () => t('resources.billings.edit.title'), /* Edit Billing */
        },
        create: {
          title: () => t('resources.billings.create.title'), /* Create Billing */
        },
        indicators: {
          pending: () => t('resources.billings.indicators.pending'), /* Pending */
          'in-progress': () => t('resources.billings.indicators.in-progress'), /* In Progress */
          done: () => t('resources.billings.indicators.done'), /* Done */
          failed: () => t('resources.billings.indicators.failed'), /* Failed */
          canceled: () => t('resources.billings.indicators.canceled'), /* Canceled */
          total: () => t('resources.billings.indicators.total'), /* Total billings */
          billingsQuantity: (data: Record<'quantity', unknown>) => t('resources.billings.indicators.billingsQuantity', data), /* %{quantity} billings */
        },
      },
      experian: {
        name: () => t('resources.experian.name'), /* Experian |||| Experian */
        fields: {
          email: () => t('resources.experian.fields.email'), /* Email */
          searchQuery: () => t('resources.experian.fields.searchQuery'), /* Search Query */
          searchResult: () => t('resources.experian.fields.searchResult'), /* Search Result */
          score: () => t('resources.experian.fields.score'), /* Score */
          buyer: () => t('resources.experian.fields.buyer'), /* Buyer */
        },
      },
      'financial-connections': {
        name: () => t('resources.financial-connections.name'), /* Financial Connection |||| Financial Connections */
        fields: {
          id: () => t('resources.financial-connections.fields.id'), /* ID */
          buyer: () => t('resources.financial-connections.fields.buyer'), /* Buyer */
          providerType: () => t('resources.financial-connections.fields.providerType'), /* Provider type */
          accountName: () => t('resources.financial-connections.fields.accountName'), /* Account name */
          ownership: () => t('resources.financial-connections.fields.ownership'), /* Ownership */
          status: () => t('resources.financial-connections.fields.status'), /* Status */
          balance: () => t('resources.financial-connections.fields.balance'), /* Balance */
          providerId: () => t('resources.financial-connections.fields.providerId'), /* Provider ID */
          paymentMethod: () => t('resources.financial-connections.fields.paymentMethod'), /* Payment method */
          createdAt: () => t('resources.financial-connections.fields.createdAt'), /* Created at */
          decisionNote: () => t('resources.financial-connections.fields.decisionNote'), /* Decision note */
          createdBy: () => t('resources.financial-connections.fields.createdBy'), /* Created by */
          platform: () => t('resources.financial-connections.fields.platform'), /* Platform */
          transactionsCount: () => t('resources.financial-connections.fields.transactionsCount'), /* Number of transactions */
        },
        edit: {
          title: () => t('resources.financial-connections.edit.title'), /* Financial Connection Identity */
        },
        list: {
          hasPaymentMethodIndication: () => t('resources.financial-connections.list.hasPaymentMethodIndication'), /* View details */
        },
        show: {
          title: () => t('resources.financial-connections.show.title'), /* Financial Connection Identity */
        },
      },
      'feature-toggles': {
        name: () => t('resources.feature-toggles.name'), /* Feature Toggle |||| Feature Toggles */
        fields: {
          id: () => t('resources.feature-toggles.fields.id'), /* ID */
          name: () => t('resources.feature-toggles.fields.name'), /* Name */
          description: () => t('resources.feature-toggles.fields.description'), /* Description */
          conditions: {
            title: () => t('resources.feature-toggles.fields.conditions.title'), /* Conditions */
            expressions: () => t('resources.feature-toggles.fields.conditions.expressions'), /* expression */
            value: () => t('resources.feature-toggles.fields.conditions.value'), /* Value */
          },
          defaultValue: () => t('resources.feature-toggles.fields.defaultValue'), /* Defualt value */
        },
        edit: {
          title: () => t('resources.feature-toggles.edit.title'), /* Feature Toggle Identity */
          valueInputOptions: {
            true: () => t('resources.feature-toggles.edit.valueInputOptions.true'), /* True */
            false: () => t('resources.feature-toggles.edit.valueInputOptions.false'), /* False */
            value: () => t('resources.feature-toggles.edit.valueInputOptions.value'), /* Value */
          },
        },
        list: {
          hasPaymentMethodIndication: () => t('resources.feature-toggles.list.hasPaymentMethodIndication'), /* View details */
        },
        show: {
          title: () => t('resources.feature-toggles.show.title'), /* Feature Toggle Identity */
        },
      },
      configs: {
        name: () => t('resources.configs.name'), /* Config |||| Configs */
      },
      'creditline-dashboard': {
        name: () => t('resources.creditline-dashboard.name'), /* Credit Line |||| Credit Lines */
      },
      'external/buyers': {
        name: () => t('resources.external/buyers.name'), /* External Buyer |||| External Buyers */
        fields: {
          providerId: () => t('resources.external/buyers.fields.providerId'), /* Provider ID */
          externalId: () => t('resources.external/buyers.fields.externalId'), /* External ID */
          providerType: () => t('resources.external/buyers.fields.providerType'), /* Provider type */
          status: () => t('resources.external/buyers.fields.status'), /* Status */
          syncUpStatus: () => t('resources.external/buyers.fields.syncUpStatus'), /* Sync up status */
          data: {
            email: () => t('resources.external/buyers.fields.data.email'), /* Email */
            dba: () => t('resources.external/buyers.fields.data.dba'), /* DBA */
          },
          action: () => t('resources.external/buyers.fields.action'), /* Action */
        },
        edit: {
          title: () => t('resources.external/buyers.edit.title'), /* External buyer details */
        },
        show: {
          details: {
            title: () => t('resources.external/buyers.show.details.title'), /* Details */
          },
          jobs: {
            title: () => t('resources.external/buyers.show.jobs.title'), /* Jobs */
          },
          invoices: {
            title: () => t('resources.external/buyers.show.invoices.title'), /* Invoices */
          },
        },
      },
      'external/invoices': {
        name: () => t('resources.external/invoices.name'), /* External Invoice |||| External Invoices */
        fields: {
          invoice: () => t('resources.external/invoices.fields.invoice'), /* Invoice */
          providerId: () => t('resources.external/invoices.fields.providerId'), /* Provider ID */
          externalId: () => t('resources.external/invoices.fields.externalId'), /* External ID */
          providerType: () => t('resources.external/invoices.fields.providerType'), /* Provider type */
          status: () => t('resources.external/invoices.fields.status'), /* Status */
          syncUpStatus: () => t('resources.external/invoices.fields.syncUpStatus'), /* Sync up status */
          attachments: () => t('resources.external/invoices.fields.attachments'), /* Attachments */
        },
        show: {
          details: {
            title: () => t('resources.external/invoices.show.details.title'), /* Details */
          },
          shipping: {
            title: () => t('resources.external/invoices.show.shipping.title'), /* Shippings */
            id: () => t('resources.external/invoices.show.shipping.id'), /* ID */
            shippingProvider: () => t('resources.external/invoices.show.shipping.shippingProvider'), /* Shipping provider */
            trackingNumber: () => t('resources.external/invoices.show.shipping.trackingNumber'), /* Tracking number */
            shipping: () => t('resources.external/invoices.show.shipping.shipping'), /* Shipping */
            attachment: () => t('resources.external/invoices.show.shipping.attachment'), /* Attachment */
          },
          attachments: {
            title: () => t('resources.external/invoices.show.attachments.title'), /* Attachments */
          },
          payments: {
            title: () => t('resources.external/invoices.show.payments.title'), /* Payments */
            emptyListMessage: () => t('resources.external/invoices.show.payments.emptyListMessage'), /* No payments yet */
            charge: () => t('resources.external/invoices.show.payments.charge'), /* Charge */
            chargeDate: () => t('resources.external/invoices.show.payments.chargeDate'), /* Charge date */
            amount: () => t('resources.external/invoices.show.payments.amount'), /* Amount */
          },
          jobs: {
            title: () => t('resources.external/invoices.show.jobs.title'), /* Jobs */
          },
          items: {
            title: () => t('resources.external/invoices.show.items.title'), /* Line Items */
          },
        },
        edit: {
          title: () => t('resources.external/invoices.edit.title'), /* External invoice details */
        },
      },
      'external/payments': {
        name: () => t('resources.external/payments.name'), /* External Payment |||| External Payments */
        fields: {
          providerId: () => t('resources.external/payments.fields.providerId'), /* Provider ID */
          externalId: () => t('resources.external/payments.fields.externalId'), /* External ID */
          providerType: () => t('resources.external/payments.fields.providerType'), /* Provider type */
          status: () => t('resources.external/payments.fields.status'), /* Status */
          syncUpStatus: () => t('resources.external/payments.fields.syncUpStatus'), /* Sync up status */
          action: () => t('resources.external/payments.fields.action'), /* Action */
        },
        edit: {
          title: () => t('resources.external/payments.edit.title'), /* External Payment details */
        },
        show: {
          details: {
            title: () => t('resources.external/payments.show.details.title'), /* Details */
          },
          jobs: {
            title: () => t('resources.external/payments.show.jobs.title'), /* Jobs */
          },
          invoices: {
            title: () => t('resources.external/payments.show.invoices.title'), /* Invoices */
          },
        },
      },
      'external/items': {
        name: () => t('resources.external/items.name'), /* External Item |||| External Items */
        fields: {
          providerId: () => t('resources.external/items.fields.providerId'), /* Provider ID */
          externalId: () => t('resources.external/items.fields.externalId'), /* External ID */
          providerType: () => t('resources.external/items.fields.providerType'), /* Provider type */
          status: () => t('resources.external/items.fields.status'), /* Status */
          syncUpStatus: () => t('resources.external/items.fields.syncUpStatus'), /* Sync up status */
          action: () => t('resources.external/items.fields.action'), /* Action */
        },
        edit: {
          title: () => t('resources.external/items.edit.title'), /* External item details */
        },
        show: {
          details: {
            title: () => t('resources.external/items.show.details.title'), /* Details */
          },
          jobs: {
            title: () => t('resources.external/items.show.jobs.title'), /* Jobs */
          },
        },
      },
      'external/expenses': {
        name: () => t('resources.external/expenses.name'), /* External Expense |||| External Expenses */
        fields: {
          providerId: () => t('resources.external/expenses.fields.providerId'), /* Provider ID */
          externalId: () => t('resources.external/expenses.fields.externalId'), /* External ID */
          providerType: () => t('resources.external/expenses.fields.providerType'), /* Provider type */
          status: () => t('resources.external/expenses.fields.status'), /* Status */
          syncUpStatus: () => t('resources.external/expenses.fields.syncUpStatus'), /* Sync up status */
          action: () => t('resources.external/expenses.fields.action'), /* Action */
        },
        edit: {
          title: () => t('resources.external/expenses.edit.title'), /* External expense details */
        },
        show: {
          details: {
            title: () => t('resources.external/expenses.show.details.title'), /* Details */
          },
          jobs: {
            title: () => t('resources.external/expenses.show.jobs.title'), /* Jobs */
          },
        },
      },
      noble: {
        name: () => t('resources.noble.name'), /* Noble |||| Noble */
      },
      comments: {
        subscribe: () => t('resources.comments.subscribe'), /* Subscribe */
        unsubscribe: () => t('resources.comments.unsubscribe'), /* Unsubscribe */
        error: () => t('resources.comments.error'), /* Error loading comments data */
      },
      checkout: {
        name: () => t('resources.checkout.name'), /* Checkout |||| Checkouts */
        title: () => t('resources.checkout.title'), /* Checkouts */
        paymentRequest: () => t('resources.checkout.paymentRequest'), /* Payments requests */
        fields: {
          id: () => t('resources.checkout.fields.id'), /* ID */
          buyer: () => t('resources.checkout.fields.buyer'), /* Buyer */
          externalId: () => t('resources.checkout.fields.externalId'), /* External ID */
          amount: () => t('resources.checkout.fields.amount'), /* Amount */
          balance: () => t('resources.checkout.fields.balance'), /* Balance */
          currency: () => t('resources.checkout.fields.currency'), /* Currency */
          expectedInvoiceDate: () => t('resources.checkout.fields.expectedInvoiceDate'), /* Expected Invoice Date */
          lineItems: () => t('resources.checkout.fields.lineItems'), /* Line Items */
          dueDate: () => t('resources.checkout.fields.dueDate'), /* Due Date */
          feeRate: () => t('resources.checkout.fields.feeRate'), /* Fee Rate */
          order: () => t('resources.checkout.fields.order'), /* Order */
          feeAmount: () => t('resources.checkout.fields.feeAmount'), /* Fee Amount */
          status: () => t('resources.checkout.fields.status'), /* Status */
          result: {
            paymentOption: {
              paymentMethod: () => t('resources.checkout.fields.result.paymentOption.paymentMethod'), /* Payment method */
            },
            totalFee: () => t('resources.checkout.fields.result.totalFee'), /* Buyer fees */
            paymentDate: () => t('resources.checkout.fields.result.paymentDate'), /* Payment date */
          },
          mode: () => t('resources.checkout.fields.mode'), /* Mode */
          paymentMethod: () => t('resources.checkout.fields.paymentMethod'), /* Payment method */
          paymentTerm: () => t('resources.checkout.fields.paymentTerm'), /* Payment term */
          paymentDate: () => t('resources.checkout.fields.paymentDate'), /* Payment date */
          paymentTermDays: () => t('resources.checkout.fields.paymentTermDays'), /* Payment term Days */
          reference: () => t('resources.checkout.fields.reference'), /* Reference */
          createdAt: () => t('resources.checkout.fields.createdAt'), /* Created at */
          paymentTermFee: () => t('resources.checkout.fields.paymentTermFee'), /* Payment Term Fee */
          total: () => t('resources.checkout.fields.total'), /* Total */
          updatedAt: () => t('resources.checkout.fields.updatedAt'), /* Updated at */
          discount: {
            percentage: () => t('resources.checkout.fields.discount.percentage'), /* Discount % */
            value: () => t('resources.checkout.fields.discount.value'), /* Discount amount */
            title: () => t('resources.checkout.fields.discount.title'), /* Discount */
          },
          amountPaid: () => t('resources.checkout.fields.amountPaid'), /* Amount Paid */
          shippingFee: () => t('resources.checkout.fields.shippingFee'), /* Shipping Fee */
          tax: {
            percentage: () => t('resources.checkout.fields.tax.percentage'), /* Tax % */
            value: () => t('resources.checkout.fields.tax.value'), /* Tax Amount */
            title: () => t('resources.checkout.fields.tax.title'), /* Tax */
          },
          action: {
            copyLink: () => t('resources.checkout.fields.action.copyLink'), /* Copy link */
            sendReminder: () => t('resources.checkout.fields.action.sendReminder'), /* Send reminder */
            sendReminderTitle: () => t('resources.checkout.fields.action.sendReminderTitle'), /* Send Payment Reminder */
            sendReminderDescription: () => t('resources.checkout.fields.action.sendReminderDescription'), /* Add an optional custom message to include in the reminder email. */
            customMessageLabel: () => t('resources.checkout.fields.action.customMessageLabel'), /* Custom Message */
            customMessagePlaceholder: () => t('resources.checkout.fields.action.customMessagePlaceholder'), /* Enter your custom message here... */
            sendReminderButton: () => t('resources.checkout.fields.action.sendReminderButton'), /* Send Reminder */
            cancelText: () => t('resources.checkout.fields.action.cancelText'), /* Cancel */
            sendSuccess: () => t('resources.checkout.fields.action.sendSuccess'), /* Reminder successfully sent */
            sendError: () => t('resources.checkout.fields.action.sendError'), /* Reminder failed to send */
            cancel: () => t('resources.checkout.fields.action.cancel'), /* Cancel */
          },
          billingAddress: () => t('resources.checkout.fields.billingAddress'), /* Billing address */
          shippingAddress: () => t('resources.checkout.fields.shippingAddress'), /* Shipping address */
          billingShippingSame: () => t('resources.checkout.fields.billingShippingSame'), /* My billing and shipping address are the same */
          metadata: () => t('resources.checkout.fields.metadata'), /* Metadata */
          invoice: () => t('resources.checkout.fields.invoice'), /* Invoice */
          sentByEmail: () => t('resources.checkout.fields.sentByEmail'), /* Sent by email */
          yourFees: () => t('resources.checkout.fields.yourFees'), /* Your fees */
          buyerFees: () => t('resources.checkout.fields.buyerFees'), /* Your fees */
          paidAmount: () => t('resources.checkout.fields.paidAmount'), /* Paid amount */
        },
        show: {
          title: () => t('resources.checkout.show.title'), /* Checkout Identity */
          checkoutLink: () => t('resources.checkout.show.checkoutLink'), /* Checkout Link */
          status: () => t('resources.checkout.show.status'), /* Status */
          tabs: {
            details: () => t('resources.checkout.show.tabs.details'), /* Details */
            payments: () => t('resources.checkout.show.tabs.payments'), /* Payments */
            additionalInformation: () => t('resources.checkout.show.tabs.additionalInformation'), /* Additional information */
            attachments: () => t('resources.checkout.show.tabs.attachments'), /* Attachments */
            ledger: () => t('resources.checkout.show.tabs.ledger'), /* Ledger */
            notifications: () => t('resources.checkout.show.tabs.notifications'), /* Notifications */
          },
          result: {
            orderAmount: () => t('resources.checkout.show.result.orderAmount'), /* Order amount */
            paymentTermFee: () => t('resources.checkout.show.result.paymentTermFee'), /* Payment Term Fee */
            dueDate: () => t('resources.checkout.show.result.dueDate'), /* Due date */
            total: () => t('resources.checkout.show.result.total'), /* Total */
            paymentMethod: () => t('resources.checkout.show.result.paymentMethod'), /* Payment method */
          },
          CopyLinkPanel: {
            paymentReissued: {
              net: {
                title: () => t('resources.checkout.show.CopyLinkPanel.paymentReissued.net.title'), /* Payment request reissued */
                message: () => t('resources.checkout.show.CopyLinkPanel.paymentReissued.net.message'), /* This new payment request was issued due to a failed Pay Later invoice payment. Copy and send this link to the buyer to complete the payment. */
              },
              immediate: {
                title: () => t('resources.checkout.show.CopyLinkPanel.paymentReissued.immediate.title'), /* Payment request reissued */
                message: () => t('resources.checkout.show.CopyLinkPanel.paymentReissued.immediate.message'), /* This new payment request was issued due to a failed payment. Copy and send this link to the buyer to complete the checkout. */
              },
            },
            message: () => t('resources.checkout.show.CopyLinkPanel.message'), /* Copy and send your buyer this link to complete the checkout */
          },
          checkoutFailedPaymentPanel: {
            net: {
              title: (data: Record<'amount', unknown>) => t('resources.checkout.show.checkoutFailedPaymentPanel.net.title', data), /* Buyer's %{amount} payment has failed */
              message: () => t('resources.checkout.show.checkoutFailedPaymentPanel.net.message'), /* The payment for a Pay Later invoice was unsuccessful. We've issued an immediate payment request to the buyer. */
            },
            immediate: {
              title: (data: Record<'amount', unknown>) => t('resources.checkout.show.checkoutFailedPaymentPanel.immediate.title', data), /* Buyer's %{amount} payment has failed */
              message: () => t('resources.checkout.show.checkoutFailedPaymentPanel.immediate.message'), /* We have notified the buyer, and a new payment request has been issued with additional fees. */
              linkText: () => t('resources.checkout.show.checkoutFailedPaymentPanel.immediate.linkText'), /* View new payment request */
            },
          },
          cancelCheckoutButton: {
            title: () => t('resources.checkout.show.cancelCheckoutButton.title'), /* Cancel payment request */
            content: () => t('resources.checkout.show.cancelCheckoutButton.content'), /* Are you sure you want to cancel this payment request? */
            cancelCheckoutText: () => t('resources.checkout.show.cancelCheckoutButton.cancelCheckoutText'), /* Cancel Checkout */
            confirmText: () => t('resources.checkout.show.cancelCheckoutButton.confirmText'), /* Confirm cancellation */
            cancelText: () => t('resources.checkout.show.cancelCheckoutButton.cancelText'), /* Keep it */
          },
          uploadProofOfPaymentButton: {
            label: () => t('resources.checkout.show.uploadProofOfPaymentButton.label'), /* Upload proof of payment */
          },
          actions: {
            filterByPaymentTermLabel: () => t('resources.checkout.show.actions.filterByPaymentTermLabel'), /* Filter by payment term */
            charge: () => t('resources.checkout.show.actions.charge'), /* Charge */
          },
          chargeModal: {
            title: () => t('resources.checkout.show.chargeModal.title'), /* Confirm charge request */
            confirmContent: () => t('resources.checkout.show.chargeModal.confirmContent'), /* Are you sure you want to perform a charge operation? */
            confirmNote: () => t('resources.checkout.show.chargeModal.confirmNote'), /* Note that checkout is not due for today! */
            selectPaymentMethodTitle: () => t('resources.checkout.show.chargeModal.selectPaymentMethodTitle'), /* Select payment method of the buyer */
          },
        },
        edit: {
          title: () => t('resources.checkout.edit.title'), /* Edit checkout */
          checkoutLink: () => t('resources.checkout.edit.checkoutLink'), /* Checkout Link */
          paymentOptions: () => t('resources.checkout.edit.paymentOptions'), /* Payment Options */
          save: () => t('resources.checkout.edit.save'), /* Update checkout */
          addWirePaymentButton: {
            label: () => t('resources.checkout.edit.addWirePaymentButton.label'), /* Add wire payment */
            title: () => t('resources.checkout.edit.addWirePaymentButton.title'), /* Add wire payment */
          },
          addWirePaymentForm: {
            paymentDate: () => t('resources.checkout.edit.addWirePaymentForm.paymentDate'), /* Payment date */
            paymentAmount: () => t('resources.checkout.edit.addWirePaymentForm.paymentAmount'), /* Amount paid */
            note: () => t('resources.checkout.edit.addWirePaymentForm.note'), /* Note */
            save: () => t('resources.checkout.edit.addWirePaymentForm.save'), /* Save */
            saving: () => t('resources.checkout.edit.addWirePaymentForm.saving'), /* Saving */
          },
          confirmPaymentButton: {
            title: () => t('resources.checkout.edit.confirmPaymentButton.title'), /* Confirm Payment */
          },
        },
        create: {
          title: () => t('resources.checkout.create.title'), /* New checkout */
          save: () => t('resources.checkout.create.save'), /* Create checkout */
        },
      },
      'currnecy-exchanges/conversions': {
        name: () => t('resources.currnecy-exchanges/conversions.name'), /* Currnecy Conversion |||| Currnecy Conversions */
        show: {
          restoreButton: () => t('resources.currnecy-exchanges/conversions.show.restoreButton'), /* Restore Conversion */
        },
      },
      'currnecy-exchanges/quotes': {
        name: () => t('resources.currnecy-exchanges/quotes.name'), /* Quote |||| Quotes */
        show: {
          title: () => t('resources.currnecy-exchanges/quotes.show.title'), /* Quote */
        },
      },
      'credit-reviews': {
        name: () => t('resources.credit-reviews.name'), /* Credit reviews */
        tabs: {
          businessVerification: () => t('resources.credit-reviews.tabs.businessVerification'), /* Digital KYB */
          identityVerification: () => t('resources.credit-reviews.tabs.identityVerification'), /* Smart KYC */
          bankAccountActivity: () => t('resources.credit-reviews.tabs.bankAccountActivity'), /* Banking insights */
          creditInsurance: () => t('resources.credit-reviews.tabs.creditInsurance'), /* Insurance */
          creditReferences: () => t('resources.credit-reviews.tabs.creditReferences'), /* Credit references */
          documents: () => t('resources.credit-reviews.tabs.documents'), /* Documents */
          compliance: () => t('resources.credit-reviews.tabs.compliance'), /* Risk and compliance */
          comments: () => t('resources.credit-reviews.tabs.comments'), /* Comments */
          financialStatement: () => t('resources.credit-reviews.tabs.financialStatement'), /* Financial Statement */
          personalGuarantee: () => t('resources.credit-reviews.tabs.personalGuarantee'), /* Personal guarantee */
        },
        fields: {
          buyer: () => t('resources.credit-reviews.fields.buyer'), /* Buyer */
          creditLimit: () => t('resources.credit-reviews.fields.creditLimit'), /* Credit limit */
          creditStatus: () => t('resources.credit-reviews.fields.creditStatus'), /* Credit status */
          riskScore: () => t('resources.credit-reviews.fields.riskScore'), /* Risk score */
          createdAt: () => t('resources.credit-reviews.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.credit-reviews.fields.updatedAt'), /* Updated at */
          createdBy: () => t('resources.credit-reviews.fields.createdBy'), /* Created by */
        },
        header: {
          refreshButton: () => t('resources.credit-reviews.header.refreshButton'), /* Refresh */
          approveButton: () => t('resources.credit-reviews.header.approveButton'), /* Approve */
          declineButton: () => t('resources.credit-reviews.header.declineButton'), /* Decline */
          holdButton: () => t('resources.credit-reviews.header.holdButton'), /* Hold credit */
          cancelButton: () => t('resources.credit-reviews.header.cancelButton'), /* Cancel */
          approveModal: {
            title: () => t('resources.credit-reviews.header.approveModal.title'), /* Approve credit line */
            subtitle: () => t('resources.credit-reviews.header.approveModal.subtitle'), /* Set a credit limit for your buyer and issue invoices with net terms. */
            approveButton: () => t('resources.credit-reviews.header.approveModal.approveButton'), /* Approve credit line */
          },
          declineModal: {
            title: () => t('resources.credit-reviews.header.declineModal.title'), /* Decline credit line */
            subtitle: () => t('resources.credit-reviews.header.declineModal.subtitle'), /* Credit line will be declined for this buyer. You can revert this decision in the future. */
            buyerCompany: () => t('resources.credit-reviews.header.declineModal.buyerCompany'), /* Buyer company */
            reasonForDecline: () => t('resources.credit-reviews.header.declineModal.reasonForDecline'), /* Reason for decline */
            declineButton: () => t('resources.credit-reviews.header.declineModal.declineButton'), /* Decline credit line */
          },
          holdModal: {
            title: () => t('resources.credit-reviews.header.holdModal.title'), /* Are you sure you want to put this buyer credit line on hold? */
            subtitle: () => t('resources.credit-reviews.header.holdModal.subtitle'), /* You can add a new credit line in the future if needed. */
            holdButton: () => t('resources.credit-reviews.header.holdModal.holdButton'), /* Confirm */
            keepButton: () => t('resources.credit-reviews.header.holdModal.keepButton'), /* Keep credit line */
            cancelButton: () => t('resources.credit-reviews.header.holdModal.cancelButton'), /* Cancel */
            error: () => t('resources.credit-reviews.header.holdModal.error'), /* Failed to hold credit line */
          },
          cancelModal: {
            title: () => t('resources.credit-reviews.header.cancelModal.title'), /* Are you sure you want to cancel this buyer's credit line? */
            subtitle: () => t('resources.credit-reviews.header.cancelModal.subtitle'), /* You can add a new credit line in the future if needed. */
            cancelButton: () => t('resources.credit-reviews.header.cancelModal.cancelButton'), /* Confirm */
            keepButton: () => t('resources.credit-reviews.header.cancelModal.keepButton'), /* Keep credit line */
            error: () => t('resources.credit-reviews.header.cancelModal.error'), /* Failed to cancel credit line */
          },
        },
        financialStatement: {
          noFinancialStatement: () => t('resources.credit-reviews.financialStatement.noFinancialStatement'), /* No financial statement found */
          title: (data: Record<'yearEndDate', unknown>) => t('resources.credit-reviews.financialStatement.title', data), /* Valid for %{yearEndDate} */
          loading: () => t('resources.credit-reviews.financialStatement.loading'), /* Loading financial statement */
          fieldHeader: () => t('resources.credit-reviews.financialStatement.fieldHeader'), /* Field */
          valueHeader: () => t('resources.credit-reviews.financialStatement.valueHeader'), /* Value */
          sections: {
            profitAndLoss: () => t('resources.credit-reviews.financialStatement.sections.profitAndLoss'), /* Profit and Loss */
            balanceSheet: () => t('resources.credit-reviews.financialStatement.sections.balanceSheet'), /* Balance Sheet */
            otherFinancials: () => t('resources.credit-reviews.financialStatement.sections.otherFinancials'), /* Other Financials */
            ratios: () => t('resources.credit-reviews.financialStatement.sections.ratios'), /* Ratios */
          },
          fields: {
            revenue: () => t('resources.credit-reviews.financialStatement.fields.revenue'), /* Revenue */
            operatingCosts: () => t('resources.credit-reviews.financialStatement.fields.operatingCosts'), /* Operating Costs */
            operatingProfit: () => t('resources.credit-reviews.financialStatement.fields.operatingProfit'), /* Operating Profit */
            wagesAndSalaries: () => t('resources.credit-reviews.financialStatement.fields.wagesAndSalaries'), /* Wages and Salaries */
            pensionCosts: () => t('resources.credit-reviews.financialStatement.fields.pensionCosts'), /* Pension Costs */
            depreciation: () => t('resources.credit-reviews.financialStatement.fields.depreciation'), /* Depreciation */
            amortisation: () => t('resources.credit-reviews.financialStatement.fields.amortisation'), /* Amortisation */
            financialIncome: () => t('resources.credit-reviews.financialStatement.fields.financialIncome'), /* Financial Income */
            financialExpenses: () => t('resources.credit-reviews.financialStatement.fields.financialExpenses'), /* Financial Expenses */
            extraordinaryIncome: () => t('resources.credit-reviews.financialStatement.fields.extraordinaryIncome'), /* Extraordinary Income */
            extraordinaryCosts: () => t('resources.credit-reviews.financialStatement.fields.extraordinaryCosts'), /* Extraordinary Costs */
            profitBeforeTax: () => t('resources.credit-reviews.financialStatement.fields.profitBeforeTax'), /* Profit Before Tax */
            tax: () => t('resources.credit-reviews.financialStatement.fields.tax'), /* Tax */
            profitAfterTax: () => t('resources.credit-reviews.financialStatement.fields.profitAfterTax'), /* Profit After Tax */
            dividends: () => t('resources.credit-reviews.financialStatement.fields.dividends'), /* Dividends */
            minorityInterests: () => t('resources.credit-reviews.financialStatement.fields.minorityInterests'), /* Minority Interests */
            otherAppropriations: () => t('resources.credit-reviews.financialStatement.fields.otherAppropriations'), /* Other Appropriations */
            retainedProfit: () => t('resources.credit-reviews.financialStatement.fields.retainedProfit'), /* Retained Profit */
            landAndBuildings: () => t('resources.credit-reviews.financialStatement.fields.landAndBuildings'), /* Land and Buildings */
            plantAndMachinery: () => t('resources.credit-reviews.financialStatement.fields.plantAndMachinery'), /* Plant and Machinery */
            otherTangibleAssets: () => t('resources.credit-reviews.financialStatement.fields.otherTangibleAssets'), /* Other Tangible Assets */
            totalTangibleAssets: () => t('resources.credit-reviews.financialStatement.fields.totalTangibleAssets'), /* Total Tangible Assets */
            goodwill: () => t('resources.credit-reviews.financialStatement.fields.goodwill'), /* Goodwill */
            otherIntangibleAssets: () => t('resources.credit-reviews.financialStatement.fields.otherIntangibleAssets'), /* Other Intangible Assets */
            totalIntangibleAssets: () => t('resources.credit-reviews.financialStatement.fields.totalIntangibleAssets'), /* Total Intangible Assets */
            investments: () => t('resources.credit-reviews.financialStatement.fields.investments'), /* Investments */
            loansToGroup: () => t('resources.credit-reviews.financialStatement.fields.loansToGroup'), /* Loans to Group */
            otherLoans: () => t('resources.credit-reviews.financialStatement.fields.otherLoans'), /* Other Loans */
            miscellaneousFixedAssets: () => t('resources.credit-reviews.financialStatement.fields.miscellaneousFixedAssets'), /* Miscellaneous Fixed Assets */
            totalOtherFixedAssets: () => t('resources.credit-reviews.financialStatement.fields.totalOtherFixedAssets'), /* Total Other Fixed Assets */
            totalFixedAssets: () => t('resources.credit-reviews.financialStatement.fields.totalFixedAssets'), /* Total Fixed Assets */
            rawMaterials: () => t('resources.credit-reviews.financialStatement.fields.rawMaterials'), /* Raw Materials */
            workInProgress: () => t('resources.credit-reviews.financialStatement.fields.workInProgress'), /* Work in Progress */
            finishedGoods: () => t('resources.credit-reviews.financialStatement.fields.finishedGoods'), /* Finished Goods */
            otherInventories: () => t('resources.credit-reviews.financialStatement.fields.otherInventories'), /* Other Inventories */
            totalInventories: () => t('resources.credit-reviews.financialStatement.fields.totalInventories'), /* Total Inventories */
            tradeReceivables: () => t('resources.credit-reviews.financialStatement.fields.tradeReceivables'), /* Trade Receivables */
            groupReceivables: () => t('resources.credit-reviews.financialStatement.fields.groupReceivables'), /* Group Receivables */
            receivablesDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.receivablesDueAfter1Year'), /* Receivables Due After 1 Year */
            miscellaneousReceivables: () => t('resources.credit-reviews.financialStatement.fields.miscellaneousReceivables'), /* Miscellaneous Receivables */
            totalReceivables: () => t('resources.credit-reviews.financialStatement.fields.totalReceivables'), /* Total Receivables */
            cash: () => t('resources.credit-reviews.financialStatement.fields.cash'), /* Cash */
            otherCurrentAssets: () => t('resources.credit-reviews.financialStatement.fields.otherCurrentAssets'), /* Other Current Assets */
            totalCurrentAssets: () => t('resources.credit-reviews.financialStatement.fields.totalCurrentAssets'), /* Total Current Assets */
            totalAssets: () => t('resources.credit-reviews.financialStatement.fields.totalAssets'), /* Total Assets */
            tradePayables: () => t('resources.credit-reviews.financialStatement.fields.tradePayables'), /* Trade Payables */
            bankLiabilities: () => t('resources.credit-reviews.financialStatement.fields.bankLiabilities'), /* Bank Liabilities */
            otherLoansOrFinance: () => t('resources.credit-reviews.financialStatement.fields.otherLoansOrFinance'), /* Other Loans or Finance */
            groupPayables: () => t('resources.credit-reviews.financialStatement.fields.groupPayables'), /* Group Payables */
            miscellaneousLiabilities: () => t('resources.credit-reviews.financialStatement.fields.miscellaneousLiabilities'), /* Miscellaneous Liabilities */
            totalCurrentLiabilities: () => t('resources.credit-reviews.financialStatement.fields.totalCurrentLiabilities'), /* Total Current Liabilities */
            tradePayablesDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.tradePayablesDueAfter1Year'), /* Trade Payables Due After 1 Year */
            bankLiabilitiesDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.bankLiabilitiesDueAfter1Year'), /* Bank Liabilities Due After 1 Year */
            otherLoansOrFinanceDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.otherLoansOrFinanceDueAfter1Year'), /* Other Loans or Finance Due After 1 Year */
            groupPayablesDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.groupPayablesDueAfter1Year'), /* Group Payables Due After 1 Year */
            miscellaneousLiabilitiesDueAfter1Year: () => t('resources.credit-reviews.financialStatement.fields.miscellaneousLiabilitiesDueAfter1Year'), /* Miscellaneous Liabilities Due After 1 Year */
            totalLongTermLiabilities: () => t('resources.credit-reviews.financialStatement.fields.totalLongTermLiabilities'), /* Total Long Term Liabilities */
            totalLiabilities: () => t('resources.credit-reviews.financialStatement.fields.totalLiabilities'), /* Total Liabilities */
            calledUpShareCapital: () => t('resources.credit-reviews.financialStatement.fields.calledUpShareCapital'), /* Called Up Share Capital */
            sharePremium: () => t('resources.credit-reviews.financialStatement.fields.sharePremium'), /* Share Premium */
            revenueReserves: () => t('resources.credit-reviews.financialStatement.fields.revenueReserves'), /* Revenue Reserves */
            otherReserves: () => t('resources.credit-reviews.financialStatement.fields.otherReserves'), /* Other Reserves */
            totalShareholdersEquity: () => t('resources.credit-reviews.financialStatement.fields.totalShareholdersEquity'), /* Total Shareholders Equity */
            contingentLiabilities: () => t('resources.credit-reviews.financialStatement.fields.contingentLiabilities'), /* Contingent Liabilities */
            workingCapital: () => t('resources.credit-reviews.financialStatement.fields.workingCapital'), /* Working Capital */
            netWorth: () => t('resources.credit-reviews.financialStatement.fields.netWorth'), /* Net Worth */
            preTaxProfitMargin: () => t('resources.credit-reviews.financialStatement.fields.preTaxProfitMargin'), /* Pre Tax Profit Margin */
            returnOnCapitalEmployed: () => t('resources.credit-reviews.financialStatement.fields.returnOnCapitalEmployed'), /* Return on Capital Employed */
            returnOnTotalAssetsEmployed: () => t('resources.credit-reviews.financialStatement.fields.returnOnTotalAssetsEmployed'), /* Return on Total Assets Employed */
            returnOnNetAssetsEmployed: () => t('resources.credit-reviews.financialStatement.fields.returnOnNetAssetsEmployed'), /* Return on Net Assets Employed */
            salesOrNetWorkingCapital: () => t('resources.credit-reviews.financialStatement.fields.salesOrNetWorkingCapital'), /* Sales or Net Working Capital */
            stockTurnoverRatio: () => t('resources.credit-reviews.financialStatement.fields.stockTurnoverRatio'), /* Stock Turnover Ratio */
            debtorDays: () => t('resources.credit-reviews.financialStatement.fields.debtorDays'), /* Debtor Days */
            creditorDays: () => t('resources.credit-reviews.financialStatement.fields.creditorDays'), /* Creditor Days */
            currentRatio: () => t('resources.credit-reviews.financialStatement.fields.currentRatio'), /* Current Ratio */
            liquidityRatioOrAcidTest: () => t('resources.credit-reviews.financialStatement.fields.liquidityRatioOrAcidTest'), /* Liquidity Ratio or Acid Test */
            currentDebtRatio: () => t('resources.credit-reviews.financialStatement.fields.currentDebtRatio'), /* Current Debt Ratio */
            gearing: () => t('resources.credit-reviews.financialStatement.fields.gearing'), /* Gearing */
            equityInPercentage: () => t('resources.credit-reviews.financialStatement.fields.equityInPercentage'), /* Equity in Percentage */
            totalDebtRatio: () => t('resources.credit-reviews.financialStatement.fields.totalDebtRatio'), /* Total Debt Ratio */
          },
          empty: {
            title: () => t('resources.credit-reviews.financialStatement.empty.title'), /* No bank account connected yet */
            subtitle: () => t('resources.credit-reviews.financialStatement.empty.subtitle'), /* Ask your buyer to connect their account to access real-time insights */
          },
        },
        creditInsurance: {
          title: () => t('resources.credit-reviews.creditInsurance.title'), /* Credit insurance */
        },
        creditBox: {
          creditLine: {
            title: () => t('resources.credit-reviews.creditBox.creditLine.title'), /* Credit Line summary */
            availableCredit: () => t('resources.credit-reviews.creditBox.creditLine.availableCredit'), /* Available credit */
            creditLimit: () => t('resources.credit-reviews.creditBox.creditLine.creditLimit'), /* Credit Limit */
            creditStatus: () => t('resources.credit-reviews.creditBox.creditLine.creditStatus'), /* Credit status */
            approvedOn: () => t('resources.credit-reviews.creditBox.creditLine.approvedOn'), /* Approved on */
            percentageOfTotal: (data: Record<'value', unknown>) => t('resources.credit-reviews.creditBox.creditLine.percentageOfTotal', data), /* %{value}% of total */
            creditLineWasDeclined: () => t('resources.credit-reviews.creditBox.creditLine.creditLineWasDeclined'), /* Credit Line was declined */
            declinedOn: () => t('resources.credit-reviews.creditBox.creditLine.declinedOn'), /* Declined on */
            approvedBy: () => t('resources.credit-reviews.creditBox.creditLine.approvedBy'), /* Approved by */
            decisionBy: () => t('resources.credit-reviews.creditBox.creditLine.decisionBy'), /* Decision by */
          },
          creditRequest: {
            title: () => t('resources.credit-reviews.creditBox.creditRequest.title'), /* Credit Request */
            requestedAmount: () => t('resources.credit-reviews.creditBox.creditRequest.requestedAmount'), /* Requested amount */
            requestedAt: () => t('resources.credit-reviews.creditBox.creditRequest.requestedAt'), /* Requested at */
            requestedBy: () => t('resources.credit-reviews.creditBox.creditRequest.requestedBy'), /* Requested by */
          },
        },
        creditReferences: {
          title: () => t('resources.credit-reviews.creditReferences.title'), /* Credit references */
          requestCreditReferences: () => t('resources.credit-reviews.creditReferences.requestCreditReferences'), /* Request credit references */
          requestTitle: () => t('resources.credit-reviews.creditReferences.requestTitle'), /* Request credit references */
          subtitle: () => t('resources.credit-reviews.creditReferences.subtitle'), /* Request credit references from your buyer */
          requestViaEmailText: () => t('resources.credit-reviews.creditReferences.requestViaEmailText'), /* Request via email */
          dividerText: () => t('resources.credit-reviews.creditReferences.dividerText'), /* Or */
          copyLinkText: () => t('resources.credit-reviews.creditReferences.copyLinkText'), /* Copy link */
          shareLinkText: () => t('resources.credit-reviews.creditReferences.shareLinkText'), /* Share link */
          noReferences: {
            askYourBuyer: () => t('resources.credit-reviews.creditReferences.noReferences.askYourBuyer'), /* Ask your buyer to add credit references */
            sendRequest: () => t('resources.credit-reviews.creditReferences.noReferences.sendRequest'), /* Send request */
          },
        },
        identityVerification: {
          title: () => t('resources.credit-reviews.identityVerification.title'), /* Identity Verification */
          inProgress: {
            title: (data: Record<'buyerName', unknown>) => t('resources.credit-reviews.identityVerification.inProgress.title', data), /* An email was sent to Eco %{buyerName} asking for their identity verification */
            subtitle: () => t('resources.credit-reviews.identityVerification.inProgress.subtitle'), /* You can also share this link for them to complete: */
            copyLink: () => t('resources.credit-reviews.identityVerification.inProgress.copyLink'), /* Copy link */
          },
          noIdentityVerification: {
            title: () => t('resources.credit-reviews.identityVerification.noIdentityVerification.title'), /* Ask your buyer to verify their identity */
            subtitle: () => t('resources.credit-reviews.identityVerification.noIdentityVerification.subtitle'), /* Require your buyer to confirm their identity with a valid photo ID and a selfie to make sure it's them. */
          },
          verified: {
            title: () => t('resources.credit-reviews.identityVerification.verified.title'), /* Identity Verification */
            document: {
              title: () => t('resources.credit-reviews.identityVerification.verified.document.title'), /* Document */
              address: () => t('resources.credit-reviews.identityVerification.verified.document.address'), /* Address */
              dob: () => t('resources.credit-reviews.identityVerification.verified.document.dob'), /* Date of birth */
              expirationDate: () => t('resources.credit-reviews.identityVerification.verified.document.expirationDate'), /* Expiration date */
              firstName: () => t('resources.credit-reviews.identityVerification.verified.document.firstName'), /* First name */
              lastName: () => t('resources.credit-reviews.identityVerification.verified.document.lastName'), /* Last name */
              fullName: () => t('resources.credit-reviews.identityVerification.verified.document.fullName'), /* Full name */
              issuedDate: () => t('resources.credit-reviews.identityVerification.verified.document.issuedDate'), /* Issued date */
              issuingCountry: () => t('resources.credit-reviews.identityVerification.verified.document.issuingCountry'), /* Issuing country */
              number: () => t('resources.credit-reviews.identityVerification.verified.document.number'), /* Number */
              type: () => t('resources.credit-reviews.identityVerification.verified.document.type'), /* Type */
            },
            idNumber: {
              title: () => t('resources.credit-reviews.identityVerification.verified.idNumber.title'), /* ID Number */
              dob: () => t('resources.credit-reviews.identityVerification.verified.idNumber.dob'), /* Date of birth */
              firstName: () => t('resources.credit-reviews.identityVerification.verified.idNumber.firstName'), /* First name */
              idNumber: () => t('resources.credit-reviews.identityVerification.verified.idNumber.idNumber'), /* ID number */
              type: () => t('resources.credit-reviews.identityVerification.verified.idNumber.type'), /* Type */
              lastName: () => t('resources.credit-reviews.identityVerification.verified.idNumber.lastName'), /* Last name */
              status: () => t('resources.credit-reviews.identityVerification.verified.idNumber.status'), /* Status */
              fullName: () => t('resources.credit-reviews.identityVerification.verified.idNumber.fullName'), /* Full name */
            },
          },
        },
        experian: {
          noMatch: () => t('resources.credit-reviews.experian.noMatch'), /* No match */
          experianLabel: () => t('resources.credit-reviews.experian.experianLabel'), /* Experian */
          experianDataCreationDate: () => t('resources.credit-reviews.experian.experianDataCreationDate'), /* Data creation date */
          experianScore: () => t('resources.credit-reviews.experian.experianScore'), /* Score */
          experianReport: () => t('resources.credit-reviews.experian.experianReport'), /* Experian report */
          personalCreditScore: () => t('resources.credit-reviews.experian.personalCreditScore'), /* Personal credit score */
          lastRefreshedOn: () => t('resources.credit-reviews.experian.lastRefreshedOn'), /* Last refreshed on */
        },
        personalGuarantee: {
          title: () => t('resources.credit-reviews.personalGuarantee.title'), /* Personal guarantee */
          loading: () => t('resources.credit-reviews.personalGuarantee.loading'), /* Loading personal guarantee */
          empty: {
            title: () => t('resources.credit-reviews.personalGuarantee.empty.title'), /* No personal guarantee provided yet */
            subtitle: () => t('resources.credit-reviews.personalGuarantee.empty.subtitle'), /* Ask your buyer to sign a personal guarantee to increase payment security */
          },
        },
        financialConnections: {
          title: () => t('resources.credit-reviews.financialConnections.title'), /* Bank account connections */
          loading: () => t('resources.credit-reviews.financialConnections.loading'), /* Loading bank account connections */
          empty: {
            title: () => t('resources.credit-reviews.financialConnections.empty.title'), /* No bank account connected yet */
            subtitle: () => t('resources.credit-reviews.financialConnections.empty.subtitle'), /* Ask your buyer to upload financial documents to better understand their financial health */
          },
        },
        compliance: {
          amlInfo: {
            title: () => t('resources.credit-reviews.compliance.amlInfo.title'), /* AML info */
            amlInfo: () => t('resources.credit-reviews.compliance.amlInfo.amlInfo'), /* AML info */
          },
          complianceAlerts: {
            title: () => t('resources.credit-reviews.compliance.complianceAlerts.title'), /* Compliance alerts */
          },
        },
        documents: {
          title: () => t('resources.credit-reviews.documents.title'), /* Documents */
          empty: {
            title: () => t('resources.credit-reviews.documents.empty.title'), /* No financial documents uploaded yet */
            subtitle: () => t('resources.credit-reviews.documents.empty.subtitle'), /* Ask your buyer to upload financial documents to better understand their financial health */
          },
        },
        businessVerification: {
          title: () => t('resources.credit-reviews.businessVerification.title'), /* Business verification */
          verifiedBusinessDetails: {
            title: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.title'), /* Verified Business Details */
            legalName: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.legalName'), /* Legal name */
            businessStartDate: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.businessStartDate'), /* Business start date */
            addresses: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.addresses'), /* Addresses */
            tin: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.tin'), /* Tax ID */
            website: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.website'), /* Website */
            lastVerificationExecutionDate: () => t('resources.credit-reviews.businessVerification.verifiedBusinessDetails.lastVerificationExecutionDate'), /* Last verification execution date */
          },
          registrationRecords: {
            title: () => t('resources.credit-reviews.businessVerification.registrationRecords.title'), /* Registration records */
            registrationRecords: () => t('resources.credit-reviews.businessVerification.registrationRecords.registrationRecords'), /* Registration records */
          },
          relatedCompanies: {
            title: () => t('resources.credit-reviews.businessVerification.relatedCompanies.title'), /* Related companies */
            relatedCompanies: () => t('resources.credit-reviews.businessVerification.relatedCompanies.relatedCompanies'), /* Related companies */
          },
          relatedPersons: {
            title: () => t('resources.credit-reviews.businessVerification.relatedPersons.title'), /* Related persons */
            relatedPersons: () => t('resources.credit-reviews.businessVerification.relatedPersons.relatedPersons'), /* Related persons */
          },
          businessScope: {
            title: () => t('resources.credit-reviews.businessVerification.businessScope.title'), /* Business scope */
            businessScope: () => t('resources.credit-reviews.businessVerification.businessScope.businessScope'), /* Business scope */
            noBusinessScope: () => t('resources.credit-reviews.businessVerification.businessScope.noBusinessScope'), /* No business scope information found */
          },
        },
      },
      'buyers/credit-reviews': {
        name: () => t('resources.buyers/credit-reviews.name'), /* Credit management */
        manageBuyerCreditButton: {
          label: () => t('resources.buyers/credit-reviews.manageBuyerCreditButton.label'), /* Manage buyer credit */
        },
        fullReportRequestButton: {
          label: () => t('resources.buyers/credit-reviews.fullReportRequestButton.label'), /* Get full report */
        },
        pendingReportAlert: {
          title: () => t('resources.buyers/credit-reviews.pendingReportAlert.title'), /* Your report is currently being built, get back in a few minutes */
          subtitle: () => t('resources.buyers/credit-reviews.pendingReportAlert.subtitle'), /* An email notification will be sent when the report is ready for review */
        },
        enhancedReportLimitReachedDialog: {
          title: () => t('resources.buyers/credit-reviews.enhancedReportLimitReachedDialog.title'), /* Reports quote Limit Reached */
          subtitle: (data: Record<'limit' | 'brandName', unknown>) => t('resources.buyers/credit-reviews.enhancedReportLimitReachedDialog.subtitle', data), /* The requested report could not be generated because the quote limit of %{limit} quotes has been exceeded. To resolve this issue or request a higher limit, please reach out to %{brandName} support for assistance. */
        },
        enhancedReportQuoteDialog: {
          title: () => t('resources.buyers/credit-reviews.enhancedReportQuoteDialog.title'), /* Get reports quote */
          subtitle: () => t('resources.buyers/credit-reviews.enhancedReportQuoteDialog.subtitle'), /* Our sales team will contact you shortly to discuss your needs and provide a quote. */
        },
        reports: {
          riskScore: {
            title: () => t('resources.buyers/credit-reviews.reports.riskScore.title'), /* Risk score */
            tooltip: () => t('resources.buyers/credit-reviews.reports.riskScore.tooltip'), /* Measures a company's 12‑month failure risk based on its history, legal issues, ownership, age, and industry. */
            notScored: () => t('resources.buyers/credit-reviews.reports.riskScore.notScored'), /* Not scored */
            veryLowRiskScore: () => t('resources.buyers/credit-reviews.reports.riskScore.veryLowRiskScore'), /* Very Low Risk Score */
            lowRiskScore: () => t('resources.buyers/credit-reviews.reports.riskScore.lowRiskScore'), /* Low Risk Score */
            moderateRiskScore: () => t('resources.buyers/credit-reviews.reports.riskScore.moderateRiskScore'), /* Moderate Risk Score */
            highRiskScore: () => t('resources.buyers/credit-reviews.reports.riskScore.highRiskScore'), /* High Risk Score */
            veryHighRiskScore: () => t('resources.buyers/credit-reviews.reports.riskScore.veryHighRiskScore'), /* Very High Risk Score */
            getFullReport: () => t('resources.buyers/credit-reviews.reports.riskScore.getFullReport'), /* Get enhanced report */
            ranges: {
              veryLow: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.veryLow'), /* 71 to 100 */
              low: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.low'), /* 51 to 70 */
              moderate: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.moderate'), /* 30 to 50 */
              high: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.high'), /* 21 to 29 */
              veryHigh: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.veryHigh'), /* 1 to 20 */
              notScored: () => t('resources.buyers/credit-reviews.reports.riskScore.ranges.notScored'), /* - */
            },
            dialogTitle: () => t('resources.buyers/credit-reviews.reports.riskScore.dialogTitle'), /* Risk score details */
          },
          internationalScore: {
            title: () => t('resources.buyers/credit-reviews.reports.internationalScore.title'), /* International score */
            tooltip: () => t('resources.buyers/credit-reviews.reports.internationalScore.tooltip'), /* Worldwide measure of 12‑month failure risk, blending local history, legal records, and structure into one comparable global score. */
            A: () => t('resources.buyers/credit-reviews.reports.internationalScore.A'), /* Very Low Risk Score */
            B: () => t('resources.buyers/credit-reviews.reports.internationalScore.B'), /* Low Risk Score */
            C: () => t('resources.buyers/credit-reviews.reports.internationalScore.C'), /* Moderate Risk Score */
            D: () => t('resources.buyers/credit-reviews.reports.internationalScore.D'), /* High Risk Score */
            E: () => t('resources.buyers/credit-reviews.reports.internationalScore.E'), /* Very High Risk Score */
            getFullReport: () => t('resources.buyers/credit-reviews.reports.internationalScore.getFullReport'), /* Get enhanced report */
            descriptions: {
              A: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.A'), /* Very good credit worthiness */
              B: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.B'), /* Good credit worthiness */
              C: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.C'), /* Credit worthy */
              D: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.D'), /* Caution - Credit at your discretion */
              E: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.E'), /* Not scored */
              BankruptcyProceedingsFiled: () => t('resources.buyers/credit-reviews.reports.internationalScore.descriptions.BankruptcyProceedingsFiled'), /* Bankruptcy proceedings filed */
            },
            dialogTitle: () => t('resources.buyers/credit-reviews.reports.internationalScore.dialogTitle'), /* International score details */
          },
          complianceAlerts: {
            title: () => t('resources.buyers/credit-reviews.reports.complianceAlerts.title'), /* Risk and compliance alerts */
            tooltip: () => t('resources.buyers/credit-reviews.reports.complianceAlerts.tooltip'), /* Flags key legal and compliance risks, from lawsuits and bankruptcies to AML and OFAC sanctions */
          },
          dbt: {
            title: () => t('resources.buyers/credit-reviews.reports.dbt.title'), /* Days beyond terms */
          },
          paymentTrend: {
            title: () => t('resources.buyers/credit-reviews.reports.paymentTrend.title'), /* Payment trend */
            small: () => t('resources.buyers/credit-reviews.reports.paymentTrend.small'), /* small */
            medium: () => t('resources.buyers/credit-reviews.reports.paymentTrend.medium'), /* medium */
            large: () => t('resources.buyers/credit-reviews.reports.paymentTrend.large'), /* large */
          },
          paymentExperiences: {
            title: () => t('resources.buyers/credit-reviews.reports.paymentExperiences.title'), /* Payment experiences */
          },
          paidOnTime: {
            title: () => t('resources.buyers/credit-reviews.reports.paidOnTime.title'), /* Paid on time */
          },
          paidOnTimePercentage: {
            title: () => t('resources.buyers/credit-reviews.reports.paidOnTimePercentage.title'), /* % Paid on time */
          },
          inquiriesTrend: {
            title: () => t('resources.buyers/credit-reviews.reports.inquiriesTrend.title'), /* Inquiries trend */
            small: () => t('resources.buyers/credit-reviews.reports.inquiriesTrend.small'), /* small */
            medium: () => t('resources.buyers/credit-reviews.reports.inquiriesTrend.medium'), /* medium */
            large: () => t('resources.buyers/credit-reviews.reports.inquiriesTrend.large'), /* large */
          },
          creditLimit: {
            title: () => t('resources.buyers/credit-reviews.reports.creditLimit.title'), /* Recommended credit limit */
          },
        },
        aiSummary: {
          title: () => t('resources.buyers/credit-reviews.aiSummary.title'), /* AI insights */
          summary: () => t('resources.buyers/credit-reviews.aiSummary.summary'), /* AI summary */
        },
        CreditManagementFullReportRequestButton: {
          buttonLabel: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.buttonLabel'), /* Get enhanced report */
          alertTitle: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.alertTitle'), /* Need clarity? Companies that unlock enhanced reports reduce their risk by 70% */
          modal: {
            buttonLabel: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.buttonLabel'), /* Get enhanced report */
            cancelButton: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.cancelButton'), /* Cancel */
            title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.title'), /* Get full report for $20 USD */
            subtitle: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.subtitle'), /* With a full credit review you can get deep understanding of your buyer company, such as: */
            tabs: {
              creditScore: {
                title: (data: Record<'brandName', unknown>) => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.creditScore.title', data), /* %{brandName} credit score */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.creditScore.description'), /* AI powered insights, risk score, international score and recommended credit limit */
              },
              businessVerification: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.businessVerification.title'), /* Digital KYB - Know Your Business */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.businessVerification.description'), /* Ownership, related companies, shareholders, business scope and more */
              },
              identityVerification: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.identityVerification.title'), /* Smart KYC - Know Your Customer */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.identityVerification.description'), /* Verify your customer identity using AI  */
              },
              riskAlerts: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.riskAlerts.title'), /* Risk alerts */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.riskAlerts.description'), /* Check for company red flags, like law suits, bankruptcy and more  */
              },
              compliance: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.compliance.title'), /* Compliance verification */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.compliance.description'), /* Check for AML and OFAC */
              },
              bankAccountActivity: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.bankAccountActivity.title'), /* Banking insights */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.bankAccountActivity.description'), /* Digital analysis of company banking, powered by AI */
              },
              financialStatement: {
                title: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.financialStatement.title'), /* Financial statement */
                description: () => t('resources.buyers/credit-reviews.CreditManagementFullReportRequestButton.modal.tabs.financialStatement.description'), /* Pull recent financial statements */
              },
            },
          },
        },
        tabs: {
          businessVerification: () => t('resources.buyers/credit-reviews.tabs.businessVerification'), /* Digital KYB */
          identityVerification: () => t('resources.buyers/credit-reviews.tabs.identityVerification'), /* Smart KYC */
          bankAccountActivity: () => t('resources.buyers/credit-reviews.tabs.bankAccountActivity'), /* Banking insights */
          creditInsurance: () => t('resources.buyers/credit-reviews.tabs.creditInsurance'), /* Insurance */
          creditReferences: () => t('resources.buyers/credit-reviews.tabs.creditReferences'), /* Credit references */
          documents: () => t('resources.buyers/credit-reviews.tabs.documents'), /* Documents */
          compliance: () => t('resources.buyers/credit-reviews.tabs.compliance'), /* Risk and compliance */
          comments: () => t('resources.buyers/credit-reviews.tabs.comments'), /* Comments */
          financialStatement: () => t('resources.buyers/credit-reviews.tabs.financialStatement'), /* Financial Statement */
          personalGuarantee: () => t('resources.buyers/credit-reviews.tabs.personalGuarantee'), /* Personal guarantee */
          smartMonitoring: () => t('resources.buyers/credit-reviews.tabs.smartMonitoring'), /* Smart monitoring */
        },
        fields: {
          buyer: () => t('resources.buyers/credit-reviews.fields.buyer'), /* Buyer */
          creditLimit: () => t('resources.buyers/credit-reviews.fields.creditLimit'), /* Credit limit */
          creditStatus: () => t('resources.buyers/credit-reviews.fields.creditStatus'), /* Credit status */
          reportType: () => t('resources.buyers/credit-reviews.fields.reportType'), /* Report type */
          riskScore: () => t('resources.buyers/credit-reviews.fields.riskScore'), /* Risk score */
          createdAt: () => t('resources.buyers/credit-reviews.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.buyers/credit-reviews.fields.updatedAt'), /* Updated at */
          createdBy: () => t('resources.buyers/credit-reviews.fields.createdBy'), /* Created by */
        },
        header: {
          refreshButton: () => t('resources.buyers/credit-reviews.header.refreshButton'), /* Refresh */
          approveButton: () => t('resources.buyers/credit-reviews.header.approveButton'), /* Approve */
          declineButton: () => t('resources.buyers/credit-reviews.header.declineButton'), /* Decline */
          approveModal: {
            title: () => t('resources.buyers/credit-reviews.header.approveModal.title'), /* Approve credit line */
            subtitle: () => t('resources.buyers/credit-reviews.header.approveModal.subtitle'), /* Set a credit limit for your buyer and issue invoices with net terms. */
            approveButton: () => t('resources.buyers/credit-reviews.header.approveModal.approveButton'), /* Approve credit line */
          },
          declineModal: {
            title: () => t('resources.buyers/credit-reviews.header.declineModal.title'), /* Decline credit line */
            subtitle: () => t('resources.buyers/credit-reviews.header.declineModal.subtitle'), /* Credit line will be declined for this buyer. You can revert this decision in the future. */
            buyerCompany: () => t('resources.buyers/credit-reviews.header.declineModal.buyerCompany'), /* Buyer company */
            reasonForDecline: () => t('resources.buyers/credit-reviews.header.declineModal.reasonForDecline'), /* Reason for decline */
            declineButton: () => t('resources.buyers/credit-reviews.header.declineModal.declineButton'), /* Decline credit line */
          },
        },
        financialStatement: {
          noFinancialStatement: () => t('resources.buyers/credit-reviews.financialStatement.noFinancialStatement'), /* No financial statement found */
          title: (data: Record<'yearEndDate', unknown>) => t('resources.buyers/credit-reviews.financialStatement.title', data), /* Valid for %{yearEndDate} */
          loading: () => t('resources.buyers/credit-reviews.financialStatement.loading'), /* Loading financial statement */
          fieldHeader: () => t('resources.buyers/credit-reviews.financialStatement.fieldHeader'), /* Field */
          valueHeader: () => t('resources.buyers/credit-reviews.financialStatement.valueHeader'), /* Value */
          sections: {
            profitAndLoss: () => t('resources.buyers/credit-reviews.financialStatement.sections.profitAndLoss'), /* Profit and Loss */
            balanceSheet: () => t('resources.buyers/credit-reviews.financialStatement.sections.balanceSheet'), /* Balance Sheet */
            otherFinancials: () => t('resources.buyers/credit-reviews.financialStatement.sections.otherFinancials'), /* Other Financials */
            ratios: () => t('resources.buyers/credit-reviews.financialStatement.sections.ratios'), /* Ratios */
          },
          fields: {
            revenue: () => t('resources.buyers/credit-reviews.financialStatement.fields.revenue'), /* Revenue */
            operatingCosts: () => t('resources.buyers/credit-reviews.financialStatement.fields.operatingCosts'), /* Operating Costs */
            operatingProfit: () => t('resources.buyers/credit-reviews.financialStatement.fields.operatingProfit'), /* Operating Profit */
            wagesAndSalaries: () => t('resources.buyers/credit-reviews.financialStatement.fields.wagesAndSalaries'), /* Wages and Salaries */
            pensionCosts: () => t('resources.buyers/credit-reviews.financialStatement.fields.pensionCosts'), /* Pension Costs */
            depreciation: () => t('resources.buyers/credit-reviews.financialStatement.fields.depreciation'), /* Depreciation */
            amortisation: () => t('resources.buyers/credit-reviews.financialStatement.fields.amortisation'), /* Amortisation */
            financialIncome: () => t('resources.buyers/credit-reviews.financialStatement.fields.financialIncome'), /* Financial Income */
            financialExpenses: () => t('resources.buyers/credit-reviews.financialStatement.fields.financialExpenses'), /* Financial Expenses */
            extraordinaryIncome: () => t('resources.buyers/credit-reviews.financialStatement.fields.extraordinaryIncome'), /* Extraordinary Income */
            extraordinaryCosts: () => t('resources.buyers/credit-reviews.financialStatement.fields.extraordinaryCosts'), /* Extraordinary Costs */
            profitBeforeTax: () => t('resources.buyers/credit-reviews.financialStatement.fields.profitBeforeTax'), /* Profit Before Tax */
            tax: () => t('resources.buyers/credit-reviews.financialStatement.fields.tax'), /* Tax */
            profitAfterTax: () => t('resources.buyers/credit-reviews.financialStatement.fields.profitAfterTax'), /* Profit After Tax */
            dividends: () => t('resources.buyers/credit-reviews.financialStatement.fields.dividends'), /* Dividends */
            minorityInterests: () => t('resources.buyers/credit-reviews.financialStatement.fields.minorityInterests'), /* Minority Interests */
            otherAppropriations: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherAppropriations'), /* Other Appropriations */
            retainedProfit: () => t('resources.buyers/credit-reviews.financialStatement.fields.retainedProfit'), /* Retained Profit */
            landAndBuildings: () => t('resources.buyers/credit-reviews.financialStatement.fields.landAndBuildings'), /* Land and Buildings */
            plantAndMachinery: () => t('resources.buyers/credit-reviews.financialStatement.fields.plantAndMachinery'), /* Plant and Machinery */
            otherTangibleAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherTangibleAssets'), /* Other Tangible Assets */
            totalTangibleAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalTangibleAssets'), /* Total Tangible Assets */
            goodwill: () => t('resources.buyers/credit-reviews.financialStatement.fields.goodwill'), /* Goodwill */
            otherIntangibleAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherIntangibleAssets'), /* Other Intangible Assets */
            totalIntangibleAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalIntangibleAssets'), /* Total Intangible Assets */
            investments: () => t('resources.buyers/credit-reviews.financialStatement.fields.investments'), /* Investments */
            loansToGroup: () => t('resources.buyers/credit-reviews.financialStatement.fields.loansToGroup'), /* Loans to Group */
            otherLoans: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherLoans'), /* Other Loans */
            miscellaneousFixedAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.miscellaneousFixedAssets'), /* Miscellaneous Fixed Assets */
            totalOtherFixedAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalOtherFixedAssets'), /* Total Other Fixed Assets */
            totalFixedAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalFixedAssets'), /* Total Fixed Assets */
            rawMaterials: () => t('resources.buyers/credit-reviews.financialStatement.fields.rawMaterials'), /* Raw Materials */
            workInProgress: () => t('resources.buyers/credit-reviews.financialStatement.fields.workInProgress'), /* Work in Progress */
            finishedGoods: () => t('resources.buyers/credit-reviews.financialStatement.fields.finishedGoods'), /* Finished Goods */
            otherInventories: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherInventories'), /* Other Inventories */
            totalInventories: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalInventories'), /* Total Inventories */
            tradeReceivables: () => t('resources.buyers/credit-reviews.financialStatement.fields.tradeReceivables'), /* Trade Receivables */
            groupReceivables: () => t('resources.buyers/credit-reviews.financialStatement.fields.groupReceivables'), /* Group Receivables */
            receivablesDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.receivablesDueAfter1Year'), /* Receivables Due After 1 Year */
            miscellaneousReceivables: () => t('resources.buyers/credit-reviews.financialStatement.fields.miscellaneousReceivables'), /* Miscellaneous Receivables */
            totalReceivables: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalReceivables'), /* Total Receivables */
            cash: () => t('resources.buyers/credit-reviews.financialStatement.fields.cash'), /* Cash */
            otherCurrentAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherCurrentAssets'), /* Other Current Assets */
            totalCurrentAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalCurrentAssets'), /* Total Current Assets */
            totalAssets: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalAssets'), /* Total Assets */
            tradePayables: () => t('resources.buyers/credit-reviews.financialStatement.fields.tradePayables'), /* Trade Payables */
            bankLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.bankLiabilities'), /* Bank Liabilities */
            otherLoansOrFinance: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherLoansOrFinance'), /* Other Loans or Finance */
            groupPayables: () => t('resources.buyers/credit-reviews.financialStatement.fields.groupPayables'), /* Group Payables */
            miscellaneousLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.miscellaneousLiabilities'), /* Miscellaneous Liabilities */
            totalCurrentLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalCurrentLiabilities'), /* Total Current Liabilities */
            tradePayablesDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.tradePayablesDueAfter1Year'), /* Trade Payables Due After 1 Year */
            bankLiabilitiesDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.bankLiabilitiesDueAfter1Year'), /* Bank Liabilities Due After 1 Year */
            otherLoansOrFinanceDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherLoansOrFinanceDueAfter1Year'), /* Other Loans or Finance Due After 1 Year */
            groupPayablesDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.groupPayablesDueAfter1Year'), /* Group Payables Due After 1 Year */
            miscellaneousLiabilitiesDueAfter1Year: () => t('resources.buyers/credit-reviews.financialStatement.fields.miscellaneousLiabilitiesDueAfter1Year'), /* Miscellaneous Liabilities Due After 1 Year */
            totalLongTermLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalLongTermLiabilities'), /* Total Long Term Liabilities */
            totalLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalLiabilities'), /* Total Liabilities */
            calledUpShareCapital: () => t('resources.buyers/credit-reviews.financialStatement.fields.calledUpShareCapital'), /* Called Up Share Capital */
            sharePremium: () => t('resources.buyers/credit-reviews.financialStatement.fields.sharePremium'), /* Share Premium */
            revenueReserves: () => t('resources.buyers/credit-reviews.financialStatement.fields.revenueReserves'), /* Revenue Reserves */
            otherReserves: () => t('resources.buyers/credit-reviews.financialStatement.fields.otherReserves'), /* Other Reserves */
            totalShareholdersEquity: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalShareholdersEquity'), /* Total Shareholders Equity */
            contingentLiabilities: () => t('resources.buyers/credit-reviews.financialStatement.fields.contingentLiabilities'), /* Contingent Liabilities */
            workingCapital: () => t('resources.buyers/credit-reviews.financialStatement.fields.workingCapital'), /* Working Capital */
            netWorth: () => t('resources.buyers/credit-reviews.financialStatement.fields.netWorth'), /* Net Worth */
            preTaxProfitMargin: () => t('resources.buyers/credit-reviews.financialStatement.fields.preTaxProfitMargin'), /* Pre Tax Profit Margin */
            returnOnCapitalEmployed: () => t('resources.buyers/credit-reviews.financialStatement.fields.returnOnCapitalEmployed'), /* Return on Capital Employed */
            returnOnTotalAssetsEmployed: () => t('resources.buyers/credit-reviews.financialStatement.fields.returnOnTotalAssetsEmployed'), /* Return on Total Assets Employed */
            returnOnNetAssetsEmployed: () => t('resources.buyers/credit-reviews.financialStatement.fields.returnOnNetAssetsEmployed'), /* Return on Net Assets Employed */
            salesOrNetWorkingCapital: () => t('resources.buyers/credit-reviews.financialStatement.fields.salesOrNetWorkingCapital'), /* Sales or Net Working Capital */
            stockTurnoverRatio: () => t('resources.buyers/credit-reviews.financialStatement.fields.stockTurnoverRatio'), /* Stock Turnover Ratio */
            debtorDays: () => t('resources.buyers/credit-reviews.financialStatement.fields.debtorDays'), /* Debtor Days */
            creditorDays: () => t('resources.buyers/credit-reviews.financialStatement.fields.creditorDays'), /* Creditor Days */
            currentRatio: () => t('resources.buyers/credit-reviews.financialStatement.fields.currentRatio'), /* Current Ratio */
            liquidityRatioOrAcidTest: () => t('resources.buyers/credit-reviews.financialStatement.fields.liquidityRatioOrAcidTest'), /* Liquidity Ratio or Acid Test */
            currentDebtRatio: () => t('resources.buyers/credit-reviews.financialStatement.fields.currentDebtRatio'), /* Current Debt Ratio */
            gearing: () => t('resources.buyers/credit-reviews.financialStatement.fields.gearing'), /* Gearing */
            equityInPercentage: () => t('resources.buyers/credit-reviews.financialStatement.fields.equityInPercentage'), /* Equity in Percentage */
            totalDebtRatio: () => t('resources.buyers/credit-reviews.financialStatement.fields.totalDebtRatio'), /* Total Debt Ratio */
          },
          empty: {
            title: () => t('resources.buyers/credit-reviews.financialStatement.empty.title'), /* No bank account connected yet */
            subtitle: () => t('resources.buyers/credit-reviews.financialStatement.empty.subtitle'), /* Ask your buyer to connect their account to access real-time insights */
          },
        },
        creditInsurance: {
          title: () => t('resources.buyers/credit-reviews.creditInsurance.title'), /* Credit insurance */
          allianzCompany: () => t('resources.buyers/credit-reviews.creditInsurance.allianzCompany'), /* Allianz Company */
          companyId: () => t('resources.buyers/credit-reviews.creditInsurance.companyId'), /* Company ID */
          legalName: () => t('resources.buyers/credit-reviews.creditInsurance.legalName'), /* Legal name */
          phone: () => t('resources.buyers/credit-reviews.creditInsurance.phone'), /* Phone */
          businessStartDate: () => t('resources.buyers/credit-reviews.creditInsurance.businessStartDate'), /* Business start date */
          companyGrade: () => t('resources.buyers/credit-reviews.creditInsurance.companyGrade'), /* Company grade */
          address: () => t('resources.buyers/credit-reviews.creditInsurance.address'), /* Address */
          match: () => t('resources.buyers/credit-reviews.creditInsurance.match'), /* Match */
          coverAmount: () => t('resources.buyers/credit-reviews.creditInsurance.coverAmount'), /* Cover amount */
          actions: {
            requestCover: () => t('resources.buyers/credit-reviews.creditInsurance.actions.requestCover'), /* Request cover */
          },
          alert: {
            insuranceConnected: () => t('resources.buyers/credit-reviews.creditInsurance.alert.insuranceConnected'), /* Insurance is connected to your account */
            connectInsurance: () => t('resources.buyers/credit-reviews.creditInsurance.alert.connectInsurance'), /* Connect your insurance to request coverage */
            linkInsurance: () => t('resources.buyers/credit-reviews.creditInsurance.alert.linkInsurance'), /* Link your credit insurance provider to request buyer coverage and reduce your risk. */
            connectInsuranceButton: () => t('resources.buyers/credit-reviews.creditInsurance.alert.connectInsuranceButton'), /* Connect insurance */
          },
          emptyState: {
            insuranceStatus: () => t('resources.buyers/credit-reviews.creditInsurance.emptyState.insuranceStatus'), /* Insurance status */
            insuranceDisconnected: () => t('resources.buyers/credit-reviews.creditInsurance.emptyState.insuranceDisconnected'), /* Disconnected */
            insuranceNoCover: () => t('resources.buyers/credit-reviews.creditInsurance.emptyState.insuranceNoCover'), /* No cover */
          },
        },
        creditBox: {
          creditLine: {
            title: () => t('resources.buyers/credit-reviews.creditBox.creditLine.title'), /* Credit Line summary */
            availableCredit: () => t('resources.buyers/credit-reviews.creditBox.creditLine.availableCredit'), /* Available credit */
            creditLimit: () => t('resources.buyers/credit-reviews.creditBox.creditLine.creditLimit'), /* Credit Limit */
            creditStatus: () => t('resources.buyers/credit-reviews.creditBox.creditLine.creditStatus'), /* Credit status */
            approvedOn: () => t('resources.buyers/credit-reviews.creditBox.creditLine.approvedOn'), /* Approved on */
            percentageOfTotal: (data: Record<'value', unknown>) => t('resources.buyers/credit-reviews.creditBox.creditLine.percentageOfTotal', data), /* %{value}% of total */
            creditLineWasDeclined: () => t('resources.buyers/credit-reviews.creditBox.creditLine.creditLineWasDeclined'), /* Credit Line was declined */
            declinedOn: () => t('resources.buyers/credit-reviews.creditBox.creditLine.declinedOn'), /* Declined on */
            approvedBy: () => t('resources.buyers/credit-reviews.creditBox.creditLine.approvedBy'), /* Approved by */
            decisionBy: () => t('resources.buyers/credit-reviews.creditBox.creditLine.decisionBy'), /* Decision by */
          },
          creditRequest: {
            title: () => t('resources.buyers/credit-reviews.creditBox.creditRequest.title'), /* Credit Request */
            requestedAmount: () => t('resources.buyers/credit-reviews.creditBox.creditRequest.requestedAmount'), /* Requested amount */
            requestedAt: () => t('resources.buyers/credit-reviews.creditBox.creditRequest.requestedAt'), /* Requested at */
            requestedBy: () => t('resources.buyers/credit-reviews.creditBox.creditRequest.requestedBy'), /* Requested by */
          },
          editCredit: {
            title: () => t('resources.buyers/credit-reviews.creditBox.editCredit.title'), /* Update Credit Limit */
            subtitle: (data: Record<'currentCreditLimit', unknown>) => t('resources.buyers/credit-reviews.creditBox.editCredit.subtitle', data), /* Current credit limit: %{currentCreditLimit} */
            approveButton: () => t('resources.buyers/credit-reviews.creditBox.editCredit.approveButton'), /* Confirm */
            buttonLabel: () => t('resources.buyers/credit-reviews.creditBox.editCredit.buttonLabel'), /* Edit Credit */
          },
        },
        creditReferences: {
          title: () => t('resources.buyers/credit-reviews.creditReferences.title'), /* Credit references */
          requestCreditReferences: () => t('resources.buyers/credit-reviews.creditReferences.requestCreditReferences'), /* Request credit references */
          requestTitle: () => t('resources.buyers/credit-reviews.creditReferences.requestTitle'), /* Request credit references */
          subtitle: () => t('resources.buyers/credit-reviews.creditReferences.subtitle'), /* Request credit references from your buyer */
          requestViaEmailText: () => t('resources.buyers/credit-reviews.creditReferences.requestViaEmailText'), /* Request via email */
          dividerText: () => t('resources.buyers/credit-reviews.creditReferences.dividerText'), /* Or */
          copyLinkText: () => t('resources.buyers/credit-reviews.creditReferences.copyLinkText'), /* Copy link */
          shareLinkText: () => t('resources.buyers/credit-reviews.creditReferences.shareLinkText'), /* Share link */
          noReferences: {
            askYourBuyer: () => t('resources.buyers/credit-reviews.creditReferences.noReferences.askYourBuyer'), /* Ask your buyer to add credit references */
            sendRequest: () => t('resources.buyers/credit-reviews.creditReferences.noReferences.sendRequest'), /* Send request */
          },
        },
        identityVerification: {
          title: () => t('resources.buyers/credit-reviews.identityVerification.title'), /* Identity Verification */
          inProgress: {
            title: (data: Record<'buyerName', unknown>) => t('resources.buyers/credit-reviews.identityVerification.inProgress.title', data), /* An email was sent to Eco %{buyerName} asking for their identity verification */
            subtitle: () => t('resources.buyers/credit-reviews.identityVerification.inProgress.subtitle'), /* You can also share this link for them to complete: */
            copyLink: () => t('resources.buyers/credit-reviews.identityVerification.inProgress.copyLink'), /* Copy link */
          },
          noIdentityVerification: {
            title: () => t('resources.buyers/credit-reviews.identityVerification.noIdentityVerification.title'), /* Ask your buyer to verify their identity */
            subtitle: () => t('resources.buyers/credit-reviews.identityVerification.noIdentityVerification.subtitle'), /* Require your buyer to confirm their identity with a valid photo ID and a selfie to make sure it's them. */
          },
          verified: {
            title: () => t('resources.buyers/credit-reviews.identityVerification.verified.title'), /* Identity Verification */
            document: {
              title: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.title'), /* Document */
              address: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.address'), /* Address */
              dob: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.dob'), /* Date of birth */
              expirationDate: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.expirationDate'), /* Expiration date */
              firstName: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.firstName'), /* First name */
              lastName: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.lastName'), /* Last name */
              fullName: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.fullName'), /* Full name */
              issuedDate: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.issuedDate'), /* Issued date */
              issuingCountry: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.issuingCountry'), /* Issuing country */
              number: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.number'), /* Number */
              type: () => t('resources.buyers/credit-reviews.identityVerification.verified.document.type'), /* Type */
            },
            idNumber: {
              title: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.title'), /* ID Number */
              dob: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.dob'), /* Date of birth */
              firstName: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.firstName'), /* First name */
              idNumber: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.idNumber'), /* ID number */
              type: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.type'), /* Type */
              lastName: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.lastName'), /* Last name */
              status: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.status'), /* Status */
              fullName: () => t('resources.buyers/credit-reviews.identityVerification.verified.idNumber.fullName'), /* Full name */
            },
          },
        },
        experian: {
          noMatch: () => t('resources.buyers/credit-reviews.experian.noMatch'), /* No match */
          experianLabel: () => t('resources.buyers/credit-reviews.experian.experianLabel'), /* Experian */
          experianDataCreationDate: () => t('resources.buyers/credit-reviews.experian.experianDataCreationDate'), /* Data creation date */
          experianScore: () => t('resources.buyers/credit-reviews.experian.experianScore'), /* Score */
          experianReport: () => t('resources.buyers/credit-reviews.experian.experianReport'), /* Experian report */
          personalCreditScore: () => t('resources.buyers/credit-reviews.experian.personalCreditScore'), /* Personal credit score */
          lastRefreshedOn: () => t('resources.buyers/credit-reviews.experian.lastRefreshedOn'), /* Last refreshed on */
        },
        personalGuarantee: {
          title: () => t('resources.buyers/credit-reviews.personalGuarantee.title'), /* Personal guarantee */
          loading: () => t('resources.buyers/credit-reviews.personalGuarantee.loading'), /* Loading personal guarantee */
          empty: {
            title: () => t('resources.buyers/credit-reviews.personalGuarantee.empty.title'), /* No personal guarantee provided yet */
            subtitle: () => t('resources.buyers/credit-reviews.personalGuarantee.empty.subtitle'), /* Ask your buyer to sign a personal guarantee to increase payment security */
          },
        },
        financialConnections: {
          title: () => t('resources.buyers/credit-reviews.financialConnections.title'), /* Bank account connections */
          loading: () => t('resources.buyers/credit-reviews.financialConnections.loading'), /* Loading bank account connections */
          empty: {
            title: () => t('resources.buyers/credit-reviews.financialConnections.empty.title'), /* No bank account connected yet */
            subtitle: () => t('resources.buyers/credit-reviews.financialConnections.empty.subtitle'), /* Ask your buyer to upload financial documents to better understand their financial health */
          },
        },
        compliance: {
          amlInfo: {
            title: () => t('resources.buyers/credit-reviews.compliance.amlInfo.title'), /* AML info */
            amlInfo: () => t('resources.buyers/credit-reviews.compliance.amlInfo.amlInfo'), /* AML info */
          },
          complianceAlerts: {
            title: () => t('resources.buyers/credit-reviews.compliance.complianceAlerts.title'), /* Compliance alerts */
          },
        },
        documents: {
          title: () => t('resources.buyers/credit-reviews.documents.title'), /* Documents */
          empty: {
            title: () => t('resources.buyers/credit-reviews.documents.empty.title'), /* No financial documents uploaded yet */
            subtitle: () => t('resources.buyers/credit-reviews.documents.empty.subtitle'), /* Ask your buyer to upload financial documents to better understand their financial health */
          },
        },
        businessVerification: {
          title: () => t('resources.buyers/credit-reviews.businessVerification.title'), /* Business verification */
          verifiedBusinessDetails: {
            title: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.title'), /* Verified business details */
            legalName: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.legalName'), /* Legal name */
            businessStartDate: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.businessStartDate'), /* Business start date */
            addresses: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.addresses'), /* Addresses */
            tin: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.tin'), /* Tax ID */
            website: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.website'), /* Website */
            lastVerificationExecutionDate: () => t('resources.buyers/credit-reviews.businessVerification.verifiedBusinessDetails.lastVerificationExecutionDate'), /* Last verification execution date */
          },
          registrationRecords: {
            title: () => t('resources.buyers/credit-reviews.businessVerification.registrationRecords.title'), /* Registration records */
            registrationRecords: () => t('resources.buyers/credit-reviews.businessVerification.registrationRecords.registrationRecords'), /* Registration records */
          },
          relatedCompanies: {
            title: () => t('resources.buyers/credit-reviews.businessVerification.relatedCompanies.title'), /* Related companies */
            relatedCompanies: () => t('resources.buyers/credit-reviews.businessVerification.relatedCompanies.relatedCompanies'), /* Related companies */
          },
          relatedPersons: {
            title: () => t('resources.buyers/credit-reviews.businessVerification.relatedPersons.title'), /* Related persons */
            relatedPersons: () => t('resources.buyers/credit-reviews.businessVerification.relatedPersons.relatedPersons'), /* Related persons */
          },
          businessScope: {
            title: () => t('resources.buyers/credit-reviews.businessVerification.businessScope.title'), /* Business scope */
            businessScope: () => t('resources.buyers/credit-reviews.businessVerification.businessScope.businessScope'), /* Business scope */
            noBusinessScope: () => t('resources.buyers/credit-reviews.businessVerification.businessScope.noBusinessScope'), /* No business scope information found */
          },
        },
      },
      assistant: {
        name: () => t('resources.assistant.name'), /* Assistants */
        create: {
          title: () => t('resources.assistant.create.title'), /* Create Assistant */
        },
        chat: {
          loadingAssistants: () => t('resources.assistant.chat.loadingAssistants'), /* Loading assistants... */
          noAssistantsFound: () => t('resources.assistant.chat.noAssistantsFound'), /* No assistants found */
          assistantLabel: () => t('resources.assistant.chat.assistantLabel'), /* Assistant */
          selectAssistant: () => t('resources.assistant.chat.selectAssistant'), /* Select an assistant */
          optimizedLatency: () => t('resources.assistant.chat.optimizedLatency'), /* Optimized latency */
        },
      },
      'assistant/feedback': {
        name: () => t('resources.assistant/feedback.name'), /* Assistant Feedback */
        fields: {
          question: () => t('resources.assistant/feedback.fields.question'), /* Question */
          answer: () => t('resources.assistant/feedback.fields.answer'), /* Answer */
          feedback: () => t('resources.assistant/feedback.fields.feedback'), /* Feedback */
          trace: () => t('resources.assistant/feedback.fields.trace'), /* Trace */
          status: () => t('resources.assistant/feedback.fields.status'), /* Status */
          actions: () => t('resources.assistant/feedback.fields.actions'), /* Actions */
        },
      },
      orders: {
        name: () => t('resources.orders.name'), /* Order |||| Orders */
        fields: {
          id: () => t('resources.orders.fields.id'), /* ID */
          buyer: () => t('resources.orders.fields.buyer'), /* Buyer */
          amount: () => t('resources.orders.fields.amount'), /* Amount */
          currency: () => t('resources.orders.fields.currency'), /* Currency */
          checkout: () => t('resources.orders.fields.checkout'), /* Checkout */
          externalId: () => t('resources.orders.fields.externalId'), /* External ID */
          result: {
            paymentOption: {
              paymentMethod: () => t('resources.orders.fields.result.paymentOption.paymentMethod'), /* Payment method */
            },
          },
          paymentMethod: () => t('resources.orders.fields.paymentMethod'), /* Payment method */
          paymentTerm: () => t('resources.orders.fields.paymentTerm'), /* Payment term */
          paymentTermDays: () => t('resources.orders.fields.paymentTermDays'), /* Payment term Days */
          billingAddress: () => t('resources.orders.fields.billingAddress'), /* Billing address */
          shippingAddress: () => t('resources.orders.fields.shippingAddress'), /* Shipping address */
          billingShippingSame: () => t('resources.orders.fields.billingShippingSame'), /* My billing and shipping address are the same */
          status: () => t('resources.orders.fields.status'), /* Status */
          consents: () => t('resources.orders.fields.consents'), /* Consents */
          attachments: () => t('resources.orders.fields.attachments'), /* Attachments */
          discount: {
            percentage: () => t('resources.orders.fields.discount.percentage'), /* Discount % */
            value: () => t('resources.orders.fields.discount.value'), /* Discount Amount */
          },
          tax: {
            percentage: () => t('resources.orders.fields.tax.percentage'), /* Tax % */
            value: () => t('resources.orders.fields.tax.value'), /* Tax Amount */
          },
          amountPaid: () => t('resources.orders.fields.amountPaid'), /* Amount paid */
          shippingFee: () => t('resources.orders.fields.shippingFee'), /* Shipping fee */
          lineItems: () => t('resources.orders.fields.lineItems'), /* Line items */
        },
        edit: {
          title: () => t('resources.orders.edit.title'), /* Update order */
          save: () => t('resources.orders.edit.save'), /* Update order */
          tabs: {
            details: () => t('resources.orders.edit.tabs.details'), /* Details */
            lineItems: () => t('resources.orders.edit.tabs.lineItems'), /* Line Items */
          },
        },
        create: {
          title: () => t('resources.orders.create.title'), /* New order */
          save: () => t('resources.orders.create.save'), /* Create order */
          tabs: {
            details: () => t('resources.orders.create.tabs.details'), /* Details */
            lineItems: () => t('resources.orders.create.tabs.lineItems'), /* Line Items */
          },
        },
      },
      'insurance/application': {
        name: () => t('resources.insurance/application.name'), /* Insurance Applications */
        fields: {
          status: () => t('resources.insurance/application.fields.status'), /* Status */
          provider: () => t('resources.insurance/application.fields.provider'), /* Provider */
          createdAt: () => t('resources.insurance/application.fields.createdAt'), /* Created At */
          updatedAt: () => t('resources.insurance/application.fields.updatedAt'), /* Updated At */
        },
        actions: {
          create: () => t('resources.insurance/application.actions.create'), /* Create Insurance Application */
        },
      },
      invoices: {
        name: () => t('resources.invoices.name'), /* Invoice |||| Invoices */
        fields: {
          id: () => t('resources.invoices.fields.id'), /* ID */
          buyer: () => t('resources.invoices.fields.buyer'), /* Buyer */
          amount: () => t('resources.invoices.fields.amount'), /* Amount */
          currency: () => t('resources.invoices.fields.currency'), /* Currency */
          checkout: () => t('resources.invoices.fields.checkout'), /* Checkout */
          externalId: () => t('resources.invoices.fields.externalId'), /* External ID */
          providerId: () => t('resources.invoices.fields.providerId'), /* Provider Id */
          externalInvoice: () => t('resources.invoices.fields.externalInvoice'), /* External invoice */
          paymentMethod: () => t('resources.invoices.fields.paymentMethod'), /* Payment method */
          issueDate: () => t('resources.invoices.fields.issueDate'), /* Issue date */
          shippingDate: () => t('resources.invoices.fields.shippingDate'), /* Shipping date */
          arrivalDate: () => t('resources.invoices.fields.arrivalDate'), /* Arrival date */
          paymentTerm: () => t('resources.invoices.fields.paymentTerm'), /* Payment term */
          paymentTermDays: () => t('resources.invoices.fields.paymentTermDays'), /* Payment term days */
          billingAddress: () => t('resources.invoices.fields.billingAddress'), /* Billing address */
          dueDate: () => t('resources.invoices.fields.dueDate'), /* Due date */
          shippingAddress: () => t('resources.invoices.fields.shippingAddress'), /* Shipping address */
          billingShippingSame: () => t('resources.invoices.fields.billingShippingSame'), /* My billing and shipping address are the same */
          status: () => t('resources.invoices.fields.status'), /* Status */
          metadata: () => t('resources.invoices.fields.metadata'), /* Metadata */
          attachments: () => t('resources.invoices.fields.attachments'), /* Attachments */
          amountPaid: () => t('resources.invoices.fields.amountPaid'), /* Amount paid */
          shippingFee: () => t('resources.invoices.fields.shippingFee'), /* Shipping fee */
          transitionType: () => t('resources.invoices.fields.transitionType'), /* Invoice Type */
          totalList: () => t('resources.invoices.fields.totalList'), /* Financed amount */
          lineItems: () => t('resources.invoices.fields.lineItems'), /* Line items */
          balance: () => t('resources.invoices.fields.balance'), /* Open balance */
          result: {
            totalFee: () => t('resources.invoices.fields.result.totalFee'), /* Buyer's fee */
            total: () => t('resources.invoices.fields.result.total'), /* Buyer's total charge */
            shippingDate: () => t('resources.invoices.fields.result.shippingDate'), /* Shipping date */
            dueDate: () => t('resources.invoices.fields.result.dueDate'), /* Due date */
            paymentOptionWithFee: () => t('resources.invoices.fields.result.paymentOptionWithFee'), /* Payment term */
          },
          discount: {
            percentage: () => t('resources.invoices.fields.discount.percentage'), /* Discount % */
            value: () => t('resources.invoices.fields.discount.value'), /* Discount amount */
            title: () => t('resources.invoices.fields.discount.title'), /* Discount */
          },
          tax: {
            percentage: () => t('resources.invoices.fields.tax.percentage'), /* Tax % */
            value: () => t('resources.invoices.fields.tax.value'), /* Tax amount */
            title: () => t('resources.invoices.fields.tax.title'), /* Tax */
          },
          payout: () => t('resources.invoices.fields.payout'), /* Payout */
          calculatedPayout: () => t('resources.invoices.fields.calculatedPayout'), /* Your payout */
          supplierFee: () => t('resources.invoices.fields.supplierFee'), /* Your fee */
          action: () => t('resources.invoices.fields.action'), /* Action */
          memo: () => t('resources.invoices.fields.memo'), /* Memo */
          mode: () => t('resources.invoices.fields.mode'), /* Mode */
          create: () => t('resources.invoices.fields.create'), /* Add new invoice */
        },
        edit: {
          invoiceDetailsForm: {
            title: () => t('resources.invoices.edit.invoiceDetailsForm.title'), /* Invoice Details */
            memoPlaceholder: () => t('resources.invoices.edit.invoiceDetailsForm.memoPlaceholder'), /* Memo (Optional) */
            externalIdInputPlaceholder: () => t('resources.invoices.edit.invoiceDetailsForm.externalIdInputPlaceholder'), /* Invoice external ID (Optional) */
            providerIdInputPlaceholder: () => t('resources.invoices.edit.invoiceDetailsForm.providerIdInputPlaceholder'), /* Provider ID (Optional) */
            helperText: () => t('resources.invoices.edit.invoiceDetailsForm.helperText'), /* ie invoice number, order number, etc. */
            save: () => t('resources.invoices.edit.invoiceDetailsForm.save'), /* Save */
          },
          invoiceBuyerInput: {
            message: (data: Record<'value', unknown>) => t('resources.invoices.edit.invoiceBuyerInput.message', data), /* %{value} was added as a new buyer successfully. */
            autocompleteCreateText: (data: Record<'searchText', unknown>) => t('resources.invoices.edit.invoiceBuyerInput.autocompleteCreateText', data), /* + Add %{searchText} as new buyer */
            addBuyerEmail: {
              title: (data: Record<'buyerName', unknown>) => t('resources.invoices.edit.invoiceBuyerInput.addBuyerEmail.title', data), /* Add %{buyerName} email address */
              body: () => t('resources.invoices.edit.invoiceBuyerInput.addBuyerEmail.body'), /* Adding your buyer's email will help us notify them about new payment requests and offer them a credit line for their business. */
              successNotification: () => t('resources.invoices.edit.invoiceBuyerInput.addBuyerEmail.successNotification'), /* Email address added to buyer */
              confirmButton: () => t('resources.invoices.edit.invoiceBuyerInput.addBuyerEmail.confirmButton'), /* Save email */
              inputPlaceholder: () => t('resources.invoices.edit.invoiceBuyerInput.addBuyerEmail.inputPlaceholder'), /* Buyer email */
            },
          },
          invoicePaymentTerms: {
            name: () => t('resources.invoices.edit.invoicePaymentTerms.name'), /* Payment Terms */
            label: () => t('resources.invoices.edit.invoicePaymentTerms.label'), /* Payment Terms */
            options: {
              netTerms: () => t('resources.invoices.edit.invoicePaymentTerms.options.netTerms'), /* Net Terms */
              onDueDate: () => t('resources.invoices.edit.invoicePaymentTerms.options.onDueDate'), /* On Due Date */
            },
            buyerNotApprovedTooltip: () => t('resources.invoices.edit.invoicePaymentTerms.buyerNotApprovedTooltip'), /* Buyer not approved for Net Terms */
            instantPaymentsNotEnabled: () => t('resources.invoices.edit.invoicePaymentTerms.instantPaymentsNotEnabled'), /* Instant payments not enabled */
            enterAmountFirst: () => t('resources.invoices.edit.invoicePaymentTerms.enterAmountFirst'), /* Enter an amount first */
          },
          InvoiceDatesInput: {
            issueDate: () => t('resources.invoices.edit.InvoiceDatesInput.issueDate'), /* Issue date */
            shippingDate: () => t('resources.invoices.edit.InvoiceDatesInput.shippingDate'), /* Shipping date */
            arrivalDate: () => t('resources.invoices.edit.InvoiceDatesInput.arrivalDate'), /* Arrival date */
            dueDate: () => t('resources.invoices.edit.InvoiceDatesInput.dueDate'), /* Due date */
          },
          invoiceTotalCalculator: {
            discount: () => t('resources.invoices.edit.invoiceTotalCalculator.discount'), /* discount */
            buyerFee: () => t('resources.invoices.edit.invoiceTotalCalculator.buyerFee'), /* Buyer's fee */
            yourFee: () => t('resources.invoices.edit.invoiceTotalCalculator.yourFee'), /* Your fee */
            yourPayout: () => t('resources.invoices.edit.invoiceTotalCalculator.yourPayout'), /* Your payout */
            buyerTotalCharge: () => t('resources.invoices.edit.invoiceTotalCalculator.buyerTotalCharge'), /* Buyer's total charge */
            firstDiscountMessage: () => t('resources.invoices.edit.invoiceTotalCalculator.firstDiscountMessage'), /*  This invoice is having first-invoice fee discount */
          },
          markAsPaidButton: {
            label: () => t('resources.invoices.edit.markAsPaidButton.label'), /* Mark as paid */
            title: () => t('resources.invoices.edit.markAsPaidButton.title'), /* Mark invoice as paid */
          },
          markAsPaidForm: {
            content: () => t('resources.invoices.edit.markAsPaidForm.content'), /* Enter payment date and amount to mark it as paid for this invoice */
            paymentDate: () => t('resources.invoices.edit.markAsPaidForm.paymentDate'), /* Payment date */
            paymentAmount: () => t('resources.invoices.edit.markAsPaidForm.paymentAmount'), /* Amount paid */
            note: () => t('resources.invoices.edit.markAsPaidForm.note'), /* Note */
            save: () => t('resources.invoices.edit.markAsPaidForm.save'), /* Save */
            saving: () => t('resources.invoices.edit.markAsPaidForm.saving'), /* Saving */
          },
          cancelInvoiceButton: {
            label: () => t('resources.invoices.edit.cancelInvoiceButton.label'), /* Cancel Invoice */
            title: () => t('resources.invoices.edit.cancelInvoiceButton.title'), /* Confirm Cancel Invoice */
            content: () => t('resources.invoices.edit.cancelInvoiceButton.content'), /* Are you sure you want to cancel invoice? */
          },
          removeFactorConfirmationButton: {
            label: () => t('resources.invoices.edit.removeFactorConfirmationButton.label'), /* Unconfirm */
            title: () => t('resources.invoices.edit.removeFactorConfirmationButton.title'), /* Remove Confirmation */
            content: () => t('resources.invoices.edit.removeFactorConfirmationButton.content'), /* Are you sure you want to remove factor confirmation for this invoice? */
            confirmText: () => t('resources.invoices.edit.removeFactorConfirmationButton.confirmText'), /* Remove Confirmation */
          },
          title: () => t('resources.invoices.edit.title'), /*   */
          confirmEditInvoice: {
            title: () => t('resources.invoices.edit.confirmEditInvoice.title'), /* The invoice has unpaid payment requests */
            content: () => t('resources.invoices.edit.confirmEditInvoice.content'), /* To update the invoice details, the unpaid payment requests must be deleted. You can create a new payment request after saving these changes */
            fieldChanged: (data: Record<'field', unknown>) => t('resources.invoices.edit.confirmEditInvoice.fieldChanged', data), /* you have unpaid PR for this invoice. Changing the %{field} will cancel the PR. After saving create a new PR for the buyer. */
          },
        },
        copyInvoiceLink: () => t('resources.invoices.copyInvoiceLink'), /* Copy link to Invoice search portal */
        create: {
          fieldNotReconizedInOcr: () => t('resources.invoices.create.fieldNotReconizedInOcr'), /* Unable to extract information. Please add it manually. */
          ocr: {
            filesErrorMessage: {
              title: () => t('resources.invoices.create.ocr.filesErrorMessage.title'), /* The invoice file you uploaded couldn't be processed */
              body: () => t('resources.invoices.create.ocr.filesErrorMessage.body'), /* It was not possible to extract the details. Please, upload a new file or add the invoice details manually */
              fillManually: () => t('resources.invoices.create.ocr.filesErrorMessage.fillManually'), /* Fill manually */
              uploadNewFile: () => t('resources.invoices.create.ocr.filesErrorMessage.uploadNewFile'), /* Upload new file */
            },
          },
          viewer: {
            toolbar: {
              addFiles: () => t('resources.invoices.create.viewer.toolbar.addFiles'), /* Add files */
              deleteFiles: {
                title: () => t('resources.invoices.create.viewer.toolbar.deleteFiles.title'), /* Are you sure you want to delete this file from the invoice? */
                content: () => t('resources.invoices.create.viewer.toolbar.deleteFiles.content'), /* The information that was extracted will be kept and it is editable */
                delete: () => t('resources.invoices.create.viewer.toolbar.deleteFiles.delete'), /* Delete */
                keep: () => t('resources.invoices.create.viewer.toolbar.deleteFiles.keep'), /* Keep File */
              },
            },
            error: () => t('resources.invoices.create.viewer.error'), /* Please upload at least one file */
          },
          preview: () => t('resources.invoices.create.preview'), /* Preview payment page */
        },
        tabs: {
          title: () => t('resources.invoices.tabs.title'), /* Invoices */
          all: () => t('resources.invoices.tabs.all'), /* All */
          'in-review': () => t('resources.invoices.tabs.in-review'), /* In review */
          unpaid: () => t('resources.invoices.tabs.unpaid'), /* Unpaid */
          'in-progress': () => t('resources.invoices.tabs.in-progress'), /* In progress */
          paid: () => t('resources.invoices.tabs.paid'), /* Paid */
        },
        actions: {
          create: () => t('resources.invoices.actions.create'), /* Add new invoice */
          addNewInvoice: () => t('resources.invoices.actions.addNewInvoice'), /* Add new invoice */
          bulkPayment: {
            buttonText: (data: Record<'amount', unknown>) => t('resources.invoices.actions.bulkPayment.buttonText', data), /* Pay (%{amount}) */
            disabledText: () => t('resources.invoices.actions.bulkPayment.disabledText'), /* Pay invoices */
          },
        },
        show: {
          invoiceDetails: {
            buyerView: {
              buyerFinancingFeeText: () => t('resources.invoices.show.invoiceDetails.buyerView.buyerFinancingFeeText'), /* Financing fee */
              buyerTotalText: () => t('resources.invoices.show.invoiceDetails.buyerView.buyerTotalText'), /* Total charge */
            },
            supplierView: {
              buyerFinancingFeeText: () => t('resources.invoices.show.invoiceDetails.supplierView.buyerFinancingFeeText'), /* Buyer's financing fee */
              buyerTotalText: () => t('resources.invoices.show.invoiceDetails.supplierView.buyerTotalText'), /* Buyer's total charge */
            },
            supplierFee: () => t('resources.invoices.show.invoiceDetails.supplierFee'), /* Supplier's fee */
            supplierTotal: () => t('resources.invoices.show.invoiceDetails.supplierTotal'), /* Supplier's payout */
            title: () => t('resources.invoices.show.invoiceDetails.title'), /* Invoice Details */
          },
          financedCard: {
            title: () => t('resources.invoices.show.financedCard.title'), /* Financed by 40seas */
            financed: () => t('resources.invoices.show.financedCard.financed'), /* financed */
            amount: () => t('resources.invoices.show.financedCard.amount'), /* Amount */
            financingFee: () => t('resources.invoices.show.financedCard.financingFee'), /* Financing fee */
          },
          createPaymentRequest: {
            createPaymentRequestTitle: () => t('resources.invoices.show.createPaymentRequest.createPaymentRequestTitle'), /* Enter the requested amount for this invoice */
            copyLinktTitle: () => t('resources.invoices.show.createPaymentRequest.copyLinktTitle'), /* Payment request created */
            openBalanceAlert: () => t('resources.invoices.show.createPaymentRequest.openBalanceAlert'), /* Invoice open balance:  */
            copyLinkContent: () => t('resources.invoices.show.createPaymentRequest.copyLinkContent'), /* The payment link is ready to be shared with your buyer. You can access this link again at anytime under the payment request details. */
            createPaymentRequestError: () => t('resources.invoices.show.createPaymentRequest.createPaymentRequestError'), /* Requested amount must be greater than 0 */
            useFunds: () => t('resources.invoices.show.createPaymentRequest.useFunds'), /* Use buyer available funds */
          },
          tabs: {
            payments: () => t('resources.invoices.show.tabs.payments'), /* Payments */
            attachments: () => t('resources.invoices.show.tabs.attachments'), /* Attachments */
            shipping: () => t('resources.invoices.show.tabs.shipping'), /* Shipping */
            ledger: () => t('resources.invoices.show.tabs.ledger'), /* Ledger */
            notifications: () => t('resources.invoices.show.tabs.notifications'), /* Notifications */
            lineItems: () => t('resources.invoices.show.tabs.lineItems'), /* Line Items */
            'external-data': () => t('resources.invoices.show.tabs.external-data'), /* External Data */
            activityTimeline: () => t('resources.invoices.show.tabs.activityTimeline'), /* Activity Timeline */
          },
          lineItems: {
            empty: () => t('resources.invoices.show.lineItems.empty'), /* No Line items */
            sku: () => t('resources.invoices.show.lineItems.sku'), /* Sku */
            type: () => t('resources.invoices.show.lineItems.type'), /* Type */
            title: () => t('resources.invoices.show.lineItems.title'), /* Title */
            description: () => t('resources.invoices.show.lineItems.description'), /* Description */
            quantity: () => t('resources.invoices.show.lineItems.quantity'), /* quantity */
            itemPrice: () => t('resources.invoices.show.lineItems.itemPrice'), /* Item price */
          },
          timeline: {
            sentTo: () => t('resources.invoices.show.timeline.sentTo'), /* Sent to: */
            showMore: (data: Record<'quantity', unknown>) => t('resources.invoices.show.timeline.showMore', data), /*  +%{quantity} more */
            showLess: () => t('resources.invoices.show.timeline.showLess'), /* Show less */
            timeline: (data: Record<'createdAt' | 'createdBy', unknown>) => t('resources.invoices.show.timeline.timeline', data), /* %{createdAt} • Created by %{createdBy} */
            noTimelineData: () => t('resources.invoices.show.timeline.noTimelineData'), /* No timeline data found */
            titles: {
              email_created: (data: Record<'templateName', unknown>) => t('resources.invoices.show.timeline.titles.email_created', data), /* Notification sent: %{templateName} */
              payout_done: (data: Record<'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.payout_done', data), /* Payout amount of %{amount} %{currency} added to your balance */
              payout_failed: (data: Record<'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.payout_failed', data), /* Payout amount of %{amount} %{currency} failed */
              invoice_created: (data: Record<'externalId' | 'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.invoice_created', data), /* Invoice %{externalId} for amount %{amount} %{currency} created */
              invoice_canceled: (data: Record<'externalId' | 'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.invoice_canceled', data), /* Invoice %{externalId} for amount %{amount} %{currency} canceled */
              checkout_created: (data: Record<'externalId' | 'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.checkout_created', data), /* Payment request %{externalId} for amount %{amount} %{currency} sent to buyer */
              checkout_canceled: (data: Record<'externalId' | 'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.checkout_canceled', data), /* Payment request %{externalId} for amount %{amount} %{currency} canceled */
              checkout_confirmed: (data: Record<'externalId' | 'amount' | 'currency', unknown>) => t('resources.invoices.show.timeline.titles.checkout_confirmed', data), /* Payment request %{externalId} for amount %{amount} %{currency} confirmed */
              charge_buyer_failed: (data: Record<'amount' | 'currency' | 'paymentMethod', unknown>) => t('resources.invoices.show.timeline.titles.charge_buyer_failed', data), /* Buyer payment of %{amount} %{currency} via %{paymentMethod} failed */
              charge_buyer_refunded: (data: Record<'amount' | 'currency' | 'paymentMethod', unknown>) => t('resources.invoices.show.timeline.titles.charge_buyer_refunded', data), /* Buyer payment of %{amount} %{currency} via %{paymentMethod} refunded */
              charge_buyer_disputed: (data: Record<'amount' | 'currency' | 'paymentMethod', unknown>) => t('resources.invoices.show.timeline.titles.charge_buyer_disputed', data), /* Buyer payment of %{amount} %{currency} via %{paymentMethod} disputed */
              charge_buyer_succeeded: (data: Record<'amount' | 'currency' | 'paymentMethod', unknown>) => t('resources.invoices.show.timeline.titles.charge_buyer_succeeded', data), /* Buyer payment of %{amount} %{currency} via %{paymentMethod} received */
            },
            buttons: {
              preview: () => t('resources.invoices.show.timeline.buttons.preview'), /* Preview */
              copyLink: () => t('resources.invoices.show.timeline.buttons.copyLink'), /* Copy link */
              showCharge: () => t('resources.invoices.show.timeline.buttons.showCharge'), /* Show charge */
              showPayout: () => t('resources.invoices.show.timeline.buttons.showPayout'), /* Show payout */
              showInvoice: () => t('resources.invoices.show.timeline.buttons.showInvoice'), /* Show invoice */
              showCheckout: () => t('resources.invoices.show.timeline.buttons.showCheckout'), /* Show checkout */
            },
          },
          stepper: {
            invoiceCreatedLabel: () => t('resources.invoices.show.stepper.invoiceCreatedLabel'), /* Invoice created */
            invoiceApproved40seasLabel: (data: Record<'brandName', unknown>) => t('resources.invoices.show.stepper.invoiceApproved40seasLabel', data), /* %{brandName} confirmation */
            invoiceApprovedLabel: () => t('resources.invoices.show.stepper.invoiceApprovedLabel'), /* Your confirmation */
            invoiceConfirmedLabel: () => t('resources.invoices.show.stepper.invoiceConfirmedLabel'), /* Buyer confirmation */
            invoicePayoutLabel: () => t('resources.invoices.show.stepper.invoicePayoutLabel'), /* Payout completed */
            invoiceChargedLabel: () => t('resources.invoices.show.stepper.invoiceChargedLabel'), /* Invoice charged */
            invoicePaymentFailedLabel: () => t('resources.invoices.show.stepper.invoicePaymentFailedLabel'), /* Invoice payment failed */
          },
          actions: {
            changePaymentMethod: () => t('resources.invoices.show.actions.changePaymentMethod'), /* Edit payment */
            payBalance: () => t('resources.invoices.show.actions.payBalance'), /* Pay balance */
            confirmNetTerms: () => t('resources.invoices.show.actions.confirmNetTerms'), /* Pay Now */
          },
          invoiceFailedPaymentPanel: {
            buyer: {
              net: {
                title: (data: Record<'amount' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.net.title', data), /* Your %{amount} payment has failed on %{failureDate}. */
                message: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.net.message'), /* Please take immediate action to avoid credit limit cancellation and the initiation of a collection process. */
                failureReason: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.net.failureReason'), /* Failure reason: */
                failureMessage: (data: Record<'failureMessage' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.net.failureMessage', data), /* %{failureMessage} on %{failureDate} */
                buttonText: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.net.buttonText'), /* Pay now */
              },
              immediate: {
                title: (data: Record<'amount' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.immediate.title', data), /* Your %{amount} payment has failed on %{failureDate}. */
                message: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.immediate.message'), /* Please try again with a different payment method. */
                failureReason: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.immediate.failureReason'), /* Failure reason: */
                failureMessage: (data: Record<'failureMessage' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.immediate.failureMessage', data), /* %{failureMessage} on %{failureDate} */
                buttonText: () => t('resources.invoices.show.invoiceFailedPaymentPanel.buyer.immediate.buttonText'), /* Repay */
              },
            },
            supplier: {
              net: {
                title: (data: Record<'amount' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.net.title', data), /* Buyer's %{amount} payment has failed on %{failureDate}. */
                message: () => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.net.message'), /* The payment for a Pay Later invoice was unsuccessful. We've issued an immediate payment request to the buyer.
                 No action is required from your side at this time. */
                linkText: () => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.net.linkText'), /* View details */
              },
              immediate: {
                title: (data: Record<'amount' | 'failureDate', unknown>) => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.immediate.title', data), /* Buyer's %{amount} payment has failed on %{failureDate}. */
                message: () => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.immediate.message'), /* We have notified the buyer to repay. Please contact your buyer to ensure payment is completed. */
                linkText: () => t('resources.invoices.show.invoiceFailedPaymentPanel.supplier.immediate.linkText'), /* View details */
              },
            },
          },
        },
        filters: {
          balance: () => t('resources.invoices.filters.balance'), /* Open Balance */
          financing: {
            values: {
              true: () => t('resources.invoices.filters.financing.values.true'), /* Financed */
              false: () => t('resources.invoices.filters.financing.values.false'), /* Not Financed */
            },
          },
          confirmation: {
            values: {
              true: () => t('resources.invoices.filters.confirmation.values.true'), /* Confirmed */
              false: () => t('resources.invoices.filters.confirmation.values.false'), /* Not Confirmed */
            },
          },
          'buyer-terms-confirmation': {
            label: () => t('resources.invoices.filters.buyer-terms-confirmation.label'), /* Buyer terms confirmation */
            values: {
              true: () => t('resources.invoices.filters.buyer-terms-confirmation.values.true'), /* Confirmed */
              false: () => t('resources.invoices.filters.buyer-terms-confirmation.values.false'), /* Not Confirmed */
            },
          },
          'factor-financing-confirmation': {
            label: (data: Record<'brandName', unknown>) => t('resources.invoices.filters.factor-financing-confirmation.label', data), /* %{brandName} financing confirmation */
            values: {
              true: () => t('resources.invoices.filters.factor-financing-confirmation.values.true'), /* Confirmed */
              false: () => t('resources.invoices.filters.factor-financing-confirmation.values.false'), /* Not Confirmed */
            },
          },
          paymentTerm: {
            label: () => t('resources.invoices.filters.paymentTerm.label'), /* Payment term */
            values: {
              immediate: () => t('resources.invoices.filters.paymentTerm.values.immediate'), /* Immediate */
              net: () => t('resources.invoices.filters.paymentTerm.values.net'), /* Net */
            },
          },
        },
        indicators: {
          notDueYet: () => t('resources.invoices.indicators.notDueYet'), /* Not due yet */
          unpaid: () => t('resources.invoices.indicators.unpaid'), /* Total unpaid */
          inProgress: () => t('resources.invoices.indicators.inProgress'), /* In progress */
          paid: () => t('resources.invoices.indicators.paid'), /* Paid */
          overdue: () => t('resources.invoices.indicators.overdue'), /* Overdue */
          invoicesAmount: (data: Record<'amount', unknown>) => t('resources.invoices.indicators.invoicesAmount', data), /* %{amount} invoices */
        },
      },
      'codat/companies': {
        name: () => t('resources.codat/companies.name'), /* Codat Company |||| Codat Companies */
        fields: {
          business: () => t('resources.codat/companies.fields.business'), /* Business */
          businessType: () => t('resources.codat/companies.fields.businessType'), /* Business Type */
        },
      },
      'codat/customers': {
        name: () => t('resources.codat/customers.name'), /* Codat Customer |||| Codat Customers */
        fields: {
          providerId: () => t('resources.codat/customers.fields.providerId'), /* Provider ID */
        },
      },
      'codat/invoices': {
        name: () => t('resources.codat/invoices.name'), /* Codat Invoice |||| Codat Invoices */
        fields: {
          providerId: () => t('resources.codat/invoices.fields.providerId'), /* Provider ID */
        },
      },
      'codat/company-refreshes': {
        name: () => t('resources.codat/company-refreshes.name'), /* Codat Company Refresh |||| Codat Company Refreshes */
        fields: {
          codatCompany: () => t('resources.codat/company-refreshes.fields.codatCompany'), /* Codat entity ID */
          companyId: () => t('resources.codat/company-refreshes.fields.companyId'), /* Codat company ID */
          dataType: () => t('resources.codat/company-refreshes.fields.dataType'), /* Data type */
          status: () => t('resources.codat/company-refreshes.fields.status'), /* Status */
          itemsSynced: () => t('resources.codat/company-refreshes.fields.itemsSynced'), /* Items synced */
        },
      },
      'codat-company-refresh-requests': {
        name: () => t('resources.codat-company-refresh-requests.name'), /* Codat Company Refresh Request |||| Codat Company Refresh Requests */
        fields: {
          codatCompany: () => t('resources.codat-company-refresh-requests.fields.codatCompany'), /* Company */
          type: () => t('resources.codat-company-refresh-requests.fields.type'), /* Type */
          status: () => t('resources.codat-company-refresh-requests.fields.status'), /* Status */
          data: () => t('resources.codat-company-refresh-requests.fields.data'), /* Data */
        },
      },
      'connected-accounts': {
        title: () => t('resources.connected-accounts.title'), /* Connected Accounts */
        name: () => t('resources.connected-accounts.name'), /* Connected Account |||| Connected Accounts */
        fields: {
          providerId: () => t('resources.connected-accounts.fields.providerId'), /* Provider Id */
          providerType: () => t('resources.connected-accounts.fields.providerType'), /* Provider Type */
          status: () => t('resources.connected-accounts.fields.status'), /* Status */
          enabledPaymentMethods: () => t('resources.connected-accounts.fields.enabledPaymentMethods'), /* Enabled payment methods */
          supportedCurrencies: () => t('resources.connected-accounts.fields.supportedCurrencies'), /* Supported Currencies */
        },
      },
      'connected-accounts/funds': {
        name: () => t('resources.connected-accounts/funds.name'), /* Connected Account Funds |||| Connected Account Funds */
        fields: {
          amount: () => t('resources.connected-accounts/funds.fields.amount'), /* Amount */
          providerId: () => t('resources.connected-accounts/funds.fields.providerId'), /* Provider Id */
        },
        show: {
          title: () => t('resources.connected-accounts/funds.show.title'), /* Connected Accounts Funds */
        },
        buttons: {
          create: () => t('resources.connected-accounts/funds.buttons.create'), /* Create Connected Account Funds */
          restore: () => t('resources.connected-accounts/funds.buttons.restore'), /* Restore Connected Account Funds */
        },
        modal: {
          title: () => t('resources.connected-accounts/funds.modal.title'), /* Create Connected Account Funds */
          successNotify: () => t('resources.connected-accounts/funds.modal.successNotify'), /* Connected Account Funds created successfully */
        },
        cards: {
          withdrawTooltip: () => t('resources.connected-accounts/funds.cards.withdrawTooltip'), /* Funds */
          noWithdrawTooltip: () => t('resources.connected-accounts/funds.cards.noWithdrawTooltip'), /* Airwallex Account is not active */
          currencyExchangeTooltip: () => t('resources.connected-accounts/funds.cards.currencyExchangeTooltip'), /* Convert */
        },
      },
      statements: {
        name: () => t('resources.statements.name'), /* Statement |||| Statements */
        list: {
          title: () => t('resources.statements.list.title'), /* Statement: Buyer ↔ Supplier */
          subtitle: () => t('resources.statements.list.subtitle'), /* Complete lifecycle of activity between buyer and supplier across payment requests, charges, fees, refunds, and funds. */
          balance: () => t('resources.statements.list.balance'), /* Balance: */
          totalTransactions: (data: Record<'count', unknown>) => t('resources.statements.list.totalTransactions', data), /* Total transactions: %{count} */
          requiredFiltersMessage: (data: Record<'filters', unknown>) => t('resources.statements.list.requiredFiltersMessage', data), /* Please select the following required filters to view statement data: %{filters} */
          amountDue: () => t('resources.statements.list.amountDue'), /* Amount Due */
          date: () => t('resources.statements.list.date'), /* Date */
        },
        filters: {
          buyer: () => t('resources.statements.filters.buyer'), /* Buyer */
          currency: () => t('resources.statements.filters.currency'), /* Currency */
          dateRange: () => t('resources.statements.filters.dateRange'), /* Date Range */
          createdAt: () => t('resources.statements.filters.createdAt'), /* Created At */
          startingBalance: () => t('resources.statements.filters.startingBalance'), /* Starting Balance */
          clearAll: () => t('resources.statements.filters.clearAll'), /* Clear all */
        },
        fields: {
          chargeViaWire: () => t('resources.statements.fields.chargeViaWire'), /* Charge via Wire */
        },
        agingSummary: {
          title: () => t('resources.statements.agingSummary.title'), /* Aging Summary */
          current: () => t('resources.statements.agingSummary.current'), /* Current */
          days1to30: () => t('resources.statements.agingSummary.days1to30'), /* 1-30 Days Past Due */
          days31to60: () => t('resources.statements.agingSummary.days31to60'), /* 31-60 Days Past Due */
          days61to90: () => t('resources.statements.agingSummary.days61to90'), /* 61-90 Days Past Due */
          over90: () => t('resources.statements.agingSummary.over90'), /* Over 90 Days Past Due */
          amountDue: () => t('resources.statements.agingSummary.amountDue'), /* Amount Due */
        },
      },
      'connected-accounts/charges': {
        name: () => t('resources.connected-accounts/charges.name'), /* Connected Account Charge |||| Connected Account Charges */
        fields: {
          amount: () => t('resources.connected-accounts/charges.fields.amount'), /* Amount */
          providerId: () => t('resources.connected-accounts/charges.fields.providerId'), /* Provider Id */
        },
        show: {
          title: () => t('resources.connected-accounts/charges.show.title'), /* Connected Accounts Charge */
        },
        buttons: {
          create: () => t('resources.connected-accounts/charges.buttons.create'), /* Create Connected Account Charge */
          restore: () => t('resources.connected-accounts/charges.buttons.restore'), /* Restore Connected Account Charge */
        },
      },
      'connected-accounts/currency-conversion': {
        name: () => t('resources.connected-accounts/currency-conversion.name'), /* Connected Account Currency Conversion |||| Connected Account Currency Conversions */
        fields: {
          amount: () => t('resources.connected-accounts/currency-conversion.fields.amount'), /* Amount */
          providerId: () => t('resources.connected-accounts/currency-conversion.fields.providerId'), /* Provider Id */
        },
        show: {
          title: () => t('resources.connected-accounts/currency-conversion.show.title'), /* Connected Accounts Currency Conversion */
        },
        buttons: {
          create: () => t('resources.connected-accounts/currency-conversion.buttons.create'), /* Create Connected Account Currency Conversion */
          restore: () => t('resources.connected-accounts/currency-conversion.buttons.restore'), /* Restore Connected Account Currency Conversion */
        },
      },
      'connected-accounts/activities': {
        name: () => t('resources.connected-accounts/activities.name'), /* Connected Account Activity |||| Connected Accounts Activities */
        show: {
          title: () => t('resources.connected-accounts/activities.show.title'), /* Connected Accounts Activity */
        },
        buttons: {
          showDeposit: () => t('resources.connected-accounts/activities.buttons.showDeposit'), /* Show Deposit Details */
          showPayout: () => t('resources.connected-accounts/activities.buttons.showPayout'), /* Show Payout Details */
        },
      },
      contacts: {
        name: () => t('resources.contacts.name'), /* Contact |||| Contacts */
        fields: {
          id: () => t('resources.contacts.fields.id'), /* ID */
          firstName: () => t('resources.contacts.fields.firstName'), /* First Name */
          lastName: () => t('resources.contacts.fields.lastName'), /* Last Name */
          email: () => t('resources.contacts.fields.email'), /* Email */
          phone: () => t('resources.contacts.fields.phone'), /* Phone */
          identificationType: () => t('resources.contacts.fields.identificationType'), /* Identification Type */
          identificationCode: () => t('resources.contacts.fields.identificationCode'), /* Identification Code */
          address: () => t('resources.contacts.fields.address'), /* Address */
          createdAt: () => t('resources.contacts.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.contacts.fields.updatedAt'), /* Updated at */
        },
        edit: {
          title: () => t('resources.contacts.edit.title'), /* Contact Identity */
          address: () => t('resources.contacts.edit.address'), /* Address */
          addContact: () => t('resources.contacts.edit.addContact'), /* Add Contact */
          editLabel: () => t('resources.contacts.edit.editLabel'), /* Edit */
        },
        show: {
          title: () => t('resources.contacts.show.title'), /* Contact Identity */
          address: () => t('resources.contacts.show.address'), /* Address */
        },
      },
      'buyers/:id/contacts': {
        name: () => t('resources.buyers/:id/contacts.name'), /* Contact |||| Contacts */
        fields: {
          id: () => t('resources.buyers/:id/contacts.fields.id'), /* ID */
          firstName: () => t('resources.buyers/:id/contacts.fields.firstName'), /* First Name */
          lastName: () => t('resources.buyers/:id/contacts.fields.lastName'), /* Last Name */
          title: () => t('resources.buyers/:id/contacts.fields.title'), /* Title */
          isPrimary: () => t('resources.buyers/:id/contacts.fields.isPrimary'), /* Is Primary */
          isOwner: () => t('resources.buyers/:id/contacts.fields.isOwner'), /* Is Owner */
          percentage: () => t('resources.buyers/:id/contacts.fields.percentage'), /* Percentage */
          hasSignatureRights: () => t('resources.buyers/:id/contacts.fields.hasSignatureRights'), /* Has Signature Rights */
          email: () => t('resources.buyers/:id/contacts.fields.email'), /* Email */
          phone: () => t('resources.buyers/:id/contacts.fields.phone'), /* Phone */
          identificationType: () => t('resources.buyers/:id/contacts.fields.identificationType'), /* Identification Type */
          identificationCode: () => t('resources.buyers/:id/contacts.fields.identificationCode'), /* Identification Code */
          identification: () => t('resources.buyers/:id/contacts.fields.identification'), /* Identification */
          address: () => t('resources.buyers/:id/contacts.fields.address'), /* Address */
          createdAt: () => t('resources.buyers/:id/contacts.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.buyers/:id/contacts.fields.updatedAt'), /* Updated at */
        },
        edit: {
          title: () => t('resources.buyers/:id/contacts.edit.title'), /* Contact Identity */
        },
      },
      'buyers/:id/instances': {
        name: () => t('resources.buyers/:id/instances.name'), /* Instance |||| Instances */
        fields: {
          id: () => t('resources.buyers/:id/instances.fields.id'), /* ID */
          name: () => t('resources.buyers/:id/instances.fields.name'), /* Name */
          displayName: () => t('resources.buyers/:id/instances.fields.displayName'), /* Business name */
          legalName: () => t('resources.buyers/:id/instances.fields.legalName'), /* Legal name */
          email: () => t('resources.buyers/:id/instances.fields.email'), /* Email */
          website: () => t('resources.buyers/:id/instances.fields.website'), /* Website */
          phone: () => t('resources.buyers/:id/instances.fields.phone'), /* Phone */
          dba: () => t('resources.buyers/:id/instances.fields.dba'), /* DBA */
          address: {
            country: () => t('resources.buyers/:id/instances.fields.address.country'), /* Country */
            city: () => t('resources.buyers/:id/instances.fields.address.city'), /* City */
            state: () => t('resources.buyers/:id/instances.fields.address.state'), /* State */
            full: () => t('resources.buyers/:id/instances.fields.address.full'), /* Address */
          },
          requestedCreditAmount: () => t('resources.buyers/:id/instances.fields.requestedCreditAmount'), /* Requested Amount */
          creditStatus: () => t('resources.buyers/:id/instances.fields.creditStatus'), /* Credit Status */
          creditLimit: () => t('resources.buyers/:id/instances.fields.creditLimit'), /* Credit Limit */
          availableCredit: () => t('resources.buyers/:id/instances.fields.availableCredit'), /* Available Credit */
          linkedFinancialConnections: () => t('resources.buyers/:id/instances.fields.linkedFinancialConnections'), /* Financial Connections Linked */
          bankAccountConnected: () => t('resources.buyers/:id/instances.fields.bankAccountConnected'), /* Bank Account Connected */
          externalId: () => t('resources.buyers/:id/instances.fields.externalId'), /* Buyer external Id */
          createdAt: () => t('resources.buyers/:id/instances.fields.createdAt'), /* Created at */
          identification: () => t('resources.buyers/:id/instances.fields.identification'), /* Identification */
          duns: () => t('resources.buyers/:id/instances.fields.duns'), /* DUNS */
          ein: () => t('resources.buyers/:id/instances.fields.ein'), /* EIN */
          cn: () => t('resources.buyers/:id/instances.fields.cn'), /* Company Number */
          bn: () => t('resources.buyers/:id/instances.fields.bn'), /* Business Number */
          updatedAt: () => t('resources.buyers/:id/instances.fields.updatedAt'), /* Updated at */
          linked: () => t('resources.buyers/:id/instances.fields.linked'), /* Linked */
          seller: {
            displayName: () => t('resources.buyers/:id/instances.fields.seller.displayName'), /* Supplier */
          },
          tenantId: () => t('resources.buyers/:id/instances.fields.tenantId'), /* Tenant */
        },
      },
      'user-consents': {
        name: () => t('resources.user-consents.name'), /* User Consent |||| User Consents */
      },
      invites: {
        name: () => t('resources.invites.name'), /* Invite |||| Invites */
        fields: {
          email: () => t('resources.invites.fields.email'), /* Email */
          status: () => t('resources.invites.fields.status'), /* Status */
          inviter: {
            entityId: () => t('resources.invites.fields.inviter.entityId'), /* Inviter */
            tenantId: () => t('resources.invites.fields.inviter.tenantId'), /* Tenant */
          },
          createdAt: () => t('resources.invites.fields.createdAt'), /* Invited at */
          createdBy: () => t('resources.invites.fields.createdBy'), /* Invited by */
          type: () => t('resources.invites.fields.type'), /* Invitation type */
        },
      },
      'invites/buyers': {
        name: () => t('resources.invites/buyers.name'), /* Invite |||| Invites */
        fields: {
          email: () => t('resources.invites/buyers.fields.email'), /* Email */
          status: () => t('resources.invites/buyers.fields.status'), /* Status */
          inviter: {
            entityId: () => t('resources.invites/buyers.fields.inviter.entityId'), /* Inviter */
            tenantId: () => t('resources.invites/buyers.fields.inviter.tenantId'), /* Tenant */
          },
          createdAt: () => t('resources.invites/buyers.fields.createdAt'), /* Invited at */
          createdBy: () => t('resources.invites/buyers.fields.createdBy'), /* Invited by */
          type: () => t('resources.invites/buyers.fields.type'), /* Type */
        },
      },
      leads: {
        name: () => t('resources.leads.name'), /* Lead |||| Leads */
        fields: {
          address: {
            country: () => t('resources.leads.fields.address.country'), /* Country */
          },
          contact: {
            id: () => t('resources.leads.fields.contact.id'), /* ID */
            firstName: () => t('resources.leads.fields.contact.firstName'), /* First Name */
            lastName: () => t('resources.leads.fields.contact.lastName'), /* Last Name */
            email: () => t('resources.leads.fields.contact.email'), /* Email */
            phone: () => t('resources.leads.fields.contact.phone'), /* Phone */
            identificationType: () => t('resources.leads.fields.contact.identificationType'), /* Identification Type */
            identificationCode: () => t('resources.leads.fields.contact.identificationCode'), /* Identification Code */
            address: () => t('resources.leads.fields.contact.address'), /* Address */
            website: () => t('resources.leads.fields.contact.website'), /* Website */
            createdAt: () => t('resources.leads.fields.contact.createdAt'), /* Created at */
            updatedAt: () => t('resources.leads.fields.contact.updatedAt'), /* Updated at */
            hasSignatureRights: () => t('resources.leads.fields.contact.hasSignatureRights'), /* Has Signature Rights */
          },
          legalName: () => t('resources.leads.fields.legalName'), /* Business name */
          email: () => t('resources.leads.fields.email'), /* Email */
          status: () => t('resources.leads.fields.status'), /* Status */
          invite: () => t('resources.leads.fields.invite'), /* Invited by */
          createdAt: () => t('resources.leads.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.leads.fields.updatedAt'), /* Updated at */
        },
        edit: {
          title: () => t('resources.leads.edit.title'), /* Lead Identity */
        },
      },
      'aiprize/companies': {
        name: () => t('resources.aiprize/companies.name'), /* Aiprise company |||| Aiprise companies */
        fields: {
          buyer: () => t('resources.aiprize/companies.fields.buyer'), /* Buyer */
          status: () => t('resources.aiprize/companies.fields.status'), /* Status */
          decision: () => t('resources.aiprize/companies.fields.decision'), /* Decision */
          match: () => t('resources.aiprize/companies.fields.match'), /* Match */
          lastVerificationExecutionDate: () => t('resources.aiprize/companies.fields.lastVerificationExecutionDate'), /* Verification execution */
          profileResult: {
            legalName: () => t('resources.aiprize/companies.fields.profileResult.legalName'), /* Legal Name */
            addresses: () => t('resources.aiprize/companies.fields.profileResult.addresses'), /* Addresses */
            tin: () => t('resources.aiprize/companies.fields.profileResult.tin'), /* Tax ID */
            relatedPersons: () => t('resources.aiprize/companies.fields.profileResult.relatedPersons'), /* Related Persons */
            relatedCompanies: () => t('resources.aiprize/companies.fields.profileResult.relatedCompanies'), /* Related Companies */
            businessScope: () => t('resources.aiprize/companies.fields.profileResult.businessScope'), /* Business Scope */
            registrationRecords: () => t('resources.aiprize/companies.fields.profileResult.registrationRecords'), /* Registration Records */
            amlInfo: () => t('resources.aiprize/companies.fields.profileResult.amlInfo'), /* AML Information */
            website: () => t('resources.aiprize/companies.fields.profileResult.website'), /* website */
            businessStartDate: () => t('resources.aiprize/companies.fields.profileResult.businessStartDate'), /* Business Start Date */
          },
          searchQuery: {
            legalName: () => t('resources.aiprize/companies.fields.searchQuery.legalName'), /* Legal Name */
            address: () => t('resources.aiprize/companies.fields.searchQuery.address'), /* Address */
            dba: () => t('resources.aiprize/companies.fields.searchQuery.dba'), /* Dba */
            website: () => t('resources.aiprize/companies.fields.searchQuery.website'), /* website */
            phone: () => t('resources.aiprize/companies.fields.searchQuery.phone'), /* Phone */
          },
        },
        actions: {
          createCompany: () => t('resources.aiprize/companies.actions.createCompany'), /* Create Company */
          createReport: () => t('resources.aiprize/companies.actions.createReport'), /* Create Report */
        },
      },
      'rutter/companies': {
        name: () => t('resources.rutter/companies.name'), /* Rutter company |||| Rutter companies */
        fields: {
          accessToken: () => t('resources.rutter/companies.fields.accessToken'), /* Access Token */
          bussinessType: () => t('resources.rutter/companies.fields.bussinessType'), /* Business Type */
          integrationConnections: () => t('resources.rutter/companies.fields.integrationConnections'), /* Integration Connections */
          syncInvoices: () => t('resources.rutter/companies.fields.syncInvoices'), /* Sync Invoices */
          syncCustomers: () => t('resources.rutter/companies.fields.syncCustomers'), /* Sync Customers */
          syncItems: () => t('resources.rutter/companies.fields.syncItems'), /* Sync Items */
        },
        actions: {
          sync: () => t('resources.rutter/companies.actions.sync'), /* Sync */
        },
      },
      'rutter/validation': {
        name: () => t('resources.rutter/validation.name'), /* Rutter validation |||| Rutter validations */
        fields: {
          providerIds: () => t('resources.rutter/validation.fields.providerIds'), /* Provider Ids */
          status: () => t('resources.rutter/validation.fields.status'), /* Status */
          entityType: () => t('resources.rutter/validation.fields.entityType'), /* Entity type */
        },
        create: {
          title: () => t('resources.rutter/validation.create.title'), /* New validation */
        },
        edit: {
          title: () => t('resources.rutter/validation.edit.title'), /* Edit validation */
        },
      },
      'request-logs': {
        name: () => t('resources.request-logs.name'), /* Request Log |||| Request Logs */
        pullButton: () => t('resources.request-logs.pullButton'), /* Pull request logs */
        fields: {
          id: () => t('resources.request-logs.fields.id'), /* ID */
          method: () => t('resources.request-logs.fields.method'), /* Request Method */
          url: () => t('resources.request-logs.fields.url'), /* URL */
          status: () => t('resources.request-logs.fields.status'), /* Status */
          requestBody: () => t('resources.request-logs.fields.requestBody'), /* Request Body */
          requestParams: () => t('resources.request-logs.fields.requestParams'), /* Request Parameters */
          requestQuery: () => t('resources.request-logs.fields.requestQuery'), /* Request Query */
          response: () => t('resources.request-logs.fields.response'), /* Response */
          createdAt: () => t('resources.request-logs.fields.createdAt'), /* Created at */
          createdBy: () => t('resources.request-logs.fields.createdBy'), /* Created by */
          origin: () => t('resources.request-logs.fields.origin'), /* Origin */
          error: () => t('resources.request-logs.fields.error'), /* Error */
        },
      },
      'erp-sync': {
        name: () => t('resources.erp-sync.name'), /* ERP Sync |||| ERP Syncs */
        fields: {
          id: () => t('resources.erp-sync.fields.id'), /* ID */
          status: () => t('resources.erp-sync.fields.status'), /* Status */
          lastSyncAt: () => t('resources.erp-sync.fields.lastSyncAt'), /* Last sync at */
          updatedAt: () => t('resources.erp-sync.fields.updatedAt'), /* Updated at */
          createdAt: () => t('resources.erp-sync.fields.createdAt'), /* Created at */
          createdBy: () => t('resources.erp-sync.fields.createdBy'), /* Created by */
        },
      },
      plaid: {
        name: () => t('resources.plaid.name'), /* Plaid access token |||| Plaid access tokens */
        fields: {
          accessToken: () => t('resources.plaid.fields.accessToken'), /* Access token */
          buyer: () => t('resources.plaid.fields.buyer'), /* Buyer */
          itemId: () => t('resources.plaid.fields.itemId'), /* Item ID */
          status: () => t('resources.plaid.fields.status'), /* Status */
          expirationDate: () => t('resources.plaid.fields.expirationDate'), /* Expiration date */
          accounts: {
            accountId: () => t('resources.plaid.fields.accounts.accountId'), /* Account ID */
            name: () => t('resources.plaid.fields.accounts.name'), /* Account name */
            mask: () => t('resources.plaid.fields.accounts.mask'), /* Account mask */
          },
          institution: {
            institutionId: () => t('resources.plaid.fields.institution.institutionId'), /* institution ID */
            name: () => t('resources.plaid.fields.institution.name'), /* Institution Name */
            logo: () => t('resources.plaid.fields.institution.logo'), /* Institution Logo */
            country: () => t('resources.plaid.fields.institution.country'), /* Country */
          },
        },
        actions: {
          refresh: () => t('resources.plaid.actions.refresh'), /* Refresh */
        },
      },
      'airwallex/recipients': {
        name: () => t('resources.airwallex/recipients.name'), /* Airwallex recipient |||| Airwallex recipients */
      },
      reports: {
        name: () => t('resources.reports.name'), /* Report |||| Reports */
        download: () => t('resources.reports.download'), /* Download report */
        aging: {
          name: () => t('resources.reports.aging.name'), /* Aging Report */
          description: () => t('resources.reports.aging.description'), /* A summary of overdue invoices categorized by age for tracking and collections */
          totals: () => t('resources.reports.aging.totals'), /* Totals */
        },
        'account-statements': {
          name: () => t('resources.reports.account-statements.name'), /* Account Statements */
          description: () => t('resources.reports.account-statements.description'), /* A comprehensive statements showing account activity, transactions, and balances */
          totals: () => t('resources.reports.account-statements.totals'), /* Summary */
        },
      },
      'airwallex/transfers': {
        name: () => t('resources.airwallex/transfers.name'), /* Airwallex transfer |||| Airwallex Transfers */
        fields: {
          recipientId: () => t('resources.airwallex/transfers.fields.recipientId'), /* Recipient ID */
          amount: () => t('resources.airwallex/transfers.fields.amount'), /* Amount */
          status: () => t('resources.airwallex/transfers.fields.status'), /* Status */
          transferId: () => t('resources.airwallex/transfers.fields.transferId'), /* Transfer ID */
          accountId: () => t('resources.airwallex/transfers.fields.accountId'), /* Account ID */
          action: () => t('resources.airwallex/transfers.fields.action'), /* Action */
          transactionId: () => t('resources.airwallex/transfers.fields.transactionId'), /* Transaction ID */
        },
        show: {
          title: () => t('resources.airwallex/transfers.show.title'), /* Airwallex Transfer */
        },
        buttons: {
          restore: () => t('resources.airwallex/transfers.buttons.restore'), /* Restore Transfer */
          confirmationLetterButton: () => t('resources.airwallex/transfers.buttons.confirmationLetterButton'), /* Confirmation Letter */
        },
      },
      'airwallex/global-accounts': {
        buttons: {
          statementLetterButton: () => t('resources.airwallex/global-accounts.buttons.statementLetterButton'), /* Statement Letter */
        },
      },
      'airwallex/funds-matching': {
        fields: {
          buyer: () => t('resources.airwallex/funds-matching.fields.buyer'), /* Buyer */
          buyerName: () => t('resources.airwallex/funds-matching.fields.buyerName'), /* Buyer Name */
        },
        show: {
          title: () => t('resources.airwallex/funds-matching.show.title'), /* Airwallex Funds Matching */
        },
      },
      'airwallex/intents': {
        name: () => t('resources.airwallex/intents.name'), /* Airwallex intent |||| Airwallex intents */
        fields: {
          providerId: () => t('resources.airwallex/intents.fields.providerId'), /* Provider ID */
          checkoutId: () => t('resources.airwallex/intents.fields.checkoutId'), /* Checkout ID */
          status: () => t('resources.airwallex/intents.fields.status'), /* Status */
        },
        show: {
          title: () => t('resources.airwallex/intents.show.title'), /* Intent Details */
        },
      },
      'airwallex/customers': {
        name: () => t('resources.airwallex/customers.name'), /* Airwallex customer |||| Airwallex customers */
        fields: {
          providerId: () => t('resources.airwallex/customers.fields.providerId'), /* Provider ID */
        },
        show: {
          title: () => t('resources.airwallex/customers.show.title'), /* Customer Details */
        },
      },
      'wise/transfers': {
        buttons: {
          restore: () => t('resources.wise/transfers.buttons.restore'), /* Restore Transfer */
        },
      },
      'wise/funds-matching': {
        show: {
          title: () => t('resources.wise/funds-matching.show.title'), /* Wise Funds Matching */
        },
      },
      'invoices/aging': {
        fields: {
          current: () => t('resources.invoices/aging.fields.current'), /* Current */
          overdue1To30: () => t('resources.invoices/aging.fields.overdue1To30'), /* 1 - 30 days overdue */
          overdue31To60: () => t('resources.invoices/aging.fields.overdue31To60'), /* 31 - 60 days overdue */
          overdue61To90: () => t('resources.invoices/aging.fields.overdue61To90'), /* 61 - 90 days overdue */
          overdue91AndOver: () => t('resources.invoices/aging.fields.overdue91AndOver'), /* over 91 days overdue */
          totalOverdue: () => t('resources.invoices/aging.fields.totalOverdue'), /* Total Overdue */
        },
      },
      'wiserfunding/companies': {
        name: () => t('resources.wiserfunding/companies.name'), /* Wiserfunding company |||| Wiserfunding companies */
        fields: {
          buyer: () => t('resources.wiserfunding/companies.fields.buyer'), /* Buyer */
          searchQuery: {
            legalName: () => t('resources.wiserfunding/companies.fields.searchQuery.legalName'), /* Legal Name */
            country: () => t('resources.wiserfunding/companies.fields.searchQuery.country'), /* Country */
          },
          searchResult: {
            legalName: () => t('resources.wiserfunding/companies.fields.searchResult.legalName'), /* legalName */
            companyId: () => t('resources.wiserfunding/companies.fields.searchResult.companyId'), /* companyId */
            address: () => t('resources.wiserfunding/companies.fields.searchResult.address'), /* Address */
            country: () => t('resources.wiserfunding/companies.fields.searchResult.country'), /* Country */
            businessStartDate: () => t('resources.wiserfunding/companies.fields.searchResult.businessStartDate'), /* Business start date */
            website: () => t('resources.wiserfunding/companies.fields.searchResult.website'), /* Website */
          },
          report: {
            reportId: () => t('resources.wiserfunding/companies.fields.report.reportId'), /* Report ID */
            reliability: () => t('resources.wiserfunding/companies.fields.report.reliability'), /* Reliability */
            smeScore: () => t('resources.wiserfunding/companies.fields.report.smeScore'), /* SME Score */
            lossGivenDefault: () => t('resources.wiserfunding/companies.fields.report.lossGivenDefault'), /* Loss Given Default */
            probabilityOfDefaultOneYear: () => t('resources.wiserfunding/companies.fields.report.probabilityOfDefaultOneYear'), /* Probability of Default One Year */
            bondRatingEquivalent: () => t('resources.wiserfunding/companies.fields.report.bondRatingEquivalent'), /* Bond Rating Equivalent */
          },
          match: () => t('resources.wiserfunding/companies.fields.match'), /* Match */
        },
        actions: {
          createCompany: () => t('resources.wiserfunding/companies.actions.createCompany'), /* Create Company */
          createReport: () => t('resources.wiserfunding/companies.actions.createReport'), /* Create Report */
        },
      },
      sellers: {
        name: () => t('resources.sellers.name'), /* Supplier |||| Suppliers */
        filters: {
          name: () => t('resources.sellers.filters.name'), /* User name */
        },
        fields: {
          id: () => t('resources.sellers.fields.id'), /* ID */
          displayName: () => t('resources.sellers.fields.displayName'), /* Business name */
          address: {
            country: () => t('resources.sellers.fields.address.country'), /* Country */
          },
        },
      },
      buyerOverview: {
        name: () => t('resources.buyerOverview.name'), /* Overview */
        title: (data: Record<'organizationName', unknown>) => t('resources.buyerOverview.title', data), /* Welcome %{organizationName}! */
      },
      supplierOverview: {
        name: () => t('resources.supplierOverview.name'), /* Overview */
        getStarted: () => t('resources.supplierOverview.getStarted'), /* Get started */
        supplierLink: {
          title: () => t('resources.supplierOverview.supplierLink.title'), /* Copy link to buyer portal login */
        },
        activityOverview: () => t('resources.supplierOverview.activityOverview'), /* Activity overview */
        currencyConversionInfo: () => t('resources.supplierOverview.currencyConversionInfo'), /* Currencies converted to<br />United States Dollar (US$) */
        showInvoices: () => t('resources.supplierOverview.showInvoices'), /* Show Invoices */
        showBuyers: () => t('resources.supplierOverview.showBuyers'), /* Show Buyers */
        showPayouts: () => t('resources.supplierOverview.showPayouts'), /* Show Payouts */
        addInvoice: {
          title: () => t('resources.supplierOverview.addInvoice.title'), /* Send invoices, get paid */
          description: (data: Record<'brandName', unknown>) => t('resources.supplierOverview.addInvoice.description', data), /* Getting paid with %{brandName} is fast and simple for you and your buyers. */
          addInvoice: () => t('resources.supplierOverview.addInvoice.addInvoice'), /* Add invoice */
        },
        ApplyForCreditBanner: {
          title: () => t('resources.supplierOverview.ApplyForCreditBanner.title'), /* Credit line */
          subtitle: () => t('resources.supplierOverview.ApplyForCreditBanner.subtitle'), /* Enable net terms by providing a credit line for this buyer */
          providerCreditButton: () => t('resources.supplierOverview.ApplyForCreditBanner.providerCreditButton'), /* Provide credit line */
          manageBuyerCreditButton: () => t('resources.supplierOverview.ApplyForCreditBanner.manageBuyerCreditButton'), /* Manage buyer credit */
        },
        CreditLineStatus: {
          title: () => t('resources.supplierOverview.CreditLineStatus.title'), /* Credit line status */
          provideCreditLineButton: () => t('resources.supplierOverview.CreditLineStatus.provideCreditLineButton'), /* Provide credit line */
        },
        CreditLineOverviewCard: {
          title: (data: Record<'provider', unknown>) => t('resources.supplierOverview.CreditLineOverviewCard.title', data), /* Credit line provided by %{provider} */
          TotalApprovedBuyersCard: {
            title: () => t('resources.supplierOverview.CreditLineOverviewCard.TotalApprovedBuyersCard.title'), /* Total approved buyers for credit line */
          },
          TotalApprovedCreditLineCard: {
            title: () => t('resources.supplierOverview.CreditLineOverviewCard.TotalApprovedCreditLineCard.title'), /* Total approved credit line */
          },
          TotalAvailableCredit: {
            title: () => t('resources.supplierOverview.CreditLineOverviewCard.TotalAvailableCredit.title'), /* Total available credit */
          },
          utilizedCredit: {
            title: () => t('resources.supplierOverview.CreditLineOverviewCard.utilizedCredit.title'), /* Utilized credit */
            percentageTotal: (data: Record<'percentage', unknown>) => t('resources.supplierOverview.CreditLineOverviewCard.utilizedCredit.percentageTotal', data), /* %{percentage}% of total */
            creditLimit: (data: Record<'limit', unknown>) => t('resources.supplierOverview.CreditLineOverviewCard.utilizedCredit.creditLimit', data), /* %{limit} credit limit */
          },
          paymentStatus: {
            title: () => t('resources.supplierOverview.CreditLineOverviewCard.paymentStatus.title'), /* Total unpaid */
            notDue: () => t('resources.supplierOverview.CreditLineOverviewCard.paymentStatus.notDue'), /* Not due yet */
            overdue: () => t('resources.supplierOverview.CreditLineOverviewCard.paymentStatus.overdue'), /* Overdue */
          },
        },
        CurrencyOverview: {
          available: () => t('resources.supplierOverview.CurrencyOverview.available'), /* Available */
          inTransit: () => t('resources.supplierOverview.CurrencyOverview.inTransit'), /* Payouts in transit */
          total: () => t('resources.supplierOverview.CurrencyOverview.total'), /* Total Paid */
          readyPayouts: () => t('resources.supplierOverview.CurrencyOverview.readyPayouts'), /* Payments being processed */
        },
        paidInvoices: {
          title: () => t('resources.supplierOverview.paidInvoices.title'), /* Paid invoices */
          totalPaidVolume: () => t('resources.supplierOverview.paidInvoices.totalPaidVolume'), /* Total paid volume */
          TotalPaidInvoices: () => t('resources.supplierOverview.paidInvoices.TotalPaidInvoices'), /* Total paid invoices */
        },
        unpaidInvoices: {
          title: () => t('resources.supplierOverview.unpaidInvoices.title'), /* Unpaid invoices */
          body: () => t('resources.supplierOverview.unpaidInvoices.body'), /* Total unpaid volume */
        },
        dso: {
          title: () => t('resources.supplierOverview.dso.title'), /* DSO */
          subtitle: () => t('resources.supplierOverview.dso.subtitle'), /* Last 90 days */
          tooltip: () => t('resources.supplierOverview.dso.tooltip'), /* Average days it takes your buyers to pay invoices */
          value: (data: Record<'value', unknown>) => t('resources.supplierOverview.dso.value', data), /* %{value} days */
        },
        agingReport: {
          title: () => t('resources.supplierOverview.agingReport.title'), /* Aging report */
          showReport: () => t('resources.supplierOverview.agingReport.showReport'), /* Show full report */
          emptyText: () => t('resources.supplierOverview.agingReport.emptyText'), /* Invoices categorized by age will be shown once there are overdue invoices */
          labels: {
            current: () => t('resources.supplierOverview.agingReport.labels.current'), /* Current */
            overdue1To30: () => t('resources.supplierOverview.agingReport.labels.overdue1To30'), /* 1-30 days */
            overdue31To60: () => t('resources.supplierOverview.agingReport.labels.overdue31To60'), /* 31-60 days */
            overdue61To90: () => t('resources.supplierOverview.agingReport.labels.overdue61To90'), /* 61-90 days */
            overdue91AndOver: () => t('resources.supplierOverview.agingReport.labels.overdue91AndOver'), /* 91+ days */
          },
        },
        totalPayments: {
          title: () => t('resources.supplierOverview.totalPayments.title'), /* Total payments */
          emptyText: () => t('resources.supplierOverview.totalPayments.emptyText'), /* Total payments per month will be shown once there are charges made */
        },
        averageNet: {
          title: () => t('resources.supplierOverview.averageNet.title'), /* Average net */
          subtitle: () => t('resources.supplierOverview.averageNet.subtitle'), /* Last 90 days */
          tooltip: () => t('resources.supplierOverview.averageNet.tooltip'), /* Average number of days it takes your buyers to pay invoices */
          value: (data: Record<'value', unknown>) => t('resources.supplierOverview.averageNet.value', data), /* %{value} days */
        },
        totalCoverByInsurance: {
          title: () => t('resources.supplierOverview.totalCoverByInsurance.title'), /* Total cover by insurance */
          value: (data: Record<'value', unknown>) => t('resources.supplierOverview.totalCoverByInsurance.value', data), /* $%{value} */
        },
        paidOnTime: {
          title: () => t('resources.supplierOverview.paidOnTime.title'), /* Paid on time */
          subtitle: () => t('resources.supplierOverview.paidOnTime.subtitle'), /* Last 90 days */
          tooltip: () => t('resources.supplierOverview.paidOnTime.tooltip'), /* Percentage of invoices paid before due date */
          value: (data: Record<'value', unknown>) => t('resources.supplierOverview.paidOnTime.value', data), /* %{value}% */
        },
        insuranceStatus: {
          title: () => t('resources.supplierOverview.insuranceStatus.title'), /* Insurance status */
          subtitle: (data: Record<'requestedDate', unknown>) => t('resources.supplierOverview.insuranceStatus.subtitle', data), /* Requested on %{requestedDate} */
          requestCover: () => t('resources.supplierOverview.insuranceStatus.requestCover'), /* Request cover */
          value: (data: Record<'value', unknown>) => t('resources.supplierOverview.insuranceStatus.value', data), /* %{value} */
        },
        aiSummary: {
          summary: () => t('resources.supplierOverview.aiSummary.summary'), /* Summary */
        },
        addBuyers: {
          title: () => t('resources.supplierOverview.addBuyers.title'), /* Get your buyers onboard */
          description: () => t('resources.supplierOverview.addBuyers.description'), /* You can pre-screen a buyer to get them approved for credit line or invite them to register through a link. */
          addBuyer: () => t('resources.supplierOverview.addBuyers.addBuyer'), /* Add a buyer */
          copyLink: () => t('resources.supplierOverview.addBuyers.copyLink'), /* Invite buyer */
        },
        checklist: {
          title: {
            setupCompleted: () => t('resources.supplierOverview.checklist.title.setupCompleted'), /* Your account is ready to go */
            setupIncomplete: () => t('resources.supplierOverview.checklist.title.setupIncomplete'), /* Finish your account setup */
          },
          addBankAccount: {
            title: () => t('resources.supplierOverview.checklist.addBankAccount.title'), /* Add bank account details */
            description: () => t('resources.supplierOverview.checklist.addBankAccount.description'), /* Add your bank account to start receiving payments. */
            addDetails: () => t('resources.supplierOverview.checklist.addBankAccount.addDetails'), /* Add details */
            detailsAdded: () => t('resources.supplierOverview.checklist.addBankAccount.detailsAdded'), /* Bank account added successfully */
          },
          addDetails: {
            title: () => t('resources.supplierOverview.checklist.addDetails.title'), /* Add your business details */
            description: () => t('resources.supplierOverview.checklist.addDetails.description'), /* Your business details helps us optimize the product offerings for you and your buyers. */
            addDetails: () => t('resources.supplierOverview.checklist.addDetails.addDetails'), /* Add details */
          },
          addSignatory: {
            title: () => t('resources.supplierOverview.checklist.addSignatory.title'), /* Add an authorized signatory */
            description: () => t('resources.supplierOverview.checklist.addSignatory.description'), /* An authorized signatory is a person legally empowered to sign official documents. */
            addSignatory: () => t('resources.supplierOverview.checklist.addSignatory.addSignatory'), /* Add signatory */
          },
          confirmFactoringAgreement: {
            title: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.title'), /* Confirm Factoring and Security Agreement */
            description: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.description'), /* To complete your company enrollment, you are required to confirm our Factoring and Security Agreement. */
            confirmAgreement: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.confirmAgreement'), /* Confirm agreement */
            noAuthorizedSignatory: {
              title: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.noAuthorizedSignatory.title'), /* Add an authorized signatory first */
              description: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.noAuthorizedSignatory.description'), /* You need to add an authorized signatory first to be able to confirm our Factoring and Security Agreement. */
              addSignatory: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.noAuthorizedSignatory.addSignatory'), /* Add signatory */
              cancel: () => t('resources.supplierOverview.checklist.confirmFactoringAgreement.noAuthorizedSignatory.cancel'), /* Cancel */
            },
          },
          confirmPaymentProcessingAgreement: {
            title: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.title'), /* Confirm Payment Processing Agreement */
            description: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.description'), /* To complete your company enrollment, you are required to confirm our Payment Processing Agreement. */
            confirmAgreement: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.confirmAgreement'), /* Confirm agreement */
            noAuthorizedSignatory: {
              title: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.noAuthorizedSignatory.title'), /* Add an authorized signatory first */
              description: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.noAuthorizedSignatory.description'), /* You need to add an authorized signatory first to be able to confirm our Payment Processing Agreement. */
              addSignatory: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.noAuthorizedSignatory.addSignatory'), /* Add signatory */
              cancel: () => t('resources.supplierOverview.checklist.confirmPaymentProcessingAgreement.noAuthorizedSignatory.cancel'), /* Cancel */
            },
          },
          airwallexKycOnboarding: {
            title: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.title'), /* Activate your account to start receiving payments */
            description: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.description'), /* Help us understand and verify your business so we can activate your account for payment. */
            confirmAgreement: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.confirmAgreement'), /* Start now */
            errorOccurred: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.errorOccurred'), /* An error occurred while activating your account. Please contact support. */
            onboardingSubmitted: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.onboardingSubmitted'), /* Your onboarding request has been submitted. We will notify you once it's approved. */
            onboardingSubmittedLabel: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.onboardingSubmittedLabel'), /* In progress */
            onboardingRfiLabel: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.onboardingRfiLabel'), /* Fill more information */
            transactionRfiLabel: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.transactionRfiLabel'), /* Release Funds */
            rfiChip: () => t('resources.supplierOverview.checklist.airwallexKycOnboarding.rfiChip'), /* New information required */
          },
          insuranceConnection: {
            title: () => t('resources.supplierOverview.checklist.insuranceConnection.title'), /* Connect insurance policy */
            description: () => t('resources.supplierOverview.checklist.insuranceConnection.description'), /* Verify your coverage to provide credit line to your buyers */
            detailsAdded: () => t('resources.supplierOverview.checklist.insuranceConnection.detailsAdded'), /* Insurance policy connected successfully */
            addDetails: () => t('resources.supplierOverview.checklist.insuranceConnection.addDetails'), /* Connect insurance */
          },
        },
      },
      account: {
        name: () => t('resources.account.name'), /* Account |||| Account */
        tabs: {
          getStarted: () => t('resources.account.tabs.getStarted'), /* Get Started */
          profile: () => t('resources.account.tabs.profile'), /* Profile */
          users: () => t('resources.account.tabs.users'), /* Users */
          emails: () => t('resources.account.tabs.emails'), /* Emails */
          paymentMethods: () => t('resources.account.tabs.paymentMethods'), /* Payment methods */
          financialInformation: () => t('resources.account.tabs.financialInformation'), /* Financial information */
          bankAccounts: () => t('resources.account.tabs.bankAccounts'), /* Bank Accounts */
          documents: () => t('resources.account.tabs.documents'), /* Documents */
          notifications: () => t('resources.account.tabs.notifications'), /* Notifications */
        },
      },
      referrals: {
        name: () => t('resources.referrals.name'), /* Referral |||| Referrals */
        fields: {
          organization: () => t('resources.referrals.fields.organization'), /* Organization */
          referrer: () => t('resources.referrals.fields.referrer'), /* Referrer */
          referee: () => t('resources.referrals.fields.referee'), /* Referee */
        },
      },
      users: {
        name: () => t('resources.users.name'), /* User |||| Users */
        filters: {
          search: () => t('resources.users.filters.search'), /* User name */
          roles: {
            label: () => t('resources.users.filters.roles.label'), /* Roles */
            values: {
              supplier: () => t('resources.users.filters.roles.values.supplier'), /* Supplier */
              buyer: () => t('resources.users.filters.roles.values.buyer'), /* Buyer */
            },
          },
        },
        fields: {
          id: () => t('resources.users.fields.id'), /* ID */
          name: () => t('resources.users.fields.name'), /* Name */
          email: () => t('resources.users.fields.email'), /* Email */
          status: () => t('resources.users.fields.status'), /* Status */
          auth0userId: () => t('resources.users.fields.auth0userId'), /* Auth0 user ID */
          createdAt: () => t('resources.users.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.users.fields.updatedAt'), /* Updated at */
          picture: () => t('resources.users.fields.picture'), /* Picture */
          roles: () => t('resources.users.fields.roles'), /* Roles */
          permissions: {
            buyers: () => t('resources.users.fields.permissions.buyers'), /* Buyer permissions */
          },
          tenants: () => t('resources.users.fields.tenants'), /* Tenants */
        },
        edit: {
          title: () => t('resources.users.edit.title'), /* User Identity */
          picture: () => t('resources.users.edit.picture'), /* Picture */
        },
        show: {
          title: () => t('resources.users.show.title'), /* User Identity */
          buyerPermissionsLabel: () => t('resources.users.show.buyerPermissionsLabel'), /* Buyer permissions */
        },
      },
      'users/suppliers': {
        name: () => t('resources.users/suppliers.name'), /* User |||| Users */
        filters: {
          name: () => t('resources.users/suppliers.filters.name'), /* User name */
        },
        fields: {
          id: () => t('resources.users/suppliers.fields.id'), /* ID */
          name: () => t('resources.users/suppliers.fields.name'), /* Name */
          email: () => t('resources.users/suppliers.fields.email'), /* Email */
          status: () => t('resources.users/suppliers.fields.status'), /* Status */
          auth0userId: () => t('resources.users/suppliers.fields.auth0userId'), /* Auth0 user ID */
          createdAt: () => t('resources.users/suppliers.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.users/suppliers.fields.updatedAt'), /* Updated at */
          picture: () => t('resources.users/suppliers.fields.picture'), /* Picture */
          roles: () => t('resources.users/suppliers.fields.roles'), /* Roles */
          permissions: {
            buyers: () => t('resources.users/suppliers.fields.permissions.buyers'), /* Buyer permissions */
          },
          tenants: () => t('resources.users/suppliers.fields.tenants'), /* Tenants */
        },
        list: {
          inviteLabel: () => t('resources.users/suppliers.list.inviteLabel'), /* Invite user */
          inviteDialog: {
            buttonLabel: () => t('resources.users/suppliers.list.inviteDialog.buttonLabel'), /* Invite */
            sendInvite: () => t('resources.users/suppliers.list.inviteDialog.sendInvite'), /* Send invite */
            invitationSuccessMessage: () => t('resources.users/suppliers.list.inviteDialog.invitationSuccessMessage'), /* Invitation successfully sent */
            inviteAuserToJoin: (data: Record<'organizationName', unknown>) => t('resources.users/suppliers.list.inviteDialog.inviteAuserToJoin', data), /* Invite a user to join %{organizationName} */
            sendInvitationByEmail: () => t('resources.users/suppliers.list.inviteDialog.sendInvitationByEmail'), /* Send invitation email to this user */
          },
        },
        edit: {
          title: () => t('resources.users/suppliers.edit.title'), /* User Identity */
          picture: () => t('resources.users/suppliers.edit.picture'), /* Picture */
        },
        show: {
          title: () => t('resources.users/suppliers.show.title'), /* User Identity */
        },
      },
      'users/buyers': {
        name: () => t('resources.users/buyers.name'), /* User |||| Users */
        filters: {
          name: () => t('resources.users/buyers.filters.name'), /* User name */
        },
        fields: {
          id: () => t('resources.users/buyers.fields.id'), /* ID */
          name: () => t('resources.users/buyers.fields.name'), /* Name */
          email: () => t('resources.users/buyers.fields.email'), /* Email */
          status: () => t('resources.users/buyers.fields.status'), /* Status */
          auth0userId: () => t('resources.users/buyers.fields.auth0userId'), /* Auth0 user ID */
          createdAt: () => t('resources.users/buyers.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.users/buyers.fields.updatedAt'), /* Updated at */
          picture: () => t('resources.users/buyers.fields.picture'), /* Picture */
          roles: () => t('resources.users/buyers.fields.roles'), /* Roles */
          permissions: {
            buyers: () => t('resources.users/buyers.fields.permissions.buyers'), /* Buyer permissions */
          },
        },
        edit: {
          title: () => t('resources.users/buyers.edit.title'), /* User Identity */
          picture: () => t('resources.users/buyers.edit.picture'), /* Picture */
        },
        show: {
          title: () => t('resources.users/buyers.show.title'), /* User Identity */
        },
      },
      'business-verification': {
        name: () => t('resources.business-verification.name'), /* Business Verification |||| Business Verifications */
        fields: {
          id: () => t('resources.business-verification.fields.id'), /* ID */
          business: () => t('resources.business-verification.fields.business'), /* Buyer */
          businessConfirmation: () => t('resources.business-verification.fields.businessConfirmation'), /* Confirmation */
          searchMatch: {
            legalName: () => t('resources.business-verification.fields.searchMatch.legalName'), /* Legal Name */
            address: () => t('resources.business-verification.fields.searchMatch.address'), /* Address */
            dba: () => t('resources.business-verification.fields.searchMatch.dba'), /* DBA */
            phone: () => t('resources.business-verification.fields.searchMatch.phone'), /* Phone */
            duns: () => t('resources.business-verification.fields.searchMatch.duns'), /* DUNS */
            businessStartDate: () => t('resources.business-verification.fields.searchMatch.businessStartDate'), /* Business Start Date */
            score: () => t('resources.business-verification.fields.searchMatch.score'), /* Score */
          },
          ownershipMatch: () => t('resources.business-verification.fields.ownershipMatch'), /* Ownership Match */
        },
      },
      buyers: {
        name: () => t('resources.buyers.name'), /* Buyer |||| Buyers */
        fields: {
          id: () => t('resources.buyers.fields.id'), /* ID */
          name: () => t('resources.buyers.fields.name'), /* Name */
          displayName: () => t('resources.buyers.fields.displayName'), /* Business name */
          legalName: () => t('resources.buyers.fields.legalName'), /* Legal name */
          email: () => t('resources.buyers.fields.email'), /* Email */
          website: () => t('resources.buyers.fields.website'), /* Website */
          phone: () => t('resources.buyers.fields.phone'), /* Phone */
          dba: () => t('resources.buyers.fields.dba'), /* DBA */
          address: {
            country: () => t('resources.buyers.fields.address.country'), /* Country */
            city: () => t('resources.buyers.fields.address.city'), /* City */
            state: () => t('resources.buyers.fields.address.state'), /* State */
            full: () => t('resources.buyers.fields.address.full'), /* Address */
          },
          requestedCreditAmount: () => t('resources.buyers.fields.requestedCreditAmount'), /* Requested Amount */
          creditStatus: () => t('resources.buyers.fields.creditStatus'), /* Credit Status */
          creditLimit: () => t('resources.buyers.fields.creditLimit'), /* Credit Limit */
          creditProvider: () => t('resources.buyers.fields.creditProvider'), /* Credit Provider */
          availableCredit: () => t('resources.buyers.fields.availableCredit'), /* Available Credit */
          linkedFinancialConnections: () => t('resources.buyers.fields.linkedFinancialConnections'), /* Financial Connections Linked */
          bankAccountConnected: () => t('resources.buyers.fields.bankAccountConnected'), /* Bank Account Connected */
          automaticPaymentEnabled: () => t('resources.buyers.fields.automaticPaymentEnabled'), /* Automatic Payment Enabled */
          externalId: () => t('resources.buyers.fields.externalId'), /* Buyer external Id */
          createdAt: () => t('resources.buyers.fields.createdAt'), /* Created at */
          identification: () => t('resources.buyers.fields.identification'), /* Identification */
          duns: () => t('resources.buyers.fields.duns'), /* DUNS */
          ein: () => t('resources.buyers.fields.ein'), /* EIN */
          cn: () => t('resources.buyers.fields.cn'), /* Company Number */
          bn: () => t('resources.buyers.fields.bn'), /* Business Number */
          updatedAt: () => t('resources.buyers.fields.updatedAt'), /* Updated at */
          openBalance: () => t('resources.buyers.fields.openBalance'), /* Open Balance */
          unpaidInvoices: () => t('resources.buyers.fields.unpaidInvoices'), /* Unpaid Invoices */
          creditLietStatus: {
            providedBy: (data: Record<'provider', unknown>) => t('resources.buyers.fields.creditLietStatus.providedBy', data), /* by %{provider} */
            requestedAmount: (data: Record<'amount', unknown>) => t('resources.buyers.fields.creditLietStatus.requestedAmount', data), /* Requested: %{amount} */
          },
          creditLine: {
            status: () => t('resources.buyers.fields.creditLine.status'), /* Credit Status */
            creditLimit: () => t('resources.buyers.fields.creditLine.creditLimit'), /* Credit Limit */
            provider: () => t('resources.buyers.fields.creditLine.provider'), /* Credit Provider */
            requestedAmount: () => t('resources.buyers.fields.creditLine.requestedAmount'), /* Requested Amount */
          },
          openBalanceSeparate: () => t('resources.buyers.fields.openBalanceSeparate'), /* Open Balance */
          openBalanceSeparateOverdue: () => t('resources.buyers.fields.openBalanceSeparateOverdue'), /* Overdue balance */
          unpaidInvoicesSeparate: () => t('resources.buyers.fields.unpaidInvoicesSeparate'), /* Unpaid invoices */
          unpaidInvoicesSeparateOverdue: () => t('resources.buyers.fields.unpaidInvoicesSeparateOverdue'), /* Overdue invoices */
          currency: () => t('resources.buyers.fields.currency'), /* Currency */
          reference: () => t('resources.buyers.fields.reference'), /* Reference */
          contactDetails: () => t('resources.buyers.fields.contactDetails'), /* Contact details */
        },
        checklist: {
          title: {
            applicationCompleted: {
              buyer: () => t('resources.buyers.checklist.title.applicationCompleted.buyer'), /* Credit application is completed and being reviewed */
              supplier: () => t('resources.buyers.checklist.title.applicationCompleted.supplier'), /* Your buyer credit application is completed and being reviewed */
            },
            applicationIncomplete: {
              buyer: () => t('resources.buyers.checklist.title.applicationIncomplete.buyer'), /* Credit application is incomplete */
              supplier: () => t('resources.buyers.checklist.title.applicationIncomplete.supplier'), /* Your buyer credit application is incomplete */
            },
          },
          fastestApproval: () => t('resources.buyers.checklist.fastestApproval'), /* Fastest approval */
          faqLink: () => t('resources.buyers.checklist.faqLink'), /* Learn more */
          verifyUserInProgress: () => t('resources.buyers.checklist.verifyUserInProgress'), /* Verifying */
          invitationSent: () => t('resources.buyers.checklist.invitationSent'), /* Invitation sent */
          createAccount: {
            title: () => t('resources.buyers.checklist.createAccount.title'), /* Create 40seas account */
            buyerDescription: () => t('resources.buyers.checklist.createAccount.buyerDescription'), /* Create a 40seas account to get started with the credit application process */
            supplierDescription: (data: Record<'faqLink', unknown>) => t('resources.buyers.checklist.createAccount.supplierDescription', data), /* To get your buyer approved for credit line they need to sign up and complete their onboarding. Share this link with your buyer to complete the process.
             %{faqLink} about buyers sign up process */
          },
          confirmBusinessDetails: {
            title: () => t('resources.buyers.checklist.confirmBusinessDetails.title'), /* Confirm business details */
            buyerDescription: () => t('resources.buyers.checklist.confirmBusinessDetails.buyerDescription'), /* Review and confirm the business details */
          },
          identityVerification: {
            title: () => t('resources.buyers.checklist.identityVerification.title'), /* Identity verification */
            buyerDescription: () => t('resources.buyers.checklist.identityVerification.buyerDescription'), /* Confirm your identity with a valid photo ID and a selfie to make sure it's yours */
          },
          connectBankAccount: {
            title: () => t('resources.buyers.checklist.connectBankAccount.title'), /* Connect bank account */
            buyerDescription: () => t('resources.buyers.checklist.connectBankAccount.buyerDescription'), /* Connecting your bank account supports us to verify your business and use as a payment method in a few seconds */
          },
          uploadFinancialDocuments: {
            title: () => t('resources.buyers.checklist.uploadFinancialDocuments.title'), /* Upload financial documents */
            buyerDescription: () => t('resources.buyers.checklist.uploadFinancialDocuments.buyerDescription'), /* Please, upload the requested financial documents so that we can verify the business and process the credit application */
          },
          buyerGuarantee: {
            title: () => t('resources.buyers.checklist.buyerGuarantee.title'), /* Sign a personal guarantee */
            buyerDescription: () => t('resources.buyers.checklist.buyerGuarantee.buyerDescription'), /* A personal guarantee will support approval of your full credit limit */
          },
          businessOwner: {
            title: () => t('resources.buyers.checklist.businessOwner.title'), /* Add business owners details */
            buyerDescription: () => t('resources.buyers.checklist.businessOwner.buyerDescription'), /* The owner details are used to check eligibility for credit */
          },
          creditReferences: {
            title: () => t('resources.buyers.checklist.creditReferences.title'), /* Add credit references */
            buyerDescription: () => t('resources.buyers.checklist.creditReferences.buyerDescription'), /* Add credit references to support your credit application */
          },
        },
        filters: {
          buyerName: () => t('resources.buyers.filters.buyerName'), /* Buyer name */
          search: () => t('resources.buyers.filters.search'), /* Search */
          creditLineStatus: () => t('resources.buyers.filters.creditLineStatus'), /* Credit line status */
          bankAccount: {
            label: () => t('resources.buyers.filters.bankAccount.label'), /* Bank account */
            values: {
              true: () => t('resources.buyers.filters.bankAccount.values.true'), /* Connected */
              false: () => t('resources.buyers.filters.bankAccount.values.false'), /* Not connected */
            },
          },
        },
        edit: {
          title: () => t('resources.buyers.edit.title'), /* Buyer Identity */
          identificationType: () => t('resources.buyers.edit.identificationType'), /* Identification Type */
          address: () => t('resources.buyers.edit.address'), /* Address */
          paymentOptions: () => t('resources.buyers.edit.paymentOptions'), /* Payment Options */
          paymentMethods: () => t('resources.buyers.edit.paymentMethods'), /* Payment methods */
          businessContacts: () => t('resources.buyers.edit.businessContacts'), /* Business Contacts */
        },
        actions: {
          create: () => t('resources.buyers.actions.create'), /* Add buyer */
          addBuyer: () => t('resources.buyers.actions.addBuyer'), /* Add buyer */
          invoice: () => t('resources.buyers.actions.invoice'), /* Add invoice */
          checkout: () => t('resources.buyers.actions.checkout'), /* Add Checkout */
          funds: () => t('resources.buyers.actions.funds'), /* Add Funds */
          creditLineRequest: () => t('resources.buyers.actions.creditLineRequest'), /* Add Request */
          underwriting: () => t('resources.buyers.actions.underwriting'), /* Add Underwriting */
          addDetails: () => t('resources.buyers.actions.addDetails'), /* Add details */
          creditReview: () => t('resources.buyers.actions.creditReview'), /* Manage credit */
        },
        show: {
          verifyTooltip: () => t('resources.buyers.show.verifyTooltip'), /* Buyer signed up */
          requestCoverSuccessMessage: () => t('resources.buyers.show.requestCoverSuccessMessage'), /* Request cover sent successfully */
          requestCoverButtonLabel: () => t('resources.buyers.show.requestCoverButtonLabel'), /* Request cover */
          buyerFinancialConnections: {
            listTitle: () => t('resources.buyers.show.buyerFinancialConnections.listTitle'), /* Financial connections */
            buttonText: () => t('resources.buyers.show.buyerFinancialConnections.buttonText'), /* Add Financial Connection */
            addBankMessage: () => t('resources.buyers.show.buyerFinancialConnections.addBankMessage'), /* To connect their bank account send this link to your buyer */
            addAnotherBankMessage: () => t('resources.buyers.show.buyerFinancialConnections.addAnotherBankMessage'), /* To connect another bank account send this link to your buyer */
            CopyFinancialConnectionLinkButton: {
              providerPlaceholder: () => t('resources.buyers.show.buyerFinancialConnections.CopyFinancialConnectionLinkButton.providerPlaceholder'), /* Provider */
              countryPlaceholder: () => t('resources.buyers.show.buyerFinancialConnections.CopyFinancialConnectionLinkButton.countryPlaceholder'), /* Country */
            },
            providers: {
              Stripe: () => t('resources.buyers.show.buyerFinancialConnections.providers.Stripe'), /* Stripe */
              GoCardLess: () => t('resources.buyers.show.buyerFinancialConnections.providers.GoCardLess'), /* GocardLess */
              Plaid: () => t('resources.buyers.show.buyerFinancialConnections.providers.Plaid'), /* Plaid */
              Codat: () => t('resources.buyers.show.buyerFinancialConnections.providers.Codat'), /* Codat */
              Documents: () => t('resources.buyers.show.buyerFinancialConnections.providers.Documents'), /* Documents */
              Wise: () => t('resources.buyers.show.buyerFinancialConnections.providers.Wise'), /* Wise */
              OrdersHistory: () => t('resources.buyers.show.buyerFinancialConnections.providers.OrdersHistory'), /* OrdersHistory */
              Other: () => t('resources.buyers.show.buyerFinancialConnections.providers.Other'), /* Other */
              PersonalGuarantee: () => t('resources.buyers.show.buyerFinancialConnections.providers.PersonalGuarantee'), /* Personal guarantee */
            },
          },
          buyerPaymentMethod: {
            listTitle: () => t('resources.buyers.show.buyerPaymentMethod.listTitle'), /* Payment methods */
            buttonText: () => t('resources.buyers.show.buyerPaymentMethod.buttonText'), /* Add Payment Method */
            addPaymentMethodMessage: () => t('resources.buyers.show.buyerPaymentMethod.addPaymentMethodMessage'), /* To connect their bank account send this link to your buyer */
            addAnotherPaymentMethodMessage: () => t('resources.buyers.show.buyerPaymentMethod.addAnotherPaymentMethodMessage'), /* To connect another bank account send this link to your buyer */
          },
          buyerVirtualAccount: {
            buttonTitle: () => t('resources.buyers.show.buyerVirtualAccount.buttonTitle'), /* View virtual account */
            title: () => t('resources.buyers.show.buyerVirtualAccount.title'), /* View Virtual Account */
            currency: () => t('resources.buyers.show.buyerVirtualAccount.currency'), /* Currency */
            button: () => t('resources.buyers.show.buyerVirtualAccount.button'), /* View account */
            loadingButton: () => t('resources.buyers.show.buyerVirtualAccount.loadingButton'), /* Loading account... */
          },
          accountStatements: {
            title: () => t('resources.buyers.show.accountStatements.title'), /* Create account statements */
            sendTo: () => t('resources.buyers.show.accountStatements.sendTo'), /* Send To */
            addRecipients: () => t('resources.buyers.show.accountStatements.addRecipients'), /* Add recipients */
            enterToAdd: () => t('resources.buyers.show.accountStatements.enterToAdd'), /* Press enter to add multiple emails */
            noPdf: () => t('resources.buyers.show.accountStatements.noPdf'), /* No PDF available */
            retryButton: () => t('resources.buyers.show.accountStatements.retryButton'), /* Retry */
            downloadPdf: () => t('resources.buyers.show.accountStatements.downloadPdf'), /* Download PDF */
            sendToBuyer: () => t('resources.buyers.show.accountStatements.sendToBuyer'), /* Send to Buyer */
            sendingEmail: () => t('resources.buyers.show.accountStatements.sendingEmail'), /* Sending... */
            successMessage: () => t('resources.buyers.show.accountStatements.successMessage'), /* Account statement sent successfully */
            errorLoadingPdf: () => t('resources.buyers.show.accountStatements.errorLoadingPdf'), /* Error loading PDF */
            errorGeneratingPdf: () => t('resources.buyers.show.accountStatements.errorGeneratingPdf'), /* Failed to generate PDF */
            errorSendingStatement: () => t('resources.buyers.show.accountStatements.errorSendingStatement'), /* Failed to send account statement */
          },
          tabs: {
            invoices: () => t('resources.buyers.show.tabs.invoices'), /* Invoices */
            checkouts: () => t('resources.buyers.show.tabs.checkouts'), /* Checkouts */
            identity: () => t('resources.buyers.show.tabs.identity'), /* Identity */
            funds: () => t('resources.buyers.show.tabs.funds'), /* Funds */
            businessDetails: () => t('resources.buyers.show.tabs.businessDetails'), /* Business details */
            financialConnection: () => t('resources.buyers.show.tabs.financialConnection'), /* Financial connections */
            paymentMethods: () => t('resources.buyers.show.tabs.paymentMethods'), /* Payment methods */
            charges: () => t('resources.buyers.show.tabs.charges'), /* Charges */
            creditRequests: () => t('resources.buyers.show.tabs.creditRequests'), /* Credit requests */
            users: () => t('resources.buyers.show.tabs.users'), /* Users */
            underwritings: () => t('resources.buyers.show.tabs.underwritings'), /* Underwritings */
            instances: () => t('resources.buyers.show.tabs.instances'), /* Instances */
            notifications: () => t('resources.buyers.show.tabs.notifications'), /* Notifications */
          },
          identity: {
            title: () => t('resources.buyers.show.identity.title'), /* Identity Information */
            loading: () => t('resources.buyers.show.identity.loading'), /* Loading identity information... */
            noData: () => t('resources.buyers.show.identity.noData'), /* No identity information available */
            table: {
              field: () => t('resources.buyers.show.identity.table.field'), /* Field */
              verifiedData: () => t('resources.buyers.show.identity.table.verifiedData'), /* Verified Data */
            },
            fields: {
              legalName: () => t('resources.buyers.show.identity.fields.legalName'), /* Legal Name */
              address: () => t('resources.buyers.show.identity.fields.address'), /* Address */
              confidenceScore: () => t('resources.buyers.show.identity.fields.confidenceScore'), /* Confidence Score */
              registrationNumber: () => t('resources.buyers.show.identity.fields.registrationNumber'), /* Registration Number */
              vatNumber: () => t('resources.buyers.show.identity.fields.vatNumber'), /* VAT/Tax Number */
              emailAddresses: () => t('resources.buyers.show.identity.fields.emailAddresses'), /* Email Addresses */
              website: () => t('resources.buyers.show.identity.fields.website'), /* Website */
              businessType: () => t('resources.buyers.show.identity.fields.businessType'), /* Business Type */
              businessStartDate: () => t('resources.buyers.show.identity.fields.businessStartDate'), /* Business Start Date */
              amlInfo: () => t('resources.buyers.show.identity.fields.amlInfo'), /* AML Info */
            },
            status: {
              verified: () => t('resources.buyers.show.identity.status.verified'), /* Verified */
              unverified: () => t('resources.buyers.show.identity.status.unverified'), /* Unverified */
              pending: () => t('resources.buyers.show.identity.status.pending'), /* Pending */
            },
            matchScore: (data: Record<'score', unknown>) => t('resources.buyers.show.identity.matchScore', data), /* Score: %{score} */
            actions: {
              verify: () => t('resources.buyers.show.identity.actions.verify'), /* Verify */
              verifySuccess: () => t('resources.buyers.show.identity.actions.verifySuccess'), /* Identity verified successfully */
              verifyError: () => t('resources.buyers.show.identity.actions.verifyError'), /* Failed to verify identity */
            },
            candidateSelector: {
              bannerMessage: () => t('resources.buyers.show.identity.candidateSelector.bannerMessage'), /* Multiple identity candidates found. Please select the correct match. */
              selectButton: () => t('resources.buyers.show.identity.candidateSelector.selectButton'), /* Select Candidate */
              dialogTitle: () => t('resources.buyers.show.identity.candidateSelector.dialogTitle'), /* Select Identity Candidate */
              dialogDescription: () => t('resources.buyers.show.identity.candidateSelector.dialogDescription'), /* Please select the correct business identity match from the candidates below. */
              noScoreBreakdown: () => t('resources.buyers.show.identity.candidateSelector.noScoreBreakdown'), /* No score breakdown available */
              confirmButton: () => t('resources.buyers.show.identity.candidateSelector.confirmButton'), /* Confirm */
              confirmingButton: () => t('resources.buyers.show.identity.candidateSelector.confirmingButton'), /* Confirming... */
              cancelButton: () => t('resources.buyers.show.identity.candidateSelector.cancelButton'), /* Cancel */
              confirmSuccess: () => t('resources.buyers.show.identity.candidateSelector.confirmSuccess'), /* Identity candidate confirmed successfully */
              confirmError: () => t('resources.buyers.show.identity.candidateSelector.confirmError'), /* Failed to confirm identity candidate */
            },
            resetDecision: {
              button: () => t('resources.buyers.show.identity.resetDecision.button'), /* Reset */
              success: () => t('resources.buyers.show.identity.resetDecision.success'), /* Identity decision reset successfully */
              error: () => t('resources.buyers.show.identity.resetDecision.error'), /* Failed to reset identity decision */
            },
          },
          buyerAlerts: {
            buyersNotSigned: () => t('resources.buyers.show.buyerAlerts.buyersNotSigned'), /* Buyer hasn't signed up yet */
            buyersNotSignedShareLink: () => t('resources.buyers.show.buyerAlerts.buyersNotSignedShareLink'), /* Share this link with your buyer to sign up to your client portal. */
            copyLink: () => t('resources.buyers.show.buyerAlerts.copyLink'), /* Copy link */
            buyerIsEligle: () => t('resources.buyers.show.buyerAlerts.buyerIsEligle'), /* Your buyer is eligible for a credit line! */
            inviteTheBuyer: () => t('resources.buyers.show.buyerAlerts.inviteTheBuyer'), /* Invite them to sign up and complete the credit application at the client portal. */
            buyerIsNotEligble: () => t('resources.buyers.show.buyerAlerts.buyerIsNotEligble'), /* Your buyer was found not eligible for a credit line */
            inviteBuyerWithoutCredit: () => t('resources.buyers.show.buyerAlerts.inviteBuyerWithoutCredit'), /* You can invite them to sign up to the client portal to view and pay their invoices. */
            buyerCreditUnknown: () => t('resources.buyers.show.buyerAlerts.buyerCreditUnknown'), /* We couldn't determine if the buyer is eligible for a credit line */
            inviteBuyerForDetails: () => t('resources.buyers.show.buyerAlerts.inviteBuyerForDetails'), /* Invite them to sign up and complete the credit application so we can review their business. */
            creditRequestDeclined: () => t('resources.buyers.show.buyerAlerts.creditRequestDeclined'), /* Credit Request was declined */
            buyerCreditRequestDeclined: () => t('resources.buyers.show.buyerAlerts.buyerCreditRequestDeclined'), /* Credit request was declined */
            buyerCreditRequestDeclinedDetails: (data: Record<'amount', unknown>) => t('resources.buyers.show.buyerAlerts.buyerCreditRequestDeclinedDetails', data), /* After reviewing your request, we were unable to approve you for %{amount} credit line. If you can provide new supporting information, such as recent financial reports, we'd be happy to review the application again. */
            creditRequestCanceled: () => t('resources.buyers.show.buyerAlerts.creditRequestCanceled'), /* Credit line was canceled */
            buyerCreditRequestCanceled: () => t('resources.buyers.show.buyerAlerts.buyerCreditRequestCanceled'), /* Credit line was canceled */
            buyerCreditRequestCanceledDetails: () => t('resources.buyers.show.buyerAlerts.buyerCreditRequestCanceledDetails'), /* Please, contact our support team in order to get more details. */
            requestedAmount: (data: Record<'amount', unknown>) => t('resources.buyers.show.buyerAlerts.requestedAmount', data), /* Requested amount: %{amount} */
            applyForCredit: () => t('resources.buyers.show.buyerAlerts.applyForCredit'), /* Apply for credit line */
            scaleYourBusiness: () => t('resources.buyers.show.buyerAlerts.scaleYourBusiness'), /* Scale your business with simplified financing options. Buy what your business needs now, pay for it later. */
            applyNow: () => t('resources.buyers.show.buyerAlerts.applyNow'), /* Apply now */
            availableCredit: () => t('resources.buyers.show.buyerAlerts.availableCredit'), /* Available credit */
            inviteSupplier: () => t('resources.buyers.show.buyerAlerts.inviteSupplier'), /* Utilize your credit line with multiple suppliers */
            inviteSupplierDescription: (data: Record<'brandName', unknown>) => t('resources.buyers.show.buyerAlerts.inviteSupplierDescription', data), /* Invite your suppliers to join %{brandName} network and utilize your credit line over their invoices. */
            invite: () => t('resources.buyers.show.buyerAlerts.invite'), /* Invite supplier */
            onHold: () => t('resources.buyers.show.buyerAlerts.onHold'), /* On Hold */
            canceled: () => t('resources.buyers.show.buyerAlerts.canceled'), /* Canceled */
            of: () => t('resources.buyers.show.buyerAlerts.of'), /* of */
            limit: () => t('resources.buyers.show.buyerAlerts.limit'), /* limit */
            poweredBy: (data: Record<'by', unknown>) => t('resources.buyers.show.buyerAlerts.poweredBy', data), /* Powered by %{by} */
          },
          buyerInvoices: {
            unpaidInvoices: () => t('resources.buyers.show.buyerInvoices.unpaidInvoices'), /* Unpaid invoices */
            emptyPendingInvoicesTitle: () => t('resources.buyers.show.buyerInvoices.emptyPendingInvoicesTitle'), /* You are all done! */
            emptyPendingInvoicesDescriptionBuyer: () => t('resources.buyers.show.buyerInvoices.emptyPendingInvoicesDescriptionBuyer'), /* There are no invoices pending your payment */
            emptyPendingInvoicesDescriptionSupplier: () => t('resources.buyers.show.buyerInvoices.emptyPendingInvoicesDescriptionSupplier'), /* There are no invoices pending buyer's payment */
            noInvoicesTitleBuyer: () => t('resources.buyers.show.buyerInvoices.noInvoicesTitleBuyer'), /* You don't have any invoices yet */
            noInvoicesDescriptionBuyer: () => t('resources.buyers.show.buyerInvoices.noInvoicesDescriptionBuyer'), /* After your supplies start adding new invoices, you'll be able to view and pay them with a click of button */
            noInvoicesTitleSupplier: () => t('resources.buyers.show.buyerInvoices.noInvoicesTitleSupplier'), /* Add your first invoice */
            noInvoicesDescriptionSupplier: () => t('resources.buyers.show.buyerInvoices.noInvoicesDescriptionSupplier'), /* Request payments from your buyers so they can view and pay them with a click of button */
            showInvoices: () => t('resources.buyers.show.buyerInvoices.showInvoices'), /* Show invoices */
            addInvoice: () => t('resources.buyers.show.buyerInvoices.addInvoice'), /* Add invoice */
            invoiceNumber: () => t('resources.buyers.show.buyerInvoices.invoiceNumber'), /* Invoice number */
            placeholderInvoiceNumber: () => t('resources.buyers.show.buyerInvoices.placeholderInvoiceNumber'), /* NA */
            amountDue: () => t('resources.buyers.show.buyerInvoices.amountDue'), /* Amount due */
            dueDate: (data: Record<'dueDate', unknown>) => t('resources.buyers.show.buyerInvoices.dueDate', data), /* Due %{dueDate} */
            overdue: () => t('resources.buyers.show.buyerInvoices.overdue'), /* Overdue */
          },
          buyerPayments: {
            upcomingPayments: () => t('resources.buyers.show.buyerPayments.upcomingPayments'), /* Upcoming payments */
            noUpcomingPaymentsTitle: () => t('resources.buyers.show.buyerPayments.noUpcomingPaymentsTitle'), /* No upcoming payments */
            showPayments: () => t('resources.buyers.show.buyerPayments.showPayments'), /* Show payments */
          },
          buyerPaymentRequests: {
            pendingPaymentRequests: () => t('resources.buyers.show.buyerPaymentRequests.pendingPaymentRequests'), /* Pending payment requests */
            emptyListTitle: () => t('resources.buyers.show.buyerPaymentRequests.emptyListTitle'), /* No pending payment requests */
          },
        },
        tabs: {
          all: () => t('resources.buyers.tabs.all'), /* All */
          approved: () => t('resources.buyers.tabs.approved'), /* Approved */
          preapproved: () => t('resources.buyers.tabs.preapproved'), /* Pre-approved */
          pending: () => t('resources.buyers.tabs.pending'), /* In review */
          declined: () => t('resources.buyers.tabs.declined'), /* Declined */
        },
        list: {
          CopySignupLinkButtonDialog: {
            title: () => t('resources.buyers.list.CopySignupLinkButtonDialog.title'), /* Invite your buyers to sign up */
            description: () => t('resources.buyers.list.CopySignupLinkButtonDialog.description'), /* Share the invitation link with buyers to let them register and onboard business */
          },
          overdueValue: (data: Record<'value', unknown>) => t('resources.buyers.list.overdueValue', data), /* %{value} overdue */
          invoicesCount: (data: Record<'smart_count' | 'smart_count', unknown>) => t('resources.buyers.list.invoicesCount', data), /* %{smart_count} invoice |||| %{smart_count} invoices */
        },
      },
      'organizations/businesses': {
        name: () => t('resources.organizations/businesses.name'), /* Business |||| Businesses */
        fields: {
          id: () => t('resources.organizations/businesses.fields.id'), /* ID */
          name: () => t('resources.organizations/businesses.fields.name'), /* Name */
          legalName: () => t('resources.organizations/businesses.fields.legalName'), /* Legal name */
          email: () => t('resources.organizations/businesses.fields.email'), /* Email */
          website: () => t('resources.organizations/businesses.fields.website'), /* Website */
          phone: () => t('resources.organizations/businesses.fields.phone'), /* Phone */
          country: () => t('resources.organizations/businesses.fields.country'), /* Country */
          city: () => t('resources.organizations/businesses.fields.city'), /* City */
          state: () => t('resources.organizations/businesses.fields.state'), /* State */
          identificationCode: () => t('resources.organizations/businesses.fields.identificationCode'), /* Identification Code */
          identificationType: () => t('resources.organizations/businesses.fields.identificationType'), /* Identification Type */
          address: () => t('resources.organizations/businesses.fields.address'), /* Address */
          externalId: () => t('resources.organizations/businesses.fields.externalId'), /* External Id */
          createdAt: () => t('resources.organizations/businesses.fields.createdAt'), /* Created at */
          identification: () => t('resources.organizations/businesses.fields.identification'), /* Identification */
          updatedAt: () => t('resources.organizations/businesses.fields.updatedAt'), /* Updated at */
          businessContacts: () => t('resources.organizations/businesses.fields.businessContacts'), /* Business Contacts */
        },
      },
      businesses: {
        name: () => t('resources.businesses.name'), /* Business |||| Businesses */
        fields: {
          id: () => t('resources.businesses.fields.id'), /* ID */
          name: () => t('resources.businesses.fields.name'), /* Name */
          displayName: () => t('resources.businesses.fields.displayName'), /* Business name */
          legalName: () => t('resources.businesses.fields.legalName'), /* Legal name */
          email: () => t('resources.businesses.fields.email'), /* Email */
          website: () => t('resources.businesses.fields.website'), /* Website */
          phone: () => t('resources.businesses.fields.phone'), /* Phone */
          country: () => t('resources.businesses.fields.country'), /* Country */
          city: () => t('resources.businesses.fields.city'), /* City */
          state: () => t('resources.businesses.fields.state'), /* State */
          identificationCode: () => t('resources.businesses.fields.identificationCode'), /* Identification Code */
          identificationType: () => t('resources.businesses.fields.identificationType'), /* Identification Type */
          externalId: () => t('resources.businesses.fields.externalId'), /* External Id */
          createdAt: () => t('resources.businesses.fields.createdAt'), /* Created at */
          number: () => t('resources.businesses.fields.number'), /* Number */
          identification: () => t('resources.businesses.fields.identification'), /* Identification */
          updatedAt: () => t('resources.businesses.fields.updatedAt'), /* Updated at */
          businessContacts: () => t('resources.businesses.fields.businessContacts'), /* Business Contacts */
          businessDetails: () => t('resources.businesses.fields.businessDetails'), /* Business Details */
          vaName: () => t('resources.businesses.fields.vaName'), /* VA name */
          address: {
            country: () => t('resources.businesses.fields.address.country'), /* Country */
            city: () => t('resources.businesses.fields.address.city'), /* City */
            state: () => t('resources.businesses.fields.address.state'), /* State */
            full: () => t('resources.businesses.fields.address.full'), /* Address */
          },
        },
        edit: {
          title: () => t('resources.businesses.edit.title'), /* Business Identity */
          identificationType: () => t('resources.businesses.edit.identificationType'), /* Identification Type */
          address: () => t('resources.businesses.edit.address'), /* Address */
          businessContacts: () => t('resources.businesses.edit.businessContacts'), /* Business Contacts */
        },
      },
      'organizations/permissions': {
        name: () => t('resources.organizations/permissions.name'), /* Organization Permission |||| Organization Permissions */
        fields: {
          id: () => t('resources.organizations/permissions.fields.id'), /* ID */
          entityId: () => t('resources.organizations/permissions.fields.entityId'), /* Organization */
          targetOrganizationId: () => t('resources.organizations/permissions.fields.targetOrganizationId'), /* Target Organization */
          permissions: {
            tenantId: () => t('resources.organizations/permissions.fields.permissions.tenantId'), /* Tenant */
            buyers: () => t('resources.organizations/permissions.fields.permissions.buyers'), /* Buyers */
          },
          createdAt: () => t('resources.organizations/permissions.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.organizations/permissions.fields.updatedAt'), /* Updated at */
        },
        edit: {
          title: () => t('resources.organizations/permissions.edit.title'), /* Organization Permissions */
        },
      },
      'organizations/:id/tenants': {
        name: () => t('resources.organizations/:id/tenants.name'), /* Tenant |||| Tenants */
        fields: {
          id: () => t('resources.organizations/:id/tenants.fields.id'), /* ID */
          displayName: () => t('resources.organizations/:id/tenants.fields.displayName'), /* Display Name */
          tenantId: () => t('resources.organizations/:id/tenants.fields.tenantId'), /* Tenant Id */
          tenantName: () => t('resources.organizations/:id/tenants.fields.tenantName'), /* Tenant Name */
          authenticationId: () => t('resources.organizations/:id/tenants.fields.authenticationId'), /* Application Id */
          stripeAccountId: () => t('resources.organizations/:id/tenants.fields.stripeAccountId'), /* Stripe Account Id */
          businessId: () => t('resources.organizations/:id/tenants.fields.businessId'), /* Business */
          preapprove: () => t('resources.organizations/:id/tenants.fields.preapprove'), /* Automatically preappove credit line */
          webhookApplicationId: () => t('resources.organizations/:id/tenants.fields.webhookApplicationId'), /* Webhook */
          environment: () => t('resources.organizations/:id/tenants.fields.environment'), /* Environment */
          createdAt: () => t('resources.organizations/:id/tenants.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.organizations/:id/tenants.fields.updatedAt'), /* Updated at */
        },
        edit: {
          title: () => t('resources.organizations/:id/tenants.edit.title'), /* Organization Tenant */
        },
      },
      organizations: {
        name: () => t('resources.organizations.name'), /* Organization |||| Organizations */
        fields: {
          id: () => t('resources.organizations.fields.id'), /* ID */
          displayName: () => t('resources.organizations.fields.displayName'), /* Display name */
          name: () => t('resources.organizations.fields.name'), /* Name */
          auth0organizationId: () => t('resources.organizations.fields.auth0organizationId'), /* Auth0 organization */
          auth0clientId: () => t('resources.organizations.fields.auth0clientId'), /* Auth0 client ID */
          logo: () => t('resources.organizations.fields.logo'), /* Logo */
          invite: () => t('resources.organizations.fields.invite'), /* Invite */
          invitedBy: () => t('resources.organizations.fields.invitedBy'), /* Invited by */
          updatedAt: () => t('resources.organizations.fields.updatedAt'), /* Updated at */
          createdAt: () => t('resources.organizations.fields.createdAt'), /* Created at */
        },
        edit: {
          title: () => t('resources.organizations.edit.title'), /* Organization Identity */
          logo: () => t('resources.organizations.edit.logo'), /* logo url */
          types: () => t('resources.organizations.edit.types'), /* Types */
        },
        filters: {
          organizationName: () => t('resources.organizations.filters.organizationName'), /* name */
        },
      },
      payouts: {
        name: () => t('resources.payouts.name'), /* Payout |||| Payouts */
        title: () => t('resources.payouts.title'), /* Payouts */
        balance: () => t('resources.payouts.balance'), /* Balance |||| Balances */
        cards: {
          withdrawTooltip: () => t('resources.payouts.cards.withdrawTooltip'), /* Withdraw */
          noWithdrawTooltip: () => t('resources.payouts.cards.noWithdrawTooltip'), /* Missing bank account for currency.<br/>Go to 'Settings' to add one. */
          currencyExchangeTooltip: () => t('resources.payouts.cards.currencyExchangeTooltip'), /* Convert */
        },
        list: {
          bulkPayout: (data: Record<'amount', unknown>) => t('resources.payouts.list.bulkPayout', data), /* Withdraw (%{amount}) */
          markAsPaid: () => t('resources.payouts.list.markAsPaid'), /* Mark balance as paid */
          filterByStatus: () => t('resources.payouts.list.filterByStatus'), /* Filter by status */
          convertCurrency: () => t('resources.payouts.list.convertCurrency'), /* Convert currency */
          revertCurrencyConversion: () => t('resources.payouts.list.revertCurrencyConversion'), /* Revert Currency Exchange */
          markBalanceAsPaidDialog: {
            buttons: {
              cancel: () => t('resources.payouts.list.markBalanceAsPaidDialog.buttons.cancel'), /* Cancel */
              confirm: () => t('resources.payouts.list.markBalanceAsPaidDialog.buttons.confirm'), /* Save */
            },
            title: () => t('resources.payouts.list.markBalanceAsPaidDialog.title'), /* Mark supplier outstanding balance as paid */
            totalPayouts: (data: Record<'totalPayouts', unknown>) => t('resources.payouts.list.markBalanceAsPaidDialog.totalPayouts', data), /* Total payouts: %{totalPayouts} */
            totalBalance: (data: Record<'totalBalance', unknown>) => t('resources.payouts.list.markBalanceAsPaidDialog.totalBalance', data), /* Total outstanding balance %{totalBalance} */
          },
        },
        currencyConversionDialog: {
          to: () => t('resources.payouts.currencyConversionDialog.to'), /* New currency */
          title: () => t('resources.payouts.currencyConversionDialog.title'), /* Currency exchange details */
          subtitle: () => t('resources.payouts.currencyConversionDialog.subtitle'), /* Enter exchange rate */
          successNotification: () => t('resources.payouts.currencyConversionDialog.successNotification'), /* `Payout currency conversion succeeded */
          successRevertNotification: () => t('resources.payouts.currencyConversionDialog.successRevertNotification'), /* `Payout currency conversion revert succeeded */
          exchangeDate: () => t('resources.payouts.currencyConversionDialog.exchangeDate'), /* Exchange date */
          calculatedAmountByDate: (data: Record<'convertedAmount', unknown>) => t('resources.payouts.currencyConversionDialog.calculatedAmountByDate', data), /* New payout amount will be %{convertedAmount} */
          toggleButtons: {
            manually: () => t('resources.payouts.currencyConversionDialog.toggleButtons.manually'), /* Manually */
            byDate: () => t('resources.payouts.currencyConversionDialog.toggleButtons.byDate'), /* By Date */
          },
          buttons: {
            cancel: () => t('resources.payouts.currencyConversionDialog.buttons.cancel'), /* Cancel */
          },
        },
        create: {
          title: () => t('resources.payouts.create.title'), /* Payout Identity */
        },
        show: {
          stepper: {
            payoutInitiatedLabel: () => t('resources.payouts.show.stepper.payoutInitiatedLabel'), /* Initiated */
            payoutInTransitLabel: () => t('resources.payouts.show.stepper.payoutInTransitLabel'), /* In-transit */
            payoutCompletedLabel: () => t('resources.payouts.show.stepper.payoutCompletedLabel'), /* Completed */
          },
          fields: {
            amount: () => t('resources.payouts.show.fields.amount'), /* Amount */
            netAmount: () => t('resources.payouts.show.fields.netAmount'), /* Net amount */
            grossAmount: () => t('resources.payouts.show.fields.grossAmount'), /* Gross amount */
            payoutDate: () => t('resources.payouts.show.fields.payoutDate'), /* Payout date */
            receivingMethod: () => t('resources.payouts.show.fields.receivingMethod'), /* Receiving method */
            reference: () => t('resources.payouts.show.fields.reference'), /* Reference */
            convertedFrom: () => t('resources.payouts.show.fields.convertedFrom'), /* Converted from */
            currencyExchageDate: (data: Record<'date', unknown>) => t('resources.payouts.show.fields.currencyExchageDate', data), /* on %{date} */
          },
          fees: {
            title: () => t('resources.payouts.show.fees.title'), /* Fees */
            subtitle: () => t('resources.payouts.show.fees.subtitle'), /* Total Fees */
            balance: () => t('resources.payouts.show.fees.balance'), /*  Supplier outstanding balance */
            noFees: () => t('resources.payouts.show.fees.noFees'), /* No fees */
            titleBuyer: () => t('resources.payouts.show.fees.titleBuyer'), /* Buyer fees */
            titleSupplier: () => t('resources.payouts.show.fees.titleSupplier'), /* Supplier fees */
            financing: () => t('resources.payouts.show.fees.financing'), /* Financing fee */
            transaction: () => t('resources.payouts.show.fees.transaction'), /* Transcation fee */
            currencyConversion: () => t('resources.payouts.show.fees.currencyConversion'), /* Currency Conversion Fee */
          },
          tabs: {
            'external-data': () => t('resources.payouts.show.tabs.external-data'), /* External data */
          },
          currencyConversion: {
            targerCurrency: (data: Record<'currency', unknown>) => t('resources.payouts.show.currencyConversion.targerCurrency', data), /* Your payout and fee were converted to %{currency} */
            rateMessage: (data: Record<'fromCurrency' | 'rate' | 'targerCurrency', unknown>) => t('resources.payouts.show.currencyConversion.rateMessage', data), /*  1 %{fromCurrency} = %{rate} %{targerCurrency} */
          },
        },
        fields: {
          invoice: () => t('resources.payouts.fields.invoice'), /* Invoice */
          amount: () => t('resources.payouts.fields.amount'), /* Amount */
          currency: () => t('resources.payouts.fields.currency'), /* Currency */
          reference: () => t('resources.payouts.fields.reference'), /* Reference */
          status: () => t('resources.payouts.fields.status'), /* Status */
          type: () => t('resources.payouts.fields.type'), /* Type */
          paidDate: () => t('resources.payouts.fields.paidDate'), /* Payout date */
          paymentMethod: () => t('resources.payouts.fields.paymentMethod'), /* Payment method */
          feeStatus: () => t('resources.payouts.fields.feeStatus'), /* Fee status */
          fee: {
            percentage: () => t('resources.payouts.fields.fee.percentage'), /* Percentage fee */
            fixed: () => t('resources.payouts.fields.fee.fixed'), /* Fixed fee */
          },
          transaction: () => t('resources.payouts.fields.transaction'), /* Transaction */
          bankDetails: () => t('resources.payouts.fields.bankDetails'), /* Bank details */
          initiatedDate: () => t('resources.payouts.fields.initiatedDate'), /* Initiated date */
          referenceMetadata: () => t('resources.payouts.fields.referenceMetadata'), /* Reference Metadata */
          note: () => t('resources.payouts.fields.note'), /* Note */
          externalId: () => t('resources.payouts.fields.externalId'), /* External ID */
          percentage: () => t('resources.payouts.fields.percentage'), /* Percentage */
          payoutDate: () => t('resources.payouts.fields.payoutDate'), /* Payout date */
          referenceExternalId: () => t('resources.payouts.fields.referenceExternalId'), /* Reference ExternalId */
          receivingMethod: () => t('resources.payouts.fields.receivingMethod'), /* Receiving method */
          buyerName: () => t('resources.payouts.fields.buyerName'), /* Buyer name */
          balance: () => t('resources.payouts.fields.balance'), /* Outstanding balance */
          rate: () => t('resources.payouts.fields.rate'), /* Rate */
          totalFees: () => t('resources.payouts.fields.totalFees'), /* Total Fees */
          originalAmount: () => t('resources.payouts.fields.originalAmount'), /* Original amount */
          buyerExternalId: () => t('resources.payouts.fields.buyerExternalId'), /* Buyer external ID */
          amountApplied: () => t('resources.payouts.fields.amountApplied'), /* Amount applied */
        },
        actions: {
          transaction: () => t('resources.payouts.actions.transaction'), /* Log transaction */
        },
        edit: {
          currencyConversionMessage: {
            targetCurrencyMessage: (data: Record<'sourceCurrency' | 'targetCurrency', unknown>) => t('resources.payouts.edit.currencyConversionMessage.targetCurrencyMessage', data), /* Payout and fee were converted from %{sourceCurrency} to %{targetCurrency} using the following rate: */
            rateMessage: (data: Record<'fromCurrency' | 'rate' | 'targerCurrency', unknown>) => t('resources.payouts.edit.currencyConversionMessage.rateMessage', data), /* 1 %{fromCurrency} = %{rate} %{targerCurrency} */
          },
        },
        tabs: {
          all: () => t('resources.payouts.tabs.all'), /* All */
          ready: () => t('resources.payouts.tabs.ready'), /* Ready */
          'in-progress': () => t('resources.payouts.tabs.in-progress'), /* In transit */
          done: () => t('resources.payouts.tabs.done'), /* Completed */
          pending: () => t('resources.payouts.tabs.pending'), /* Pending */
        },
      },
      shipping: {
        name: () => t('resources.shipping.name'), /* Shipping |||| Shippings */
        title: () => t('resources.shipping.title'), /* Shippings */
        fields: {
          buyer: () => t('resources.shipping.fields.buyer'), /* Buyer */
          invoice: () => t('resources.shipping.fields.invoice'), /* Invoice */
          type: () => t('resources.shipping.fields.type'), /* Type */
          shippingProvider: () => t('resources.shipping.fields.shippingProvider'), /* Shipping provider */
          trackingNumber: () => t('resources.shipping.fields.trackingNumber'), /* Tracking number */
          trackingUrl: () => t('resources.shipping.fields.trackingUrl'), /* Tracking URL */
          status: () => t('resources.shipping.fields.status'), /* Status */
        },
        edit: {
          title: () => t('resources.shipping.edit.title'), /* Update shipping */
          save: () => t('resources.shipping.edit.save'), /* Update shipping */
          form: {
            title: () => t('resources.shipping.edit.form.title'), /* Shipping details */
            attachmentLabel: () => t('resources.shipping.edit.form.attachmentLabel'), /* Attachments */
          },
        },
        create: {
          title: () => t('resources.shipping.create.title'), /* New shipping */
          save: () => t('resources.shipping.create.save'), /* Create shipping */
        },
      },
      emails: {
        name: () => t('resources.emails.name'), /* Email |||| Emails */
        fields: {
          createdAt: () => t('resources.emails.fields.createdAt'), /* Sent on */
          updatedAt: () => t('resources.emails.fields.updatedAt'), /* Last status update */
          subject: () => t('resources.emails.fields.subject'), /* Email subject */
          body: () => t('resources.emails.fields.body'), /* Email body */
          from: () => t('resources.emails.fields.from'), /* Sender */
          to: () => t('resources.emails.fields.to'), /* Sent To */
          cc: () => t('resources.emails.fields.cc'), /* CC */
          role: () => t('resources.emails.fields.role'), /* Role */
          inbox: () => t('resources.emails.fields.inbox'), /* Recipient */
          emailParams: () => t('resources.emails.fields.emailParams'), /* Email Params */
          templateId: () => t('resources.emails.fields.templateId'), /* Template ID */
          template: () => t('resources.emails.fields.template'), /* Template */
          providerId: () => t('resources.emails.fields.providerId'), /* Provider ID */
          entityType: () => t('resources.emails.fields.entityType'), /* Entity Type */
          entityId: () => t('resources.emails.fields.entityId'), /* Entity ID */
          emailPreview: () => t('resources.emails.fields.emailPreview'), /* Email preview */
          action: () => t('resources.emails.fields.action'), /* Action */
          status: () => t('resources.emails.fields.status'), /* Status */
        },
        filters: {
          input: () => t('resources.emails.filters.input'), /* Search by email */
          templateId: {
            values: {
              'd-248c032c33454362be5b489ce25fc03b': (data: Record<'brandName', unknown>) => t('resources.emails.filters.templateId.values.d-248c032c33454362be5b489ce25fc03b', data), /* Invitation for buyer to join %{brandName} */
              'd-652817cb4a0e49e5b0c8548ff81da5e6': () => t('resources.emails.filters.templateId.values.d-652817cb4a0e49e5b0c8548ff81da5e6'), /* Invitation for user to be buyer owner */
              'd-04f43b2a147144268a88e5fb06eb5ccc': () => t('resources.emails.filters.templateId.values.d-04f43b2a147144268a88e5fb06eb5ccc'), /* Mention in chat */
              'd-bc1ead6020474f12a2f2629aa771300e': () => t('resources.emails.filters.templateId.values.d-bc1ead6020474f12a2f2629aa771300e'), /* Buyer credit line status update */
              'd-429b9cec54a84e5193be7c8c890a6a5f': () => t('resources.emails.filters.templateId.values.d-429b9cec54a84e5193be7c8c890a6a5f'), /* Confirmation on charge scheduled */
              'd-23f03b3f4f0c4275979cc3404e7299a6': () => t('resources.emails.filters.templateId.values.d-23f03b3f4f0c4275979cc3404e7299a6'), /* Confirmation on charge completed */
              'd-86a57cf6846847a8981497016cf3542e': () => t('resources.emails.filters.templateId.values.d-86a57cf6846847a8981497016cf3542e'), /* Buyer payment processed successfully */
              'd-f8417cd9dd8540798efd885bd7652ca9': () => t('resources.emails.filters.templateId.values.d-f8417cd9dd8540798efd885bd7652ca9'), /* Password reset */
              'd-fa5cc3dde16241b78bdf59c33b3d7b7a': () => t('resources.emails.filters.templateId.values.d-fa5cc3dde16241b78bdf59c33b3d7b7a'), /* Reminder to buyer to confirm an invoice */
              'd-99fabd5f73da440ca3cd3065126bc824': () => t('resources.emails.filters.templateId.values.d-99fabd5f73da440ca3cd3065126bc824'), /* Customization */
              'd-a43b9d497aa34e5d9cc22ed60b8baf35': () => t('resources.emails.filters.templateId.values.d-a43b9d497aa34e5d9cc22ed60b8baf35'), /* Email verification */
              'd-770d853e8e724446ad3812c64381e2c9': () => t('resources.emails.filters.templateId.values.d-770d853e8e724446ad3812c64381e2c9'), /* Buyer completed payment request flow */
              'd-434d52c22a4549ac883df0c55aad3ff1': () => t('resources.emails.filters.templateId.values.d-434d52c22a4549ac883df0c55aad3ff1'), /* Email received successfully to organization inbox */
              'd-6ad5c2da56c5412f8c4ea5e585c80d4b': () => t('resources.emails.filters.templateId.values.d-6ad5c2da56c5412f8c4ea5e585c80d4b'), /* Buyer selection of net terms for invoice payment request */
              'd-81e9d313a3db43fc86c038a19423cd28': () => t('resources.emails.filters.templateId.values.d-81e9d313a3db43fc86c038a19423cd28'), /* Payment request issued to buyer */
              'd-718e7c395d574fcdb1f4703f0940ddac': () => t('resources.emails.filters.templateId.values.d-718e7c395d574fcdb1f4703f0940ddac'), /* Bulk payout initiated */
              'd-2ebc97f7eb2d49daad93ba61c7f8fcbb': (data: Record<'brandName', unknown>) => t('resources.emails.filters.templateId.values.d-2ebc97f7eb2d49daad93ba61c7f8fcbb', data), /* Invitation for supplier to join %{brandName} */
              'd-1b16e48a86724d9d80c21b91867c38fa': () => t('resources.emails.filters.templateId.values.d-1b16e48a86724d9d80c21b91867c38fa'), /* Credit released */
              'd-145fbe8b2c8a4c319274a50e14d91e50': () => t('resources.emails.filters.templateId.values.d-145fbe8b2c8a4c319274a50e14d91e50'), /* Payment request issued to buyer */
              'd-85f10041b1e54e969c6938e3f7d76656': () => t('resources.emails.filters.templateId.values.d-85f10041b1e54e969c6938e3f7d76656'), /* Reminder to buyer to complete credit application requirements */
              'd-b017f163bc224677852a3121c3ce2840': () => t('resources.emails.filters.templateId.values.d-b017f163bc224677852a3121c3ce2840'), /* Reminder to buyer to complete credit application requirements */
              'd-0ff1d9960b314863b7244d22ef0b5903': () => t('resources.emails.filters.templateId.values.d-0ff1d9960b314863b7244d22ef0b5903'), /* Reminder to buyer to complete credit application requirements */
              'd-6c294d45df974854b0e63dff8fbfc67d': () => t('resources.emails.filters.templateId.values.d-6c294d45df974854b0e63dff8fbfc67d'), /* Buyer was declined for credit line */
              'd-7dc2c6df03e049948760fc5d6fc845f9': () => t('resources.emails.filters.templateId.values.d-7dc2c6df03e049948760fc5d6fc845f9'), /* Buyer was approved for credit line */
              'd-61006c83c1e74d49a6ad1774d22aeaf9': () => t('resources.emails.filters.templateId.values.d-61006c83c1e74d49a6ad1774d22aeaf9'), /* Buyer applied for credit line */
              'd-88c0a41be6e9411caf9007a96fd77073': () => t('resources.emails.filters.templateId.values.d-88c0a41be6e9411caf9007a96fd77073'), /* Buyer was declined for credit line */
              'd-d33fff6991d7416abf29a4e274d603a0': () => t('resources.emails.filters.templateId.values.d-d33fff6991d7416abf29a4e274d603a0'), /* Buyer was approved for credit line */
              'd-f29551dc5e7a460e86f5226461267486': () => t('resources.emails.filters.templateId.values.d-f29551dc5e7a460e86f5226461267486'), /* Confirmation on charge initiated */
              'd-80258220550b4679b0d74d130b476ce6': () => t('resources.emails.filters.templateId.values.d-80258220550b4679b0d74d130b476ce6'), /* Payout initiated */
              'd-0b3fa6dc83974edaa35e2baf204b4eb9': () => t('resources.emails.filters.templateId.values.d-0b3fa6dc83974edaa35e2baf204b4eb9'), /* Reminder to buyer to confirm an invoice */
              'd-af348cd3518243b4bda914243ad3ccfc': () => t('resources.emails.filters.templateId.values.d-af348cd3518243b4bda914243ad3ccfc'), /* Buyer didn't confirm invoice terms */
              'd-e80f918cfa954ccea2e05ba9ff1d9e41': () => t('resources.emails.filters.templateId.values.d-e80f918cfa954ccea2e05ba9ff1d9e41'), /* Payout initiated */
              'd-80a08591dd8b4ddb93a61d89e731f571': () => t('resources.emails.filters.templateId.values.d-80a08591dd8b4ddb93a61d89e731f571'), /* Buyer completed payment request flow */
              'd-24b0855595f24062b544b7cd71c02057': () => t('resources.emails.filters.templateId.values.d-24b0855595f24062b544b7cd71c02057'), /* Bank Transfer instructions */
              'd-0bbf5fa86af34e5f9dcbe327b859dabc': () => t('resources.emails.filters.templateId.values.d-0bbf5fa86af34e5f9dcbe327b859dabc'), /* Buyer was approved for credit line */
              'd-656933c14307420d866b5a661a80794e': (data: Record<'brandName', unknown>) => t('resources.emails.filters.templateId.values.d-656933c14307420d866b5a661a80794e', data), /* Net term invoice was confirmed by %{brandName} */
              'd-cf1573a4c5b2433d8c648ff8b147e952': () => t('resources.emails.filters.templateId.values.d-cf1573a4c5b2433d8c648ff8b147e952'), /* Email verification */
              'd-61ebfb56d6d345dd9121aca3aa7c621b': () => t('resources.emails.filters.templateId.values.d-61ebfb56d6d345dd9121aca3aa7c621b'), /* Invoice issued to buyer */
              'd-e7cecb99a4424b479fe94e68081516e4': () => t('resources.emails.filters.templateId.values.d-e7cecb99a4424b479fe94e68081516e4'), /* Upcoming charge reminder */
              'd-62dc18d7f83649038c8959458535de55': () => t('resources.emails.filters.templateId.values.d-62dc18d7f83649038c8959458535de55'), /* New user invitation */
              'd-54e1f00bfac14361a2eb1d3b8de95746': () => t('resources.emails.filters.templateId.values.d-54e1f00bfac14361a2eb1d3b8de95746'), /* Invoice issued to buyer */
              'd-f2ff253b2a6740d78b5cb39e2cacf1c6': () => t('resources.emails.filters.templateId.values.d-f2ff253b2a6740d78b5cb39e2cacf1c6'), /* Credit line decline */
              'd-fdfff30816314b5bb8705b4b9d3edca0': () => t('resources.emails.filters.templateId.values.d-fdfff30816314b5bb8705b4b9d3edca0'), /* Credit line approval */
              'd-8b680be25643435ab4e34fd2afbc4a87': () => t('resources.emails.filters.templateId.values.d-8b680be25643435ab4e34fd2afbc4a87'), /* Credit application submitted */
              'd-0d41376f41434f54945bd6970590c15b': () => t('resources.emails.filters.templateId.values.d-0d41376f41434f54945bd6970590c15b'), /* Payout amount was added to available balance */
              'd-2f18ed3bf58a45baa69cbfa8865348bf': () => t('resources.emails.filters.templateId.values.d-2f18ed3bf58a45baa69cbfa8865348bf'), /* Failed payment notification */
              'd-8da0cc0372944ab19045b47f0bef1460': () => t('resources.emails.filters.templateId.values.d-8da0cc0372944ab19045b47f0bef1460'), /* Reminder to buyer for overdue invoice */
              'd-bb52f7a7879a4488b7cc4222df835433': () => t('resources.emails.filters.templateId.values.d-bb52f7a7879a4488b7cc4222df835433'), /* Buyer account statement */
              'd-ba1c3f7b049e4d0abb88d1ec88b9e1ba': () => t('resources.emails.filters.templateId.values.d-ba1c3f7b049e4d0abb88d1ec88b9e1ba'), /* Reminder to supplier to handle uncaptured credit card payments */
            },
          },
        },
        tabs: {
          buyer: () => t('resources.emails.tabs.buyer'), /* Sent to buyer */
          supplier: () => t('resources.emails.tabs.supplier'), /* Sent to my organization */
        },
      },
      'allianz/companies': {
        name: () => t('resources.allianz/companies.name'), /* Allianz Company |||| Allianz Companies */
        fields: {
          foundMatch: () => t('resources.allianz/companies.fields.foundMatch'), /* Found match */
          buyer: () => t('resources.allianz/companies.fields.buyer'), /* Buyer name */
          legalName: () => t('resources.allianz/companies.fields.legalName'), /* Legal Name */
          status: () => t('resources.allianz/companies.fields.status'), /* Cover status */
          decision: () => t('resources.allianz/companies.fields.decision'), /* Decision */
          coverAmount: () => t('resources.allianz/companies.fields.coverAmount'), /* Cover amount */
          startDate: () => t('resources.allianz/companies.fields.startDate'), /* Start date */
          coverId: () => t('resources.allianz/companies.fields.coverId'), /* Cover ID */
          grade: () => t('resources.allianz/companies.fields.grade'), /* Company grade */
          searchResult: {
            companyId: () => t('resources.allianz/companies.fields.searchResult.companyId'), /* Company ID */
            grade: () => t('resources.allianz/companies.fields.searchResult.grade'), /* Company grade */
            legalName: () => t('resources.allianz/companies.fields.searchResult.legalName'), /* Legal name */
            duns: () => t('resources.allianz/companies.fields.searchResult.duns'), /* DUNS */
            phone: () => t('resources.allianz/companies.fields.searchResult.phone'), /* Phone */
            businessStartDate: () => t('resources.allianz/companies.fields.searchResult.businessStartDate'), /* Business start date */
            address: () => t('resources.allianz/companies.fields.searchResult.address'), /* Address */
          },
          coverResult: {
            status: () => t('resources.allianz/companies.fields.coverResult.status'), /* Cover status */
            decision: () => t('resources.allianz/companies.fields.coverResult.decision'), /* Decision */
            coverAmount: () => t('resources.allianz/companies.fields.coverResult.coverAmount'), /* Cover amount */
            startDate: () => t('resources.allianz/companies.fields.coverResult.startDate'), /* Start date */
            coverId: () => t('resources.allianz/companies.fields.coverResult.coverId'), /* Cover ID */
          },
        },
      },
      'allianz/cover-requests': {
        name: () => t('resources.allianz/cover-requests.name'), /* Allianz Cover Request |||| Allianz Cover Requests */
        fields: {
          allianzCompany: () => t('resources.allianz/cover-requests.fields.allianzCompany'), /* Company */
          requestedAmount: () => t('resources.allianz/cover-requests.fields.requestedAmount'), /* Requested amount */
          currency: () => t('resources.allianz/cover-requests.fields.currency'), /* Currency */
          status: () => t('resources.allianz/cover-requests.fields.status'), /* Status */
          coverId: () => t('resources.allianz/cover-requests.fields.coverId'), /* Cover ID */
          jobId: () => t('resources.allianz/cover-requests.fields.jobId'), /* Job ID */
          refresh: () => t('resources.allianz/cover-requests.fields.refresh'), /* Refresh */
        },
      },
      'allianz/covers': {
        name: () => t('resources.allianz/covers.name'), /* Allianz Covers */
        fields: {
          allianzCompany: () => t('resources.allianz/covers.fields.allianzCompany'), /* Company */
          allianzCompanyId: () => t('resources.allianz/covers.fields.allianzCompanyId'), /* Company ID */
          requestStatus: () => t('resources.allianz/covers.fields.requestStatus'), /* Request status */
          buyer: () => t('resources.allianz/covers.fields.buyer'), /* Buyer */
          status: () => t('resources.allianz/covers.fields.status'), /* Cover status */
          grade: () => t('resources.allianz/covers.fields.grade'), /* Company grade */
          decision: () => t('resources.allianz/covers.fields.decision'), /* Decision */
          coverAmount: () => t('resources.allianz/covers.fields.coverAmount'), /* Cover amount */
          startDate: () => t('resources.allianz/covers.fields.startDate'), /* Start date */
          coverId: () => t('resources.allianz/covers.fields.coverId'), /* Cover ID */
          jobIds: () => t('resources.allianz/covers.fields.jobIds'), /* Job IDs */
          requestedAmount: () => t('resources.allianz/covers.fields.requestedAmount'), /* Requested amount */
          refresh: () => t('resources.allianz/covers.fields.refresh'), /* Refresh */
          createCoverRequest: () => t('resources.allianz/covers.fields.createCoverRequest'), /* Create a cover request */
        },
      },
      'atradius/companies': {
        name: () => t('resources.atradius/companies.name'), /* Atradius Company |||| Atradius Companies */
        fields: {
          foundMatch: () => t('resources.atradius/companies.fields.foundMatch'), /* Found match */
          buyer: () => t('resources.atradius/companies.fields.buyer'), /* Buyer name */
          searchQuery: {
            searchQuery: () => t('resources.atradius/companies.fields.searchQuery.searchQuery'), /* Search Query */
            legalName: () => t('resources.atradius/companies.fields.searchQuery.legalName'), /* Legal Name */
            address: () => t('resources.atradius/companies.fields.searchQuery.address'), /* Address */
          },
          match: () => t('resources.atradius/companies.fields.match'), /* Match */
          searchResult: {
            searchResult: () => t('resources.atradius/companies.fields.searchResult.searchResult'), /* Search Result */
            companyId: () => t('resources.atradius/companies.fields.searchResult.companyId'), /* Company ID */
            grade: () => t('resources.atradius/companies.fields.searchResult.grade'), /* Company grade */
            legalName: () => t('resources.atradius/companies.fields.searchResult.legalName'), /* Legal name */
            duns: () => t('resources.atradius/companies.fields.searchResult.duns'), /* DUNS */
            phone: () => t('resources.atradius/companies.fields.searchResult.phone'), /* Phone */
            businessStartDate: () => t('resources.atradius/companies.fields.searchResult.businessStartDate'), /* Business start date */
            address: () => t('resources.atradius/companies.fields.searchResult.address'), /* Address */
          },
          rating: {
            companyRating: () => t('resources.atradius/companies.fields.rating.companyRating'), /* Company rating */
            currentRating: () => t('resources.atradius/companies.fields.rating.currentRating'), /* Current company rating */
            currentClass: () => t('resources.atradius/companies.fields.rating.currentClass'), /* Current company class */
          },
          coverResult: {
            status: () => t('resources.atradius/companies.fields.coverResult.status'), /* Cover status */
            decision: () => t('resources.atradius/companies.fields.coverResult.decision'), /* Decision */
            coverAmount: () => t('resources.atradius/companies.fields.coverResult.coverAmount'), /* Cover amount */
            startDate: () => t('resources.atradius/companies.fields.coverResult.startDate'), /* Start date */
            coverId: () => t('resources.atradius/companies.fields.coverResult.coverId'), /* Cover ID */
          },
        },
      },
      charges: {
        create: {
          title: () => t('resources.charges.create.title'), /* New charge */
          detailsSubtitle: () => t('resources.charges.create.detailsSubtitle'), /* Charge details */
          save: () => t('resources.charges.create.save'), /* Create charge */
          chargeDetailsForm: {
            chargeTypes: {
              manual: () => t('resources.charges.create.chargeDetailsForm.chargeTypes.manual'), /* Manual */
              automatic: () => t('resources.charges.create.chargeDetailsForm.chargeTypes.automatic'), /* Automatic */
              log: () => t('resources.charges.create.chargeDetailsForm.chargeTypes.log'), /* Log */
            },
            feeStatus: {
              done: () => t('resources.charges.create.chargeDetailsForm.feeStatus.done'), /* Done */
              pending: () => t('resources.charges.create.chargeDetailsForm.feeStatus.pending'), /* Pending */
            },
          },
        },
        edit: {
          title: () => t('resources.charges.edit.title'), /* Update charge */
          save: () => t('resources.charges.edit.save'), /* Update charge */
        },
        name: () => t('resources.charges.name'), /* Charge |||| Charges */
        title: () => t('resources.charges.title'), /* Charges */
        fields: {
          paymentMethodOptionFunds: () => t('resources.charges.fields.paymentMethodOptionFunds'), /* Payment method options funds */
          checkout: () => t('resources.charges.fields.checkout'), /* Checkout */
          buyer: () => t('resources.charges.fields.buyer'), /* Buyer */
          invoice: () => t('resources.charges.fields.invoice'), /* Invoice */
          amount: () => t('resources.charges.fields.amount'), /* Amount */
          currency: () => t('resources.charges.fields.currency'), /* Currency */
          status: () => t('resources.charges.fields.status'), /* Status */
          type: () => t('resources.charges.fields.type'), /* Type */
          reference: () => t('resources.charges.fields.reference'), /* Reference */
          chargeDate: () => t('resources.charges.fields.chargeDate'), /* Payment date */
          referenceMetadata: () => t('resources.charges.fields.referenceMetadata'), /* Reference metadata */
          paymentMethod: () => t('resources.charges.fields.paymentMethod'), /* Payment method */
          externalId: () => t('resources.charges.fields.externalId'), /* External ID */
          fee: {
            percentage: () => t('resources.charges.fields.fee.percentage'), /* Percentage fee */
            fixed: () => t('resources.charges.fields.fee.fixed'), /* Fixed fee */
          },
          feeStatus: () => t('resources.charges.fields.feeStatus'), /* Fee status */
          availableOn: () => t('resources.charges.fields.availableOn'), /* Available on */
          amountCaptured: () => t('resources.charges.fields.amountCaptured'), /* Amount captured */
          amountApplied: () => t('resources.charges.fields.amountApplied'), /* Amount applied */
          note: () => t('resources.charges.fields.note'), /* Note */
          openBalance: () => t('resources.charges.fields.openBalance'), /* Open balance */
        },
        show: {
          stepper: {
            chargeInitiatedLabel: () => t('resources.charges.show.stepper.chargeInitiatedLabel'), /* Initiated */
            chargeInTransitLabel: () => t('resources.charges.show.stepper.chargeInTransitLabel'), /* In-transit */
            chargeCompletedLabel: () => t('resources.charges.show.stepper.chargeCompletedLabel'), /* Completed */
          },
          chargeDetails: {
            title: () => t('resources.charges.show.chargeDetails.title'), /* Charge details */
          },
          notifications: () => t('resources.charges.show.notifications'), /* Notifications */
          fees: () => t('resources.charges.show.fees'), /* Fees */
          actions: {
            refund: {
              button: () => t('resources.charges.show.actions.refund.button'), /* Refund */
              partially: {
                button: () => t('resources.charges.show.actions.refund.partially.button'), /* Refund partially */
                title: () => t('resources.charges.show.actions.refund.partially.title'), /* Enter amount to refund */
                amount: () => t('resources.charges.show.actions.refund.partially.amount'), /* Amount */
                formButton: () => t('resources.charges.show.actions.refund.partially.formButton'), /* Initiate refund */
              },
            },
          },
        },
        tabs: {
          title: () => t('resources.charges.tabs.title'), /* Charges */
          all: () => t('resources.charges.tabs.all'), /* All */
          pending: () => t('resources.charges.tabs.pending'), /* Pending */
          scheduled: () => t('resources.charges.tabs.scheduled'), /* Scheduled */
          'in-transit': () => t('resources.charges.tabs.in-transit'), /* In transit */
          done: () => t('resources.charges.tabs.done'), /* Completed */
          failed: () => t('resources.charges.tabs.failed'), /* Failed */
        },
        empty: {
          title: () => t('resources.charges.empty.title'), /* No payments done yet */
        },
      },
      'charges/reconciliation': {
        name: () => t('resources.charges/reconciliation.name'), /* Charge |||| Charges */
        fields: {
          buyerLegalName: () => t('resources.charges/reconciliation.fields.buyerLegalName'), /* Buyer */
          supplierLegalName: () => t('resources.charges/reconciliation.fields.supplierLegalName'), /* Supplier */
          amount: () => t('resources.charges/reconciliation.fields.amount'), /* Amount */
          status: () => t('resources.charges/reconciliation.fields.status'), /* Status */
          completionDate: () => t('resources.charges/reconciliation.fields.completionDate'), /* Completion date */
          provider: () => t('resources.charges/reconciliation.fields.provider'), /* Provider */
          revenue: () => t('resources.charges/reconciliation.fields.revenue'), /* Revenue */
          reference: () => t('resources.charges/reconciliation.fields.reference'), /* Reference */
        },
      },
      'refunds/reconciliation': {
        name: () => t('resources.refunds/reconciliation.name'), /* Refund |||| Refunds */
        fields: {
          buyerLegalName: () => t('resources.refunds/reconciliation.fields.buyerLegalName'), /* Buyer */
          supplierLegalName: () => t('resources.refunds/reconciliation.fields.supplierLegalName'), /* Supplier */
          amount: () => t('resources.refunds/reconciliation.fields.amount'), /* Amount */
          status: () => t('resources.refunds/reconciliation.fields.status'), /* Status */
          completionDate: () => t('resources.refunds/reconciliation.fields.completionDate'), /* Completion date */
          provider: () => t('resources.refunds/reconciliation.fields.provider'), /* Provider */
          revenue: () => t('resources.refunds/reconciliation.fields.revenue'), /* Revenue */
          reference: () => t('resources.refunds/reconciliation.fields.reference'), /* Reference */
        },
      },
      funds: {
        title: () => t('resources.funds.title'), /* Buyer funds */
        create: {
          title: () => t('resources.funds.create.title'), /* New funds */
          detailsSubtitle: () => t('resources.funds.create.detailsSubtitle'), /* Funds details */
          save: () => t('resources.funds.create.save'), /* Create funds */
        },
        edit: {
          title: () => t('resources.funds.edit.title'), /* Update funds */
          save: () => t('resources.funds.edit.save'), /* Update funds */
        },
        name: () => t('resources.funds.name'), /* Buyer funds |||| Buyer funds */
        fields: {
          buyer: () => t('resources.funds.fields.buyer'), /* Buyer */
          charges: () => t('resources.funds.fields.charges'), /* Charges */
          amount: () => t('resources.funds.fields.amount'), /* Amount */
          available: () => t('resources.funds.fields.available'), /* Available */
          currency: () => t('resources.funds.fields.currency'), /* Currency */
          status: () => t('resources.funds.fields.status'), /* Status */
          reference: () => t('resources.funds.fields.reference'), /* Reference */
          payerName: () => t('resources.funds.fields.payerName'), /* Payer Name */
          paymentMethod: () => t('resources.funds.fields.paymentMethod'), /* Payment method */
          providerId: () => t('resources.funds.fields.providerId'), /* Provider ID */
          providerAccountId: () => t('resources.funds.fields.providerAccountId'), /* Provider Account ID */
          arrivedAt: () => t('resources.funds.fields.arrivedAt'), /* Arrived at */
          location: () => t('resources.funds.fields.location'), /* Location */
          suggestedMatch: () => t('resources.funds.fields.suggestedMatch'), /* Suggested match */
        },
        show: {
          tabs: {
            details: () => t('resources.funds.show.tabs.details'), /* Details */
            comments: () => t('resources.funds.show.tabs.comments'), /* Comments */
          },
          fundsDetails: {
            title: () => t('resources.funds.show.fundsDetails.title'), /* Funds details */
          },
          potentialBuyers: {
            title: () => t('resources.funds.show.potentialBuyers.title'), /* Buyers exposed to bank account details */
          },
          suggestedBuyers: {
            title: () => t('resources.funds.show.suggestedBuyers.title'), /* Suggested buyers */
            fields: {
              buyer: () => t('resources.funds.show.suggestedBuyers.fields.buyer'), /* Buyer */
              matchingMethod: () => t('resources.funds.show.suggestedBuyers.fields.matchingMethod'), /* Matching method */
              confidenceScore: () => t('resources.funds.show.suggestedBuyers.fields.confidenceScore'), /* Confidence Score */
            },
          },
        },
        tabs: {
          all: () => t('resources.funds.tabs.all'), /* All */
          pending: () => t('resources.funds.tabs.pending'), /* Pending */
          received: () => t('resources.funds.tabs.received'), /* Received */
          allocated: () => t('resources.funds.tabs.allocated'), /* Allocated */
          'partially-allocated': () => t('resources.funds.tabs.partially-allocated'), /* Partially allocated */
          unmatched: () => t('resources.funds.tabs.unmatched'), /* Unallocated */
          refunded: () => t('resources.funds.tabs.refunded'), /* Refunded */
        },
        allocateFunds: {
          buttonText: () => t('resources.funds.allocateFunds.buttonText'), /* Allocate funds */
          form: {
            selectFundLabel: () => t('resources.funds.allocateFunds.form.selectFundLabel'), /* Select fund */
            selectQuoteLabel: () => t('resources.funds.allocateFunds.form.selectQuoteLabel'), /* Quote */
            selectAmountToAllocateLabel: () => t('resources.funds.allocateFunds.form.selectAmountToAllocateLabel'), /* Amount to allocate */
            estimatedAmountHelperText: () => t('resources.funds.allocateFunds.form.estimatedAmountHelperText'), /* Estimated to */
          },
          dialog: {
            title: () => t('resources.funds.allocateFunds.dialog.title'), /* Allocate funds */
            content: () => t('resources.funds.allocateFunds.dialog.content'), /* Are you sure you want to allocate funds ? */
            buttons: {
              cancel: () => t('resources.funds.allocateFunds.dialog.buttons.cancel'), /* Cancel */
              confirm: () => t('resources.funds.allocateFunds.dialog.buttons.confirm'), /* Confirm */
            },
            helperText: () => t('resources.funds.allocateFunds.dialog.helperText'), /* This action will create a new payment request with the allocated funds amount. No notification will be sent to the buyer. */
          },
        },
        downloadConfirmation: {
          buttonText: () => t('resources.funds.downloadConfirmation.buttonText'), /* Download confirmation */
        },
        indicators: {
          pending: () => t('resources.funds.indicators.pending'), /* Pending */
          allocated: () => t('resources.funds.indicators.allocated'), /* Allocated */
          unmatched: () => t('resources.funds.indicators.unmatched'), /* Unallocated */
          'partially-allocated': () => t('resources.funds.indicators.partially-allocated'), /* Partially-allocated */
          fundsQuantity: (data: Record<'quantity', unknown>) => t('resources.funds.indicators.fundsQuantity', data), /* %{quantity} transfers */
        },
        moveFundsModal: {
          title: () => t('resources.funds.moveFundsModal.title'), /* Move buyer fund to tenant */
          buttons: {
            move: () => t('resources.funds.moveFundsModal.buttons.move'), /* Move to tenant */
            save: () => t('resources.funds.moveFundsModal.buttons.save'), /* Confirm */
            cancel: () => t('resources.funds.moveFundsModal.buttons.cancel'), /* Cancel */
          },
          airwallexWarning: {
            title: () => t('resources.funds.moveFundsModal.airwallexWarning.title'), /* Airwallex deposit reference exists */
            description: () => t('resources.funds.moveFundsModal.airwallexWarning.description'), /* This fund has an Airwallex deposit ID that will become invalid in the destination tenant. Consider removing the provider ID before moving, or the fund may fail to process charges in the new tenant. */
          },
        },
      },
      'notifications/user-settings': {
        name: () => t('resources.notifications/user-settings.name'), /* User Notification settings |||| User Notification settings */
        show: {
          title: () => t('resources.notifications/user-settings.show.title'), /* User Notification Settings details */
        },
        create: {
          title: () => t('resources.notifications/user-settings.create.title'), /* New User Notification settings */
        },
        edit: {
          title: () => t('resources.notifications/user-settings.edit.title'), /* Edit User Notification settings */
        },
        fields: {
          id: () => t('resources.notifications/user-settings.fields.id'), /* ID */
          email: () => t('resources.notifications/user-settings.fields.email'), /* Email */
          disabledEvents: () => t('resources.notifications/user-settings.fields.disabledEvents'), /* Disabled events */
        },
        modal: {
          title: () => t('resources.notifications/user-settings.modal.title'), /* Manage notifications */
          cancel: () => t('resources.notifications/user-settings.modal.cancel'), /* Cancel */
          notificationSettingsSaved: () => t('resources.notifications/user-settings.modal.notificationSettingsSaved'), /* Notification settings saved */
          save: () => t('resources.notifications/user-settings.modal.save'), /* Save */
        },
      },
      notificationDefinition: {
        name: () => t('resources.notificationDefinition.name'), /* Notification definition |||| Notification definition */
        create: {
          title: () => t('resources.notificationDefinition.create.title'), /* New notification definition */
          detailsSubtitle: () => t('resources.notificationDefinition.create.detailsSubtitle'), /* Notification definition details */
          save: () => t('resources.notificationDefinition.create.save'), /* Create notification definition */
        },
        edit: {
          title: () => t('resources.notificationDefinition.edit.title'), /* Update notification definition */
          save: () => t('resources.notificationDefinition.edit.save'), /* Update notification definition */
        },
        fields: {
          status: () => t('resources.notificationDefinition.fields.status'), /* Status */
          provider: () => t('resources.notificationDefinition.fields.provider'), /* Provider */
          payload: () => t('resources.notificationDefinition.fields.payload'), /* Payload */
          entityType: () => t('resources.notificationDefinition.fields.entityType'), /* Entity Type */
        },
        show: {
          notificationDefinitionDetails: {
            title: () => t('resources.notificationDefinition.show.notificationDefinitionDetails.title'), /* Notification Definition details */
          },
        },
      },
      refunds: {
        name: () => t('resources.refunds.name'), /* Refund |||| Refunds */
        title: () => t('resources.refunds.title'), /* Refunds */
        fields: {
          invoice: () => t('resources.refunds.fields.invoice'), /* Invoice */
          amount: () => t('resources.refunds.fields.amount'), /* Amount */
          charge: () => t('resources.refunds.fields.charge'), /* Charge */
          billing: () => t('resources.refunds.fields.billing'), /* Billing */
          currency: () => t('resources.refunds.fields.currency'), /* Currency */
          status: () => t('resources.refunds.fields.status'), /* Status */
          refundedTo: () => t('resources.refunds.fields.refundedTo'), /* Refunded To */
        },
      },
      fees: {
        name: () => t('resources.fees.name'), /* Fee |||| Fees */
        fields: {
          baseFee: () => t('resources.fees.fields.baseFee'), /* Base fee */
          status: () => t('resources.fees.fields.status'), /* Status */
          supplierAdjustmentFee: () => t('resources.fees.fields.supplierAdjustmentFee'), /* Supplier adjustment */
          buyerCalcFee: () => t('resources.fees.fields.buyerCalcFee'), /* Buyer calc fee */
          countFrom: () => t('resources.fees.fields.countFrom'), /* Count from */
          overflowMenu: () => t('resources.fees.fields.overflowMenu'), /* Actions */
          type: () => t('resources.fees.fields.type'), /* Type */
          businessType: () => t('resources.fees.fields.businessType'), /* Business Type */
          volumeMin: () => t('resources.fees.fields.volumeMin'), /* Min Volume */
          volumeMax: () => t('resources.fees.fields.volumeMax'), /* Max Volume */
          amountMin: () => t('resources.fees.fields.amountMin'), /* Min Order Amount */
          amountMax: () => t('resources.fees.fields.amountMax'), /* Max Order Amount */
          paymentMethod: () => t('resources.fees.fields.paymentMethod'), /* Payment method */
          paymentTerm: {
            provider: () => t('resources.fees.fields.paymentTerm.provider'), /* Credit Line Provider */
            type: () => t('resources.fees.fields.paymentTerm.type'), /* Payment term type */
            payload: {
              days: () => t('resources.fees.fields.paymentTerm.payload.days'), /* Payment term days */
              countFrom: () => t('resources.fees.fields.paymentTerm.payload.countFrom'), /* Count days from */
            },
          },
          paymentFee: {
            percentage: () => t('resources.fees.fields.paymentFee.percentage'), /* Percentage fee */
            fixed: () => t('resources.fees.fields.paymentFee.fixed'), /* Fixed fee */
          },
          adjustment: {
            percentage: () => t('resources.fees.fields.adjustment.percentage'), /* Percentage adjustment */
            fixed: () => t('resources.fees.fields.adjustment.fixed'), /* Fixed adjustment */
          },
          intentTypes: () => t('resources.fees.fields.intentTypes'), /* Intents */
          filter: {
            label: () => t('resources.fees.fields.filter.label'), /* Filter by status */
          },
          editDialog: {
            title: () => t('resources.fees.fields.editDialog.title'), /* This fee is being used on existing invoices */
            content: () => t('resources.fees.fields.editDialog.content'), /* To make changes to this fee we must duplicate it and archive the existing one. */
            buttons: {
              cancel: () => t('resources.fees.fields.editDialog.buttons.cancel'), /* Cancel */
              confirm: () => t('resources.fees.fields.editDialog.buttons.confirm'), /* Duplicate and archive fee */
            },
          },
          notifications: {
            feeCreated: () => t('resources.fees.fields.notifications.feeCreated'), /* Fee created successfully */
            feeDuplicated: () => t('resources.fees.fields.notifications.feeDuplicated'), /* Fee duplicated successfully */
          },
          paymentMethodOptions: {
            label: () => t('resources.fees.fields.paymentMethodOptions.label'), /* Options */
            wire: {
              location: () => t('resources.fees.fields.paymentMethodOptions.wire.location'), /* Bank location */
            },
          },
        },
        actions: {
          showArchived: () => t('resources.fees.actions.showArchived'), /* Show archived */
          hideArchived: () => t('resources.fees.actions.hideArchived'), /* Hide archived */
          archive: () => t('resources.fees.actions.archive'), /* Archive */
          unarchive: () => t('resources.fees.actions.unarchive'), /* Unarchive */
        },
        tabs: {
          buyer: () => t('resources.fees.tabs.buyer'), /* Buyer fees */
          supplier: () => t('resources.fees.tabs.supplier'), /* Supplier fees */
        },
      },
      creditline: {
        name: () => t('resources.creditline.name'), /* Credit Line |||| Credit Lines */
        fields: {
          isActive: () => t('resources.creditline.fields.isActive'), /* Active */
          buyer: () => t('resources.creditline.fields.buyer'), /* Buyer */
          requestedAmount: () => t('resources.creditline.fields.requestedAmount'), /* Requested amount */
          filterByStatus: () => t('resources.creditline.fields.filterByStatus'), /* Filter by status */
          financialConnectionsLinked: () => t('resources.creditline.fields.financialConnectionsLinked'), /* Financial connections linked */
          currency: () => t('resources.creditline.fields.currency'), /* Currency */
          buyerCompany: () => t('resources.creditline.fields.buyerCompany'), /* Buyer company */
          result: {
            status: () => t('resources.creditline.fields.result.status'), /* Credit Status */
            creditLimit: () => t('resources.creditline.fields.result.creditLimit'), /* Credit limit */
            breakdown: {
              buyer: () => t('resources.creditline.fields.result.breakdown.buyer'), /* Buyer breakdown */
              supplier: () => t('resources.creditline.fields.result.breakdown.supplier'), /* Supplier breakdown */
            },
          },
          provider: () => t('resources.creditline.fields.provider'), /* Provider */
          tooltips: {
            'in-review': (data: Record<'requestedAmount', unknown>) => t('resources.creditline.fields.tooltips.in-review', data), /* Your credit line request for %{requestedAmount} is under review. */
            'manual-review': (data: Record<'requestedAmount', unknown>) => t('resources.creditline.fields.tooltips.manual-review', data), /* Your credit line request for %{requestedAmount} is under review. */
            declined: (data: Record<'legalName', unknown>) => t('resources.creditline.fields.tooltips.declined', data), /* Unfortunately, we were unable to approve %{legalName} for a credit line. If you can provide new supporting financial information we'd be happy to review the application again. */
            preapproved: () => t('resources.creditline.fields.tooltips.preapproved'), /* Approval of your credit limit is subject to review of your financial data. */
          },
        },
        create: {
          title: () => t('resources.creditline.create.title'), /* Credit Line Identity */
          result: () => t('resources.creditline.create.result'), /* Result */
        },
        actions: {
          creditLineRequest: () => t('resources.creditline.actions.creditLineRequest'), /* Add Request */
        },
        list: {
          filterByStatus: () => t('resources.creditline.list.filterByStatus'), /* Filter by status */
        },
        show: {
          noNotificationsForCreditline: () => t('resources.creditline.show.noNotificationsForCreditline'), /* No notifications for creditline yet */
          noNotificationsForCreditlineRequest: () => t('resources.creditline.show.noNotificationsForCreditlineRequest'), /* No notifications for creditline request yet */
          creditLineNotifications: () => t('resources.creditline.show.creditLineNotifications'), /* Creditline Notifications */
          creditLineRequestNotifications: () => t('resources.creditline.show.creditLineRequestNotifications'), /* Creditline request Notifications */
        },
      },
      'creditline/requests': {
        name: () => t('resources.creditline/requests.name'), /* Credit Request |||| Credit Requests */
        fields: {
          buyer: () => t('resources.creditline/requests.fields.buyer'), /* Buyer */
          creditLine: () => t('resources.creditline/requests.fields.creditLine'), /* Credit Line */
          requestedAmount: () => t('resources.creditline/requests.fields.requestedAmount'), /* Requested Amount */
          currency: () => t('resources.creditline/requests.fields.currency'), /* Currency */
          status: () => t('resources.creditline/requests.fields.status'), /* Status */
          type: () => t('resources.creditline/requests.fields.type'), /* Type */
          creditLimit: () => t('resources.creditline/requests.fields.creditLimit'), /* Credit Limit */
          bankAccountConnected: () => t('resources.creditline/requests.fields.bankAccountConnected'), /* Bank Account Connected */
          cancelReason: () => t('resources.creditline/requests.fields.cancelReason'), /* Cancellation reason */
          filterByStatus: () => t('resources.creditline/requests.fields.filterByStatus'), /* Filter by status */
          decidedBy: () => t('resources.creditline/requests.fields.decidedBy'), /* Decided by */
          decisionType: () => t('resources.creditline/requests.fields.decisionType'), /* Decision type */
          decisionNote: () => t('resources.creditline/requests.fields.decisionNote'), /* Decision note */
          funding: () => t('resources.creditline/requests.fields.funding'), /* Funding */
        },
        show: {
          result: () => t('resources.creditline/requests.show.result'), /* Result */
        },
        create: {
          title: () => t('resources.creditline/requests.create.title'), /* Credit Line Request */
        },
      },
      underwriting: {
        name: () => t('resources.underwriting.name'), /* Underwriting |||| Underwritings */
        manualWiserfundingSearch: {
          enterCompanyIdOrLegalName: () => t('resources.underwriting.manualWiserfundingSearch.enterCompanyIdOrLegalName'), /* Enter company ID or Legal Name */
          companyIdOrLegalName: () => t('resources.underwriting.manualWiserfundingSearch.companyIdOrLegalName'), /* Company ID or Legal Name */
          findCompany: () => t('resources.underwriting.manualWiserfundingSearch.findCompany'), /* Find company */
          matchManually: () => t('resources.underwriting.manualWiserfundingSearch.matchManually'), /* Match manually */
          manuallyMatchBuyerToWiserfundingCompany: () => t('resources.underwriting.manualWiserfundingSearch.manuallyMatchBuyerToWiserfundingCompany'), /* Manually match buyer to Wiserfunding company */
          matchCompany: () => t('resources.underwriting.manualWiserfundingSearch.matchCompany'), /* Match Company */
        },
        fields: {
          requestedAmount: () => t('resources.underwriting.fields.requestedAmount'), /* Requested amount */
          allianzCompany: () => t('resources.underwriting.fields.allianzCompany'), /* Allianz Company */
          country: () => t('resources.underwriting.fields.country'), /* Country */
          businessStartDate: () => t('resources.underwriting.fields.businessStartDate'), /* Business start date */
          transactions: () => t('resources.underwriting.fields.transactions'), /* Transactions */
          ownership: () => t('resources.underwriting.fields.ownership'), /* Ownership */
          balance: () => t('resources.underwriting.fields.balance'), /* Balance */
          currency: () => t('resources.underwriting.fields.currency'), /* Currency */
          status: () => t('resources.underwriting.fields.status'), /* Status */
          tracking: {
            heron: () => t('resources.underwriting.fields.tracking.heron'), /* Heron report */
            allianz: () => t('resources.underwriting.fields.tracking.allianz'), /* Allianz cover */
          },
          result: {
            status: () => t('resources.underwriting.fields.result.status'), /* Result status */
            creditLimit: () => t('resources.underwriting.fields.result.creditLimit'), /* Credit limit */
          },
        },
        show: {
          underwritingDetails: {
            title: () => t('resources.underwriting.show.underwritingDetails.title'), /* Underwriting details */
            underwritingAnalysis: () => t('resources.underwriting.show.underwritingDetails.underwritingAnalysis'), /* Underwriting analysis */
            creditRequest: () => t('resources.underwriting.show.underwritingDetails.creditRequest'), /* Credit request */
            creditRequestDetails: () => t('resources.underwriting.show.underwritingDetails.creditRequestDetails'), /* Credit request details */
            details: () => t('resources.underwriting.show.underwritingDetails.details'), /* Details */
            balance: () => t('resources.underwriting.show.underwritingDetails.balance'), /* Balance */
            ownership: () => t('resources.underwriting.show.underwritingDetails.ownership'), /* Ownership */
            heronReport: () => t('resources.underwriting.show.underwritingDetails.heronReport'), /* Heron report */
            visitHeron: () => t('resources.underwriting.show.underwritingDetails.visitHeron'), /* Visit Heron */
            decidedBy: () => t('resources.underwriting.show.underwritingDetails.decidedBy'), /* Decided by */
            creditApproved: () => t('resources.underwriting.show.underwritingDetails.creditApproved'), /* Approved credit */
            applyDecision: () => t('resources.underwriting.show.underwritingDetails.applyDecision'), /* Apply decision */
            noOwners: () => t('resources.underwriting.show.underwritingDetails.noOwners'), /* No owner details available */
            creditDecision: () => t('resources.underwriting.show.underwritingDetails.creditDecision'), /* Credit decision */
            decisionType: () => t('resources.underwriting.show.underwritingDetails.decisionType'), /* Decision type */
            noCredit: () => t('resources.underwriting.show.underwritingDetails.noCredit'), /* No credit */
            qualifiedFor: () => t('resources.underwriting.show.underwritingDetails.qualifiedFor'), /* Qualified for */
            decisionDate: () => t('resources.underwriting.show.underwritingDetails.decisionDate'), /* Decision date */
            decisionNote: () => t('resources.underwriting.show.underwritingDetails.decisionNote'), /* Decision note */
            creditLineRequestType: () => t('resources.underwriting.show.underwritingDetails.creditLineRequestType'), /* Type */
          },
          UnderwritingHeronStatistics: {
            monthsOfBankData: () => t('resources.underwriting.show.UnderwritingHeronStatistics.monthsOfBankData'), /* # months of bank data */
            avgMonthlyTrx: () => t('resources.underwriting.show.UnderwritingHeronStatistics.avgMonthlyTrx'), /* Average #Trx / month */
            avgDebtRepayment: () => t('resources.underwriting.show.UnderwritingHeronStatistics.avgDebtRepayment'), /* Average debt repayment */
            nsfOverdraftCases: () => t('resources.underwriting.show.UnderwritingHeronStatistics.nsfOverdraftCases'), /* # NSF / Overdraft cases */
            newDebt: () => t('resources.underwriting.show.UnderwritingHeronStatistics.newDebt'), /* New debt in the last 3 months */
            netProfit: () => t('resources.underwriting.show.UnderwritingHeronStatistics.netProfit'), /* Net profit (loss) */
            avgMonthlyRevenueByRequestCredit: () => t('resources.underwriting.show.UnderwritingHeronStatistics.avgMonthlyRevenueByRequestCredit'), /* Average monthly revenue / Requested credit */
            debtRepaymentRatioByAvgMonthlyRevenue: () => t('resources.underwriting.show.UnderwritingHeronStatistics.debtRepaymentRatioByAvgMonthlyRevenue'), /* Debt repayment ratio / Average monthly revenue */
            newDebtByRequestAmount: () => t('resources.underwriting.show.UnderwritingHeronStatistics.newDebtByRequestAmount'), /* Last 3 months new debt / Requested credit */
            lastBalance: () => t('resources.underwriting.show.UnderwritingHeronStatistics.lastBalance'), /* Last balance */
            revenue: () => t('resources.underwriting.show.UnderwritingHeronStatistics.revenue'), /* Annual revenue */
          },
          UnderwritingAllianzCompanyDetails: {
            noMatch: () => t('resources.underwriting.show.UnderwritingAllianzCompanyDetails.noMatch'), /* No match */
            businessStartDateAllianz: () => t('resources.underwriting.show.UnderwritingAllianzCompanyDetails.businessStartDateAllianz'), /* Business start date (Allianz) */
          },
          underwritingExperianDetails: {
            noMatch: () => t('resources.underwriting.show.underwritingExperianDetails.noMatch'), /* No match */
            experianLabel: () => t('resources.underwriting.show.underwritingExperianDetails.experianLabel'), /* Experian */
            experianDataCreationDate: () => t('resources.underwriting.show.underwritingExperianDetails.experianDataCreationDate'), /* Data creation date */
            experianScore: () => t('resources.underwriting.show.underwritingExperianDetails.experianScore'), /* Score */
            experianReport: () => t('resources.underwriting.show.underwritingExperianDetails.experianReport'), /* Experian report */
          },
          underwritingFinancialActivitiesPolicy: {
            title: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.title'), /* Financial Activities Credit Policy */
            gridTitles: {
              parameters: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.gridTitles.parameters'), /* Parameters */
              approvalCriteria: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.gridTitles.approvalCriteria'), /* Approval criteria */
              results: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.gridTitles.results'), /* Results */
            },
            parameters: {
              availableBankActivity: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.availableBankActivity'), /* Available bank activity */
              nsfOverdraftCases: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.nsfOverdraftCases'), /* NSF / Overdraft cases */
              negativeBalanceDays: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.negativeBalanceDays'), /* Negative balance days */
              accountBalance: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.accountBalance'), /* Account balance */
              transactionsPerMonth: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.transactionsPerMonth'), /* Transactions per month */
              annualBankRevenue: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.annualBankRevenue'), /* Annual Bank Revenue */
              ratioOfBankRevenueToRequestedCredit: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.ratioOfBankRevenueToRequestedCredit'), /* Ratio of Bank Revenue to Requested Credit */
              ratioOfDebtRepaymentToMonthlyBankRevenue: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.ratioOfDebtRepaymentToMonthlyBankRevenue'), /* Ratio of Debt Repayment to Monthly Bank Revenue */
              debtAmount: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.debtAmount'), /* Debt amount */
              netProfit: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.parameters.netProfit'), /* Net Profit */
            },
            approvalCriteria: {
              availableBankActivity: (data: Record<'monthsOfBankData', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.availableBankActivity', data), /* %{monthsOfBankData} months */
              nsfOverdraftCases: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.nsfOverdraftCases'), /* No cases */
              negativeBalanceDays: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.negativeBalanceDays'), /* No negative balance days */
              accountBalance: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.accountBalance'), /* Positive balance */
              transactionsPerMonth: (data: Record<'transactionsPerMonth', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.transactionsPerMonth', data), /* Minimal %{transactionsPerMonth} transactions */
              annualBankRevenue: (data: Record<'minimalAnnualBankRevenue', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.annualBankRevenue', data), /* Minimal %{minimalAnnualBankRevenue} */
              ratioOfBankRevenueToRequestedCredit: (data: Record<'ratio', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.ratioOfBankRevenueToRequestedCredit', data), /* Higher than %{ratio}x */
              ratioOfDebtRepaymentToMonthlyBankRevenue: (data: Record<'ratio', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.ratioOfDebtRepaymentToMonthlyBankRevenue', data), /* Lower than %{ratio}% */
              debtAmount: (data: Record<'ratio', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.debtAmount', data), /* No debt for %{ratio}% of requested limit or in the last 3 months */
              netProfit: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.approvalCriteria.netProfit'), /* Positive */
            },
            results: {
              availableBankActivity: (data: Record<'availableBankActivity', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.availableBankActivity', data), /* %{availableBankActivity} months */
              transactionsPerMonth: (data: Record<'transactions', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.transactionsPerMonth', data), /* %{transactions} transactions */
              ratioOfBankRevenueToRequestedCredit: (data: Record<'ratio', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfBankRevenueToRequestedCredit', data), /* Ratio: %{ratio}x */
              ratioOfDebtRepaymentToMonthlyBankRevenue: (data: Record<'ratio', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfDebtRepaymentToMonthlyBankRevenue', data), /* Ratio: %{ratio}% */
              ratioOfBankRevenueToRequestedCreditCreditRequest: (data: Record<'creditRequest', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfBankRevenueToRequestedCreditCreditRequest', data), /* Credit request: %{creditRequest} */
              ratioOfBankRevenueToRequestedCreditMonthlyBankRevenue: (data: Record<'monthlyBankRevenue', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfBankRevenueToRequestedCreditMonthlyBankRevenue', data), /* Monthly bank revenue: %{monthlyBankRevenue} */
              ratioOfDebtRepaymentToMonthlyBankRevenueDebtRepayment: (data: Record<'debtRepayment', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfDebtRepaymentToMonthlyBankRevenueDebtRepayment', data), /* Debt repayment: %{debtRepayment} */
              ratioOfDebtRepaymentToMonthlyBankRevenueMonthlyBankRevenue: (data: Record<'monthlyBankRevenue', unknown>) => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.ratioOfDebtRepaymentToMonthlyBankRevenueMonthlyBankRevenue', data), /* Monthly Bank Revenue: %{monthlyBankRevenue} */
              debtAmountNoDebt: () => t('resources.underwriting.show.underwritingFinancialActivitiesPolicy.results.debtAmountNoDebt'), /* No debt */
            },
          },
          underwritingBondRatingPolicy: {
            title: () => t('resources.underwriting.show.underwritingBondRatingPolicy.title'), /* Bond Rating Policy */
            gridTitles: {
              parameters: () => t('resources.underwriting.show.underwritingBondRatingPolicy.gridTitles.parameters'), /* Parameters */
              approvalCriteria: () => t('resources.underwriting.show.underwritingBondRatingPolicy.gridTitles.approvalCriteria'), /* Approval criteria */
              results: () => t('resources.underwriting.show.underwritingBondRatingPolicy.gridTitles.results'), /* Results */
            },
            parameters: {
              bondRating: () => t('resources.underwriting.show.underwritingBondRatingPolicy.parameters.bondRating'), /* Bond Rating */
              reliability: () => t('resources.underwriting.show.underwritingBondRatingPolicy.parameters.reliability'), /* Reliability */
            },
            approvalCriteria: {
              bondRating: () => t('resources.underwriting.show.underwritingBondRatingPolicy.approvalCriteria.bondRating'), /* At least BB */
              reliability: (data: Record<'reliability', unknown>) => t('resources.underwriting.show.underwritingBondRatingPolicy.approvalCriteria.reliability', data), /* Higher than %{reliability} */
            },
          },
          underwritingLowLimitPolicy: {
            title: () => t('resources.underwriting.show.underwritingLowLimitPolicy.title'), /* Low Limits Credit Policy */
            signed: () => t('resources.underwriting.show.underwritingLowLimitPolicy.signed'), /* Signed */
            unsigned: () => t('resources.underwriting.show.underwritingLowLimitPolicy.unsigned'), /* Unsigned */
            noCreditScore: () => t('resources.underwriting.show.underwritingLowLimitPolicy.noCreditScore'), /* No credit score */
            annualRevenue: () => t('resources.underwriting.show.underwritingLowLimitPolicy.annualRevenue'), /* Annual revenue */
            approvedCredit: () => t('resources.underwriting.show.underwritingLowLimitPolicy.approvedCredit'), /* Approved credit */
          },
          creditScoreAnnualRevenuePolicy: {
            title: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.title'), /* Credit Score + Financial Connection Policy */
            creditScore: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.creditScore'), /* Credit score */
            annualRevenue: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.annualRevenue'), /* Annual revenue */
            noCreditScore: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.noCreditScore'), /* No credit score */
            approvedCredit: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.approvedCredit'), /* Approved credit */
            exists: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.exists'), /* Exists */
            missing: () => t('resources.underwriting.show.creditScoreAnnualRevenuePolicy.missing'), /* Missing */
          },
          creditScoreIdVerificationPolicy: {
            title: () => t('resources.underwriting.show.creditScoreIdVerificationPolicy.title'), /* Credit score + ID Verification Policy */
            identityVerification: () => t('resources.underwriting.show.creditScoreIdVerificationPolicy.identityVerification'), /* Identity verification */
            noCreditScore: () => t('resources.underwriting.show.creditScoreIdVerificationPolicy.noCreditScore'), /* No credit score */
            creditScore: () => t('resources.underwriting.show.creditScoreIdVerificationPolicy.creditScore'), /* Credit score */
            approvedCredit: () => t('resources.underwriting.show.creditScoreIdVerificationPolicy.approvedCredit'), /* Approved credit */
          },
          underwritingCreditScorePGPolicy: {
            title: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.title'), /* Credit score + Personal Guarantee Policy */
            creditScore: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.creditScore'), /* Credit score */
            personalGuarantee: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.personalGuarantee'), /* Personal guarantee */
            signed: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.signed'), /* Signed */
            unsigned: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.unsigned'), /* Unsigned */
            noCreditScore: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.noCreditScore'), /* No credit score */
            approvedCredit: () => t('resources.underwriting.show.underwritingCreditScorePGPolicy.approvedCredit'), /* Approved credit */
          },
          underwritingCreditPoliciesSummary: {
            title: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.title'), /* Credit policies summary */
            creditEligibility: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.creditEligibility'), /* Credit eligibility */
            preapproved: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.preapproved'), /* Pre-approved */
            lowlimit: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.lowlimit'), /* Low limits policy */
            'credit-score-annual-revenue': () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.credit-score-annual-revenue'), /* Credit score + FC policy */
            'credit-score-id-verification': () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.credit-score-id-verification'), /* Credit score + ID Verification policy */
            'credit-score-pg': () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.credit-score-pg'), /* Credit score + Personal Guarantee policy */
            'bond-rating': () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.bond-rating'), /* Bond rating policy */
            'financial-activities': () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.financial-activities'), /* Financial Activities Credit policy */
            showDetails: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.showDetails'), /* Show details */
            noCredit: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.noCredit'), /* No credit */
            appliedPolicy: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.appliedPolicy'), /* Applied policy */
            manual: () => t('resources.underwriting.show.underwritingCreditPoliciesSummary.manual'), /* Manual */
          },
          underwritingProcessesChecks: {
            title: () => t('resources.underwriting.show.underwritingProcessesChecks.title'), /* Checks */
            businessVerification: () => t('resources.underwriting.show.underwritingProcessesChecks.businessVerification'), /* Business found and verified */
            showDetails: () => t('resources.underwriting.show.underwritingProcessesChecks.showDetails'), /* Show details */
            businessAgeOverAYear: () => t('resources.underwriting.show.underwritingProcessesChecks.businessAgeOverAYear'), /* Business age over a year */
            heron: () => t('resources.underwriting.show.underwritingProcessesChecks.heron'), /* Heron */
            insuranceCover: () => t('resources.underwriting.show.underwritingProcessesChecks.insuranceCover'), /* Insurance cover */
            coverRequest: () => t('resources.underwriting.show.underwritingProcessesChecks.coverRequest'), /* Cover request  */
            coverAmount: () => t('resources.underwriting.show.underwritingProcessesChecks.coverAmount'), /* Cover amount:  */
            noInformation: () => t('resources.underwriting.show.underwritingProcessesChecks.noInformation'), /* No information */
            notRequired: () => t('resources.underwriting.show.underwritingProcessesChecks.notRequired'), /* Not required */
            requireFromBuyer: () => t('resources.underwriting.show.underwritingProcessesChecks.requireFromBuyer'), /* Require from buyer */
            inProgress: () => t('resources.underwriting.show.underwritingProcessesChecks.inProgress'), /* In progress */
            verifying: () => t('resources.underwriting.show.underwritingProcessesChecks.verifying'), /* Verifying */
            copyLink: () => t('resources.underwriting.show.underwritingProcessesChecks.copyLink'), /* Copy link */
            viewOnStripe: () => t('resources.underwriting.show.underwritingProcessesChecks.viewOnStripe'), /* View on Stripe */
            requireNewVerification: () => t('resources.underwriting.show.underwritingProcessesChecks.requireNewVerification'), /* Failed, require new verification */
          },
        },
      },
      'noble/customers': {
        name: () => t('resources.noble/customers.name'), /* Noble Customer |||| Noble Customers */
        fields: {
          nobleId: () => t('resources.noble/customers.fields.nobleId'), /* Noble ID */
          externalLink: () => t('resources.noble/customers.fields.externalLink'), /*  */
        },
      },
      'noble/workflows': {
        name: () => t('resources.noble/workflows.name'), /* Noble Workflow |||| Noble Workflows */
        fields: {
          workflowName: () => t('resources.noble/workflows.fields.workflowName'), /* Workflow name */
          creationDate: () => t('resources.noble/workflows.fields.creationDate'), /* Created at */
          lastUpdated: () => t('resources.noble/workflows.fields.lastUpdated'), /* Updated at */
          externalLink: () => t('resources.noble/workflows.fields.externalLink'), /*  */
        },
      },
      'heron/companies': {
        name: () => t('resources.heron/companies.name'), /* Heron Company |||| Heron Companies */
        fields: {
          heronId: () => t('resources.heron/companies.fields.heronId'), /* Heron ID */
          externalLink: () => t('resources.heron/companies.fields.externalLink'), /*  */
        },
      },
      'heron/reports': {
        name: () => t('resources.heron/reports.name'), /* Heron Report |||| Heron Reports */
        fields: {
          status: () => t('resources.heron/reports.fields.status'), /* Status */
          process: () => t('resources.heron/reports.fields.process'), /* Process */
          confidence: () => t('resources.heron/reports.fields.confidence'), /* Confidence */
          financialConnections: () => t('resources.heron/reports.fields.financialConnections'), /* Financial connections */
          totalTransactions: () => t('resources.heron/reports.fields.totalTransactions'), /* Total transactions */
          lastBalance: () => t('resources.heron/reports.fields.lastBalance'), /* Last balance */
          annualRevenue: () => t('resources.heron/reports.fields.annualRevenue'), /* Annual revenue */
          creditScore: () => t('resources.heron/reports.fields.creditScore'), /* Credit score */
        },
        statistics: {
          monthsOfBankData: () => t('resources.heron/reports.statistics.monthsOfBankData'), /* # months of bank data */
          avgMonthlyTrx: () => t('resources.heron/reports.statistics.avgMonthlyTrx'), /* Average #Trx / month */
          avgDebtRepayment: () => t('resources.heron/reports.statistics.avgDebtRepayment'), /* Average debt repayment */
          nsfOverdraftCases: () => t('resources.heron/reports.statistics.nsfOverdraftCases'), /* # NSF / Overdraft cases */
          newDebt: () => t('resources.heron/reports.statistics.newDebt'), /* New debt in the last 3 months */
          netProfit: () => t('resources.heron/reports.statistics.netProfit'), /* Net profit (loss) */
          avgMonthlyRevenueByRequestCredit: () => t('resources.heron/reports.statistics.avgMonthlyRevenueByRequestCredit'), /* Average monthly revenue / Requested credit */
          debtRepaymentRatioByAvgMonthlyRevenue: () => t('resources.heron/reports.statistics.debtRepaymentRatioByAvgMonthlyRevenue'), /* Debt repayment ratio / Average monthly revenue */
          newDebtByRequestAmount: () => t('resources.heron/reports.statistics.newDebtByRequestAmount'), /* Last 3 months new debt / Requested credit */
          lastBalance: () => t('resources.heron/reports.statistics.lastBalance'), /* Latest balance */
          avg90DaysBalance: () => t('resources.heron/reports.statistics.avg90DaysBalance'), /* Average 90 days balance */
          negativeBalanceDays: () => t('resources.heron/reports.statistics.negativeBalanceDays'), /* Negative balance days, last 365 days */
          revenue: () => t('resources.heron/reports.statistics.revenue'), /* Total revenues, last 12 months */
          revenueResources: () => t('resources.heron/reports.statistics.revenueResources'), /* Revenue sources. last 365 days */
          netOperatingCashflow: () => t('resources.heron/reports.statistics.netOperatingCashflow'), /* Net operating cashflow, last 12 month */
          debtRepayment: () => t('resources.heron/reports.statistics.debtRepayment'), /* Debt repayment, last 12 months */
          netIncomeToDebtRatio: () => t('resources.heron/reports.statistics.netIncomeToDebtRatio'), /* Net income to debt ratio */
        },
      },
      allianz: {
        name: () => t('resources.allianz.name'), /* Allianz |||| Allianz */
      },
      'stripe/customers': {
        name: () => t('resources.stripe/customers.name'), /* Stripe Customer |||| Stripe Customers */
        fields: {
          providerId: () => t('resources.stripe/customers.fields.providerId'), /* Provider ID */
          isMicroDepositEnabled: () => t('resources.stripe/customers.fields.isMicroDepositEnabled'), /* Micro deposit enabled */
        },
      },
      'webhooks/applications': {
        name: () => t('resources.webhooks/applications.name'), /* Webhook Application |||| Webhook Applications */
      },
      webhooks: {
        name: () => t('resources.webhooks.name'), /* Webhook |||| Webhooks */
      },
      bankaccount: {
        name: () => t('resources.bankaccount.name'), /* Bank Account |||| Bank Accounts */
        fields: {
          currency: () => t('resources.bankaccount.fields.currency'), /* Currency */
          location: () => t('resources.bankaccount.fields.location'), /* Account location */
          name: () => t('resources.bankaccount.fields.name'), /* Bank account name */
          provider: () => t('resources.bankaccount.fields.provider'), /* Provider */
          status: () => t('resources.bankaccount.fields.status'), /* Status */
          ownership: () => t('resources.bankaccount.fields.ownership'), /* Ownership */
        },
        list: {
          addBankAccount: () => t('resources.bankaccount.list.addBankAccount'), /* Add bank account */
        },
        show: {
          nickname: () => t('resources.bankaccount.show.nickname'), /* Nickname */
          currency: () => t('resources.bankaccount.show.currency'), /* Currency */
          bankName: () => t('resources.bankaccount.show.bankName'), /* Bank name */
          accountHolderName: () => t('resources.bankaccount.show.accountHolderName'), /* Account holder name */
          accountLocation: () => t('resources.bankaccount.show.accountLocation'), /* Account location */
          ownership: () => t('resources.bankaccount.show.ownership'), /* Ownership */
          routingNumber: () => t('resources.bankaccount.show.routingNumber'), /* Routing number */
          accountNumber: () => t('resources.bankaccount.show.accountNumber'), /* Account number */
          createdAt: () => t('resources.bankaccount.show.createdAt'), /* Created at */
          createdBy: () => t('resources.bankaccount.show.createdBy'), /* Created by */
          bankDetails: () => t('resources.bankaccount.show.bankDetails'), /* Bank details */
          provider: () => t('resources.bankaccount.show.provider'), /* Provider */
          accountLocationDictionary: {
            USD: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.USD.domestic'), /* Inside United States of America */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.USD.international'), /* Outside United States of America */
            },
            EUR: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.EUR.domestic'), /* Inside Europe */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.EUR.international'), /* Outside Europe */
            },
            GBP: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.GBP.domestic'), /* Inside United Kingdom */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.GBP.international'), /* Outside United Kingdom */
            },
            CAD: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.CAD.domestic'), /* Inside Canada */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.CAD.international'), /* Outside Canada */
            },
            MXN: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.MXN.domestic'), /* Inside Mexico */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.MXN.international'), /* Outside Mexico */
            },
            CNY: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.CNY.domestic'), /* Inside China */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.CNY.international'), /* Outside China */
            },
            JPY: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.JPY.domestic'), /* Inside Japan */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.JPY.international'), /* Outside Japan */
            },
            HKD: {
              domestic: () => t('resources.bankaccount.show.accountLocationDictionary.HKD.domestic'), /* Inside Hong Kong */
              international: () => t('resources.bankaccount.show.accountLocationDictionary.HKD.international'), /* Outside Hong Kong */
            },
          },
        },
        create: {
          title: () => t('resources.bankaccount.create.title'), /* Add bank account details */
          addressTitle: () => t('resources.bankaccount.create.addressTitle'), /* Recipient Address */
          bankAccountDetailsCurrency: () => t('resources.bankaccount.create.bankAccountDetailsCurrency'), /* Bank account currency */
          bankName: () => t('resources.bankaccount.create.bankName'), /* Bank name */
          nickname: () => t('resources.bankaccount.create.nickname'), /* Bank account nickname (Optional) */
          accountOwnerName: () => t('resources.bankaccount.create.accountOwnerName'), /* Account owner name */
          accountLocation: () => t('resources.bankaccount.create.accountLocation'), /* Account location */
          businessRegistrationNumber: () => t('resources.bankaccount.create.businessRegistrationNumber'), /* Business Registration Number */
          accountLocationDictionary: {
            USD: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.USD.domestic'), /* Inside United States of America */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.USD.international'), /* Outside United States of America */
            },
            EUR: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.EUR.domestic'), /* Inside Europe */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.EUR.international'), /* Outside Europe */
            },
            GBP: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.GBP.domestic'), /* Inside United Kingdom */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.GBP.international'), /* Outside United Kingdom */
            },
            CAD: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.CAD.domestic'), /* Inside Canada */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.CAD.international'), /* Outside Canada */
            },
            CNH: {
              international: () => t('resources.bankaccount.create.accountLocationDictionary.CNH.international'), /* Outside China */
            },
            CNY: {
              international: () => t('resources.bankaccount.create.accountLocationDictionary.CNY.international'), /* Outside China */
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.CNY.domestic'), /* Inside China */
            },
            MXN: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.MXN.domestic'), /* Inside Mexico */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.MXN.international'), /* Outside Mexico */
            },
            JPY: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.JPY.domestic'), /* Inside Japan */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.JPY.international'), /* Outside Japan */
            },
            HKD: {
              domestic: () => t('resources.bankaccount.create.accountLocationDictionary.HKD.domestic'), /* Inside Hong Kong */
              international: () => t('resources.bankaccount.create.accountLocationDictionary.HKD.international'), /* Outside Hong Kong */
            },
          },
          dialog: {
            country: () => t('resources.bankaccount.create.dialog.country'), /* Country */
            city: () => t('resources.bankaccount.create.dialog.city'), /* City */
            addressLine1: () => t('resources.bankaccount.create.dialog.addressLine1'), /* Address Line1 */
            zipCode: () => t('resources.bankaccount.create.dialog.zipCode'), /* ZipCode */
            state: () => t('resources.bankaccount.create.dialog.state'), /* State */
            currency: () => t('resources.bankaccount.create.dialog.currency'), /* Currency */
            accountNumber: () => t('resources.bankaccount.create.dialog.accountNumber'), /* Account Number */
            bsb: () => t('resources.bankaccount.create.dialog.bsb'), /* BSB */
            routingNumber: () => t('resources.bankaccount.create.dialog.routingNumber'), /* Routing Number */
            bankAccountName: () => t('resources.bankaccount.create.dialog.bankAccountName'), /* Bank Account Name */
            bankName: () => t('resources.bankaccount.create.dialog.bankName'), /* Bank Name */
            iban: () => t('resources.bankaccount.create.dialog.iban'), /* IBAN */
            sortCode: () => t('resources.bankaccount.create.dialog.sortCode'), /* Sort Code */
            swift_code: () => t('resources.bankaccount.create.dialog.swift_code'), /* SWIFT code */
          },
        },
      },
      transactions: {
        name: () => t('resources.transactions.name'), /* Transaction |||| Transactions */
        fields: {
          for: () => t('resources.transactions.fields.for'), /* For */
          type: () => t('resources.transactions.fields.type'), /* Type */
          mode: () => t('resources.transactions.fields.mode'), /* Mode */
          transactionTime: () => t('resources.transactions.fields.transactionTime'), /* Time */
          providerType: () => t('resources.transactions.fields.providerType'), /* Provider type */
          bankName: () => t('resources.transactions.fields.bankName'), /* Bank name */
          currency: () => t('resources.transactions.fields.currency'), /* Currency */
          buyer: () => t('resources.transactions.fields.buyer'), /* Buyer */
          country: () => t('resources.transactions.fields.country'), /* Country */
          iban: () => t('resources.transactions.fields.iban'), /* IBAN */
          nickname: () => t('resources.transactions.fields.nickname'), /* Nickname */
          email: () => t('resources.transactions.fields.email'), /* Email */
          note: () => t('resources.transactions.fields.note'), /* Note */
          amountConverted: () => t('resources.transactions.fields.amountConverted'), /* Amount converted */
          amountTo: () => t('resources.transactions.fields.amountTo'), /* Amount to */
          fromCurrency: () => t('resources.transactions.fields.fromCurrency'), /* From currency */
          toCurrency: () => t('resources.transactions.fields.toCurrency'), /* To currency */
          exchangeRate: () => t('resources.transactions.fields.exchangeRate'), /* Exchange rate */
          accountHolderName: () => t('resources.transactions.fields.accountHolderName'), /* Account holder name */
          location: () => t('resources.transactions.fields.location'), /* Account location */
          recipientDetails: () => t('resources.transactions.fields.recipientDetails'), /* Recipient details */
          payoutDetails: () => t('resources.transactions.fields.payoutDetails'), /* Payout details */
          entityReference: () => t('resources.transactions.fields.entityReference'), /* Reference */
          reference: () => t('resources.transactions.fields.reference'), /* External ID */
          externalId: () => t('resources.transactions.fields.externalId'), /* External ID */
          transactionType: () => t('resources.transactions.fields.transactionType'), /* Transaction type */
          amount: () => t('resources.transactions.fields.amount'), /* Amount */
          creationDate: () => t('resources.transactions.fields.creationDate'), /* Creation date */
          status: () => t('resources.transactions.fields.status'), /* Status */
          fees: () => t('resources.transactions.fields.fees'), /* Fees */
          netAmount: () => t('resources.transactions.fields.netAmount'), /* Amount transferred */
        },
        cards: {
          withdraw: () => t('resources.transactions.cards.withdraw'), /* Withdraw */
          scheduledTransactionsActive: () => t('resources.transactions.cards.scheduledTransactionsActive'), /* Your account it set to automatic withdrawals */
          convert: () => t('resources.transactions.cards.convert'), /* Convert */
        },
        automate: {
          buttonLabel: () => t('resources.transactions.automate.buttonLabel'), /* Automate withdrawals */
          addRecipientButton: () => t('resources.transactions.automate.addRecipientButton'), /* Add new recipient */
          title: () => t('resources.transactions.automate.title'), /* Automate withdrawals */
          setSchedule: () => t('resources.transactions.automate.setSchedule'), /* Set a schedule to automatically receive your balance into your bank account. */
          selectCurrency: () => t('resources.transactions.automate.selectCurrency'), /* Select currency */
          selectAccount: () => t('resources.transactions.automate.selectAccount'), /* Select an  account */
          automaticEvery: () => t('resources.transactions.automate.automaticEvery'), /* Automatic every */
          selectPeriod: () => t('resources.transactions.automate.selectPeriod'), /* Select a period */
          manual: () => t('resources.transactions.automate.manual'), /* Manual */
          youCanManuallyInitiateWithdraw: () => t('resources.transactions.automate.youCanManuallyInitiateWithdraw'), /* You can manually initiate a withdraw with any amount whenever you want */
          automatic: () => t('resources.transactions.automate.automatic'), /* Automatic */
          createAutomaticWithdrawOnEveryPayout: () => t('resources.transactions.automate.createAutomaticWithdrawOnEveryPayout'), /* Create automatic withdraw on every payout */
          close: () => t('resources.transactions.automate.close'), /* Close */
          save: () => t('resources.transactions.automate.save'), /* Save */
          at: () => t('resources.transactions.automate.at'), /* at */
          at4PMEST: () => t('resources.transactions.automate.at4PMEST'), /* at 4 PM EST */
          scheduledTransactionsSaved: () => t('resources.transactions.automate.scheduledTransactionsSaved'), /* Scheduled transaction settings saved successfully */
          recipient: {
            title: () => t('resources.transactions.automate.recipient.title'), /* Add new recipient */
            addressTitle: () => t('resources.transactions.automate.recipient.addressTitle'), /* Recipient address */
            bankAccountDetailsCurrency: () => t('resources.transactions.automate.recipient.bankAccountDetailsCurrency'), /* Currency */
            bankName: () => t('resources.transactions.automate.recipient.bankName'), /* Bank name */
            nickname: () => t('resources.transactions.automate.recipient.nickname'), /* Account nickname (Optional) */
            accountOwnerName: () => t('resources.transactions.automate.recipient.accountOwnerName'), /* Recipient name */
            accountLocation: () => t('resources.transactions.automate.recipient.accountLocation'), /* Account location */
            email: () => t('resources.transactions.automate.recipient.email'), /* Recipient's email */
          },
        },
        notifications: () => t('resources.transactions.notifications'), /* Notifications */
        buttons: {
          confirmationLetterButton: () => t('resources.transactions.buttons.confirmationLetterButton'), /* Confirmation Letter */
        },
        transactionNote: {
          charge: {
            canceledPayout: () => t('resources.transactions.transactionNote.charge.canceledPayout'), /* Billing for canceled payout */
          },
        },
      },
      files: {
        name: () => t('resources.files.name'), /* File |||| Files */
      },
      audits: {
        name: () => t('resources.audits.name'), /* Audit |||| Audits */
        fields: {
          createdAt: () => t('resources.audits.fields.createdAt'), /* Created at */
          executor: () => t('resources.audits.fields.executor'), /* Executor */
          eventType: () => t('resources.audits.fields.eventType'), /* Event type */
          commit: () => t('resources.audits.fields.commit'), /* Commit */
          traceId: () => t('resources.audits.fields.traceId'), /* Trace ID */
        },
      },
      attachments: {
        name: () => t('resources.attachments.name'), /* Attachment |||| Attachments */
        fields: {
          fileName: () => t('resources.attachments.fields.fileName'), /* File name */
          name: () => t('resources.attachments.fields.name'), /* Name */
          entity: () => t('resources.attachments.fields.entity'), /* Entity */
          type: () => t('resources.attachments.fields.type'), /* Type */
          file: () => t('resources.attachments.fields.file'), /* File */
          createdAt: () => t('resources.attachments.fields.createdAt'), /* Uploaded at */
          createdBy: () => t('resources.attachments.fields.createdBy'), /* Uploaded by */
          action: () => t('resources.attachments.fields.action'), /* Action */
          preview: () => t('resources.attachments.fields.preview'), /* Preview */
          download: () => t('resources.attachments.fields.download'), /* Download */
          overflowMenu: () => t('resources.attachments.fields.overflowMenu'), /* Actions */
        },
        list: {
          deleteAttachmentConfirmation: {
            title: () => t('resources.attachments.list.deleteAttachmentConfirmation.title'), /* Delete attachment */
            content: () => t('resources.attachments.list.deleteAttachmentConfirmation.content'), /* Are you sure you want to delete this attachment? */
          },
        },
        attachmentsDisplay: {
          title: () => t('resources.attachments.attachmentsDisplay.title'), /* No attachments */
        },
      },
      'payment-methods': {
        name: () => t('resources.payment-methods.name'), /* Payment method |||| Payment methods */
        fields: {
          financialConnectionsAccounts: () => t('resources.payment-methods.fields.financialConnectionsAccounts'), /* Financial connection */
          isDefaultMethod: () => t('resources.payment-methods.fields.isDefaultMethod'), /*  */
          isAutomaticMethod: () => t('resources.payment-methods.fields.isAutomaticMethod'), /*  */
          buyer: () => t('resources.payment-methods.fields.buyer'), /* Buyer */
          provider: () => t('resources.payment-methods.fields.provider'), /* Provider */
          paymentMethodId: () => t('resources.payment-methods.fields.paymentMethodId'), /* Payment Method ID */
          walletAddress: () => t('resources.payment-methods.fields.walletAddress'), /* Wallet Address */
          network: () => t('resources.payment-methods.fields.network'), /* Network */
          stablecoin: () => t('resources.payment-methods.fields.stablecoin'), /* Stablecoin */
          cardholderName: () => t('resources.payment-methods.fields.cardholderName'), /* Cardholder Name */
          createdAt: () => t('resources.payment-methods.fields.createdAt'), /* Created At */
          createdBy: () => t('resources.payment-methods.fields.createdBy'), /* Created By */
        },
        default: () => t('resources.payment-methods.default'), /* Default */
        show: {
          generalInformation: () => t('resources.payment-methods.show.generalInformation'), /* General Information */
          walletDetails: () => t('resources.payment-methods.show.walletDetails'), /* Wallet Details */
          cardDetails: () => t('resources.payment-methods.show.cardDetails'), /* Card Details */
          metadata: () => t('resources.payment-methods.show.metadata'), /* Metadata */
        },
      },
      gocardless: {
        name: () => t('resources.gocardless.name'), /* Gocardless Customer |||| Gocardless Customers */
        fields: {
          id: () => t('resources.gocardless.fields.id'), /* ID */
          buyer: () => t('resources.gocardless.fields.buyer'), /* Buyer */
          providerId: () => t('resources.gocardless.fields.providerId'), /* Provider ID */
          createdAt: () => t('resources.gocardless.fields.createdAt'), /* Created at */
          createdBy: () => t('resources.gocardless.fields.createdBy'), /* Created by */
        },
      },
      tenants: {
        name: () => t('resources.tenants.name'), /* Tenant |||| Tenants */
      },
      ledgers: {
        name: () => t('resources.ledgers.name'), /* Ledger Entry |||| Ledger Entries */
        fields: {
          type: () => t('resources.ledgers.fields.type'), /* Type */
          reason: () => t('resources.ledgers.fields.reason'), /* Reason */
          amount: () => t('resources.ledgers.fields.amount'), /* Amount */
          currency: () => t('resources.ledgers.fields.currency'), /* Currency */
          dueDate: () => t('resources.ledgers.fields.dueDate'), /* Due date */
          status: () => t('resources.ledgers.fields.status'), /* Status */
          createdAt: () => t('resources.ledgers.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.ledgers.fields.updatedAt'), /* Updated at */
          createdBy: () => t('resources.ledgers.fields.createdBy'), /* Created by */
        },
      },
      intents: {
        name: () => t('resources.intents.name'), /* Intent |||| Intents */
        fields: {
          type: () => t('resources.intents.fields.type'), /* Type */
          status: () => t('resources.intents.fields.status'), /* Status */
          entityId: () => t('resources.intents.fields.entityId'), /* Entity ID */
          url: () => t('resources.intents.fields.url'), /* URL */
          originalUrl: () => t('resources.intents.fields.originalUrl'), /* Original URL */
          token: () => t('resources.intents.fields.token'), /* Token */
          createdAt: () => t('resources.intents.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.intents.fields.updatedAt'), /* Updated at */
          createdBy: () => t('resources.intents.fields.createdBy'), /* Created by */
        },
      },
      'users/settings': {
        name: () => t('resources.users/settings.name'), /* Settings |||| Settings */
      },
      auth: {
        name: () => t('resources.auth.name'), /* Authorization */
      },
      'auth/permissions': {
        fields: {
          permission: {
            resource: () => t('resources.auth/permissions.fields.permission.resource'), /* Resource */
            action: () => t('resources.auth/permissions.fields.permission.action'), /* Action */
            access: () => t('resources.auth/permissions.fields.permission.access'), /* Access */
          },
          roles: () => t('resources.auth/permissions.fields.roles'), /* Roles */
        },
      },
      settings: {
        name: () => t('resources.settings.name'), /* Settings |||| Settings */
        buyer: {
          tabs: {
            businessDetails: () => t('resources.settings.buyer.tabs.businessDetails'), /* Business details */
            paymentMethods: () => t('resources.settings.buyer.tabs.paymentMethods'), /* Payment methods */
            financialInformation: () => t('resources.settings.buyer.tabs.financialInformation'), /* Financial information */
            notifications: () => t('resources.settings.buyer.tabs.notifications'), /* Notifications */
          },
        },
        supplier: {
          tabs: {
            businessDetails: () => t('resources.settings.supplier.tabs.businessDetails'), /* Business details */
            credentials: () => t('resources.settings.supplier.tabs.credentials'), /* Credentials */
            bankAccounts: () => t('resources.settings.supplier.tabs.bankAccounts'), /* Bank accounts */
            fees: () => t('resources.settings.supplier.tabs.fees'), /* Fees */
            documents: () => t('resources.settings.supplier.tabs.documents'), /* Documents */
            integrations: () => t('resources.settings.supplier.tabs.integrations'), /* Integrations */
            notifications: () => t('resources.settings.supplier.tabs.notifications'), /* Notifications */
            customization: () => t('resources.settings.supplier.tabs.customization'), /* Customization */
            reminders: () => t('resources.settings.supplier.tabs.reminders'), /* Reminders */
          },
          documents: {
            supplierAgreementPanel: {
              title: () => t('resources.settings.supplier.documents.supplierAgreementPanel.title'), /* Factoring and Security Agreement */
              bodyConfirmedOn: () => t('resources.settings.supplier.documents.supplierAgreementPanel.bodyConfirmedOn'), /* Confirmed on  */
              bodyConfirmedBy: () => t('resources.settings.supplier.documents.supplierAgreementPanel.bodyConfirmedBy'), /*  by:  */
              labelDownload: () => t('resources.settings.supplier.documents.supplierAgreementPanel.labelDownload'), /* download */
              labelConfirm: () => t('resources.settings.supplier.documents.supplierAgreementPanel.labelConfirm'), /* Confirm agreement */
              body: () => t('resources.settings.supplier.documents.supplierAgreementPanel.body'), /* To complete your company enrollment, you are required to confirm our Factoring and Security Agreement. */
            },
            paymentProcessingAgreementPanel: {
              title: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.title'), /* Payment Processing Agreement */
              bodyConfirmedOn: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.bodyConfirmedOn'), /* Confirmed on  */
              bodyConfirmedBy: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.bodyConfirmedBy'), /*  by:  */
              labelDownload: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.labelDownload'), /* download */
              labelConfirm: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.labelConfirm'), /* Confirm agreement */
              body: () => t('resources.settings.supplier.documents.paymentProcessingAgreementPanel.body'), /* To complete your company enrollment, you are required to confirm our Payment Processing Agreement. */
            },
            supplierDocumentationsPanel: {
              title: () => t('resources.settings.supplier.documents.supplierDocumentationsPanel.title'), /* Business documentations */
              body: () => t('resources.settings.supplier.documents.supplierDocumentationsPanel.body'), /* Upload documentation about your business, including the company articles of association, proof of fiscal registration, and certified register of the shareholders */
              buttonText: () => t('resources.settings.supplier.documents.supplierDocumentationsPanel.buttonText'), /* Add Documents */
              dialogTitle: () => t('resources.settings.supplier.documents.supplierDocumentationsPanel.dialogTitle'), /* Upload business documentation */
              dialogContent: () => t('resources.settings.supplier.documents.supplierDocumentationsPanel.dialogContent'), /* Click or drag to upload file */
            },
          },
          completeSupplierDetailsIndication: {
            title: () => t('resources.settings.supplier.completeSupplierDetailsIndication.title'), /* Complete supplier organization details */
            content: () => t('resources.settings.supplier.completeSupplierDetailsIndication.content'), /*  This supplier has missing details. Please make sure all business details are in place and that there is at least one primary contact. */
          },
          integrations: {
            title: () => t('resources.settings.supplier.integrations.title'), /* Integrations */
            description: () => t('resources.settings.supplier.integrations.description'), /* Suppliers can connect their account to their ERP in order to sync, invoices, customers and payments. */
            tenantEnabled: () => t('resources.settings.supplier.integrations.tenantEnabled'), /* This tenant is now enabled for ERP sync */
            tenantNotEnabled: () => t('resources.settings.supplier.integrations.tenantNotEnabled'), /* This tenant is currently not enabled for ERP sync */
            turnOnErpSync: () => t('resources.settings.supplier.integrations.turnOnErpSync'), /* Enable sync */
            turnOffErpSync: () => t('resources.settings.supplier.integrations.turnOffErpSync'), /* Disable sync */
            connectedOn: () => t('resources.settings.supplier.integrations.connectedOn'), /* Connected on */
            configuration: {
              title: () => t('resources.settings.supplier.integrations.configuration.title'), /* Configuration */
              createPaymentRequestsAutomatically: () => t('resources.settings.supplier.integrations.configuration.createPaymentRequestsAutomatically'), /* Create payment requests automatically */
              invoiceCutoffDate: () => t('resources.settings.supplier.integrations.configuration.invoiceCutoffDate'), /* Invoice cutoff date */
              invoiceCutoffPeriod: () => t('resources.settings.supplier.integrations.configuration.invoiceCutoffPeriod'), /* Invoice cutoff period */
            },
            createPaymentRequestsAutomatically: () => t('resources.settings.supplier.integrations.createPaymentRequestsAutomatically'), /* Create payment requests automatically */
            invoiceCutoffDate: () => t('resources.settings.supplier.integrations.invoiceCutoffDate'), /* Invoice cutoff date */
            noSyncsYet: () => t('resources.settings.supplier.integrations.noSyncsYet'), /* No syncs yet */
            lastSyncAt: () => t('resources.settings.supplier.integrations.lastSyncAt'), /* Last sync at */
            isConnected: () => t('resources.settings.supplier.integrations.isConnected'), /* is connected */
            isDisconnected: () => t('resources.settings.supplier.integrations.isDisconnected'), /* is disconnected */
            contactSupport: (data: Record<'brandName', unknown>) => t('resources.settings.supplier.integrations.contactSupport', data), /* Please contact the %{brandName} Support Team */
            odooDisabledAlert: {
              title: () => t('resources.settings.supplier.integrations.odooDisabledAlert.title'), /* Odoo integration disabled */
              description: () => t('resources.settings.supplier.integrations.odooDisabledAlert.description'), /* Odoo integration is currently disabled for your organization. Your existing connection is not shown. Contact your administrator to re-enable it. */
            },
            syncSettings: () => t('resources.settings.supplier.integrations.syncSettings'), /* Sync settings */
            sync: {
              dataSyncRequested: () => t('resources.settings.supplier.integrations.sync.dataSyncRequested'), /* Data sync requested */
              syncStartedOn: () => t('resources.settings.supplier.integrations.sync.syncStartedOn'), /* Started on */
              syncing: () => t('resources.settings.supplier.integrations.sync.syncing'), /* Syncing */
              sync: () => t('resources.settings.supplier.integrations.sync.sync'), /* Sync */
            },
            invoiceCutoffPeriod: {
              noCutoff: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.noCutoff'), /* No cutoff */
              lastMonth: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.lastMonth'), /* Last month */
              last3Months: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.last3Months'), /* Last 3 months */
              last6Months: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.last6Months'), /* Last 6 months */
              lastYear: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.lastYear'), /* Last year */
              successMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.successMessage'), /* Cutoff period saved */
              errorMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffPeriod.errorMessage'), /* Failed to save cutoff period */
            },
            invoiceCutoffDateConfirmation: {
              title: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.title'), /* Set invoice cutoff date */
              content: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.content'), /* Are you sure you want to set an invoice cutoff date? Invoices created before this date will no longer be synced from your ERP. */
              confirm: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.confirm'), /* Continue */
              cancel: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.cancel'), /* Cancel */
              successMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.successMessage'), /* Cutoff date saved */
              errorMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.errorMessage'), /* Failed to save cutoff date */
              deleteTitle: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.deleteTitle'), /* Remove invoice cutoff date */
              deleteContent: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.deleteContent'), /* Are you sure you want to remove the invoice cutoff date? All invoices will be synced from your ERP. */
              deleteConfirm: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.deleteConfirm'), /* Remove */
              deleteSuccessMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.deleteSuccessMessage'), /* Cutoff date removed */
              deleteErrorMessage: () => t('resources.settings.supplier.integrations.invoiceCutoffDateConfirmation.deleteErrorMessage'), /* Failed to remove cutoff date */
            },
            buttons: {
              accountingSoftwareConnect: {
                title: () => t('resources.settings.supplier.integrations.buttons.accountingSoftwareConnect.title'), /* Accounting software */
                description: () => t('resources.settings.supplier.integrations.buttons.accountingSoftwareConnect.description'), /* Connect to Quickbooks, Xero, Odoo, Netsuite, Wave, and more */
                buttonText: () => t('resources.settings.supplier.integrations.buttons.accountingSoftwareConnect.buttonText'), /* Connect */
              },
              kingdeeConnect: {
                title: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.title'), /* Kingdee */
                description: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.description'), /* Pull financial data directly from your Kingdee account, including multiple entities */
                buttonText: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.buttonText'), /* Contact sales */
                dialog: {
                  title: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.title'), /* Connect to Kingdee */
                  content: (data: Record<'brandName', unknown>) => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.content', data), /* Send a request to our sales team to get instruction how to connect your Kingdee account in order sync your business activity to %{brandName} */
                  connectButtonText: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.connectButtonText'), /* Send request */
                  cancelButtonText: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.cancelButtonText'), /* Cancel */
                  connectSuccess: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.connectSuccess'), /* Request sent to our sales team */
                  connectError: () => t('resources.settings.supplier.integrations.buttons.kingdeeConnect.dialog.connectError'), /* Failed to send a request */
                },
              },
              shopifyConnect: {
                title: () => t('resources.settings.supplier.integrations.buttons.shopifyConnect.title'), /* Shopify */
                description: () => t('resources.settings.supplier.integrations.buttons.shopifyConnect.description'), /* Pull financial data directly from your Shopify account, including multiple entities */
                buttonText: () => t('resources.settings.supplier.integrations.buttons.shopifyConnect.buttonText'), /* Connect */
              },
              odooConnect: {
                title: () => t('resources.settings.supplier.integrations.buttons.odooConnect.title'), /* Odoo */
                description: () => t('resources.settings.supplier.integrations.buttons.odooConnect.description'), /* Connect your Odoo instance to sync buyers, invoices, and payments */
                buttonText: () => t('resources.settings.supplier.integrations.buttons.odooConnect.buttonText'), /* Connect */
                form: {
                  url: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.url'), /* Odoo URL */
                  urlPlaceholder: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.urlPlaceholder'), /* https://your-instance.odoo.com */
                  apiKey: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.apiKey'), /* API key */
                  apiKeyPlaceholder: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.apiKeyPlaceholder'), /* Your Odoo API key */
                  companyId: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.companyId'), /* Company ID (optional) */
                  companyIdPlaceholder: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.companyIdPlaceholder'), /* Leave empty for default */
                  submit: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.submit'), /* Connect */
                  connecting: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.connecting'), /* Connecting... */
                  success: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.success'), /* Connected successfully */
                  error: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.error'), /* Failed to connect */
                  errorUrlAndKeyRequired: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.errorUrlAndKeyRequired'), /* URL and API key are required */
                  errorTenantUpdate: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.errorTenantUpdate'), /* Connection created but we couldn't update organization settings. Please refresh the page. */
                  errorMissingContext: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.errorMissingContext'), /* Organization or tenant context is missing. Please refresh the page and try again. */
                  errorCompanyIdInvalid: () => t('resources.settings.supplier.integrations.buttons.odooConnect.form.errorCompanyIdInvalid'), /* Company ID must be a positive integer */
                },
                status: {
                  connected: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.connected'), /* Odoo connected */
                  disconnected: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.disconnected'), /* Odoo disconnected */
                  connectionFailed: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.connectionFailed'), /* Connection failed */
                  statusCheckFailed: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.statusCheckFailed'), /* Could not check Odoo connection status */
                  unlink: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlink'), /* Disconnect */
                  unlinkConfirmTitle: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlinkConfirmTitle'), /* Disconnect Odoo? */
                  unlinkConfirmMessage: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlinkConfirmMessage'), /* You can reconnect later. */
                  unlinkSuccess: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlinkSuccess'), /* Disconnected */
                  unlinkError: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlinkError'), /* Failed to disconnect */
                  unlinkErrorTenantUpdate: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.unlinkErrorTenantUpdate'), /* Disconnected but we couldn't update organization settings. Please refresh the page. */
                  loading: () => t('resources.settings.supplier.integrations.buttons.odooConnect.status.loading'), /* Loading... */
                },
              },
            },
          },
          creditCustomization: {
            title: () => t('resources.settings.supplier.creditCustomization.title'), /* Customize your buyer’s credit application journey */
            description: () => t('resources.settings.supplier.creditCustomization.description'), /* Select which steps buyers must complete when applying for a credit line. */
            steps: {
              connectBank: {
                title: () => t('resources.settings.supplier.creditCustomization.steps.connectBank.title'), /* Connect bank account */
                description: () => t('resources.settings.supplier.creditCustomization.steps.connectBank.description'), /* Ask your buyer to connect their account to access real-time insights */
              },
              uploadDocuments: {
                title: () => t('resources.settings.supplier.creditCustomization.steps.uploadDocuments.title'), /* Upload financial documents */
                description: () => t('resources.settings.supplier.creditCustomization.steps.uploadDocuments.description'), /* Ask your buyer to upload financial documents to better understand their financial health. */
              },
              personalGuarantee: {
                title: () => t('resources.settings.supplier.creditCustomization.steps.personalGuarantee.title'), /* Sign a personal guarantee */
                description: () => t('resources.settings.supplier.creditCustomization.steps.personalGuarantee.description'), /* Ask your buyer to sign a personal guarantee to increase payment security */
              },
              identityVerification: {
                title: () => t('resources.settings.supplier.creditCustomization.steps.identityVerification.title'), /* Identity verification */
                description: () => t('resources.settings.supplier.creditCustomization.steps.identityVerification.description'), /* Require your buyer to confirm their identity with a valid photo ID and a selfie to make sure it's them. */
              },
              creditReference: {
                title: () => t('resources.settings.supplier.creditCustomization.steps.creditReference.title'), /* Add credit references */
                description: () => t('resources.settings.supplier.creditCustomization.steps.creditReference.description'), /* Ask your buyer for references to help you evaluate their payment behavior */
              },
            },
          },
        },
        notifications: {
          noActiveNotifications: () => t('resources.settings.notifications.noActiveNotifications'), /* No active notifications found */
          manageYourNotifications: () => t('resources.settings.notifications.manageYourNotifications'), /* Manage your notifications */
          manageYourNotificationsDescription: () => t('resources.settings.notifications.manageYourNotificationsDescription'), /* Select the kinds of notifications the invoice's creator and all primary contacts of your business will receive. You can also send a copy to other recipients to get the same notifications. */
          buyerManageYourNotificationsDescription: () => t('resources.settings.notifications.buyerManageYourNotificationsDescription'), /* Select the kinds of notifications you will receive in your email address. */
          sentToMeOnlyDescription: () => t('resources.settings.notifications.sentToMeOnlyDescription'), /* Select the kinds of notifications you will receive in your email address. */
          addRecipients: () => t('resources.settings.notifications.addRecipients'), /* Add recipients to copy */
          sentTo: () => t('resources.settings.notifications.sentTo'), /* Sent to */
          sentToMe: () => t('resources.settings.notifications.sentToMe'), /* Sent to me */
          sentToMyOrganization: () => t('resources.settings.notifications.sentToMyOrganization'), /* Sent to my organization */
          sentToBuyer: () => t('resources.settings.notifications.sentToBuyer'), /* Sent to buyer */
          customizations: {
            name: () => t('resources.settings.notifications.customizations.name'), /* Customizations */
            title: () => t('resources.settings.notifications.customizations.title'), /* Customized email address for notifications */
            description: () => t('resources.settings.notifications.customizations.description'), /* Set up email address from which we send notifications to your buyers. Customized email address provides brand recognition and higher engagment. */
            addEmail: () => t('resources.settings.notifications.customizations.addEmail'), /* Add email address */
            email: () => t('resources.settings.notifications.customizations.email'), /* Email address */
            invalidEmailError: () => t('resources.settings.notifications.customizations.invalidEmailError'), /* Invalid email address */
            domainEmailError: () => t('resources.settings.notifications.customizations.domainEmailError'), /* Domain can't be changed after it's been verified. */
            save: () => t('resources.settings.notifications.customizations.save'), /* Save */
            verify: () => t('resources.settings.notifications.customizations.verify'), /* Verify */
            change: () => t('resources.settings.notifications.customizations.change'), /* Change */
            verified: () => t('resources.settings.notifications.customizations.verified'), /* Verified */
            failed: () => t('resources.settings.notifications.customizations.failed'), /* Failed */
            verificationSuccess: () => t('resources.settings.notifications.customizations.verificationSuccess'), /* Verification successful */
            verificationFailed: () => t('resources.settings.notifications.customizations.verificationFailed'), /* Verification failed */
            verifySteps: () => t('resources.settings.notifications.customizations.verifySteps'), /* To verify your email address, follow there steps: */
            verifyStep1: () => t('resources.settings.notifications.customizations.verifyStep1'), /* Copy the DNS records below. */
            verifyStep2: () => t('resources.settings.notifications.customizations.verifyStep2'), /* Add the DNS records into your server's DNS settings. */
            verifyStep2Link: () => t('resources.settings.notifications.customizations.verifyStep2Link'), /* Click here for detailed instructions if needed. */
            verifyStep3: () => t('resources.settings.notifications.customizations.verifyStep3'), /* Click verify and wait for confirmation. */
          },
          tooltips: {
            'entity-invoice-creator': () => t('resources.settings.notifications.tooltips.entity-invoice-creator'), /* The Invoice owner is the person who created the invoice in the system */
            'credit-line-requestor': () => t('resources.settings.notifications.tooltips.credit-line-requestor'), /* The Credit line requestor is the individual who initiated the credit line request */
          },
          descriptions: {
            'reminder-required-checkout-confirmed': () => t('resources.settings.notifications.descriptions.reminder-required-checkout-confirmed'), /* Sent 3 and 7 days after payment request creation. */
            'reminder-required-checkout-initiated': () => t('resources.settings.notifications.descriptions.reminder-required-checkout-initiated'), /* Sent 3 and 7 days after the due date. */
            'reminder-upcoming-charge': () => t('resources.settings.notifications.descriptions.reminder-upcoming-charge'), /* Sent 5 and 1 days before the payment date. */
            'reminder-required-financial-connections-created': () => t('resources.settings.notifications.descriptions.reminder-required-financial-connections-created'), /* Sent 30 minutes, 1 day, 3 days, 7 days, and 30 days after credit application started. */
            'buyer-generate-weekly-account-statements': () => t('resources.settings.notifications.descriptions.buyer-generate-weekly-account-statements'), /* Sent every Monday if there is an open balance. */
          },
          'entity-creator': () => t('resources.settings.notifications.entity-creator'), /* Entity Creator */
          'entity-invoice-creator': () => t('resources.settings.notifications.entity-invoice-creator'), /* Invoice Owner */
          'business-contacts': () => t('resources.settings.notifications.business-contacts'), /* Business Contacts */
          'primary-business-contacts': () => t('resources.settings.notifications.primary-business-contacts'), /* Business Primary Contacts */
          'business-email': () => t('resources.settings.notifications.business-email'), /* Business Email */
          'credit-line-requestor': () => t('resources.settings.notifications.credit-line-requestor'), /* Credit line requestor */
          email: () => t('resources.settings.notifications.email'), /* Email */
          intent: () => t('resources.settings.notifications.intent'), /* Intent */
          chargeUpdates: () => t('resources.settings.notifications.chargeUpdates'), /* Charge updates */
          creditLineUpdates: () => t('resources.settings.notifications.creditLineUpdates'), /* Credit line updates */
          upcomingChargeReminders: () => t('resources.settings.notifications.upcomingChargeReminders'), /* Upcoming charge reminders */
          invoiceUpdates: () => t('resources.settings.notifications.invoiceUpdates'), /* Invoice updates */
          payoutUpdates: () => t('resources.settings.notifications.payoutUpdates'), /* Payout updates */
          creditManagementUpdates: () => t('resources.settings.notifications.creditManagementUpdates'), /* Credit management updates */
          uncapturedPaymentReminders: () => t('resources.settings.notifications.uncapturedPaymentReminders'), /* Uncaptured payment reminders */
          titles: {
            supplier: {
              charge_buyer_succeeded: () => t('resources.settings.notifications.titles.supplier.charge_buyer_succeeded'), /* Buyer payment processed successfully */
              checkout_confirmed: () => t('resources.settings.notifications.titles.supplier.checkout_confirmed'), /* Buyer completed payment request flow */
              creditline_approved: () => t('resources.settings.notifications.titles.supplier.creditline_approved'), /* Buyer was approved for credit line */
              creditline_declined: () => t('resources.settings.notifications.titles.supplier.creditline_declined'), /* Buyer was declined for credit line */
              creditline_canceled: () => t('resources.settings.notifications.titles.supplier.creditline_canceled'), /* Buyer was canceled for credit line */
              'creditline_on-hold': () => t('resources.settings.notifications.titles.supplier.creditline_on-hold'), /* Buyer credit line was put on hold */
              'creditline-request_approved': () => t('resources.settings.notifications.titles.supplier.creditline-request_approved'), /* Buyer was approved for credit line */
              'creditline-request_declined': () => t('resources.settings.notifications.titles.supplier.creditline-request_declined'), /* Buyer was declined for credit line */
              'creditline-request_pending': () => t('resources.settings.notifications.titles.supplier.creditline-request_pending'), /* Buyer submitted credit application */
              invoice_confirmed_factor: (data: Record<'brandName', unknown>) => t('resources.settings.notifications.titles.supplier.invoice_confirmed_factor', data), /* Net term invoice was confirmed by %{brandName} */
              payout_ready: () => t('resources.settings.notifications.titles.supplier.payout_ready'), /* Payout amount was added to available balance */
              transaction_initiated: () => t('resources.settings.notifications.titles.supplier.transaction_initiated'), /* Bulk payout initiated */
              comment_message_received: () => t('resources.settings.notifications.titles.supplier.comment_message_received'), /* Comment message received */
              comment_mention_received: () => t('resources.settings.notifications.titles.supplier.comment_mention_received'), /* Comment mention received */
              'credit-review_ready': () => t('resources.settings.notifications.titles.supplier.credit-review_ready'), /* Credit review is ready */
              'reminder_required_stripe-intent_completed': () => t('resources.settings.notifications.titles.supplier.reminder_required_stripe-intent_completed'), /* Payment authorized but not completed */
            },
            buyer: {
              creditline_approved: () => t('resources.settings.notifications.titles.buyer.creditline_approved'), /* Credit line approval */
              creditline_declined: () => t('resources.settings.notifications.titles.buyer.creditline_declined'), /* Credit line decline */
              creditline_canceled: () => t('resources.settings.notifications.titles.buyer.creditline_canceled'), /* Credit line cancellation */
              'creditline_on-hold': () => t('resources.settings.notifications.titles.buyer.creditline_on-hold'), /* Credit line put on hold */
              charge_buyer_initiated: () => t('resources.settings.notifications.titles.buyer.charge_buyer_initiated'), /* Confirmation on charge initiated */
              charge_buyer_scheduled: () => t('resources.settings.notifications.titles.buyer.charge_buyer_scheduled'), /* Confirmation on charge scheduled */
              charge_buyer_succeeded: () => t('resources.settings.notifications.titles.buyer.charge_buyer_succeeded'), /* Confirmation on charge completed */
              checkout_confirmed: () => t('resources.settings.notifications.titles.buyer.checkout_confirmed'), /* Bank Transfer instructions */
              intent_created: () => t('resources.settings.notifications.titles.buyer.intent_created'), /* Invoice issued to buyer */
              reminder_required_checkout_confirmed: () => t('resources.settings.notifications.titles.buyer.reminder_required_checkout_confirmed'), /* Reminder to buyer to confirm an invoice */
              reminder_upcoming_charge: () => t('resources.settings.notifications.titles.buyer.reminder_upcoming_charge'), /* Upcoming charge reminder */
              reminder_required_checkout_initiated: () => t('resources.settings.notifications.titles.buyer.reminder_required_checkout_initiated'), /* Reminder to buyer for overdue invoice */
              checkout_created: () => t('resources.settings.notifications.titles.buyer.checkout_created'), /* Failed payment notification */
              'creditline-request_approved': () => t('resources.settings.notifications.titles.buyer.creditline-request_approved'), /* Credit line approval */
              'creditline-request_declined': () => t('resources.settings.notifications.titles.buyer.creditline-request_declined'), /* Credit line decline */
              'creditline-request_pending': () => t('resources.settings.notifications.titles.buyer.creditline-request_pending'), /* Credit application submitted */
              creditline_released: () => t('resources.settings.notifications.titles.buyer.creditline_released'), /* Credit released */
              'reminder_required_financial-connections_created': () => t('resources.settings.notifications.titles.buyer.reminder_required_financial-connections_created'), /* Reminder to buyer to complete credit application requirements */
              'financial-connections_disconnected': () => t('resources.settings.notifications.titles.buyer.financial-connections_disconnected'), /* Bank account disconnected */
              'buyer_generate-weekly-account-statements': () => t('resources.settings.notifications.titles.buyer.buyer_generate-weekly-account-statements'), /* Weekly account statements */
            },
          },
        },
        reminders: {
          title: () => t('resources.settings.reminders.title'), /* Reminders */
          tabs: {
            sentToBuyer: () => t('resources.settings.reminders.tabs.sentToBuyer'), /* Sent to buyer */
            sentToMyOrganization: () => t('resources.settings.reminders.tabs.sentToMyOrganization'), /* Sent to my organization */
          },
          reminderGroup: {
            from: {
              title: () => t('resources.settings.reminders.reminderGroup.from.title'), /* Reminder details */
              buttons: {
                cancel: () => t('resources.settings.reminders.reminderGroup.from.buttons.cancel'), /* Cancel */
                confirm: () => t('resources.settings.reminders.reminderGroup.from.buttons.confirm'), /* Save */
                create: () => t('resources.settings.reminders.reminderGroup.from.buttons.create'), /* Create reminder */
              },
            },
            titles: {
              checkout_initiated: () => t('resources.settings.reminders.reminderGroup.titles.checkout_initiated'), /* Reminder for overdue payment request */
              checkout_confirmed: () => t('resources.settings.reminders.reminderGroup.titles.checkout_confirmed'), /* Reminder to confirm payment request */
            },
            actions: {
              addReminder: () => t('resources.settings.reminders.reminderGroup.actions.addReminder'), /* Add reminder */
              deleteReminder: () => t('resources.settings.reminders.reminderGroup.actions.deleteReminder'), /* Delete */
              editReminderTiming: () => t('resources.settings.reminders.reminderGroup.actions.editReminderTiming'), /* Edit */
            },
            tooltips: {
              customizationNotAvailable: () => t('resources.settings.reminders.reminderGroup.tooltips.customizationNotAvailable'), /* System reminders not available for customization */
            },
            offsetUnit: {
              day: () => t('resources.settings.reminders.reminderGroup.offsetUnit.day'), /* day(s) */
              hour: () => t('resources.settings.reminders.reminderGroup.offsetUnit.hour'), /* hour(s) */
              minute: () => t('resources.settings.reminders.reminderGroup.offsetUnit.minute'), /* minute(s) */
            },
            offsetDirection: {
              on: () => t('resources.settings.reminders.reminderGroup.offsetDirection.on'), /* on */
              after: () => t('resources.settings.reminders.reminderGroup.offsetDirection.after'), /* after */
              before: () => t('resources.settings.reminders.reminderGroup.offsetDirection.before'), /* before */
            },
            offsetReferenceField: {
              dueDate: () => t('resources.settings.reminders.reminderGroup.offsetReferenceField.dueDate'), /* due date */
              paymentDate: () => t('resources.settings.reminders.reminderGroup.offsetReferenceField.paymentDate'), /* payment date */
              creationDate: () => t('resources.settings.reminders.reminderGroup.offsetReferenceField.creationDate'), /* creation date */
            },
            offsetReferenceEntity: {
              checkout: () => t('resources.settings.reminders.reminderGroup.offsetReferenceEntity.checkout'), /* payment request */
            },
            description: (data: Record<'offsetValue' | 'offsetUnit' | 'offsetDirection' | 'referenceEntity' | 'referenceField', unknown>) => t('resources.settings.reminders.reminderGroup.description', data), /* Send reminder %{offsetValue} %{offsetUnit} %{offsetDirection} %{referenceEntity} %{referenceField}. */
          },
          noReminderDefinitions: () => t('resources.settings.reminders.noReminderDefinitions'), /* No reminder definitions found */
        },
      },
      'fees/entity': {
        name: () => t('resources.fees/entity.name'), /* Fee |||| Fees */
        fields: {
          buyer: () => t('resources.fees/entity.fields.buyer'), /* Buyer */
          entityId: () => t('resources.fees/entity.fields.entityId'), /* Entity ID */
          entityType: () => t('resources.fees/entity.fields.entityType'), /* Entity type */
          businessType: () => t('resources.fees/entity.fields.businessType'), /* Business Type */
          feeDefinition: () => t('resources.fees/entity.fields.feeDefinition'), /* Fee definition */
          business: () => t('resources.fees/entity.fields.business'), /* Business */
          category: () => t('resources.fees/entity.fields.category'), /* Category */
          amount: () => t('resources.fees/entity.fields.amount'), /* Amount */
          status: () => t('resources.fees/entity.fields.status'), /* Status */
          type: () => t('resources.fees/entity.fields.type'), /* Type */
          externalId: () => t('resources.fees/entity.fields.externalId'), /* External ID */
        },
      },
      'transactions/scheduled-settings': {
        name: () => t('resources.transactions/scheduled-settings.name'), /* Scheduled transaction setting |||| Scheduled transactions settings */
        fields: {
          value: () => t('resources.transactions/scheduled-settings.fields.value'), /* Value */
          period: () => t('resources.transactions/scheduled-settings.fields.period'), /* Period */
          isManual: () => t('resources.transactions/scheduled-settings.fields.isManual'), /* Is manual sync */
          account: () => t('resources.transactions/scheduled-settings.fields.account'), /* Account */
          currency: () => t('resources.transactions/scheduled-settings.fields.currency'), /* Currency */
          createdAt: () => t('resources.transactions/scheduled-settings.fields.createdAt'), /* Created at */
          updatedAt: () => t('resources.transactions/scheduled-settings.fields.updatedAt'), /* Updated at */
        },
      },
    },
    common: {
      id: () => t('common.id'), /* ID */
      buyer: () => t('common.buyer'), /* Buyer */
      buyers: () => t('common.buyers'), /* Buyers */
      supplier: () => t('common.supplier'), /* Supplier */
      tenant: () => t('common.tenant'), /* Tenant */
      invoices: () => t('common.invoices'), /* Invoices */
      invoice: () => t('common.invoice'), /* Invoice */
      externalEntity: () => t('common.externalEntity'), /* External entity */
      createdBy: () => t('common.createdBy'), /* Created by */
      createdAt: () => t('common.createdAt'), /* Created at */
      updatedAt: () => t('common.updatedAt'), /* Updated at */
      optional: () => t('common.optional'), /* Optional */
      overflowMenu: () => t('common.overflowMenu'), /*  */
      delete: () => t('common.delete'), /*  */
      refresh: () => t('common.refresh'), /* Refresh */
      execute: () => t('common.execute'), /* Execute */
      edit: () => t('common.edit'), /* Edit */
      viewDetails: () => t('common.viewDetails'), /* View details */
      payBalance: () => t('common.payBalance'), /* Pay balance */
      expiresAt: () => t('common.expiresAt'), /* Expires at */
      payNow: () => t('common.payNow'), /* Pay now */
      confirm: () => t('common.confirm'), /* Confirm */
      repay: () => t('common.repay'), /* Repay */
      ppaBlocked: () => t('common.ppaBlocked'), /* This action requires a signed Payment Processing Agreement. Please visit the Overview page to sign it. */
      validation: {
        fieldRequired: () => t('common.validation.fieldRequired'), /* Required field. */
        amountMustBeGreaterThan: (data: Record<'amount', unknown>) => t('common.validation.amountMustBeGreaterThan', data), /* Amount must be greater than %{amount} */
      },
      countriesAutiComplete: {
        label: () => t('common.countriesAutiComplete.label'), /* Country */
      },
      addressInputs: {
        title: () => t('common.addressInputs.title'), /* Address */
        addressLine1: () => t('common.addressInputs.addressLine1'), /* Address line 1 */
        city: () => t('common.addressInputs.city'), /* City */
        state: () => t('common.addressInputs.state'), /* State */
        zipCode: () => t('common.addressInputs.zipCode'), /* Zip code */
        primaryCheck: () => t('common.addressInputs.primaryCheck'), /* This is the primary contact */
        ownerCheck: () => t('common.addressInputs.ownerCheck'), /* This is the owner of the business */
        authorizedSignatoryCheck: () => t('common.addressInputs.authorizedSignatoryCheck'), /* This is an authorized signatory */
        addFormTitle: () => t('common.addressInputs.addFormTitle'), /* Add contact details */
        EditFormTitle: () => t('common.addressInputs.EditFormTitle'), /* Edit contact details */
      },
      filters: {
        search: () => t('common.filters.search'), /* Search */
        status: () => t('common.filters.status'), /* Status */
        total: () => t('common.filters.total'), /* Total */
        amount: () => t('common.filters.amount'), /* Amount */
        createdAt: () => t('common.filters.createdAt'), /* Created at */
        createdBy: () => t('common.filters.createdBy'), /* Created by */
        creditLineStatus: () => t('common.filters.creditLineStatus'), /* Credit line status */
        bankAccount: () => t('common.filters.bankAccount'), /* Bank account */
        reference: () => t('common.filters.reference'), /* Reference */
        externalId: () => t('common.filters.externalId'), /* External ID */
      },
      buyerFinancingFeesTable: {
        title: () => t('common.buyerFinancingFeesTable.title'), /* Financing fees */
        paymentTerm: () => t('common.buyerFinancingFeesTable.paymentTerm'), /* Payment term */
        countFrom: () => t('common.buyerFinancingFeesTable.countFrom'), /* Count from */
        paymentMethod: () => t('common.buyerFinancingFeesTable.paymentMethod'), /* Payment method */
        minOrderAmount: () => t('common.buyerFinancingFeesTable.minOrderAmount'), /* Min order amount */
        maxOrderAmount: () => t('common.buyerFinancingFeesTable.maxOrderAmount'), /* Max order amount */
        baseFee: () => t('common.buyerFinancingFeesTable.baseFee'), /* Base fee */
        youPay: () => t('common.buyerFinancingFeesTable.youPay'), /* You pay */
        buyerPays: () => t('common.buyerFinancingFeesTable.buyerPays'), /* Buyer pays */
      },
    },
    guest: {
      creditLinesOverview: {
        title: {
          default: () => t('guest.creditLinesOverview.title.default'), /* Credit line application */
          approved: () => t('guest.creditLinesOverview.title.approved'), /* Credit line was approved */
          notStarted: () => t('guest.creditLinesOverview.title.notStarted'), /* Credit line hasn't started yet */
        },
        emptyState: {
          title: () => t('guest.creditLinesOverview.emptyState.title'), /* Ready to Start Your Credit Application? */
          subtitle: () => t('guest.creditLinesOverview.emptyState.subtitle'), /* Credit lets you pay on your terms, without slowing your business. */
        },
        actions: {
          startApplication: () => t('guest.creditLinesOverview.actions.startApplication'), /* Start application */
          checkUpdates: () => t('guest.creditLinesOverview.actions.checkUpdates'), /* Check for updates */
        },
      },
      companySearch: {
        title: () => t('guest.companySearch.title'), /* Tell us about the business you would like to check */
        subtitle: () => t('guest.companySearch.subtitle'), /* We need to know a little bit about the business to verify its identity */
      },
      loginOrCreateAccount: () => t('guest.loginOrCreateAccount'), /* Login or create an account */
    },
    enums: {
      AuthApplicationStatus: {
        active: () => t('enums.AuthApplicationStatus.active'), /* Active */
        inactive: () => t('enums.AuthApplicationStatus.inactive'), /* Inactive */
        suspended: () => t('enums.AuthApplicationStatus.suspended'), /* Suspended */
      },
      CreditReviewNotesStatus: {
        pending: () => t('enums.CreditReviewNotesStatus.pending'), /* Pending */
        done: () => t('enums.CreditReviewNotesStatus.done'), /* Done */
      },
      InsuranceProvider: {
        allianz: () => t('enums.InsuranceProvider.allianz'), /* Allianz */
        atradius: () => t('enums.InsuranceProvider.atradius'), /* Atradius */
        coface: () => t('enums.InsuranceProvider.coface'), /* Coface */
        'china-export': () => t('enums.InsuranceProvider.china-export'), /* China Export */
      },
      InsuranceStatus: {
        Pending: () => t('enums.InsuranceStatus.Pending'), /* Pending */
        Approved: () => t('enums.InsuranceStatus.Approved'), /* Approved */
        Declined: () => t('enums.InsuranceStatus.Declined'), /* Declined */
        OnHold: () => t('enums.InsuranceStatus.OnHold'), /* On hold */
        Canceled: () => t('enums.InsuranceStatus.Canceled'), /* Canceled */
      },
      InsuranceApplicationStatus: {
        pending: () => t('enums.InsuranceApplicationStatus.pending'), /* Pending */
        unsupported: () => t('enums.InsuranceApplicationStatus.unsupported'), /* Unsupported */
        success: () => t('enums.InsuranceApplicationStatus.success'), /* Success */
        failed: () => t('enums.InsuranceApplicationStatus.failed'), /* Failed */
      },
      CreditReviewStatus: {
        ready: () => t('enums.CreditReviewStatus.ready'), /* Ready for review */
        'in-progress': () => t('enums.CreditReviewStatus.in-progress'), /* Processing */
        failed: () => t('enums.CreditReviewStatus.failed'), /* Failed */
        pending: () => t('enums.CreditReviewStatus.pending'), /* Pending */
      },
      IdentityDocumentType: {
        driving_license: () => t('enums.IdentityDocumentType.driving_license'), /* Driving license */
        id_card: () => t('enums.IdentityDocumentType.id_card'), /* ID card */
        passport: () => t('enums.IdentityDocumentType.passport'), /* Passport */
      },
      IdentityIdNumberType: {
        br_cpf: () => t('enums.IdentityIdNumberType.br_cpf'), /* Brazilian CPF */
        sg_nric: () => t('enums.IdentityIdNumberType.sg_nric'), /* Singaporean NRIC */
        us_ssn: () => t('enums.IdentityIdNumberType.us_ssn'), /* SSN */
      },
      IdentityVerificationStatus: {
        verified: () => t('enums.IdentityVerificationStatus.verified'), /* Verified */
        'in-progress': () => t('enums.IdentityVerificationStatus.in-progress'), /* In progress */
        failed: () => t('enums.IdentityVerificationStatus.failed'), /* Failed */
      },
      RutterValidationStatus: {
        pending: () => t('enums.RutterValidationStatus.pending'), /* Pending */
        succeeded: () => t('enums.RutterValidationStatus.succeeded'), /* Succeeded */
        failed: () => t('enums.RutterValidationStatus.failed'), /* Failed */
      },
      AmountFilterType: {
        all: () => t('enums.AmountFilterType.all'), /* All amounts */
        eq: () => t('enums.AmountFilterType.eq'), /* Equals to */
        range: () => t('enums.AmountFilterType.range'), /* In between */
        lt: () => t('enums.AmountFilterType.lt'), /* Lower than */
        gt: () => t('enums.AmountFilterType.gt'), /* Greater than */
      },
      DateFilterType: {
        all: () => t('enums.DateFilterType.all'), /* All time */
        substract: () => t('enums.DateFilterType.substract'), /* Last x days */
        add: () => t('enums.DateFilterType.add'), /* Next x days */
        range: () => t('enums.DateFilterType.range'), /* Date range */
      },
      PlaidAccessTokenStatus: {
        active: () => t('enums.PlaidAccessTokenStatus.active'), /* Active */
        inactive: () => t('enums.PlaidAccessTokenStatus.inactive'), /* Inactive */
        Disconnected: () => t('enums.PlaidAccessTokenStatus.Disconnected'), /* Disconnected */
      },
      AiprizeCompanyStatus: {
        pending: () => t('enums.AiprizeCompanyStatus.pending'), /* Pending */
        'in-progress': () => t('enums.AiprizeCompanyStatus.in-progress'), /* In progress */
        completed: () => t('enums.AiprizeCompanyStatus.completed'), /* Completed */
        failed: () => t('enums.AiprizeCompanyStatus.failed'), /* Failed */
      },
      AiprizeCompanyDecision: {
        approved: () => t('enums.AiprizeCompanyDecision.approved'), /* Approved */
        declined: () => t('enums.AiprizeCompanyDecision.declined'), /* Declined */
        unknown: () => t('enums.AiprizeCompanyDecision.unknown'), /* Unknown */
        review: () => t('enums.AiprizeCompanyDecision.review'), /* Review */
      },
      AirwallexTransferStatus: {
        pending: () => t('enums.AirwallexTransferStatus.pending'), /* Pending */
        'in-progress': () => t('enums.AirwallexTransferStatus.in-progress'), /* In Progress */
        done: () => t('enums.AirwallexTransferStatus.done'), /* Done */
        failed: () => t('enums.AirwallexTransferStatus.failed'), /* Failed */
        canceled: () => t('enums.AirwallexTransferStatus.canceled'), /* Canceled */
        initiated: () => t('enums.AirwallexTransferStatus.initiated'), /* Initiated */
        blocked: () => t('enums.AirwallexTransferStatus.blocked'), /* Blocked */
      },
      BankAccountDetailsStatus: {
        active: () => t('enums.BankAccountDetailsStatus.active'), /* Active */
        inactive: () => t('enums.BankAccountDetailsStatus.inactive'), /* Inactive */
      },
      RutterCompanyConnectionStatus: {
        active: () => t('enums.RutterCompanyConnectionStatus.active'), /* Active */
        inactive: () => t('enums.RutterCompanyConnectionStatus.inactive'), /* Inactive */
        pending: () => t('enums.RutterCompanyConnectionStatus.pending'), /* Pending */
      },
      ComplyAdvantageStatus: {
        active: () => t('enums.ComplyAdvantageStatus.active'), /* Active */
        inactive: () => t('enums.ComplyAdvantageStatus.inactive'), /* Inactive */
        unknown: () => t('enums.ComplyAdvantageStatus.unknown'), /* Unknown */
      },
      HeronDataUploadStatus: {
        succeeded: () => t('enums.HeronDataUploadStatus.succeeded'), /* Succeeded */
        failed: () => t('enums.HeronDataUploadStatus.failed'), /* Failed */
      },
      InviteStatus: {
        pending: () => t('enums.InviteStatus.pending'), /* Pending */
        accepted: () => t('enums.InviteStatus.accepted'), /* Accepted */
      },
      ErpSyncSystemStatus: {
        'in-sync': () => t('enums.ErpSyncSystemStatus.in-sync'), /* In Sync */
        'out-of-sync': () => t('enums.ErpSyncSystemStatus.out-of-sync'), /* Out of Sync */
      },
      PolicyResultStatus: {
        qualified: () => t('enums.PolicyResultStatus.qualified'), /* Qualified */
        unqualified: () => t('enums.PolicyResultStatus.unqualified'), /* Unqualified */
      },
      LeadStatus: {
        pending: () => t('enums.LeadStatus.pending'), /* Pending */
        'in-progress': () => t('enums.LeadStatus.in-progress'), /* In progress */
        disqualified: () => t('enums.LeadStatus.disqualified'), /* Disqualified */
        'signed-up': () => t('enums.LeadStatus.signed-up'), /* Signed up */
        churned: () => t('enums.LeadStatus.churned'), /* Churned */
      },
      HeronReportStatus: {
        pending: () => t('enums.HeronReportStatus.pending'), /* Pending */
        'in-progress': () => t('enums.HeronReportStatus.in-progress'), /* In progress */
        succeeded: () => t('enums.HeronReportStatus.succeeded'), /* Succeeded */
        failed: () => t('enums.HeronReportStatus.failed'), /* Failed */
      },
      FeesEntitiesType: {
        charge: () => t('enums.FeesEntitiesType.charge'), /* Charge */
        payout: () => t('enums.FeesEntitiesType.payout'), /* Payout */
        invoice: () => t('enums.FeesEntitiesType.invoice'), /* Invoice */
        'currency-conversion': () => t('enums.FeesEntitiesType.currency-conversion'), /* Currency conversion */
      },
      ExternalEntityStatus: {
        pending: () => t('enums.ExternalEntityStatus.pending'), /* Pending */
        ready: () => t('enums.ExternalEntityStatus.ready'), /* Ready */
        succeeded: () => t('enums.ExternalEntityStatus.succeeded'), /* Succeeded */
        'partially-succeeded': () => t('enums.ExternalEntityStatus.partially-succeeded'), /* Partially succeeded */
        failed: () => t('enums.ExternalEntityStatus.failed'), /* Failed */
        filtered: () => t('enums.ExternalEntityStatus.filtered'), /* Filtered */
        'in-progress': () => t('enums.ExternalEntityStatus.in-progress'), /* In progress */
        blocked: () => t('enums.ExternalEntityStatus.blocked'), /* Blocked */
      },
      ExternalEntitySyncMode: {
        'two-way': () => t('enums.ExternalEntitySyncMode.two-way'), /* Two Way */
        down: () => t('enums.ExternalEntitySyncMode.down'), /* Down */
      },
      CreditLineRequestStatus: {
        pending: () => t('enums.CreditLineRequestStatus.pending'), /* Pending */
        'in-review': () => t('enums.CreditLineRequestStatus.in-review'), /* In review */
        blocked: () => t('enums.CreditLineRequestStatus.blocked'), /* Blocked */
        declined: () => t('enums.CreditLineRequestStatus.declined'), /* Declined */
        approved: () => t('enums.CreditLineRequestStatus.approved'), /* Approved */
        preapproved: () => t('enums.CreditLineRequestStatus.preapproved'), /* Pre-approved */
        'manual-review': () => t('enums.CreditLineRequestStatus.manual-review'), /* Manual Review */
        canceled: () => t('enums.CreditLineRequestStatus.canceled'), /* Canceled */
      },
      BusinessConfirmation: {
        pending: () => t('enums.BusinessConfirmation.pending'), /* Pending */
        confirmed: () => t('enums.BusinessConfirmation.confirmed'), /* Confirmed */
        manual: () => t('enums.BusinessConfirmation.manual'), /* Manual */
      },
      DetailsMatch: {
        'exact-match': () => t('enums.DetailsMatch.exact-match'), /* Exact match */
        'no-match': () => t('enums.DetailsMatch.no-match'), /* No match */
        'partial-match': () => t('enums.DetailsMatch.partial-match'), /* Partial match */
      },
      UsersStatus: {
        pending: () => t('enums.UsersStatus.pending'), /* Pending */
        active: () => t('enums.UsersStatus.active'), /* Active */
      },
      UserRole: {
        factor: () => t('enums.UserRole.factor'), /* Factor */
        developer: () => t('enums.UserRole.developer'), /* Developer */
        charges: () => t('enums.UserRole.charges'), /* Charges */
        checkout: () => t('enums.UserRole.checkout'), /* Checkout */
        buyer: () => t('enums.UserRole.buyer'), /* Buyer */
        'buyer - owner': () => t('enums.UserRole.buyer - owner'), /* Owner */
        supplier: () => t('enums.UserRole.supplier'), /* Supplier */
        'supplier - viewer': () => t('enums.UserRole.supplier - viewer'), /* Viewer */
        'supplier - invoice coordinator': () => t('enums.UserRole.supplier - invoice coordinator'), /* Invoice Coordinator */
        'supplier - buyers manager': () => t('enums.UserRole.supplier - buyers manager'), /* Buyers Manager */
        'supplier - sales manager': () => t('enums.UserRole.supplier - sales manager'), /* Sales */
        'supplier - Financial Manager': () => t('enums.UserRole.supplier - Financial Manager'), /* Buyer Financial Manager */
        'supplier - external sync': () => t('enums.UserRole.supplier - external sync'), /* External Sync */
        'supplier - m2m': () => t('enums.UserRole.supplier - m2m'), /* Machine to Machine */
        allianz: () => t('enums.UserRole.allianz'), /* Allianz */
        'switch roles': () => t('enums.UserRole.switch roles'), /* Switch roles */
        refund: () => t('enums.UserRole.refund'), /* Refund */
        guest: () => t('enums.UserRole.guest'), /* Guest */
        fund: () => t('enums.UserRole.fund'), /* Fund */
        'guest-landing': () => t('enums.UserRole.guest-landing'), /* Guest Landing */
        'guest-credit-line': () => t('enums.UserRole.guest-credit-line'), /* Guest Credit Line */
        assistant: () => t('enums.UserRole.assistant'), /* Assistant */
        'solution-integrator': () => t('enums.UserRole.solution-integrator'), /* Solution Integrator */
      },
      PermissionAccess: {
        allow: () => t('enums.PermissionAccess.allow'), /* Allow */
        deny: () => t('enums.PermissionAccess.deny'), /* Deny */
      },
      CurrencyConversionStatus: {
        pending: () => t('enums.CurrencyConversionStatus.pending'), /* Pending */
        scheduled: () => t('enums.CurrencyConversionStatus.scheduled'), /* Scheduled */
        overdue: () => t('enums.CurrencyConversionStatus.overdue'), /* Overdue */
        settled: () => t('enums.CurrencyConversionStatus.settled'), /* Settled */
        cancelled: () => t('enums.CurrencyConversionStatus.cancelled'), /* Cancelled */
        blocked: () => t('enums.CurrencyConversionStatus.blocked'), /* Blocked */
      },
      AirwallexIntentStatus: {
        REQUIRES_PAYMENT_METHOD: () => t('enums.AirwallexIntentStatus.REQUIRES_PAYMENT_METHOD'), /* Requires payment method */
        REQUIRES_CAPTURE: () => t('enums.AirwallexIntentStatus.REQUIRES_CAPTURE'), /* Requires capture */
        REQUIRES_CUSTOMER_ACTION: () => t('enums.AirwallexIntentStatus.REQUIRES_CUSTOMER_ACTION'), /* Requires customer action */
        PENDING: () => t('enums.AirwallexIntentStatus.PENDING'), /* Pending */
        SUCCEEDED: () => t('enums.AirwallexIntentStatus.SUCCEEDED'), /* Succeeded */
        CANCELLED: () => t('enums.AirwallexIntentStatus.CANCELLED'), /* Cancelled */
      },
      RecipientsProviderType: {
        'entity-creator': () => t('enums.RecipientsProviderType.entity-creator'), /* Entity creator */
        'entity-invoice-creator': () => t('enums.RecipientsProviderType.entity-invoice-creator'), /* Entity invoice creator */
        'business-contacts': () => t('enums.RecipientsProviderType.business-contacts'), /* Business contacts */
        'business-email': () => t('enums.RecipientsProviderType.business-email'), /* Business email */
        email: () => t('enums.RecipientsProviderType.email'), /* Email */
        intent: () => t('enums.RecipientsProviderType.intent'), /* Intent */
      },
      RecipientsProviderOutputType: {
        include: () => t('enums.RecipientsProviderOutputType.include'), /* Include */
        exclude: () => t('enums.RecipientsProviderOutputType.exclude'), /* Exclude */
      },
      NotificationDefinitionStatus: {
        active: () => t('enums.NotificationDefinitionStatus.active'), /* Active */
        inactive: () => t('enums.NotificationDefinitionStatus.inactive'), /* Inactive */
      },
      NotificationDeliveryMethod: {
        email: () => t('enums.NotificationDeliveryMethod.email'), /* Email */
      },
      RecipientType: {
        primary: () => t('enums.RecipientType.primary'), /* Primary */
        Secondary: () => t('enums.RecipientType.Secondary'), /* Secondary */
      },
      CurrencyConversionProviderType: {
        wise: () => t('enums.CurrencyConversionProviderType.wise'), /* Wise */
        airwallex: () => t('enums.CurrencyConversionProviderType.airwallex'), /* Airwallex */
      },
      PaymentMethodStatus: {
        pending: () => t('enums.PaymentMethodStatus.pending'), /* Pending */
        'pending-mandate': () => t('enums.PaymentMethodStatus.pending-mandate'), /* Pending mandate */
        active: () => t('enums.PaymentMethodStatus.active'), /* Active */
        inactive: () => t('enums.PaymentMethodStatus.inactive'), /* Inactive */
        disconnected: () => t('enums.PaymentMethodStatus.disconnected'), /* Disconnected */
      },
      FeeType: {
        buyer: () => t('enums.FeeType.buyer'), /* Buyer Fee */
        immediate: () => t('enums.FeeType.immediate'), /* Transaction fees */
        net: () => t('enums.FeeType.net'), /* Net term fees */
      },
      BusinessType: {
        seller: () => t('enums.BusinessType.seller'), /* Supplier */
        buyer: () => t('enums.BusinessType.buyer'), /* Buyer */
      },
      FinancialConnectionStatus: {
        active: () => t('enums.FinancialConnectionStatus.active'), /* Active */
        inactive: () => t('enums.FinancialConnectionStatus.inactive'), /* Inactive */
        disconnected: () => t('enums.FinancialConnectionStatus.disconnected'), /* Disconnected */
        suspended: () => t('enums.FinancialConnectionStatus.suspended'), /* Suspended */
      },
      FeeDefinitionStatus: {
        active: () => t('enums.FeeDefinitionStatus.active'), /* Active */
        inactive: () => t('enums.FeeDefinitionStatus.inactive'), /* Inactive */
        archived: () => t('enums.FeeDefinitionStatus.archived'), /* Archived */
      },
      country: {
        AF: () => t('enums.country.AF'), /* Afghanistan */
        AL: () => t('enums.country.AL'), /* Albania */
        DZ: () => t('enums.country.DZ'), /* Algeria */
        AD: () => t('enums.country.AD'), /* Andorra */
        AO: () => t('enums.country.AO'), /* Angola */
        AG: () => t('enums.country.AG'), /* Antigua and Barbuda */
        AR: () => t('enums.country.AR'), /* Argentina */
        AM: () => t('enums.country.AM'), /* Armenia */
        AU: () => t('enums.country.AU'), /* Australia */
        AT: () => t('enums.country.AT'), /* Austria */
        AZ: () => t('enums.country.AZ'), /* Azerbaijan */
        BS: () => t('enums.country.BS'), /* Bahamas */
        BH: () => t('enums.country.BH'), /* Bahrain */
        BD: () => t('enums.country.BD'), /* Bangladesh */
        BB: () => t('enums.country.BB'), /* Barbados */
        BY: () => t('enums.country.BY'), /* Belarus */
        BE: () => t('enums.country.BE'), /* Belgium */
        BZ: () => t('enums.country.BZ'), /* Belize */
        BJ: () => t('enums.country.BJ'), /* Benin */
        BT: () => t('enums.country.BT'), /* Bhutan */
        BO: () => t('enums.country.BO'), /* Bolivia */
        BA: () => t('enums.country.BA'), /* Bosnia and Herzegovina */
        BW: () => t('enums.country.BW'), /* Botswana */
        BR: () => t('enums.country.BR'), /* Brazil */
        BN: () => t('enums.country.BN'), /* Brunei */
        BG: () => t('enums.country.BG'), /* Bulgaria */
        BF: () => t('enums.country.BF'), /* Burkina Faso */
        BI: () => t('enums.country.BI'), /* Burundi */
        CV: () => t('enums.country.CV'), /* Cabo Verde */
        KH: () => t('enums.country.KH'), /* Cambodia */
        CM: () => t('enums.country.CM'), /* Cameroon */
        CA: () => t('enums.country.CA'), /* Canada */
        CF: () => t('enums.country.CF'), /* Central African Republic */
        TD: () => t('enums.country.TD'), /* Chad */
        CL: () => t('enums.country.CL'), /* Chile */
        CN: () => t('enums.country.CN'), /* China */
        CO: () => t('enums.country.CO'), /* Colombia */
        KM: () => t('enums.country.KM'), /* Comoros */
        CD: () => t('enums.country.CD'), /* Congo, Democratic Republic of the */
        CG: () => t('enums.country.CG'), /* Congo, Republic of the */
        CR: () => t('enums.country.CR'), /* Costa Rica */
        CI: () => t('enums.country.CI'), /* Cote d'Ivoire */
        HR: () => t('enums.country.HR'), /* Croatia */
        CU: () => t('enums.country.CU'), /* Cuba */
        CY: () => t('enums.country.CY'), /* Cyprus */
        CZ: () => t('enums.country.CZ'), /* Czechia */
        DK: () => t('enums.country.DK'), /* Denmark */
        DJ: () => t('enums.country.DJ'), /* Djibouti */
        DM: () => t('enums.country.DM'), /* Dominica */
        DO: () => t('enums.country.DO'), /* Dominican Republic */
        EC: () => t('enums.country.EC'), /* Ecuador */
        EG: () => t('enums.country.EG'), /* Egypt */
        SV: () => t('enums.country.SV'), /* El Salvador */
        GQ: () => t('enums.country.GQ'), /* Equatorial Guinea */
        ER: () => t('enums.country.ER'), /* Eritrea */
        EE: () => t('enums.country.EE'), /* Estonia */
        ET: () => t('enums.country.ET'), /* Ethiopia */
        FJ: () => t('enums.country.FJ'), /* Fiji */
        FI: () => t('enums.country.FI'), /* Finland */
        FR: () => t('enums.country.FR'), /* France */
        GA: () => t('enums.country.GA'), /* Gabon */
        GM: () => t('enums.country.GM'), /* Gambia */
        GE: () => t('enums.country.GE'), /* Georgia */
        DE: () => t('enums.country.DE'), /* Germany */
        GH: () => t('enums.country.GH'), /* Ghana */
        GR: () => t('enums.country.GR'), /* Greece */
        GD: () => t('enums.country.GD'), /* Grenada */
        GP: () => t('enums.country.GP'), /* Guadeloupe */
        GT: () => t('enums.country.GT'), /* Guatemala */
        GN: () => t('enums.country.GN'), /* Guinea */
        GW: () => t('enums.country.GW'), /* Guinea-Bissau */
        GY: () => t('enums.country.GY'), /* Guyana */
        HT: () => t('enums.country.HT'), /* Haiti */
        HN: () => t('enums.country.HN'), /* Honduras */
        HK: () => t('enums.country.HK'), /* Hong Kong */
        HU: () => t('enums.country.HU'), /* Hungary */
        IS: () => t('enums.country.IS'), /* Iceland */
        IN: () => t('enums.country.IN'), /* India */
        ID: () => t('enums.country.ID'), /* Indonesia */
        IR: () => t('enums.country.IR'), /* Iran */
        IQ: () => t('enums.country.IQ'), /* Iraq */
        IE: () => t('enums.country.IE'), /* Ireland */
        IL: () => t('enums.country.IL'), /* Israel */
        IT: () => t('enums.country.IT'), /* Italy */
        JM: () => t('enums.country.JM'), /* Jamaica */
        JP: () => t('enums.country.JP'), /* Japan */
        JO: () => t('enums.country.JO'), /* Jordan */
        KZ: () => t('enums.country.KZ'), /* Kazakhstan */
        KE: () => t('enums.country.KE'), /* Kenya */
        KI: () => t('enums.country.KI'), /* Kiribati */
        KP: () => t('enums.country.KP'), /* Korea, North */
        KR: () => t('enums.country.KR'), /* Korea, South */
        KW: () => t('enums.country.KW'), /* Kuwait */
        KG: () => t('enums.country.KG'), /* Kyrgyzstan */
        LA: () => t('enums.country.LA'), /* Laos */
        LV: () => t('enums.country.LV'), /* Latvia */
        LB: () => t('enums.country.LB'), /* Lebanon */
        LS: () => t('enums.country.LS'), /* Lesotho */
        LR: () => t('enums.country.LR'), /* Liberia */
        LY: () => t('enums.country.LY'), /* Libya */
        LI: () => t('enums.country.LI'), /* Liechtenstein */
        LT: () => t('enums.country.LT'), /* Lithuania */
        LU: () => t('enums.country.LU'), /* Luxembourg */
        MG: () => t('enums.country.MG'), /* Madagascar */
        MW: () => t('enums.country.MW'), /* Malawi */
        MY: () => t('enums.country.MY'), /* Malaysia */
        MV: () => t('enums.country.MV'), /* Maldives */
        ML: () => t('enums.country.ML'), /* Mali */
        MT: () => t('enums.country.MT'), /* Malta */
        MH: () => t('enums.country.MH'), /* Marshall Islands */
        MQ: () => t('enums.country.MQ'), /* Martinique */
        RE: () => t('enums.country.RE'), /* 团圆 */
        MR: () => t('enums.country.MR'), /* Mauritania */
        MU: () => t('enums.country.MU'), /* Mauritius */
        MX: () => t('enums.country.MX'), /* Mexico */
        FM: () => t('enums.country.FM'), /* Micronesia, Federated States of */
        MD: () => t('enums.country.MD'), /* Moldova */
        MC: () => t('enums.country.MC'), /* Monaco */
        MN: () => t('enums.country.MN'), /* Mongolia */
        ME: () => t('enums.country.ME'), /* Montenegro */
        MA: () => t('enums.country.MA'), /* Morocco */
        MZ: () => t('enums.country.MZ'), /* Mozambique */
        MM: () => t('enums.country.MM'), /* Myanmar (Burma) */
        NA: () => t('enums.country.NA'), /* Namibia */
        NR: () => t('enums.country.NR'), /* Nauru */
        NP: () => t('enums.country.NP'), /* Nepal */
        NL: () => t('enums.country.NL'), /* Netherlands */
        NZ: () => t('enums.country.NZ'), /* New Zealand */
        NI: () => t('enums.country.NI'), /* Nicaragua */
        NE: () => t('enums.country.NE'), /* Niger */
        NG: () => t('enums.country.NG'), /* Nigeria */
        MK: () => t('enums.country.MK'), /* North Macedonia */
        NO: () => t('enums.country.NO'), /* Norway */
        OM: () => t('enums.country.OM'), /* Oman */
        PK: () => t('enums.country.PK'), /* Pakistan */
        PW: () => t('enums.country.PW'), /* Palau */
        PA: () => t('enums.country.PA'), /* Panama */
        PG: () => t('enums.country.PG'), /* Papua New Guinea */
        PY: () => t('enums.country.PY'), /* Paraguay */
        PE: () => t('enums.country.PE'), /* Peru */
        PH: () => t('enums.country.PH'), /* Philippines */
        PL: () => t('enums.country.PL'), /* Poland */
        PS: () => t('enums.country.PS'), /* Palestine */
        PT: () => t('enums.country.PT'), /* Portugal */
        QA: () => t('enums.country.QA'), /* Qatar */
        RO: () => t('enums.country.RO'), /* Romania */
        RU: () => t('enums.country.RU'), /* Russia */
        RW: () => t('enums.country.RW'), /* Rwanda */
        KN: () => t('enums.country.KN'), /* Saint Kitts and Nevis */
        LC: () => t('enums.country.LC'), /* Saint Lucia */
        VC: () => t('enums.country.VC'), /* Saint Vincent and the Grenadines */
        WS: () => t('enums.country.WS'), /* Samoa */
        SM: () => t('enums.country.SM'), /* San Marino */
        ST: () => t('enums.country.ST'), /* Sao Tome and Principe */
        SA: () => t('enums.country.SA'), /* Saudi Arabia */
        SN: () => t('enums.country.SN'), /* Senegal */
        RS: () => t('enums.country.RS'), /* Serbia */
        SC: () => t('enums.country.SC'), /* Seychelles */
        SL: () => t('enums.country.SL'), /* Sierra Leone */
        SG: () => t('enums.country.SG'), /* Singapore */
        SK: () => t('enums.country.SK'), /* Slovakia */
        SI: () => t('enums.country.SI'), /* Slovenia */
        SB: () => t('enums.country.SB'), /* Solomon Islands */
        SO: () => t('enums.country.SO'), /* Somalia */
        SZ: () => t('enums.country.SZ'), /* Eswatini */
        ZA: () => t('enums.country.ZA'), /* South Africa */
        SS: () => t('enums.country.SS'), /* South Sudan */
        ES: () => t('enums.country.ES'), /* Spain */
        LK: () => t('enums.country.LK'), /* Sri Lanka */
        SD: () => t('enums.country.SD'), /* Sudan */
        SR: () => t('enums.country.SR'), /* Suriname */
        SE: () => t('enums.country.SE'), /* Sweden */
        CH: () => t('enums.country.CH'), /* Switzerland */
        SY: () => t('enums.country.SY'), /* Syria */
        TW: () => t('enums.country.TW'), /* Taiwan */
        TJ: () => t('enums.country.TJ'), /* Tajikistan */
        TZ: () => t('enums.country.TZ'), /* Tanzania */
        TH: () => t('enums.country.TH'), /* Thailand */
        TL: () => t('enums.country.TL'), /* Timor-Leste */
        TG: () => t('enums.country.TG'), /* Togo */
        TO: () => t('enums.country.TO'), /* Tonga */
        TT: () => t('enums.country.TT'), /* Trinidad and Tobago */
        TN: () => t('enums.country.TN'), /* Tunisia */
        TR: () => t('enums.country.TR'), /* Turkey */
        TM: () => t('enums.country.TM'), /* Turkmenistan */
        TV: () => t('enums.country.TV'), /* Tuvalu */
        UG: () => t('enums.country.UG'), /* Uganda */
        UA: () => t('enums.country.UA'), /* Ukraine */
        AE: () => t('enums.country.AE'), /* United Arab Emirates */
        GB: () => t('enums.country.GB'), /* United Kingdom */
        US: () => t('enums.country.US'), /* United States */
        UY: () => t('enums.country.UY'), /* Uruguay */
        UZ: () => t('enums.country.UZ'), /* Uzbekistan */
        VA: () => t('enums.country.VA'), /* Vatican City */
        VU: () => t('enums.country.VU'), /* Vanuatu */
        VE: () => t('enums.country.VE'), /* Venezuela */
        VN: () => t('enums.country.VN'), /* Vietnam */
        YE: () => t('enums.country.YE'), /* Yemen */
        ZM: () => t('enums.country.ZM'), /* Zambia */
        ZW: () => t('enums.country.ZW'), /* Zimbabwe */
        AX: () => t('enums.country.AX'), /* Aland Islands */
        MF: () => t('enums.country.MF'), /* Saint Martin */
        XK: () => t('enums.country.XK'), /* Kosovo */
        AW: () => t('enums.country.AW'), /* Aruba */
        PF: () => t('enums.country.PF'), /* French Polynesia */
        PR: () => t('enums.country.PR'), /* Puerto Rico */
        BV: () => t('enums.country.BV'), /* Bouvet Island */
        VI: () => t('enums.country.VI'), /* Virgin Islands, U.S. */
        GI: () => t('enums.country.GI'), /* Gibraltar */
      },
      Currency: {
        USD: () => t('enums.Currency.USD'), /* USD */
        GBP: () => t('enums.Currency.GBP'), /* GBP */
        EUR: () => t('enums.Currency.EUR'), /* EUR */
        AUD: () => t('enums.Currency.AUD'), /* AUD */
        HUF: () => t('enums.Currency.HUF'), /* HUF */
        AED: () => t('enums.Currency.AED'), /* AED */
        ARS: () => t('enums.Currency.ARS'), /* ARS */
        BRL: () => t('enums.Currency.BRL'), /* BRL */
        CAD: () => t('enums.Currency.CAD'), /* CAD */
        CHF: () => t('enums.Currency.CHF'), /* CHF */
        CNY: () => t('enums.Currency.CNY'), /* CNY */
        CNH: () => t('enums.Currency.CNH'), /* CNH */
        CZK: () => t('enums.Currency.CZK'), /* CZK */
        DKK: () => t('enums.Currency.DKK'), /* DKK */
        HKD: () => t('enums.Currency.HKD'), /* HKD */
        INR: () => t('enums.Currency.INR'), /* INR */
        JPY: () => t('enums.Currency.JPY'), /* JPY */
        KRW: () => t('enums.Currency.KRW'), /* KRW */
        MXN: () => t('enums.Currency.MXN'), /* MXN */
        NOK: () => t('enums.Currency.NOK'), /* NOK */
        PLN: () => t('enums.Currency.PLN'), /* PLN */
        RUB: () => t('enums.Currency.RUB'), /* RUB */
        SEK: () => t('enums.Currency.SEK'), /* SEK */
        SGD: () => t('enums.Currency.SGD'), /* SGD */
        TRY: () => t('enums.Currency.TRY'), /* TRY */
        ZAR: () => t('enums.Currency.ZAR'), /* ZAR */
        RON: () => t('enums.Currency.RON'), /* RON */
        PHP: () => t('enums.Currency.PHP'), /* PHP */
        NZD: () => t('enums.Currency.NZD'), /* NZD */
        IDR: () => t('enums.Currency.IDR'), /* IDR */
      },
      CreditLineResultStatus: {
        declined: () => t('enums.CreditLineResultStatus.declined'), /* Declined */
        pending: () => t('enums.CreditLineResultStatus.pending'), /* Pending */
        'on-hold': () => t('enums.CreditLineResultStatus.on-hold'), /* On hold */
        preapproved: () => t('enums.CreditLineResultStatus.preapproved'), /* Pre-approved */
        approved: () => t('enums.CreditLineResultStatus.approved'), /* Approved */
        canceled: () => t('enums.CreditLineResultStatus.canceled'), /* Canceled */
        'not-eligeble': () => t('enums.CreditLineResultStatus.not-eligeble'), /* Not eligible */
        unknown: () => t('enums.CreditLineResultStatus.unknown'), /* Unknown */
        'in-review': () => t('enums.CreditLineResultStatus.in-review'), /* In review */
        'manual-review': () => t('enums.CreditLineResultStatus.manual-review'), /* Manual Review */
      },
      CreditLineRequestType: {
        credit: () => t('enums.CreditLineRequestType.credit'), /* Credit */
        prescreening: () => t('enums.CreditLineRequestType.prescreening'), /* Prescreening */
      },
      UnderwritingStatus: {
        pending: () => t('enums.UnderwritingStatus.pending'), /* Pending */
        waiting: () => t('enums.UnderwritingStatus.waiting'), /* Waiting */
        blocked: () => t('enums.UnderwritingStatus.blocked'), /* Blocked */
        done: () => t('enums.UnderwritingStatus.done'), /* Done */
        'in-progress': () => t('enums.UnderwritingStatus.in-progress'), /* In progress */
        failed: () => t('enums.UnderwritingStatus.failed'), /* Failed */
        canceled: () => t('enums.UnderwritingStatus.canceled'), /* Canceled */
      },
      UnderwritingResultStatus: {
        declined: () => t('enums.UnderwritingResultStatus.declined'), /* Declined */
        preapproved: () => t('enums.UnderwritingResultStatus.preapproved'), /* Pre-approved */
        approved: () => t('enums.UnderwritingResultStatus.approved'), /* Approved */
        'manual-review': () => t('enums.UnderwritingResultStatus.manual-review'), /* Manual Review */
        pending: () => t('enums.UnderwritingResultStatus.pending'), /* Pending */
      },
      ChargeStatus: {
        pending: () => t('enums.ChargeStatus.pending'), /* Pending */
        initiated: () => t('enums.ChargeStatus.initiated'), /* Initiated */
        'in-transit': () => t('enums.ChargeStatus.in-transit'), /* In transit */
        done: () => t('enums.ChargeStatus.done'), /* Done */
        failed: () => t('enums.ChargeStatus.failed'), /* Failed */
        canceled: () => t('enums.ChargeStatus.canceled'), /* Canceled */
        refunded: () => t('enums.ChargeStatus.refunded'), /* Refunded */
        'refund-failed': () => t('enums.ChargeStatus.refund-failed'), /* Refund failed */
        'refund-initiated': () => t('enums.ChargeStatus.refund-initiated'), /* Refund initiated */
        scheduled: () => t('enums.ChargeStatus.scheduled'), /* Scheduled */
        submitted: () => t('enums.ChargeStatus.submitted'), /* Submitted */
        disputed: () => t('enums.ChargeStatus.disputed'), /* Disputed */
        'marked-as-paid': () => t('enums.ChargeStatus.marked-as-paid'), /* Marked as paid */
        'partially-refunded': () => t('enums.ChargeStatus.partially-refunded'), /* Partially refunded */
      },
      FundsStatus: {
        pending: () => t('enums.FundsStatus.pending'), /* Pending */
        received: () => t('enums.FundsStatus.received'), /* Received */
        allocated: () => t('enums.FundsStatus.allocated'), /* Allocated */
        'partially-allocated': () => t('enums.FundsStatus.partially-allocated'), /* Partially allocated */
        unmatched: () => t('enums.FundsStatus.unmatched'), /* Unallocated */
        'match-suggested': () => t('enums.FundsStatus.match-suggested'), /* Match suggested */
      },
      FundsLocation: {
        domestic: () => t('enums.FundsLocation.domestic'), /* Domestic */
        international: () => t('enums.FundsLocation.international'), /* International */
      },
      FundsMatchingMethod: {
        'by-buyer-contact': () => t('enums.FundsMatchingMethod.by-buyer-contact'), /* By Buyer Contact */
        'by-buyer-reference': () => t('enums.FundsMatchingMethod.by-buyer-reference'), /* By Buyer Reference */
        'by-buyer-legal-name': () => t('enums.FundsMatchingMethod.by-buyer-legal-name'), /* By Buyer Legal Name */
        'by-buyer-display-name': () => t('enums.FundsMatchingMethod.by-buyer-display-name'), /* By Buyer Display Name */
        'by-checkout-amount': () => t('enums.FundsMatchingMethod.by-checkout-amount'), /* By Checkout Amount */
        'by-invoice-reference': () => t('enums.FundsMatchingMethod.by-invoice-reference'), /* By Invoice Reference */
        'by-checkout-reference': () => t('enums.FundsMatchingMethod.by-checkout-reference'), /* By Checkout Reference */
        'by-payment-method-reference': () => t('enums.FundsMatchingMethod.by-payment-method-reference'), /* By Payment Method Reference */
        'by-payment-method-provider-id': () => t('enums.FundsMatchingMethod.by-payment-method-provider-id'), /* By Payment Method Provider ID */
        'by-buyer-predefined-matching': () => t('enums.FundsMatchingMethod.by-buyer-predefined-matching'), /* By Buyer Predefined Matching */
        'by-existing-fund-payer-name': () => t('enums.FundsMatchingMethod.by-existing-fund-payer-name'), /* By Existing Fund Payer Name */
        'by-existing-fund-payer-name-and-reference': () => t('enums.FundsMatchingMethod.by-existing-fund-payer-name-and-reference'), /* By Existing Fund Payer Name and Reference */
      },
      PayoutStatus: {
        pending: () => t('enums.PayoutStatus.pending'), /* Pending */
        'in-progress': () => t('enums.PayoutStatus.in-progress'), /* In progress */
        done: () => t('enums.PayoutStatus.done'), /* Done */
        failed: () => t('enums.PayoutStatus.failed'), /* Failed */
        canceled: () => t('enums.PayoutStatus.canceled'), /* Canceled */
        scheduled: () => t('enums.PayoutStatus.scheduled'), /* Scheduled */
        initiated: () => t('enums.PayoutStatus.initiated'), /* Initiated */
        ready: () => t('enums.PayoutStatus.ready'), /* Ready */
        deposited: () => t('enums.PayoutStatus.deposited'), /* Deposited */
      },
      TransactionStatus: {
        pending: () => t('enums.TransactionStatus.pending'), /* Pending */
        'in-progress': () => t('enums.TransactionStatus.in-progress'), /* In progress */
        done: () => t('enums.TransactionStatus.done'), /* Done */
        failed: () => t('enums.TransactionStatus.failed'), /* Failed */
        canceled: () => t('enums.TransactionStatus.canceled'), /* Canceled */
        scheduled: () => t('enums.TransactionStatus.scheduled'), /* Scheduled */
        initiated: () => t('enums.TransactionStatus.initiated'), /* Initiated */
        blocked: () => t('enums.TransactionStatus.blocked'), /* Blocked */
      },
      RefundStatus: {
        pending: () => t('enums.RefundStatus.pending'), /* Pending */
        initiated: () => t('enums.RefundStatus.initiated'), /* Initiated */
        succeeded: () => t('enums.RefundStatus.succeeded'), /* Completed */
        failed: () => t('enums.RefundStatus.failed'), /* Failed */
      },
      ExecutorType: {
        system: () => t('enums.ExecutorType.system'), /* System */
        user: () => t('enums.ExecutorType.user'), /* User */
        application: () => t('enums.ExecutorType.application'), /* Application */
        event: () => t('enums.ExecutorType.event'), /* Event */
      },
      InvoiceStatus: {
        pending: () => t('enums.InvoiceStatus.pending'), /* Pending */
        eligible: () => t('enums.InvoiceStatus.eligible'), /* Eligible */
        assigned: () => t('enums.InvoiceStatus.assigned'), /* Assigned */
        confirmed: () => t('enums.InvoiceStatus.confirmed'), /* Confirmed */
        'partially-paid': () => t('enums.InvoiceStatus.partially-paid'), /* Partially paid */
        charged: () => t('enums.InvoiceStatus.charged'), /* Charged */
        refunded: () => t('enums.InvoiceStatus.refunded'), /* Refunded */
        canceled: () => t('enums.InvoiceStatus.canceled'), /* Canceled */
        expired: () => t('enums.InvoiceStatus.expired'), /* Expired */
        overdue: () => t('enums.InvoiceStatus.overdue'), /* Overdue */
        defaulted: () => t('enums.InvoiceStatus.defaulted'), /* Defaulted */
      },
      OrderStatus: {
        pending: () => t('enums.OrderStatus.pending'), /* Pending */
        'in-progress': () => t('enums.OrderStatus.in-progress'), /* In progress */
        done: () => t('enums.OrderStatus.done'), /* Done */
        failed: () => t('enums.OrderStatus.failed'), /* Failed */
        canceled: () => t('enums.OrderStatus.canceled'), /* Canceled */
      },
      ShippingStatus: {
        pending: () => t('enums.ShippingStatus.pending'), /* Pending */
        valid: () => t('enums.ShippingStatus.valid'), /* Valid */
        invalid: () => t('enums.ShippingStatus.invalid'), /* Invalid */
        canceled: () => t('enums.ShippingStatus.canceled'), /* Canceled */
      },
      FinancialConnectionRefreshRequestStatus: {
        pending: () => t('enums.FinancialConnectionRefreshRequestStatus.pending'), /* Pending */
        succeeded: () => t('enums.FinancialConnectionRefreshRequestStatus.succeeded'), /* Succeeded */
        failed: () => t('enums.FinancialConnectionRefreshRequestStatus.failed'), /* Failed */
        canceled: () => t('enums.FinancialConnectionRefreshRequestStatus.canceled'), /* Canceled */
      },
      CodatCompanyRefreshRequestStatus: {
        pending: () => t('enums.CodatCompanyRefreshRequestStatus.pending'), /* Pending */
        succeeded: () => t('enums.CodatCompanyRefreshRequestStatus.succeeded'), /* Succeeded */
        failed: () => t('enums.CodatCompanyRefreshRequestStatus.failed'), /* Failed */
        'in-progress': () => t('enums.CodatCompanyRefreshRequestStatus.in-progress'), /* In progress */
      },
      CheckoutStatus: {
        paid: () => t('enums.CheckoutStatus.paid'), /* Paid */
        pending: () => t('enums.CheckoutStatus.pending'), /* Pending */
        confirmed: () => t('enums.CheckoutStatus.confirmed'), /* Confirmed */
        charged: () => t('enums.CheckoutStatus.charged'), /* Charged */
        refunded: () => t('enums.CheckoutStatus.refunded'), /* Refunded */
        'refund-failed': () => t('enums.CheckoutStatus.refund-failed'), /* Refund failed */
        'refund-initiated': () => t('enums.CheckoutStatus.refund-initiated'), /* Refund initiated */
        'partially-refunded': () => t('enums.CheckoutStatus.partially-refunded'), /* Partially refunded */
        canceled: () => t('enums.CheckoutStatus.canceled'), /* Canceled */
        scheduled: () => t('enums.CheckoutStatus.scheduled'), /* Scheduled */
        initiated: () => t('enums.CheckoutStatus.initiated'), /* Initiated */
        'in-transit': () => t('enums.CheckoutStatus.in-transit'), /* In transit */
        failed: () => t('enums.CheckoutStatus.failed'), /* Failed */
        disputed: () => t('enums.CheckoutStatus.disputed'), /* Disputed */
        'partially-paid': () => t('enums.CheckoutStatus.partially-paid'), /* Partially paid */
        'marked-as-paid': () => t('enums.CheckoutStatus.marked-as-paid'), /* Marked as paid */
        overdue: () => t('enums.CheckoutStatus.overdue'), /* Overdue */
        defaulted: () => t('enums.CheckoutStatus.defaulted'), /* Defaulted */
      },
      EmailStatus: {
        unprocessed: () => t('enums.EmailStatus.unprocessed'), /* Unprocessed */
        processed: () => t('enums.EmailStatus.processed'), /* Processed */
        click: () => t('enums.EmailStatus.click'), /* Clicked */
        open: () => t('enums.EmailStatus.open'), /* Opened */
        bounce: () => t('enums.EmailStatus.bounce'), /* Bounced */
        dropped: () => t('enums.EmailStatus.dropped'), /* Dropped */
        deferred: () => t('enums.EmailStatus.deferred'), /* Deferred */
        delivered: () => t('enums.EmailStatus.delivered'), /* Delivered */
      },
      RutterJobStatus: {
        prequeued: () => t('enums.RutterJobStatus.prequeued'), /* Prequeued */
        success: () => t('enums.RutterJobStatus.success'), /* Success */
        failure: () => t('enums.RutterJobStatus.failure'), /* Failed */
        in_progress: () => t('enums.RutterJobStatus.in_progress'), /* In progress */
        pending: () => t('enums.RutterJobStatus.pending'), /* Pending */
      },
      ShippingType: {
        waybill: () => t('enums.ShippingType.waybill'), /* Waybill */
        'bill-of-lading': () => t('enums.ShippingType.bill-of-lading'), /* Bill of Lading */
      },
      Status: {
        pending: () => t('enums.Status.pending'), /* Pending */
        done: () => t('enums.Status.done'), /* Done */
        'in-progress': () => t('enums.Status.in-progress'), /* In progress */
        failed: () => t('enums.Status.failed'), /* Failed */
      },
      PaymentMethod: {
        card: () => t('enums.PaymentMethod.card'), /* Card */
        ach: () => t('enums.PaymentMethod.ach'), /* ACH */
        acss: () => t('enums.PaymentMethod.acss'), /* ACSS */
        bacs: () => t('enums.PaymentMethod.bacs'), /* BACS */
        becs: () => t('enums.PaymentMethod.becs'), /* BECS */
        sepa_core: () => t('enums.PaymentMethod.sepa_core'), /* SEPA */
        phone: () => t('enums.PaymentMethod.phone'), /* Phone */
        wire: () => t('enums.PaymentMethod.wire'), /* Wire */
        check: () => t('enums.PaymentMethod.check'), /* Check */
      },
      CreditLineProvider: {
        default: () => t('enums.CreditLineProvider.default'), /* Default */
        supplier: () => t('enums.CreditLineProvider.supplier'), /* Supplier */
      },
      BillingStatus: {
        pending: () => t('enums.BillingStatus.pending'), /* Pending */
        'in-progress': () => t('enums.BillingStatus.in-progress'), /* In Progress */
        done: () => t('enums.BillingStatus.done'), /* Done */
        failed: () => t('enums.BillingStatus.failed'), /* Failed */
        canceled: () => t('enums.BillingStatus.canceled'), /* Canceled */
      },
      CreditLineRequestFundingType: {
        buyer: () => t('enums.CreditLineRequestFundingType.buyer'), /* Buyer */
        supplier: () => t('enums.CreditLineRequestFundingType.supplier'), /* Supplier */
      },
      PaymentTermType: {
        immediate: () => t('enums.PaymentTermType.immediate'), /* Immediate */
        net: () => t('enums.PaymentTermType.net'), /* Net */
      },
      FeeDefinitionType: {
        transaction: () => t('enums.FeeDefinitionType.transaction'), /* Transaction */
        financing: () => t('enums.FeeDefinitionType.financing'), /* Financing */
        'currency-conversion': () => t('enums.FeeDefinitionType.currency-conversion'), /* Currency Conversion */
        subscription: () => t('enums.FeeDefinitionType.subscription'), /* Subscription */
      },
      PaymentTermTiming: {
        'from-shipping': () => t('enums.PaymentTermTiming.from-shipping'), /* From Shipping */
        'from-invoice': () => t('enums.PaymentTermTiming.from-invoice'), /* From Invoice */
        'from-arrival': () => t('enums.PaymentTermTiming.from-arrival'), /* From Arrival */
        'from-dueDate': () => t('enums.PaymentTermTiming.from-dueDate'), /* From Due */
      },
      InvoiceMode: {
        draft: () => t('enums.InvoiceMode.draft'), /* Draft */
        active: () => t('enums.InvoiceMode.active'), /* Active */
      },
      AttachmentType: {
        invoice: () => t('enums.AttachmentType.invoice'), /* Invoice */
        agreement: () => t('enums.AttachmentType.agreement'), /* Agreement */
        'payment-processing-agreement': () => t('enums.AttachmentType.payment-processing-agreement'), /* Payment processing agreement */
        shipping: () => t('enums.AttachmentType.shipping'), /* Shipping */
        'tax-return': () => t('enums.AttachmentType.tax-return'), /* Tax return */
        'bank-statement': () => t('enums.AttachmentType.bank-statement'), /* Bank statement */
        'audited-financial-statement': () => t('enums.AttachmentType.audited-financial-statement'), /* Audited financial statement */
        other: () => t('enums.AttachmentType.other'), /* Other */
        'incorporation-document': () => t('enums.AttachmentType.incorporation-document'), /* Incorporation document */
        'bank-ownership': () => t('enums.AttachmentType.bank-ownership'), /* Bank ownership */
        'signatory-rights': () => t('enums.AttachmentType.signatory-rights'), /* Signatory rights */
        'orders-history': () => t('enums.AttachmentType.orders-history'), /* Orders history */
        'external-files': () => t('enums.AttachmentType.external-files'), /* External file */
        'buyer-guarantee': () => t('enums.AttachmentType.buyer-guarantee'), /* Buyer guarantee */
        'business-owner': () => t('enums.AttachmentType.business-owner'), /* Business owner */
        'business-license': () => t('enums.AttachmentType.business-license'), /* Business license */
        'proof-of-payment': () => t('enums.AttachmentType.proof-of-payment'), /* Proof of payment */
      },
      PaymentMethodProviderType: {
        Stripe: () => t('enums.PaymentMethodProviderType.Stripe'), /* Stripe */
        GoCardLess: () => t('enums.PaymentMethodProviderType.GoCardLess'), /* GoCardLess */
      },
      PaymentMethodType: {
        card: () => t('enums.PaymentMethodType.card'), /* Card */
        ach: () => t('enums.PaymentMethodType.ach'), /* ACH (US) */
        acss: () => t('enums.PaymentMethodType.acss'), /* ACSS (CA) */
        bacs: () => t('enums.PaymentMethodType.bacs'), /* BACS (UK) */
        becs: () => t('enums.PaymentMethodType.becs'), /* BECS (AU) */
        sepa_core: () => t('enums.PaymentMethodType.sepa_core'), /* SEPA (EU) */
        phone: () => t('enums.PaymentMethodType.phone'), /* Phone */
        wire: () => t('enums.PaymentMethodType.wire'), /* Wire */
        check: () => t('enums.PaymentMethodType.check'), /* Check */
        stablecoin: () => t('enums.PaymentMethodType.stablecoin'), /* Stablecoin */
      },
      FileResource: {
        invoices: () => t('enums.FileResource.invoices'), /* Invoices */
        shipping: () => t('enums.FileResource.shipping'), /* Shipping */
        checkout: () => t('enums.FileResource.checkout'), /* Checkouts */
      },
      IntentType: {
        invoice: () => t('enums.IntentType.invoice'), /* Invoice */
        checkout: () => t('enums.IntentType.checkout'), /* Checkout */
        'buyer-invoice': () => t('enums.IntentType.buyer-invoice'), /* Buyer Invoice */
        'bank-connectivity': () => t('enums.IntentType.bank-connectivity'), /* Bank Connectivity */
        order: () => t('enums.IntentType.order'), /* Order */
        'credit-line': () => t('enums.IntentType.credit-line'), /* Credit Line */
      },
      AllianzCoverStatus: {
        Pending: () => t('enums.AllianzCoverStatus.Pending'), /* Pending */
        NoCover: () => t('enums.AllianzCoverStatus.NoCover'), /* No cover */
        Partial: () => t('enums.AllianzCoverStatus.Partial'), /* Partial */
        Cover: () => t('enums.AllianzCoverStatus.Cover'), /* Cover */
        Rejected: () => t('enums.AllianzCoverStatus.Rejected'), /* Rejected */
        Closed: () => t('enums.AllianzCoverStatus.Closed'), /* Closed */
        CheckPolicy: () => t('enums.AllianzCoverStatus.CheckPolicy'), /* Check policy */
        Inactive: () => t('enums.AllianzCoverStatus.Inactive'), /* Inactive */
        Failed: () => t('enums.AllianzCoverStatus.Failed'), /* Failed */
      },
      ErpSyncStatus: {
        pending: () => t('enums.ErpSyncStatus.pending'), /* Pending */
        'in-progress': () => t('enums.ErpSyncStatus.in-progress'), /* In progress */
        succeeded: () => t('enums.ErpSyncStatus.succeeded'), /* Succeeded */
        completed: () => t('enums.ErpSyncStatus.completed'), /* Completed */
        'pending-summary': () => t('enums.ErpSyncStatus.pending-summary'), /* Pending Summary */
        failed: () => t('enums.ErpSyncStatus.failed'), /* Failed */
        timeout: () => t('enums.ErpSyncStatus.timeout'), /* Timeout */
      },
      AtradiusCoverStatus: {
        Pending: () => t('enums.AtradiusCoverStatus.Pending'), /* Pending */
        Partial: () => t('enums.AtradiusCoverStatus.Partial'), /* Partial */
        RefusalForIncrease: () => t('enums.AtradiusCoverStatus.RefusalForIncrease'), /* Refusal for increase */
        Cover: () => t('enums.AtradiusCoverStatus.Cover'), /* Cover */
        Rejected: () => t('enums.AtradiusCoverStatus.Rejected'), /* Rejected */
        Revised: () => t('enums.AtradiusCoverStatus.Revised'), /* Revised */
        Reissue: () => t('enums.AtradiusCoverStatus.Reissue'), /* Reissue */
        PartialExpiry: () => t('enums.AtradiusCoverStatus.PartialExpiry'), /* Partial Expiry */
        WithdrawalOfLimit: () => t('enums.AtradiusCoverStatus.WithdrawalOfLimit'), /* Withdrawal of limit */
        ReductionOfCover: () => t('enums.AtradiusCoverStatus.ReductionOfCover'), /* Reduction of cover */
      },
      AtradiusCoverRequestStatus: {
        Decision: () => t('enums.AtradiusCoverRequestStatus.Decision'), /* Decision */
        ManualReview: () => t('enums.AtradiusCoverRequestStatus.ManualReview'), /* Manual Review */
      },
      AllianzJobStatus: {
        PENDING: () => t('enums.AllianzJobStatus.PENDING'), /* Pending */
        PROCESSED: () => t('enums.AllianzJobStatus.PROCESSED'), /* Processed */
        TECHNICAL_ERROR: () => t('enums.AllianzJobStatus.TECHNICAL_ERROR'), /* Technical error */
        FUNCTIONAL_ERROR: () => t('enums.AllianzJobStatus.FUNCTIONAL_ERROR'), /* Functional error */
      },
      FeeStatus: {
        pending: () => t('enums.FeeStatus.pending'), /* Pending */
        done: () => t('enums.FeeStatus.done'), /* Done */
        failed: () => t('enums.FeeStatus.failed'), /* Failed */
        ready: () => t('enums.FeeStatus.ready'), /* Ready */
        'in-progress': () => t('enums.FeeStatus.in-progress'), /* In progress */
        canceled: () => t('enums.FeeStatus.canceled'), /* Canceled */
        disputed: () => t('enums.FeeStatus.disputed'), /* Disputed */
        'partially-refunded': () => t('enums.FeeStatus.partially-refunded'), /* Partially refunded */
        refunded: () => t('enums.FeeStatus.refunded'), /* Refunded */
      },
      TransactionProviderType: {
        svb: () => t('enums.TransactionProviderType.svb'), /* SVB */
        wise: () => t('enums.TransactionProviderType.wise'), /* WISE */
      },
      TransactionMode: {
        manual: () => t('enums.TransactionMode.manual'), /* Manual */
        automatic: () => t('enums.TransactionMode.automatic'), /* Automatic */
        log: () => t('enums.TransactionMode.log'), /* Log */
      },
      TransactionType: {
        deposit: () => t('enums.TransactionType.deposit'), /* Deposit */
        withdrawal: () => t('enums.TransactionType.withdrawal'), /* Withdrawal */
        'currency-conversion': () => t('enums.TransactionType.currency-conversion'), /* Currency conversion */
        charge: () => t('enums.TransactionType.charge'), /* Charge */
        payment: () => t('enums.TransactionType.payment'), /* Payment */
      },
      TransactionEntityType: {
        payout: () => t('enums.TransactionEntityType.payout'), /* Payout */
        billing: () => t('enums.TransactionEntityType.billing'), /* Billing */
        currencyconversion: () => t('enums.TransactionEntityType.currencyconversion'), /* Currency conversion */
      },
      EntityType: {
        invoice: () => t('enums.EntityType.invoice'), /* Invoice */
        checkout: () => t('enums.EntityType.checkout'), /* Checkout */
        order: () => t('enums.EntityType.order'), /* Order */
      },
      CreditLineInformationType: {
        'company-not-found': () => t('enums.CreditLineInformationType.company-not-found'), /* Company not found */
        'bank-ownership': () => t('enums.CreditLineInformationType.bank-ownership'), /* Bank ownership not available */
        'bank-transactions': () => t('enums.CreditLineInformationType.bank-transactions'), /* Bank transactions not available */
        'financial-connection': () => t('enums.CreditLineInformationType.financial-connection'), /* Financial connection not available */
        'bank-balance': () => t('enums.CreditLineInformationType.bank-balance'), /* Bank balance not available */
        'business-start-date': () => t('enums.CreditLineInformationType.business-start-date'), /* Business start date not available */
        identification: () => t('enums.CreditLineInformationType.identification'), /* Identification not available */
        'bank-ownership-mismatch': () => t('enums.CreditLineInformationType.bank-ownership-mismatch'), /* Bank account ownership does not match business name */
        'business-minimum-age': () => t('enums.CreditLineInformationType.business-minimum-age'), /* Business age does not meet the minimum */
        'awaiting-decision': () => t('enums.CreditLineInformationType.awaiting-decision'), /* Awaiting decision */
        'business-age': () => t('enums.CreditLineInformationType.business-age'), /* Business start date not found */
        'business-country': () => t('enums.CreditLineInformationType.business-country'), /* Business has no country set */
      },
      LedgerEntryStatus: {
        pending: () => t('enums.LedgerEntryStatus.pending'), /* Pending */
        done: () => t('enums.LedgerEntryStatus.done'), /* Done */
        canceled: () => t('enums.LedgerEntryStatus.canceled'), /* Canceled */
      },
      IntentStatus: {
        active: () => t('enums.IntentStatus.active'), /* Active */
        inactive: () => t('enums.IntentStatus.inactive'), /* Inactive */
        done: () => t('enums.IntentStatus.done'), /* Done */
      },
      ProcessType: {
        personalGuarantee: () => t('enums.ProcessType.personalGuarantee'), /* Personal Guarantee */
        bankFinancialConnection: () => t('enums.ProcessType.bankFinancialConnection'), /* Bank Financial Connection */
        allianz: () => t('enums.ProcessType.allianz'), /* Allianz */
        creditScore: () => t('enums.ProcessType.creditScore'), /* Credit Score */
        annualBankRevenue: () => t('enums.ProcessType.annualBankRevenue'), /* Annual Bank Revenue */
        businessVerification: () => t('enums.ProcessType.businessVerification'), /* Business Verification */
        businessStartDate: () => t('enums.ProcessType.businessStartDate'), /* Business Start Date */
        identityVerification: () => t('enums.ProcessType.identityVerification'), /* Identity Verification */
      },
      HttpMethod: {
        GET: () => t('enums.HttpMethod.GET'), /* GET */
        POST: () => t('enums.HttpMethod.POST'), /* POST */
        PUT: () => t('enums.HttpMethod.PUT'), /* PUT */
        DELETE: () => t('enums.HttpMethod.DELETE'), /* DELETE */
        PATCH: () => t('enums.HttpMethod.PATCH'), /* PATCH */
        OPTIONS: () => t('enums.HttpMethod.OPTIONS'), /* OPTIONS */
        HEAD: () => t('enums.HttpMethod.HEAD'), /* HEAD */
        CONNECT: () => t('enums.HttpMethod.CONNECT'), /* CONNECT */
        TRACE: () => t('enums.HttpMethod.TRACE'), /* TRACE */
      },
      HttpStatusCodeGroup: {
        Informational: () => t('enums.HttpStatusCodeGroup.Informational'), /* Informational - 1xx */
        Success: () => t('enums.HttpStatusCodeGroup.Success'), /* Success - 2xx */
        Redirection: () => t('enums.HttpStatusCodeGroup.Redirection'), /* Redirection - 3xx */
        ClientError: () => t('enums.HttpStatusCodeGroup.ClientError'), /* Client Error - 4xx */
        ServerError: () => t('enums.HttpStatusCodeGroup.ServerError'), /* Server Error - 5xx */
      },
      HttpStatusCode: {
        Continue: () => t('enums.HttpStatusCode.Continue'), /* Continue - 100 */
        SwitchingProtocols: () => t('enums.HttpStatusCode.SwitchingProtocols'), /* Switching Protocols - 101 */
        Processing: () => t('enums.HttpStatusCode.Processing'), /* Processing - 102 */
        EarlyHints: () => t('enums.HttpStatusCode.EarlyHints'), /* Early Hints - 103 */
        OK: () => t('enums.HttpStatusCode.OK'), /* OK - 200 */
        Created: () => t('enums.HttpStatusCode.Created'), /* Created - 201 */
        Accepted: () => t('enums.HttpStatusCode.Accepted'), /* Accepted - 202 */
        NonAuthoritativeInformation: () => t('enums.HttpStatusCode.NonAuthoritativeInformation'), /* Non-Authoritative Information - 203 */
        NoContent: () => t('enums.HttpStatusCode.NoContent'), /* No Content - 204 */
        ResetContent: () => t('enums.HttpStatusCode.ResetContent'), /* Reset Content - 205 */
        PartialContent: () => t('enums.HttpStatusCode.PartialContent'), /* Partial Content - 206 */
        MultiStatus: () => t('enums.HttpStatusCode.MultiStatus'), /* Multi-Status - 207 */
        AlreadyReported: () => t('enums.HttpStatusCode.AlreadyReported'), /* Already Reported - 208 */
        IMUsed: () => t('enums.HttpStatusCode.IMUsed'), /* IM Used - 226 */
        MultipleChoices: () => t('enums.HttpStatusCode.MultipleChoices'), /* Multiple Choices - 300 */
        MovedPermanently: () => t('enums.HttpStatusCode.MovedPermanently'), /* Moved Permanently - 301 */
        Found: () => t('enums.HttpStatusCode.Found'), /* Found - 302 */
        SeeOther: () => t('enums.HttpStatusCode.SeeOther'), /* See Other - 303 */
        NotModified: () => t('enums.HttpStatusCode.NotModified'), /* Not Modified - 304 */
        UseProxy: () => t('enums.HttpStatusCode.UseProxy'), /* Use Proxy - 305 */
        SwitchProxy: () => t('enums.HttpStatusCode.SwitchProxy'), /* Switch Proxy - 306 */
        TemporaryRedirect: () => t('enums.HttpStatusCode.TemporaryRedirect'), /* Temporary Redirect - 307 */
        PermanentRedirect: () => t('enums.HttpStatusCode.PermanentRedirect'), /* Permanent Redirect - 308 */
        BadRequest: () => t('enums.HttpStatusCode.BadRequest'), /* Bad Request - 400 */
        Unauthorized: () => t('enums.HttpStatusCode.Unauthorized'), /* Unauthorized - 401 */
        PaymentRequired: () => t('enums.HttpStatusCode.PaymentRequired'), /* Payment Required - 402 */
        Forbidden: () => t('enums.HttpStatusCode.Forbidden'), /* Forbidden - 403 */
        NotFound: () => t('enums.HttpStatusCode.NotFound'), /* Not Found - 404 */
        MethodNotAllowed: () => t('enums.HttpStatusCode.MethodNotAllowed'), /* Method Not Allowed - 405 */
        NotAcceptable: () => t('enums.HttpStatusCode.NotAcceptable'), /* Not Acceptable - 406 */
        ProxyAuthenticationRequired: () => t('enums.HttpStatusCode.ProxyAuthenticationRequired'), /* Proxy Authentication Required - 407 */
        RequestTimeout: () => t('enums.HttpStatusCode.RequestTimeout'), /* Request Timeout - 408 */
        Conflict: () => t('enums.HttpStatusCode.Conflict'), /* Conflict - 409 */
        Gone: () => t('enums.HttpStatusCode.Gone'), /* Gone - 410 */
        LengthRequired: () => t('enums.HttpStatusCode.LengthRequired'), /* Length Required - 411 */
        PreconditionFailed: () => t('enums.HttpStatusCode.PreconditionFailed'), /* Precondition Failed - 412 */
        PayloadTooLarge: () => t('enums.HttpStatusCode.PayloadTooLarge'), /* Payload Too Large - 413 */
        URITooLong: () => t('enums.HttpStatusCode.URITooLong'), /* URI Too Long - 414 */
        UnsupportedMediaType: () => t('enums.HttpStatusCode.UnsupportedMediaType'), /* Unsupported Media Type - 415 */
        RangeNotSatisfiable: () => t('enums.HttpStatusCode.RangeNotSatisfiable'), /* Range Not Satisfiable - 416 */
        ExpectationFailed: () => t('enums.HttpStatusCode.ExpectationFailed'), /* Expectation Failed - 417 */
        ImATeapot: () => t('enums.HttpStatusCode.ImATeapot'), /* I'm a teapot - 418 */
        MisdirectedRequest: () => t('enums.HttpStatusCode.MisdirectedRequest'), /* Misdirected Request - 421 */
        UnprocessableEntity: () => t('enums.HttpStatusCode.UnprocessableEntity'), /* Unprocessable Entity - 422 */
        Locked: () => t('enums.HttpStatusCode.Locked'), /* Locked - 423 */
        FailedDependency: () => t('enums.HttpStatusCode.FailedDependency'), /* Failed Dependency - 424 */
        TooEarly: () => t('enums.HttpStatusCode.TooEarly'), /* Too Early - 425 */
        UpgradeRequired: () => t('enums.HttpStatusCode.UpgradeRequired'), /* Upgrade Required - 426 */
        PreconditionRequired: () => t('enums.HttpStatusCode.PreconditionRequired'), /* Precondition Required - 428 */
        TooManyRequests: () => t('enums.HttpStatusCode.TooManyRequests'), /* Too Many Requests - 429 */
        RequestHeaderFieldsTooLarge: () => t('enums.HttpStatusCode.RequestHeaderFieldsTooLarge'), /* Request Header Fields Too Large - 431 */
        UnavailableForLegalReasons: () => t('enums.HttpStatusCode.UnavailableForLegalReasons'), /* Unavailable For Legal Reasons - 451 */
        InternalServerError: () => t('enums.HttpStatusCode.InternalServerError'), /* Internal Server Error - 500 */
        NotImplemented: () => t('enums.HttpStatusCode.NotImplemented'), /* Not Implemented - 501 */
        BadGateway: () => t('enums.HttpStatusCode.BadGateway'), /* Bad Gateway - 502 */
        ServiceUnavailable: () => t('enums.HttpStatusCode.ServiceUnavailable'), /* Service Unavailable - 503 */
        GatewayTimeout: () => t('enums.HttpStatusCode.GatewayTimeout'), /* Gateway Timeout - 504 */
        HTTPVersionNotSupported: () => t('enums.HttpStatusCode.HTTPVersionNotSupported'), /* HTTP Version Not Supported - 505 */
        VariantAlsoNegotiates: () => t('enums.HttpStatusCode.VariantAlsoNegotiates'), /* Variant Also Negotiates - 506 */
        InsufficientStorage: () => t('enums.HttpStatusCode.InsufficientStorage'), /* Insufficient Storage - 507 */
        LoopDetected: () => t('enums.HttpStatusCode.LoopDetected'), /* Loop Detected - 508 */
        NotExtended: () => t('enums.HttpStatusCode.NotExtended'), /* Not Extended - 510 */
        NetworkAuthenticationRequired: () => t('enums.HttpStatusCode.NetworkAuthenticationRequired'), /* Network Authentication Required - 511 */
      },
      ProviderType: {
        airwallex: () => t('enums.ProviderType.airwallex'), /* Airwallex */
      },
      ConnectedAccountStatus: {
        pending: () => t('enums.ConnectedAccountStatus.pending'), /* Pending */
        active: () => t('enums.ConnectedAccountStatus.active'), /* Active */
        initiated: () => t('enums.ConnectedAccountStatus.initiated'), /* Initiated */
        submitted: () => t('enums.ConnectedAccountStatus.submitted'), /* Submitted */
        suspended: () => t('enums.ConnectedAccountStatus.suspended'), /* Suspended */
        'action-required': () => t('enums.ConnectedAccountStatus.action-required'), /* Action required */
        disabled: () => t('enums.ConnectedAccountStatus.disabled'), /* Disabled */
      },
      ConnectedAccountKybStatus: {
        pending: () => t('enums.ConnectedAccountKybStatus.pending'), /* Pending */
        active: () => t('enums.ConnectedAccountKybStatus.active'), /* Active */
        submitted: () => t('enums.ConnectedAccountKybStatus.submitted'), /* Submitted */
        suspended: () => t('enums.ConnectedAccountKybStatus.suspended'), /* Suspended */
        'action-required': () => t('enums.ConnectedAccountKybStatus.action-required'), /* Action required */
        disabled: () => t('enums.ConnectedAccountKybStatus.disabled'), /* Disabled */
      },
      ConnectedAccountRfiStatus: {
        pending: () => t('enums.ConnectedAccountRfiStatus.pending'), /* Pending */
        active: () => t('enums.ConnectedAccountRfiStatus.active'), /* Active */
        submitted: () => t('enums.ConnectedAccountRfiStatus.submitted'), /* Submitted */
        suspended: () => t('enums.ConnectedAccountRfiStatus.suspended'), /* Suspended */
        'action-required': () => t('enums.ConnectedAccountRfiStatus.action-required'), /* Action required */
        disabled: () => t('enums.ConnectedAccountRfiStatus.disabled'), /* Disabled */
      },
      ConnectedAccountActivityStatus: {
        pending: () => t('enums.ConnectedAccountActivityStatus.pending'), /* Pending */
        settled: () => t('enums.ConnectedAccountActivityStatus.settled'), /* Settled */
        cancelled: () => t('enums.ConnectedAccountActivityStatus.cancelled'), /* Cancelled */
      },
      ConnectedAccountActivitySourceType: {
        payout: () => t('enums.ConnectedAccountActivitySourceType.payout'), /* Payout */
        conversion: () => t('enums.ConnectedAccountActivitySourceType.conversion'), /* Conversion */
        deposit: () => t('enums.ConnectedAccountActivitySourceType.deposit'), /* Deposit */
        adjustment: () => t('enums.ConnectedAccountActivitySourceType.adjustment'), /* Adjustment */
        fee: () => t('enums.ConnectedAccountActivitySourceType.fee'), /* Fee */
        payment_attempt: () => t('enums.ConnectedAccountActivitySourceType.payment_attempt'), /* Payment Attempt */
        refund: () => t('enums.ConnectedAccountActivitySourceType.refund'), /* Refund */
        dispute: () => t('enums.ConnectedAccountActivitySourceType.dispute'), /* Dispute */
        charge: () => t('enums.ConnectedAccountActivitySourceType.charge'), /* Charge */
        transfer: () => t('enums.ConnectedAccountActivitySourceType.transfer'), /* Transfer */
        yield: () => t('enums.ConnectedAccountActivitySourceType.yield'), /* Yield */
        batch_payout: () => t('enums.ConnectedAccountActivitySourceType.batch_payout'), /* Batch Payout */
        card_purchase: () => t('enums.ConnectedAccountActivitySourceType.card_purchase'), /* Card Purchase */
        card_refund: () => t('enums.ConnectedAccountActivitySourceType.card_refund'), /* Card Refund */
        purchase: () => t('enums.ConnectedAccountActivitySourceType.purchase'), /* Purchase */
        refund_reversal: () => t('enums.ConnectedAccountActivitySourceType.refund_reversal'), /* Refund Reversal */
      },
      ConnectedAccountActivityTransactionType: {
        dispute: () => t('enums.ConnectedAccountActivityTransactionType.dispute'), /* Dispute */
        dispute_reversal: () => t('enums.ConnectedAccountActivityTransactionType.dispute_reversal'), /* Dispute Reversal */
        dispute_lost: () => t('enums.ConnectedAccountActivityTransactionType.dispute_lost'), /* Dispute Lost */
        refund: () => t('enums.ConnectedAccountActivityTransactionType.refund'), /* Refund */
        refund_reversal: () => t('enums.ConnectedAccountActivityTransactionType.refund_reversal'), /* Refund Reversal */
        refund_failure: () => t('enums.ConnectedAccountActivityTransactionType.refund_failure'), /* Refund Failure */
        payment_reserve_hold: () => t('enums.ConnectedAccountActivityTransactionType.payment_reserve_hold'), /* Payment Reserve Hold */
        payment_reserve_release: () => t('enums.ConnectedAccountActivityTransactionType.payment_reserve_release'), /* Payment Reserve Release */
        payout: () => t('enums.ConnectedAccountActivityTransactionType.payout'), /* Payout */
        payout_failure: () => t('enums.ConnectedAccountActivityTransactionType.payout_failure'), /* Payout Failure */
        payout_reversal: () => t('enums.ConnectedAccountActivityTransactionType.payout_reversal'), /* Payout Reversal */
        conversion_sell: () => t('enums.ConnectedAccountActivityTransactionType.conversion_sell'), /* Conversion Sell */
        conversion_buy: () => t('enums.ConnectedAccountActivityTransactionType.conversion_buy'), /* Conversion Buy */
        conversion_reversal: () => t('enums.ConnectedAccountActivityTransactionType.conversion_reversal'), /* Conversion Reversal */
        deposit: () => t('enums.ConnectedAccountActivityTransactionType.deposit'), /* Deposit */
        adjustment: () => t('enums.ConnectedAccountActivityTransactionType.adjustment'), /* Adjustment */
        fee: () => t('enums.ConnectedAccountActivityTransactionType.fee'), /* Fee */
        dd_credit: () => t('enums.ConnectedAccountActivityTransactionType.dd_credit'), /* DD Credit */
        dd_debit: () => t('enums.ConnectedAccountActivityTransactionType.dd_debit'), /* DD Debit */
        dc_credit: () => t('enums.ConnectedAccountActivityTransactionType.dc_credit'), /* DC Credit */
        dc_debit: () => t('enums.ConnectedAccountActivityTransactionType.dc_debit'), /* DC Debit */
        transfer: () => t('enums.ConnectedAccountActivityTransactionType.transfer'), /* Transfer */
        payment: () => t('enums.ConnectedAccountActivityTransactionType.payment'), /* Payment */
        issuing_authorisation_hold: () => t('enums.ConnectedAccountActivityTransactionType.issuing_authorisation_hold'), /* Issuing Authorisation */
        issuing_authorisation_release: () => t('enums.ConnectedAccountActivityTransactionType.issuing_authorisation_release'), /* Issuing Authorisation Release */
        issuing_capture: () => t('enums.ConnectedAccountActivityTransactionType.issuing_capture'), /* Issuing Capture */
        issuing_refund: () => t('enums.ConnectedAccountActivityTransactionType.issuing_refund'), /* Issuing Refund */
        purchase: () => t('enums.ConnectedAccountActivityTransactionType.purchase'), /* Purchase */
      },
      ConnectedAccountFundsStatus: {
        pending: () => t('enums.ConnectedAccountFundsStatus.pending'), /* Pending */
        'in-progress': () => t('enums.ConnectedAccountFundsStatus.in-progress'), /* In progress */
        done: () => t('enums.ConnectedAccountFundsStatus.done'), /* Done */
        failed: () => t('enums.ConnectedAccountFundsStatus.failed'), /* Failed */
        suspended: () => t('enums.ConnectedAccountFundsStatus.suspended'), /* Suspended */
        blocked: () => t('enums.ConnectedAccountFundsStatus.blocked'), /* Blocked */
      },
      ConnectedAccountChargeStatus: {
        pending: () => t('enums.ConnectedAccountChargeStatus.pending'), /* Pending */
        'in-progress': () => t('enums.ConnectedAccountChargeStatus.in-progress'), /* In progress */
        done: () => t('enums.ConnectedAccountChargeStatus.done'), /* Done */
        failed: () => t('enums.ConnectedAccountChargeStatus.failed'), /* Failed */
        suspended: () => t('enums.ConnectedAccountChargeStatus.suspended'), /* Suspended */
        blocked: () => t('enums.ConnectedAccountChargeStatus.blocked'), /* Blocked */
      },
      ConnectedAccountCurrencyConversionStatus: {
        pending: () => t('enums.ConnectedAccountCurrencyConversionStatus.pending'), /* Pending */
        'in-progress': () => t('enums.ConnectedAccountCurrencyConversionStatus.in-progress'), /* In progress */
        done: () => t('enums.ConnectedAccountCurrencyConversionStatus.done'), /* Done */
        failed: () => t('enums.ConnectedAccountCurrencyConversionStatus.failed'), /* Failed */
        suspended: () => t('enums.ConnectedAccountCurrencyConversionStatus.suspended'), /* Suspended */
        blocked: () => t('enums.ConnectedAccountCurrencyConversionStatus.blocked'), /* Blocked */
        settled: () => t('enums.ConnectedAccountCurrencyConversionStatus.settled'), /* Settled */
      },
      QuoteStatus: {
        active: () => t('enums.QuoteStatus.active'), /* Active */
        expired: () => t('enums.QuoteStatus.expired'), /* Expired */
      },
      BankAccountScheme: {
        ach: () => t('enums.BankAccountScheme.ach'), /* ACH */
        fedwire: () => t('enums.BankAccountScheme.fedwire'), /* Fedwire */
      },
      ScheduledTransactionPeriod: {
        daily: () => t('enums.ScheduledTransactionPeriod.daily'), /* Daily */
        weekly: () => t('enums.ScheduledTransactionPeriod.weekly'), /* Weekly */
        monthly: () => t('enums.ScheduledTransactionPeriod.monthly'), /* Monthly */
      },
    },
    list: {
      filters: {
        title: () => t('list.filters.title'), /* Filters */
        open: () => t('list.filters.open'), /* Filters */
        clear: () => t('list.filters.clear'), /* Clear */
        buyerHint: () => t('list.filters.buyerHint'), /* Type to search buyers */
        reset: () => t('list.filters.reset'), /* Reset filters */
      },
    },
    customComponents: {
      RequestCreditReviewButton: {
        requestLabel: () => t('customComponents.RequestCreditReviewButton.requestLabel'), /* Manage credit */
        showLabel: () => t('customComponents.RequestCreditReviewButton.showLabel'), /* Manage credit */
      },
      RequestCreditReview: {
        loadingTitle: () => t('customComponents.RequestCreditReview.loadingTitle'), /* Generating Credit Review */
        loadingMessage: () => t('customComponents.RequestCreditReview.loadingMessage'), /* We are checking if your buyer can be matched to a company in our database. This may take a few moments... */
        errorTitle: () => t('customComponents.RequestCreditReview.errorTitle'), /* We couldn't generate a credit review report */
        errorMessage: () => t('customComponents.RequestCreditReview.errorMessage'), /* We couldn't find a matching company for this buyer in our database. You can copy the application link to share with your buyer or re-enter their details. */
        reenterDetails: () => t('customComponents.RequestCreditReview.reenterDetails'), /* Re-enter details */
      },
      CustomizedLogo: {
        label: () => t('customComponents.CustomizedLogo.label'), /* Add logo */
      },
      errorPage: {
        title: () => t('customComponents.errorPage.title'), /* Oops, something went wrong */
        subtitle: () => t('customComponents.errorPage.subtitle'), /* Sorry, an unexpected error occurred. */
        backToHome: () => t('customComponents.errorPage.backToHome'), /* Go back home */
      },
      ownerDetails: {
        dateOfBirth: () => t('customComponents.ownerDetails.dateOfBirth'), /* Date of birth */
        tin: () => t('customComponents.ownerDetails.tin'), /* TIN */
        website: () => t('customComponents.ownerDetails.website'), /* Website */
        addresses: () => t('customComponents.ownerDetails.addresses'), /* Addresses */
        legalName: () => t('customComponents.ownerDetails.legalName'), /* Legal name */
        businessStartDate: () => t('customComponents.ownerDetails.businessStartDate'), /* Business start date */
        phone: () => t('customComponents.ownerDetails.phone'), /* Phone number */
        email: () => t('customComponents.ownerDetails.email'), /* Email */
      },
      BuyerInvitationForm: {
        subtitle: () => t('customComponents.BuyerInvitationForm.subtitle'), /* Review buyers onboard process. */
        learnMore: () => t('customComponents.BuyerInvitationForm.learnMore'), /* Learn more */
        dividerText: () => t('customComponents.BuyerInvitationForm.dividerText'), /* OR */
        inviteInputTitle: () => t('customComponents.BuyerInvitationForm.inviteInputTitle'), /* Invite via email */
        inviteEmailInputPlaceholder: () => t('customComponents.BuyerInvitationForm.inviteEmailInputPlaceholder'), /* Enter buyer email address */
        ShareYourLinkTitle: () => t('customComponents.BuyerInvitationForm.ShareYourLinkTitle'), /* Share your link */
        sendInviteButton: () => t('customComponents.BuyerInvitationForm.sendInviteButton'), /* Send invite */
        copyLinkLabel: () => t('customComponents.BuyerInvitationForm.copyLinkLabel'), /* Copy link */
        recommendedChip: () => t('customComponents.BuyerInvitationForm.recommendedChip'), /* Recommended */
        inviteSentText: () => t('customComponents.BuyerInvitationForm.inviteSentText'), /* Invite sent to */
      },
      localesMenuButton: {
        name: () => t('customComponents.localesMenuButton.name'), /* ENG */
      },
      invoiceIndicators: {
        invoiceApprovedPanel: {
          title: () => t('customComponents.invoiceIndicators.invoiceApprovedPanel.title'), /* Invoice approved */
          body: () => t('customComponents.invoiceIndicators.invoiceApprovedPanel.body'), /* Copy and send your buyer the link below to pay the invoice */
          bodyWrapPayLater: () => t('customComponents.invoiceIndicators.invoiceApprovedPanel.bodyWrapPayLater'), /* Copy the link and send it your buyer to confirm the invoice */
        },
        invoiceOverDuePanel: {
          title: () => t('customComponents.invoiceIndicators.invoiceOverDuePanel.title'), /* This invoice is overdue */
          body: () => t('customComponents.invoiceIndicators.invoiceOverDuePanel.body'), /* To avoid delivery delays, please pay it as early as possible */
          buttonText: () => t('customComponents.invoiceIndicators.invoiceOverDuePanel.buttonText'), /* Pay now */
          requestPaymentMessage: () => t('customComponents.invoiceIndicators.invoiceOverDuePanel.requestPaymentMessage'), /* There are no pending payment requests for this invoice */
        },
        invoiceAddShippingPanel: {
          title: () => t('customComponents.invoiceIndicators.invoiceAddShippingPanel.title'), /* Your buyer confirmed the invoice terms */
          buttonText: () => t('customComponents.invoiceIndicators.invoiceAddShippingPanel.buttonText'), /* Add shipping details */
          body: () => t('customComponents.invoiceIndicators.invoiceAddShippingPanel.body'), /* Your payout will be sent out after adding shipping confirmation. */
        },
        invoiceSupplierWireConfirmedPanel: {
          body1: () => t('customComponents.invoiceIndicators.invoiceSupplierWireConfirmedPanel.body1'), /* Your buyer confirmed the invoice details and selected to pay via  */
          offlineLink: () => t('customComponents.invoiceIndicators.invoiceSupplierWireConfirmedPanel.offlineLink'), /* offline bank transfer */
          body2: () => t('customComponents.invoiceIndicators.invoiceSupplierWireConfirmedPanel.body2'), /* . We are waiting to receiving the payment from them. */
        },
        invoiceSupplierFactorConfirmedPanel: {
          body: () => t('customComponents.invoiceIndicators.invoiceSupplierFactorConfirmedPanel.body'), /* The buyer chose to repay this invoice via offline bank transfer.  */
          body2: () => t('customComponents.invoiceIndicators.invoiceSupplierFactorConfirmedPanel.body2'), /* Proof of payment received from buyer. */
          offlineLink: () => t('customComponents.invoiceIndicators.invoiceSupplierFactorConfirmedPanel.offlineLink'), /* Show instructions */
          buttonText: () => t('customComponents.invoiceIndicators.invoiceSupplierFactorConfirmedPanel.buttonText'), /* Edit payment */
        },
        invoiceBuyerWireConfirmedPanel: {
          body1: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.body1'), /* You selected to pay this payment request via  */
          offlineLink: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.offlineLink'), /* offline bank transfer */
          body2: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.body2'), /* . We are waiting to receive the payment from you. */
          body3: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.body3'), /* If you want to hasten the process, you have the option to upload a proof of payment */
          uploadProofOfPayment: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.uploadProofOfPayment'), /* Upload proof of payment */
          buttonText: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.buttonText'), /* Edit payment */
          content: () => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.content'), /* Pay with bank transfer to the following bank details: */
          includingFee: (data: Record<'fee', unknown>) => t('customComponents.invoiceIndicators.invoiceBuyerWireConfirmedPanel.includingFee', data), /* Including %{fee} processing fee */
        },
        invoiceCreatedPanel: {
          title: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.title'), /* Invoice pending review */
          body: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.body'), /* Our team is reviewing your invoice details. Once approved you will be able to send your buyer a link to confirm the terms. */
          payoutPendingInvoice: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.payoutPendingInvoice'), /* Your payout is pending your invoice upload. */
          ourTeamIsReviewing: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.ourTeamIsReviewing'), /* Our team is reviewing your invoice details. */
          invoicePendingConfirmation: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.invoicePendingConfirmation'), /* The invoice is pending your confirmation. */
          invoiceRequireBuyerConfirmation: () => t('customComponents.invoiceIndicators.invoiceCreatedPanel.invoiceRequireBuyerConfirmation'), /* The invoice is pending buyer confirmation. */
        },
        invoiceChargedPanel: {
          title: () => t('customComponents.invoiceIndicators.invoiceChargedPanel.title'), /* Invoice charged */
        },
      },
      upcomingChargeIndicator: {
        upcomingPaymentTitle: () => t('customComponents.upcomingChargeIndicator.upcomingPaymentTitle'), /* Upcoming payment */
        noUpcomingPaymentTitle: () => t('customComponents.upcomingChargeIndicator.noUpcomingPaymentTitle'), /* No upcoming payment */
      },
      availableCredit: {
        availableCreditLabel: () => t('customComponents.availableCredit.availableCreditLabel'), /* Available credit */
      },
      creditLimitIndicator: {
        creditLimit: () => t('customComponents.creditLimitIndicator.creditLimit'), /* Credit Limit */
        intentButtonText: () => t('customComponents.creditLimitIndicator.intentButtonText'), /* Copy application link */
      },
      CreditLineRequestButton: {
        buttonText: () => t('customComponents.CreditLineRequestButton.buttonText'), /* Get credit line */
      },
      CreditLineBySupplierButton: {
        provideCreditButtonLabel: () => t('customComponents.CreditLineBySupplierButton.provideCreditButtonLabel'), /* Provide credit line */
        manageCreditButtonLabel: () => t('customComponents.CreditLineBySupplierButton.manageCreditButtonLabel'), /* Manage credit line */
        modalSubtitle: () => t('customComponents.CreditLineBySupplierButton.modalSubtitle'), /* You can provide your buyer credit line and extend their invoice payment terms. */
      },
      BuyerManageUserAccessButton: {
        buttonText: () => t('customComponents.BuyerManageUserAccessButton.buttonText'), /* Manage sales access */
        modal: {
          title: () => t('customComponents.BuyerManageUserAccessButton.modal.title'), /* Manage sales access */
          subtitle: () => t('customComponents.BuyerManageUserAccessButton.modal.subtitle'), /* Select the sales manager you want to grant permission for this buyer */
          cancelButton: () => t('customComponents.BuyerManageUserAccessButton.modal.cancelButton'), /* Cancel */
          saveButton: () => t('customComponents.BuyerManageUserAccessButton.modal.saveButton'), /* Save */
          inviteUsersButtonText: () => t('customComponents.BuyerManageUserAccessButton.modal.inviteUsersButtonText'), /* Invite users */
          noSalesManagers: () => t('customComponents.BuyerManageUserAccessButton.modal.noSalesManagers'), /* No sales manager added yet */
        },
      },
      UserManageBuyerAccess: {
        title: () => t('customComponents.UserManageBuyerAccess.title'), /* Manage buyers access */
        subtitle: () => t('customComponents.UserManageBuyerAccess.subtitle'), /* Select the buyers this sales manager will be able to access */
        cancelButton: () => t('customComponents.UserManageBuyerAccess.cancelButton'), /* Cancel */
        saveButton: () => t('customComponents.UserManageBuyerAccess.saveButton'), /* Save */
      },
      UserBuyersList: {
        title: () => t('customComponents.UserBuyersList.title'), /* Access to buyers */
        subtitle: () => t('customComponents.UserBuyersList.subtitle'), /* Select the buyers this sales manager will be able to access */
        selectTheBuyer: () => t('customComponents.UserBuyersList.selectTheBuyer'), /* Select the buyers you want to grant permission for this user */
        manageBuyersAccess: () => t('customComponents.UserBuyersList.manageBuyersAccess'), /* Manage buyers access */
        noBuyerAccess: () => t('customComponents.UserBuyersList.noBuyerAccess'), /* This user doesn't have access to any buyers yet */
      },
      BuyerNonMandatoryInformationButton: {
        skipAction: {
          title: () => t('customComponents.BuyerNonMandatoryInformationButton.skipAction.title'), /* Remove bank connection requirement for this buyer */
          subtitle: () => t('customComponents.BuyerNonMandatoryInformationButton.skipAction.subtitle'), /* Are you sure you want to let this buyer confirm net terms invoices without a bank connection */
          button: () => t('customComponents.BuyerNonMandatoryInformationButton.skipAction.button'), /* Skip bank connection */
        },
        requireAction: {
          title: () => t('customComponents.BuyerNonMandatoryInformationButton.requireAction.title'), /* Require bank connection */
          subtitle: () => t('customComponents.BuyerNonMandatoryInformationButton.requireAction.subtitle'), /* Require bank connection for this buyer */
          button: () => t('customComponents.BuyerNonMandatoryInformationButton.requireAction.button'), /* Require bank connection */
        },
        confirmButton: () => t('customComponents.BuyerNonMandatoryInformationButton.confirmButton'), /* Confirm */
        cancelButton: () => t('customComponents.BuyerNonMandatoryInformationButton.cancelButton'), /* Cancel */
      },
      RequireIdentityVerification: {
        requireText: () => t('customComponents.RequireIdentityVerification.requireText'), /* Require identity verification */
        viewLinkText: () => t('customComponents.RequireIdentityVerification.viewLinkText'), /* Request identity verification */
        title: () => t('customComponents.RequireIdentityVerification.title'), /* Require identity verification */
        requestTitle: () => t('customComponents.RequireIdentityVerification.requestTitle'), /* Request identity verification */
        shareLink: () => t('customComponents.RequireIdentityVerification.shareLink'), /* Share your link */
        copyLink: () => t('customComponents.RequireIdentityVerification.copyLink'), /* Copy link */
        subtitle: () => t('customComponents.RequireIdentityVerification.subtitle'), /* Ask buyer to confirm their identity with a valid photo ID and a selfie to make sure it's them. */
        confirmButton: () => t('customComponents.RequireIdentityVerification.confirmButton'), /* Confirm */
        cancelButton: () => t('customComponents.RequireIdentityVerification.cancelButton'), /* Cancel */
        removeRequirement: () => t('customComponents.RequireIdentityVerification.removeRequirement'), /* Remove requirement */
        requestViaEmail: () => t('customComponents.RequireIdentityVerification.requestViaEmail'), /* Request via email */
        sentTo: (data: Record<'email', unknown>) => t('customComponents.RequireIdentityVerification.sentTo', data), /* Identity verification request sent to %{email} */
        dividerText: () => t('customComponents.RequireIdentityVerification.dividerText'), /* OR */
      },
      IdentityRequestForm: {
        sendRequestButton: () => t('customComponents.IdentityRequestForm.sendRequestButton'), /* Send request */
        placeHolder: () => t('customComponents.IdentityRequestForm.placeHolder'), /* Enter buyer email address */
      },
      SupplierOnboardingPromotionIndicator: {
        title: () => t('customComponents.SupplierOnboardingPromotionIndicator.title'), /* Your buyer needs to complete the credit application */
        body: () => t('customComponents.SupplierOnboardingPromotionIndicator.body'), /* To get your buyer approved for credit line they need to connect their bank account. Share this link with your buyer to complete the process. */
      },
      BuyerOnboardingPromotionIndicator: {
        title: () => t('customComponents.BuyerOnboardingPromotionIndicator.title'), /* Complete your credit application */
        buttonText: () => t('customComponents.BuyerOnboardingPromotionIndicator.buttonText'), /* Complete application */
        body: () => t('customComponents.BuyerOnboardingPromotionIndicator.body'), /* To get approved for credit line you need complete the application process. */
      },
      CrediLineEligibilityIndicator: {
        preapproved: {
          title: () => t('customComponents.CrediLineEligibilityIndicator.preapproved.title'), /* Your buyer is eligible for a credit line! */
          description: () => t('customComponents.CrediLineEligibilityIndicator.preapproved.description'), /* Invite them to sign up and complete the credit application at the client portal. */
        },
        'not-eligeble': {
          title: () => t('customComponents.CrediLineEligibilityIndicator.not-eligeble.title'), /* Your buyer was found not eligible for a credit line */
          description: () => t('customComponents.CrediLineEligibilityIndicator.not-eligeble.description'), /* You can invite them to sign up to the client portal to view and pay their invoices. */
        },
        unknown: {
          title: () => t('customComponents.CrediLineEligibilityIndicator.unknown.title'), /* We couldn't determine if the buyer is eligible for a credit line */
          description: () => t('customComponents.CrediLineEligibilityIndicator.unknown.description'), /* Invite them to sign up and complete the credit application so we can review their business. */
        },
        intentButtonText: () => t('customComponents.CrediLineEligibilityIndicator.intentButtonText'), /* Copy link */
      },
      userMenu: {
        settingsLabel: () => t('customComponents.userMenu.settingsLabel'), /* Settings */
        accountLabel: () => t('customComponents.userMenu.accountLabel'), /* Account */
      },
      testModeSwitch: {
        switchLabel: () => t('customComponents.testModeSwitch.switchLabel'), /* Test mode */
      },
      businessContact: {
        title: () => t('customComponents.businessContact.title'), /* Delete contact */
        contactListTitle: () => t('customComponents.businessContact.contactListTitle'), /* Contact */
        content: (data: Record<'name', unknown>) => t('customComponents.businessContact.content', data), /* Are you sure you want to delete this contact? %{name} */
        editLabel: () => t('customComponents.businessContact.editLabel'), /* Edit */
        deleteLabel: () => t('customComponents.businessContact.deleteLabel'), /* Delete */
        contactFields: {
          firstName: () => t('customComponents.businessContact.contactFields.firstName'), /* First name */
          lastName: () => t('customComponents.businessContact.contactFields.lastName'), /* Last name */
          email: () => t('customComponents.businessContact.contactFields.email'), /* Email */
          phone: () => t('customComponents.businessContact.contactFields.phone'), /* Phone number */
          primaryContact: () => t('customComponents.businessContact.contactFields.primaryContact'), /* Primary Contact */
          ssn: () => t('customComponents.businessContact.contactFields.ssn'), /* SSN */
          hasSignatureRights: () => t('customComponents.businessContact.contactFields.hasSignatureRights'), /* Has signature rights */
          isOwner: () => t('customComponents.businessContact.contactFields.isOwner'), /* Is Owner */
        },
      },
      userPermissions: {
        title: (data: Record<'tenantId', unknown>) => t('customComponents.userPermissions.title', data), /* Remove user from tenant %{tenantId} */
        content: (data: Record<'tenantId', unknown>) => t('customComponents.userPermissions.content', data), /* Are you sure you want to remove this user from %{tenantId}? */
        PermissionslistTitle: () => t('customComponents.userPermissions.PermissionslistTitle'), /* Permissions */
        tenantIdLabel: () => t('customComponents.userPermissions.tenantIdLabel'), /* Tenant ID */
        removePermissionLabel: () => t('customComponents.userPermissions.removePermissionLabel'), /* Remove permission */
        editRoleLabel: () => t('customComponents.userPermissions.editRoleLabel'), /* Edit role */
        addPermissionLabel: () => t('customComponents.userPermissions.addPermissionLabel'), /* Add permission */
        chooseRole: () => t('customComponents.userPermissions.chooseRole'), /* Choose role */
        addPermissionsToThisUser: () => t('customComponents.userPermissions.addPermissionsToThisUser'), /* Add permissions to this user */
        learnMore: () => t('customComponents.userPermissions.learnMore'), /* Learn more */
        aboutUserPermissions: () => t('customComponents.userPermissions.aboutUserPermissions'), /* about user permissions */
        developerRole: () => t('customComponents.userPermissions.developerRole'), /* Add developer permission to this user */
      },
      userDelete: {
        title: () => t('customComponents.userDelete.title'), /* Delete user */
        content: () => t('customComponents.userDelete.content'), /* Are you sure you want to delete this user? */
        label: () => t('customComponents.userDelete.label'), /* Delete user */
      },
      showActions: {
        auditLogsLabel: () => t('customComponents.showActions.auditLogsLabel'), /* Audit Logs */
      },
      creditLineRequestUnderwritingDetails: {
        underwritingListTitle: () => t('customComponents.creditLineRequestUnderwritingDetails.underwritingListTitle'), /* Previous underwritings */
        underwritingListEmpty: () => t('customComponents.creditLineRequestUnderwritingDetails.underwritingListEmpty'), /* No previous underwritings */
      },
      refreshComplyAdvantageCompanyButton: {
        label: () => t('customComponents.refreshComplyAdvantageCompanyButton.label'), /* Create case */
      },
      openExternalProviderButton: {
        label: () => t('customComponents.openExternalProviderButton.label'), /* View */
      },
      chargeDateField: {
        immediateChargeSwitch: {
          label: () => t('customComponents.chargeDateField.immediateChargeSwitch.label'), /* Immediate charge */
        },
      },
      chargeSchedulePanel: {
        title: () => t('customComponents.chargeSchedulePanel.title'), /* Payment Scheduled for  */
      },
      chargeFailedPanel: {
        title: (data: Record<'failedDate', unknown>) => t('customComponents.chargeFailedPanel.title', data), /* Your payment has failed on %{failedDate} */
        alternativeTitle: (data: Record<'failedDate' | 'createdDate', unknown>) => t('customComponents.chargeFailedPanel.alternativeTitle', data), /* Your payment has failed on %{failedDate}, for a transaction initiated on %{createdDate} */
        failureCode: () => t('customComponents.chargeFailedPanel.failureCode'), /* Failure code: */
        failureMessage: () => t('customComponents.chargeFailedPanel.failureMessage'), /* Failure message: */
      },
      invoiceAttachmentHoverDeleteButton: {
        title: () => t('customComponents.invoiceAttachmentHoverDeleteButton.title'), /* Delete attachment */
        content: () => t('customComponents.invoiceAttachmentHoverDeleteButton.content'), /* Are you sure you want to delete this attachment? */
      },
      createShippingButton: {
        label: () => t('customComponents.createShippingButton.label'), /* Add Shipping */
        title: () => t('customComponents.createShippingButton.title'), /* New shipping */
      },
      RefundedPanel: {
        titlePartA: () => t('customComponents.RefundedPanel.titlePartA'), /* Payment refunded on */
        titlePartB: () => t('customComponents.RefundedPanel.titlePartB'), /* . it may take 5-10 business days for funds to settle. */
        link: () => t('customComponents.RefundedPanel.link'), /* Review refund details */
      },
      additionalCostsInput: {
        title: () => t('customComponents.additionalCostsInput.title'), /* Additional Costs */
      },
      actions: {
        columns: () => t('customComponents.actions.columns'), /* Columns */
        filters: () => t('customComponents.actions.filters'), /* Filters */
        resetFilters: () => t('customComponents.actions.resetFilters'), /* Reset filters */
      },
      list: {
        emptyMessage: (data: Record<'resourceName', unknown>) => t('customComponents.list.emptyMessage', data), /* No %{resourceName} yet */
        createButtonText: (data: Record<'resourceName', unknown>) => t('customComponents.list.createButtonText', data), /* Add %{resourceName} */
      },
      ShowActionsMenu: {
        auditLogs: () => t('customComponents.ShowActionsMenu.auditLogs'), /* Audit Logs */
        showActionsMenuDropdown: {
          actions: () => t('customComponents.ShowActionsMenu.showActionsMenuDropdown.actions'), /* Actions */
        },
      },
      lineItemsDisplay: {
        lineItems: () => t('customComponents.lineItemsDisplay.lineItems'), /* Line Item */
        type: () => t('customComponents.lineItemsDisplay.type'), /* Type */
        title: () => t('customComponents.lineItemsDisplay.title'), /* Title */
        description: () => t('customComponents.lineItemsDisplay.description'), /* Description */
        quantity: () => t('customComponents.lineItemsDisplay.quantity'), /* Quantity */
        itemPrice: () => t('customComponents.lineItemsDisplay.itemPrice'), /* Item Price */
      },
      customizeColumns: {
        selectionDialog: {
          title: () => t('customComponents.customizeColumns.selectionDialog.title'), /* Columns */
          infoMessage: () => t('customComponents.customizeColumns.selectionDialog.infoMessage'), /* Show or hide column by checking it's checkbox. Rearrange the columns order by drag and drop. */
          actionButtions: {
            resetToDefault: () => t('customComponents.customizeColumns.selectionDialog.actionButtions.resetToDefault'), /* Reset to default */
          },
        },
      },
      addInvoiceAttachmentsDialog: {
        title: () => t('customComponents.addInvoiceAttachmentsDialog.title'), /* Add attachments to invoice */
        uploadFilesTitle: () => t('customComponents.addInvoiceAttachmentsDialog.uploadFilesTitle'), /* Drop your invoice here or  */
        chooseFilesTitle: () => t('customComponents.addInvoiceAttachmentsDialog.chooseFilesTitle'), /* choose files */
        toolBarButtonText: () => t('customComponents.addInvoiceAttachmentsDialog.toolBarButtonText'), /* Add Attachment */
        type: () => t('customComponents.addInvoiceAttachmentsDialog.type'), /* Type */
        maxFileSize: () => t('customComponents.addInvoiceAttachmentsDialog.maxFileSize'), /* (Max 10MB) */
      },
      address: {
        city: () => t('customComponents.address.city'), /* City */
        state: () => t('customComponents.address.state'), /* State */
        zipCode: () => t('customComponents.address.zipCode'), /* Zip Code */
        country: () => t('customComponents.address.country'), /* Country */
        addressLine1: () => t('customComponents.address.addressLine1'), /* Address Line 1 */
        addressLine2: () => t('customComponents.address.addressLine2'), /* Address Line 2 */
      },
      copyUrl: {
        copied: () => t('customComponents.copyUrl.copied'), /* Link copied to your clipboard */
      },
      creditReviewButton: {
        loadingTitle: () => t('customComponents.creditReviewButton.loadingTitle'), /* Generating Credit Review */
        loadingMessage: () => t('customComponents.creditReviewButton.loadingMessage'), /* We are checking if your buyer can be matched to a company in our database. This may take a few moments... */
        errorTitle: () => t('customComponents.creditReviewButton.errorTitle'), /* We couldn't generate a credit review report */
        errorMessage: () => t('customComponents.creditReviewButton.errorMessage'), /* It looks like we couldn't find any information about this buyer. This may be due to missing or incorrect details. To proceed, you can either re-enter the buyer's details or send the buyer a credit application link to provide the information themselves. */
        copyApplicationLink: () => t('customComponents.creditReviewButton.copyApplicationLink'), /* Copy application link */
        reenterDetails: () => t('customComponents.creditReviewButton.reenterDetails'), /* Re-enter details */
      },
      copyUrlIntent: {
        copyLink: () => t('customComponents.copyUrlIntent.copyLink'), /* Copy link */
        payNow: () => t('customComponents.copyUrlIntent.payNow'), /* Pay now */
        copied: () => t('customComponents.copyUrlIntent.copied'), /* Copied successfully! */
        invitationLink: () => t('customComponents.copyUrlIntent.invitationLink'), /* Invite buyer */
        copyInvitationLink: () => t('customComponents.copyUrlIntent.copyInvitationLink'), /* Copy invite link */
        invitationLinkTooltip: () => t('customComponents.copyUrlIntent.invitationLinkTooltip'), /* Share your invitation URL with buyers to let them add their business details and request for credit line themselves. */
      },
      copyOrganizationUrlIntent: {
        invitationLink: () => t('customComponents.copyOrganizationUrlIntent.invitationLink'), /* Invite supplier */
      },
      credentials: {
        copied: () => t('customComponents.credentials.copied'), /* Copied successfully! */
      },
      buyerPaymentOptions: {
        buyerFee: () => t('customComponents.buyerPaymentOptions.buyerFee'), /* Buyer Fee */
        sellerAdjustment: () => t('customComponents.buyerPaymentOptions.sellerAdjustment'), /* Seller Adjustment */
        day: () => t('customComponents.buyerPaymentOptions.day'), /* day */
        title: () => t('customComponents.buyerPaymentOptions.title'), /* title */
        fixed: () => t('customComponents.buyerPaymentOptions.fixed'), /* fixed */
      },
      bankConnectivityDetails: {
        bankAccountIsConnected: () => t('customComponents.bankConnectivityDetails.bankAccountIsConnected'), /* Buyer's bank account is connected */
        bankAccountIsNotConnectedTitle: () => t('customComponents.bankConnectivityDetails.bankAccountIsNotConnectedTitle'), /* Get your buyer approved faster */
        bankAccountIsNotConnectedBody: () => t('customComponents.bankConnectivityDetails.bankAccountIsNotConnectedBody'), /* Share this URL with your buyer to let them add their business details and complete the credit line request. */
        copyLink: () => t('customComponents.bankConnectivityDetails.copyLink'), /* COPY LINK */
        copied: () => t('customComponents.bankConnectivityDetails.copied'), /* COPIED ! */
      },
      generateInvoicePdf: {
        button: () => t('customComponents.generateInvoicePdf.button'), /* Generate PDF */
      },
      identification: {
        code: () => t('customComponents.identification.code'), /* Identification Code */
        type: () => t('customComponents.identification.type'), /* Identification Type */
      },
      addInvoice: {
        button: () => t('customComponents.addInvoice.button'), /* Add Invoice */
      },
      inactivityPopup: {
        title: () => t('customComponents.inactivityPopup.title'), /* You've been away for some time */
        description: () => t('customComponents.inactivityPopup.description'), /* Please refresh the page to stay up to date. */
        refresh: () => t('customComponents.inactivityPopup.refresh'), /* Refresh page */
      },
    },
    settings: {
      info: () => t('settings.info'), /* Info */
      credentials: {
        credentials: () => t('settings.credentials.credentials'), /* Credentials */
        clientId: () => t('settings.credentials.clientId'), /* Client ID */
        clientSecret: () => t('settings.credentials.clientSecret'), /* Client Secret */
        noCredentialsFound: () => t('settings.credentials.noCredentialsFound'), /* No API credentials found */
      },
    },
    webhooks: {
      name: () => t('webhooks.name'), /* Webhooks */
    },
    'webhooks/applications': {
      name: () => t('webhooks/applications.name'), /* Webhook Applications */
    },
    confirmDialog: {
      confirm: () => t('confirmDialog.confirm'), /* Confirm */
      cancel: () => t('confirmDialog.cancel'), /* Cancel */
    },
    accountFieldsDictionary: {
      USDDomestic: {
        routingNumber: () => t('accountFieldsDictionary.USDDomestic.routingNumber'), /* Routing number */
        accountNumber: () => t('accountFieldsDictionary.USDDomestic.accountNumber'), /* Account number */
      },
      USDInternational: {
        swiftCode: () => t('accountFieldsDictionary.USDInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.USDInternational.accountNumber'), /* IBAN / Account number */
      },
      EURDomestic: {
        iban: () => t('accountFieldsDictionary.EURDomestic.iban'), /* IBAN */
      },
      EURInternational: {
        swiftCode: () => t('accountFieldsDictionary.EURInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.EURInternational.accountNumber'), /* IBAN / Account number */
      },
      GBPDomestic: {
        sortCode: () => t('accountFieldsDictionary.GBPDomestic.sortCode'), /* Sort code */
        accountNumber: () => t('accountFieldsDictionary.GBPDomestic.accountNumber'), /* Account number */
      },
      GBInternational: {
        iban: () => t('accountFieldsDictionary.GBInternational.iban'), /* IBAN */
      },
      AUDDomestic: {
        bsb: () => t('accountFieldsDictionary.AUDDomestic.bsb'), /* BSB */
        accountNumber: () => t('accountFieldsDictionary.AUDDomestic.accountNumber'), /* Account number */
      },
      AUDInternational: {
        bsb: () => t('accountFieldsDictionary.AUDInternational.bsb'), /* BSB */
        accountNumber: () => t('accountFieldsDictionary.AUDInternational.accountNumber'), /* Account number */
      },
      CADInternational: {
        swiftCode: () => t('accountFieldsDictionary.CADInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.CADInternational.accountNumber'), /* IBAN / Account number */
      },
      CADDomestic: {
        institutionNumber: () => t('accountFieldsDictionary.CADDomestic.institutionNumber'), /* Institution Number */
        transitNumber: () => t('accountFieldsDictionary.CADDomestic.transitNumber'), /* Transit Number */
        accountNumber: () => t('accountFieldsDictionary.CADDomestic.accountNumber'), /* Account number */
      },
      CNHInternational: {
        swiftCode: () => t('accountFieldsDictionary.CNHInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.CNHInternational.accountNumber'), /* IBAN / Account number */
      },
      CNYInternational: {
        swiftCode: () => t('accountFieldsDictionary.CNYInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.CNYInternational.accountNumber'), /* IBAN / Account number */
      },
      CNYDomestic: {
        routingNumber: () => t('accountFieldsDictionary.CNYDomestic.routingNumber'), /* Routing number */
        accountNumber: () => t('accountFieldsDictionary.CNYDomestic.accountNumber'), /* Account number */
      },
      JPYInternational: {
        swiftCode: () => t('accountFieldsDictionary.JPYInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.JPYInternational.accountNumber'), /* IBAN / Account number */
      },
      JPYDomestic: {
        accountNumber: () => t('accountFieldsDictionary.JPYDomestic.accountNumber'), /* Account number */
        bankCode: () => t('accountFieldsDictionary.JPYDomestic.bankCode'), /* Bank code */
        branchCode: () => t('accountFieldsDictionary.JPYDomestic.branchCode'), /* Branch Code */
      },
      HKDInternational: {
        swiftCode: () => t('accountFieldsDictionary.HKDInternational.swiftCode'), /* Swift / BIC Code */
        accountNumber: () => t('accountFieldsDictionary.HKDInternational.accountNumber'), /* IBAN / Account number */
      },
      HKDDomestic: {
        accountNumber: () => t('accountFieldsDictionary.HKDDomestic.accountNumber'), /* Account number */
        bankCode: () => t('accountFieldsDictionary.HKDDomestic.bankCode'), /* Bank code */
        branchCode: () => t('accountFieldsDictionary.HKDDomestic.branchCode'), /* Branch Code */
      },
    },
  };
}

export type IDashboardLocaleKeys = ReturnType<typeof dashboardLocaleKeys>;

const LocaleKeysContext = React.createContext({} as IDashboardLocaleKeys);
export const DashboardLocaleKeysProvider: React.FC<{ translateFn?: (...args: unknown[]) => string; localeKeys?: IDashboardLocaleKeys; children?: React.ReactNode }> = ({ translateFn, localeKeys, children }) => {
    if (!translateFn && !localeKeys) { throw new Error('Either translateFn or localeKeys must be provided') }
    const value = (typeof translateFn === 'function' ? dashboardLocaleKeys(translateFn) : localeKeys) as IDashboardLocaleKeys
    return <LocaleKeysContext.Provider value={value}>{children}</LocaleKeysContext.Provider>;
  };
export const useDashboardLocaleKeys = () => React.useContext(LocaleKeysContext);
export type DashboardLocaleKeys = ReturnType<typeof useDashboardLocaleKeys>; export type LocaleFunctionType = (arg: { smart_count: number; _: string }) => string;
